
window.drawZoneLimits = function () {
if (typeof window.refreshAllDesignZones === 'function') {
window.refreshAllDesignZones();
}
['front', 'back', 'left', 'right'].forEach((viewName) => {
const area = document.querySelector(
`.product-view[data-view="${viewName}"] .design-area[data-area="${viewName}"]`
);
if (area) area.classList.add('zone-limits-visible');
});
};
function detectProductType(productHandle) {
const handle = productHandle.toLowerCase();
if (handle.includes('chaussette') || handle.includes('sock')) return 'accessory';
if (handle.includes('bonnet') || handle.includes('beanie')) return 'accessory';
if (handle.includes('casquette') || handle.includes('cap') || handle.includes('snapback')) return 'cap';
if (handle.includes('sac') || handle.includes('bag') || handle.includes('tote')) return 'bag';
if (handle.includes('shirt') || handle.includes('tee')) return 'front';
if (handle.includes('sweat') || handle.includes('hoodie')) return 'front';
if (handle.includes('polo')) return 'front';
if (handle.includes('veste') || handle.includes('jacket')) return 'front';
return 'front';
}
async function exportUniversalDesign() {
try {
if (!window.currentProduct) {
throw new Error('Veuillez sélectionner un produit');
}
const productHandle = window.currentProduct.handle;
const productType = detectProductType(productHandle);
const currentView = window.currentView || 'front';
const zoneKey = (productType === 'accessory' || productType === 'cap' || productType === 'bag')
? productType
: currentView;
const zone = UNIVERSAL_ZONES[zoneKey];
if (!zone) {
throw new Error('Configuration de zone introuvable');
}
if (!window.canvas) {
throw new Error('Canvas non initialisé');
}
const designDataURL = window.canvas.toDataURL({
format: 'png',
quality: 1,
multiplier: 2
});
const payload = {
design: designDataURL,
zone: {
x: zone.designZoneX,
y: zone.designZoneY,
width: zone.designZoneWidth,
height: zone.designZoneHeight,
productWidth: zone.productWidth,
productHeight: zone.productHeight
},
product: {
handle: productHandle,
type: productType,
title: window.currentProduct.title
},
view: currentView,
technique: window.currentTechnique || 'impression',
timestamp: Date.now()
};
const response = await fetch('https://customizer.oazar-shop.com/render_mockup.php', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify(payload)
});
if (!response.ok) {
throw new Error(`Erreur serveur: ${response.status}`);
}
const result = await response.json();
if (result.success) {
return {
mockup: result.mockup_url,
design: result.design_url,
productType: productType
};
} else {
throw new Error(result.error || 'Erreur inconnue');
}
} catch (error) {
alert('Erreur lors de la génération du mockup: ' + error.message);
return null;
}
}
let currentProduct = null;
/* Le pont des anciennes fiches attend ce signal avant d'ouvrir le modèle.
   Cela évite qu'un changement de produit efface le SVG juste après son ajout. */
window.__ozCustomizerProductReady = false;
let currentView = 'front';
let selectedVariantId = null;
let currentTechnique = 'impression';
let productsData = {};
let sizeGuidesData = {};
let designLibrary = { categories: [] };
let sizeQuantities = {};
let variantBySize = {};
let currentZoom = 100;
let canvasOffset = { x: 0, y: 0 };
let selectedItem = null;
let toolsLockIsLocked = false;
const HISTORY_MAX = 50;
const HISTORY = {
past:   { front: [], back: [], left: [], right: [] },
future: { front: [], back: [], left: [], right: [] },
restoring: false
};
const historyTimers = Object.create(null);
function genUid() {
return 'di_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
}
function ensureUid(el) {
if (el && !el.dataset.uid) el.dataset.uid = genUid();
}
function getViewNameFromElement(el) {
return el?.closest?.('.product-view')?.dataset?.view || currentView || 'front';
}
function snapshotView(viewName) {
const area = document.querySelector(`.design-area[data-area="${viewName}"]`);
if (!area) return { items: [], selectedUid: null };
const items = Array.from(area.querySelectorAll('.design-item')).map(el => {
ensureUid(el);
const type = el.dataset.type || '';
const angle = el.dataset.angle || '0';
const locked = el.dataset.locked === '1';
const snap = {
uid: el.dataset.uid,
type,
left: el.style.left || '0px',
top: el.style.top || '0px',
width: el.style.width || (el.offsetWidth + 'px'),
height: el.style.height || (el.offsetHeight + 'px'),
angle,
locked
};
if (el.dataset.ozIncludedInBase === 'true') snap.ozIncludedInBase = true;
if (el.dataset.templateId) snap.templateId = el.dataset.templateId;
if (el.dataset.templateKey) snap.templateKey = el.dataset.templateKey;
if (el.dataset.templateTitle) snap.templateTitle = el.dataset.templateTitle;
if (el.dataset.templateKind) snap.templateKind = el.dataset.templateKind;
if (type === 'image') {
const img = el.querySelector('img');
snap.src = img?.src || '';
snap.originalSrc = img?.dataset?.originalSrc || '';
snap.originalName = img?.dataset?.originalName || '';
snap.remoteOriginalSrc = img?.dataset?.remoteOriginalSrc || '';
snap.clientImagePath = img?.dataset?.clientImagePath || '';
snap.clientImageSrc = img?.dataset?.clientImageSrc || '';
snap.inlineSrc = img?.dataset?.inlineSrc || '';
snap.originalRatio = el.dataset.originalRatio || '';
snap.patchConfig = img?.dataset?.ozPatchConfig || '';
snap.patchSource = img?.dataset?.ozPatchSource || '';
snap.patchSourceName = img?.dataset?.ozPatchSourceName || '';
snap.visualOrigin = img?.dataset?.ozVisualOrigin || '';
snap.embroiderySourceUrl = img?.dataset?.ozEmbroiderySourceUrl || '';
snap.embroiderySourceName = img?.dataset?.ozEmbroiderySourceName || '';
snap.embroideredPreview = img?.dataset?.embroideredPreview || '';
} else {
const contentEl = el.querySelector('.di-content');
snap.html = contentEl ? contentEl.innerHTML : '';
}
return snap;
});
return {
items,
selectedUid: selectedItem?.dataset?.uid || null,
areaWidth: area.clientWidth || area.offsetWidth || 0,
areaHeight: area.clientHeight || area.offsetHeight || 0
};
}
function pushHistory(viewName) {
if (HISTORY.restoring) return;
const snap = snapshotView(viewName);
const key = JSON.stringify(snap);
const stack = HISTORY.past[viewName] || (HISTORY.past[viewName] = []);
const last = stack[stack.length - 1];
if (last?.key === key) return;
stack.push({ key, snap });
if (stack.length > HISTORY_MAX) stack.shift();
HISTORY.future[viewName] = [];
updateUndoRedoUI();
}
function pushHistoryDebounced(viewName, delay = 250) {
clearTimeout(historyTimers[viewName]);
historyTimers[viewName] = setTimeout(() => pushHistory(viewName), delay);
}
function isBlobUrlReferencedInHistory(url) {
  try {
    const views = ['front', 'back', 'left', 'right'];
    for (const v of views) {
      const stacks = []
        .concat(HISTORY.past?.[v] || [])
        .concat(HISTORY.future?.[v] || []);
      for (const entry of stacks) {
        const items = entry?.snap?.items || [];
        for (const it of items) {
          if (it && (it.src === url || it.originalSrc === url || it.patchSource === url)) return true;
        }
      }
    }
  } catch (e) {}
  return false;
}
function buildItemFromData(data) {
const el = document.createElement('div');
el.className = 'design-item';
el.dataset.uid = data.uid || genUid();
el.dataset.type = data.type || '';
el.dataset.angle = data.angle || '0';
el.dataset.locked = data.locked ? '1' : '0';
if (data.ozIncludedInBase) el.dataset.ozIncludedInBase = 'true';
if (data.templateId) el.dataset.templateId = data.templateId;
if (data.templateKey) el.dataset.templateKey = data.templateKey;
if (data.templateTitle) el.dataset.templateTitle = data.templateTitle;
if (data.templateKind) el.dataset.templateKind = data.templateKind;
if (data.originalRatio) el.dataset.originalRatio = data.originalRatio;
el.style.left = data.left || '0px';
el.style.top = data.top || '0px';
el.style.width = data.width || '200px';
el.style.height = data.height || '200px';
el.style.transform = `rotate(${parseFloat(data.angle || 0)}deg)`;
const contentEl = document.createElement('div');
contentEl.className = 'di-content';
if ((data.type || '') === 'image') {
const img = document.createElement('img');
img.src = data.src || data.originalSrc || '';
img.dataset.originalSrc = data.originalSrc || data.src || '';
if (data.originalName) img.dataset.originalName = data.originalName;
if (data.remoteOriginalSrc) img.dataset.remoteOriginalSrc = data.remoteOriginalSrc;
if (data.clientImagePath) img.dataset.clientImagePath = data.clientImagePath;
if (data.clientImageSrc) img.dataset.clientImageSrc = data.clientImageSrc;
if (data.inlineSrc) img.dataset.inlineSrc = data.inlineSrc;
if (data.patchConfig) img.dataset.ozPatchConfig = data.patchConfig;
if (data.patchSource) img.dataset.ozPatchSource = data.patchSource;
if (data.patchSourceName) img.dataset.ozPatchSourceName = data.patchSourceName;
if (data.visualOrigin) img.dataset.ozVisualOrigin = data.visualOrigin;
if (data.embroiderySourceUrl) img.dataset.ozEmbroiderySourceUrl = data.embroiderySourceUrl;
if (data.embroiderySourceName) img.dataset.ozEmbroiderySourceName = data.embroiderySourceName;
if (data.embroideredPreview) img.dataset.embroideredPreview = data.embroideredPreview;
img.alt = 'Design personnalisé';
img.draggable = false;
contentEl.appendChild(img);
} else {
contentEl.innerHTML = data.html || '';
}
el.appendChild(contentEl);
return el;
}
function restoreSnapshot(viewName, snap) {
const area = document.querySelector(`.design-area[data-area="${viewName}"]`);
if (!area) return;
HISTORY.restoring = true;
try {
area.innerHTML = '';
if (designLayers && designLayers[viewName]) {
designLayers[viewName] = [];
}
const snapshotItems = window.currentProduct?.patch ? (viewName === 'front' ? snap.items.filter(data => data.type === 'image' && ['import','ai'].includes(data.visualOrigin || 'import')).slice(-1) : []) : snap.items;
snapshotItems.forEach(data => {
const el = buildItemFromData(data);
area.appendChild(el);
// Saved positions refer to the saved zone size, not to the visitor's viewport.
const ratioX = snap.areaWidth > 0 && area.clientWidth > 0 ? area.clientWidth / snap.areaWidth : 1;
const ratioY = snap.areaHeight > 0 && area.clientHeight > 0 ? area.clientHeight / snap.areaHeight : 1;
if (Math.abs(ratioX - 1) > .001 || Math.abs(ratioY - 1) > .001) {
  [['left',ratioX],['top',ratioY],['width',ratioX],['height',ratioY]].forEach(function(entry) {
    const value = Number.parseFloat(el.style[entry[0]]);
    if (Number.isFinite(value)) el.style[entry[0]] = (value * entry[1]) + 'px';
  });
  const text = el.dataset.type === 'text' && el.querySelector('.di-content > div');
  if (text) text.style.fontSize = (Number.parseFloat(getComputedStyle(text).fontSize) * Math.min(ratioX,ratioY)) + 'px';
}
if (designLayers && designLayers[viewName]) designLayers[viewName].push(el);
if (typeof makeInteractive === 'function') makeInteractive(el);
if (typeof updateLockOnElement === 'function') updateLockOnElement(el, !!data.locked);
if (typeof updateOverflowState === 'function') updateOverflowState(el);
});
if (snap.selectedUid) {
const found = (designLayers?.[viewName] || []).find(x => x.dataset.uid === snap.selectedUid);
if (found && typeof selectItem === 'function') selectItem(found);
else if (typeof deselectAll === 'function') deselectAll();
} else {
if (typeof deselectAll === 'function') deselectAll();
}
if (typeof updateDesignLayers === 'function') updateDesignLayers();
if (typeof saveDesignToLocalStorage === 'function') saveDesignToLocalStorage();
if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
} finally {
HISTORY.restoring = false;
updateUndoRedoUI();
}
}
function undo() {
const v = currentView || 'front';
const past = HISTORY.past[v];
if (!past || past.length <= 1) return;
const current = past.pop();
HISTORY.future[v].push(current);
const prev = past[past.length - 1];
restoreSnapshot(v, prev.snap);
}
function redo() {
const v = currentView || 'front';
const fut = HISTORY.future[v];
if (!fut || fut.length === 0) return;
const next = fut.pop();
HISTORY.past[v].push(next);
restoreSnapshot(v, next.snap);
}
function updateUndoRedoUI() {
const v = currentView || 'front';
const undoBtn = document.getElementById('undoBtn');
const redoBtn = document.getElementById('redoBtn');
if (undoBtn) undoBtn.disabled = !(HISTORY.past[v] && HISTORY.past[v].length > 1);
if (redoBtn) redoBtn.disabled = !(HISTORY.future[v] && HISTORY.future[v].length > 0);
}
function initUndoRedo() {
const undoBtn = document.getElementById('undoBtn');
const redoBtn = document.getElementById('redoBtn');
if (undoBtn) undoBtn.addEventListener('click', undo);
if (redoBtn) redoBtn.addEventListener('click', redo);
['front', 'back', 'left', 'right'].forEach(v => {
HISTORY.past[v] = [];
HISTORY.future[v] = [];
pushHistory(v);
});
updateUndoRedoUI();
}
let lockButtonWasClicked = false;
function oazarStudioIcon(name) {
  if (['product', 'importer', 'texte', 'designs', 'ia'].includes(name)) return oazarProvidedIcon(name);
  const paths = {
    copy: '<path d="M7 4h10l3 3v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 1-2Z"/><path d="M17 4v4h4M3 8v12a2 2 0 0 0 2 2h10M13 11v6m-3-3h6"/>',
    lock: '<path d="M12 2 5 5v6c0 5 3 8 7 11 4-3 7-6 7-11V5l-7-3Z"/><rect x="9" y="11" width="6" height="5" rx="1"/><path d="M10 11V9a2 2 0 0 1 4 0v2"/>',
    unlock: '<path d="M12 2 5 5v6c0 5 3 8 7 11 4-3 7-6 7-11V5l-7-3Z"/><rect x="9" y="11" width="6" height="5" rx="1"/><path d="M10 11V9a2 2 0 0 1 4 0"/>',
    trash: '<path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5"/>',
    left: '<path d="M5 3v18M10 7h9M10 12h6M10 17h9"/>',
    centerH: '<path d="M12 3v18M5 7h14M8 12h8M5 17h14"/>',
    right: '<path d="M19 3v18M5 7h9M8 12h6M5 17h9"/>',
    top: '<path d="M3 5h18M7 10v9m5-9v6m5-6v9"/>',
    centerV: '<path d="M3 12h18M7 5v14m5-11v8m5-11v14"/>',
    bottom: '<path d="M3 19h18M7 5v9m5-6v6m5-9v9"/>',
    edit: '<path d="m4 20 4.5-1 10-10a2.1 2.1 0 0 0-3-3l-10 10L4 20Zm9.5-11.5 3 3"/>',
    check: '<path d="m5 12 4.5 4.5L19 7"/>',
    back: '<path d="m14 5-7 7 7 7M7 12h14"/>',
    close: '<path d="M5 5l14 14M19 5 5 19"/>',
    image: '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m4 17 5-5 4 4 3-3 4 4"/>',
    text: '<path d="M4 5V3h16v2M12 4v16m-4 0h8"/><path d="M2 2h2v2H2zM20 2h2v2h-2zM2 20h2v2H2zM20 20h2v2h-2z"/>',
    design: '<path d="m12 2 1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8L12 2Zm7 14 .7 2.3L22 19l-2.3.7L19 22l-.7-2.3L16 19l2.3-.7L19 16Z"/>',
    print: '<rect x="5" y="3" width="14" height="5" rx="1"/><path d="M5 17H3V9h18v8h-2M6 15h12v6H6zM17 11h1"/>',
    needle: '<path d="M20 3 8 15m10-10 2 2M5 16l3 3m-3-3-2 5 5-2M10 5c-2 2-2 4 0 6"/>'
    ,product: '<path d="m8 4-5 3 2 5 3-1v10h8V11l3 1 2-5-5-3c0 4-8 4-8 0Z"/>'
    ,palette: '<circle cx="7" cy="6" r="3"/><circle cx="17" cy="6" r="3"/><circle cx="7" cy="17" r="3"/><path d="M14 15h6v5h-6z"/>'
    ,upload: '<path d="M6.5 18.5H5a3.5 3.5 0 0 1-.4-7A7.5 7.5 0 0 1 19 9.5a4.5 4.5 0 0 1 .5 9H18"/><path d="M12 21V11m-4 4 4-4 4 4"/>'
    ,gallery: '<rect x="5" y="6" width="16" height="15" rx="2"/><path d="M2 17V5a2 2 0 0 1 2-2h13"/><circle cx="10" cy="11" r="1"/><path d="m7 18 4-4 2.5 2.5 2-2 3.5 3.5"/>'
    ,rotate: '<path d="M6 8a7 7 0 1 1-1 7M3 4v5h5"/><circle cx="12" cy="12" r="1"/>'
    ,resize: '<path d="M4 9V4h5m6 16h5v-5M4 4l6 6m10 10-6-6"/>'
  };
  return '<svg class="oz-studio-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (paths[name] || paths.edit) + '</svg>';
}
function oazarProvidedIcon(name) {
  const url = document.getElementById('mon-customizer')?.getAttribute('data-icon-' + name);
  return url ? '<img class="oz-provided-icon" src="' + url + '" alt="" aria-hidden="true">' : '';
}
window.oazarProvidedIcon = oazarProvidedIcon;
function oazarStudioColorName(value) {
  const color = String(value || '').toLowerCase();
  return ({ '#000000': 'Noir', '#111111': 'Noir', '#ffffff': 'Blanc', '#0b3262': 'Bleu marine', '#e63b42': 'Rouge', '#2363d9': 'Bleu roi', '#168b62': 'Vert' })[color] || color.toUpperCase();
}
const OAZAR_STUDIO_PALETTE = [
  ['Noir', '#000000'], ['Blanc', '#ffffff'], ['Gris', '#777777'],
  ['Rouge', '#e63b42'], ['Orange', '#ef8d32'], ['Jaune', '#f4c430'],
  ['Vert', '#168b62'], ['Bleu roi', '#2363d9'], ['Bleu marine', '#0b3262'],
  ['Rose', '#dc6f9b'], ['Violet', '#7856a5'], ['Marron', '#795548']
];
function oazarStudioColorInk(value) {
  const match = /^#([0-9a-f]{6})$/i.exec(String(value || ''));
  if (!match) return '#ffffff';
  const rgb = [0, 2, 4].map(function(index) { return parseInt(match[1].slice(index, index + 2), 16) / 255; });
  const luminance = rgb.map(function(channel) { return channel <= .04045 ? channel / 12.92 : Math.pow((channel + .055) / 1.055, 2.4); });
  return .2126 * luminance[0] + .7152 * luminance[1] + .0722 * luminance[2] > .45 ? '#171717' : '#ffffff';
}
// Secours local quand le serveur d'illustration refuse l'envoi de la photo.
window.oazarCreateLocalIllustration = function (blob) {
  return new Promise(function (resolve, reject) {
    if (!(blob instanceof Blob)) return reject(new Error('Photo indisponible.'));
    var objectUrl = URL.createObjectURL(blob);
    var photo = new Image();
    photo.onload = function () {
      try {
        var side = Math.min(1, 1000 / Math.max(photo.naturalWidth, photo.naturalHeight));
        var width = Math.max(1, Math.round(photo.naturalWidth * side));
        var height = Math.max(1, Math.round(photo.naturalHeight * side));
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        var context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) throw new Error('Aperçu indisponible.');
        context.drawImage(photo, 0, 0, width, height);
        var frame = context.getImageData(0, 0, width, height);
        var pixels = frame.data;
        var source = new Uint8ClampedArray(pixels);
        for (var y = 0; y < height; y++) {
          for (var x = 0; x < width; x++) {
            var p = (y * width + x) * 4;
            var right = (y * width + Math.min(x + 1, width - 1)) * 4;
            var below = (Math.min(y + 1, height - 1) * width + x) * 4;
            var edge = Math.abs(source[p] - source[right]) + Math.abs(source[p + 1] - source[right + 1]) +
              Math.abs(source[p + 2] - source[right + 2]) + Math.abs(source[p] - source[below]) +
              Math.abs(source[p + 1] - source[below + 1]) + Math.abs(source[p + 2] - source[below + 2]);
            var shade = edge > 145 ? 0.82 : 1;
            for (var channel = 0; channel < 3; channel++) {
              var value = source[p + channel];
              pixels[p + channel] = Math.max(0, Math.min(255, Math.round((value * .9 + 13) / 32) * 32 * shade));
            }
          }
        }
        context.putImageData(frame, 0, 0);
        resolve({ url: canvas.toDataURL('image/png'), name: 'illustration-locale.png', local: true });
      } catch (error) { reject(error); }
      finally { URL.revokeObjectURL(objectUrl); }
    };
    photo.onerror = function () {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Photo illisible.'));
    };
    photo.src = objectUrl;
  });
};
function applyOazarStudioActionIcons() {
  const targets = [
    ['#openImageDrawer .action-icon', 'importer'], ['#openTextDrawer .action-icon', 'texte'],
    ['#openDesignsDrawer .action-icon', 'designs'], ['#openAiDrawer .action-icon', 'ia'], ['#techniqueImpression .technique-icon', 'print'],
    ['#techniqueBroderie .technique-icon', 'needle'],
    ['#mobileTechniqueImpression .card-icon', 'print'], ['#mobileTechniqueBroderie .card-icon', 'needle']
  ];
  targets.forEach(function(entry) {
    const target = document.querySelector(entry[0]);
    if (target) target.innerHTML = oazarStudioIcon(entry[1]);
  });
  [['drawerBack', 'back'], ['closeDrawer', 'close'], ['designFullBack', 'back'], ['designFullClose', 'close']].forEach(function(entry) {
    const button = document.getElementById(entry[0]);
    if (button) button.innerHTML = oazarStudioIcon(entry[1]);
  });
  const pickerClose = document.querySelector('#productPicker .picker-close');
  if (pickerClose) pickerClose.innerHTML = oazarStudioIcon('close');
  [['mobileProductBtn', 'product'], ['mobileColorBtn', 'palette'], ['mobileImageBtn', 'importer'], ['mobileTextBtn', 'texte'], ['mobileDesignsBtn', 'designs'], ['mobileNoteBtn', 'edit']].forEach(function(entry) {
    const oldIcon = document.querySelector('#' + entry[0] + ' svg');
    if (oldIcon) oldIcon.outerHTML = oazarStudioIcon(entry[1]);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyOazarStudioActionIcons);
else applyOazarStudioActionIcons();
function resetHistoryForAllViews() {
  ['front', 'back', 'left', 'right'].forEach(v => {
    HISTORY.past[v] = [];
    HISTORY.future[v] = [];
    pushHistory(v); 
  });
  updateUndoRedoUI();
}
function syncToolsLockButtons() {
document.querySelectorAll('[data-action="lock"]').forEach(btn => {
btn.innerHTML = oazarStudioIcon(toolsLockIsLocked ? 'lock' : 'unlock');
btn.setAttribute('aria-label', toolsLockIsLocked ? 'Déverrouiller' : 'Verrouiller');
btn.setAttribute('aria-pressed', toolsLockIsLocked ? 'true' : 'false');
});
}
let designNote = '';
let drawerMode = 'import';
/* Ecrans traverses depuis l'ouverture du tiroir. Le bouton retour depile,
   au lieu de renvoyer systematiquement vers l'ecran d'import. */
let drawerHistory = [];
let drawerJustOpened = false;
let zonesConfig = {};
let categoriesConfig = { categories: [] };
let productsCache = [];
let currentFilter = 'all';
let currentSearchQuery = '';
let currentPickerTechnique = 'all';
let currentPickerSort = 'recommended';
const SNAP_TOL = 10;
const designLayers = { front: [], back: [], left: [], right: [] };
const BASE_UNIT_PRICE_FALLBACK = 8.15;
const pricingProductHandles = window.pricingProductHandles || {};
const pricingVariantCache = {};
function fetchVariantId(handle) {
if (!handle) return Promise.resolve(null);
if (pricingVariantCache[handle]) {
return Promise.resolve(pricingVariantCache[handle]);
}
return fetch('/products/' + handle + '.js')
.then(function (res) {
if (!res.ok) throw new Error('Produit introuvable: ' + handle);
return res.json();
})
.then(function (product) {
const variant = product && product.variants && product.variants[0];
const id = variant ? variant.id : null;
pricingVariantCache[handle] = id;
return id;
})
.catch(function (err) {
if (typeof window.hideCustomizerCartLoader === 'function') window.hideCustomizerCartLoader();
return null;
});
}
function parsePriceToNumber(priceStr) {
if (typeof priceStr !== 'string') return NaN;
let cleaned = priceStr.replace(/[^0-9,.\-]/g, '');
if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) cleaned = cleaned.replace(/\./g, '').replace(',', '.');
else cleaned = cleaned.replace(/,/g, '');
return parseFloat(cleaned);
}
const VD_TIERS = [
{ min: 5, pct: 5 },
{ min: 10, pct: 7 },
{ min: 20, pct: 10 },
{ min: 50, pct: 20 },
{ min: 100, pct: 25 },
{ min: 200, pct: 30 },
{ min: 500, pct: 35 },
{ min: 1000, pct: 40 }
].sort((a,b) => a.min - b.min);
function vdGetTier(qty){
let t = null;
for (const tier of VD_TIERS) {
if (qty >= tier.min) t = tier;
}
return t;
}
function vdGetPercent(qty){
if (window.currentProduct?.patch?.pricing) return 0;
const t = vdGetTier(qty);
return t ? t.pct : 0;
}
function vdGetNextTier(qty){
for (const tier of VD_TIERS) {
if (qty < tier.min) return tier;
}
return null;
}
function vdIsActive(qty){
return vdGetPercent(qty) > 0;
}
function getBaseUnitPrice() {
const patchVariant = getPatchPricingVariant();
if (patchVariant) return typeof patchVariant.price === 'number' ? patchVariant.price / 100 : parsePriceToNumber(patchVariant.price);
let price = BASE_UNIT_PRICE_FALLBACK;
try {
// Tarif standard : le prix de base est toujours celui du vêtement sélectionné.
// Les modèles SVG ne remplacent plus le prix du produit de base.
if (window.currentProduct && typeof window.currentProduct.price === 'number') {
price = window.currentProduct.price / 100;
} else {
const priceEl = document.querySelector(
'.product-info [data-product-price]'
);
let pStr = priceEl ? (priceEl.textContent || '') : '';
if (!pStr && window.currentProduct && window.currentProduct.price) {
pStr = window.currentProduct.price;
}
if (pStr) {
const parsed = parsePriceToNumber(pStr);
if (!isNaN(parsed)) {
price = parsed;
}
}
}
} catch (e) {
}
return price;
}
function getPatchPricingVariant(config) {
  const product = window.currentProduct;
  if (!product?.patch?.pricing?.bands || !Array.isArray(product.variants)) return null;
  if (!config) { try { config = JSON.parse(document.querySelector('#mon-customizer .design-area img[data-oz-patch-config]')?.dataset.ozPatchConfig || 'null'); } catch (_) {} }
  if (!config) config = window.OazarPatchStudio?.getConfig?.() || {width_cm:7,height_cm:7,shape:'round'};
  if (!config) return null;
  const area = Number((Number(config.width_cm) * Number(config.height_cm)).toFixed(4));
  const band = product.patch.pricing.bands.find(item => area > 0 && area <= item.max_area_cm2);
  return band ? product.variants.find(variant => variant.option2 === band.size && variant.available) || null : null;
}
function syncPatchPricingSize() {
  const variant = getPatchPricingVariant();
  if (!variant) return;
  const quantity = Object.values(sizeQuantities || {}).reduce((sum,value)=>sum+(parseInt(value,10)||0),0);
  const size = ozNormalizeSizeLabel(variant.option2);
  variantBySize = { [size]:variant.id }; window.variantBySize = variantBySize;
  sizeQuantities = { [size]:quantity }; window.sizeQuantities = sizeQuantities;
  const sizesList = document.getElementById('availableSizesList');
  if (sizesList) { const config=window.OazarPatchStudio?.getConfig?.();const pill = document.createElement('span');pill.className='studio-size-pill';pill.dataset.ozPatchSize='1';pill.textContent=config?config.width_cm+' × '+config.height_cm+' cm':'Dimensions choisies';sizesList.replaceChildren(pill); }
  updateSizeSummary();updateSelectSizesButton();
  if (typeof updatePriceLiveBlock === 'function') updatePriceLiveBlock();
}
document.addEventListener('oazar:patch-updated',syncPatchPricingSize);
function getTotalQty() {
return Object.values(sizeQuantities || {}).reduce(function (sum, qty) {
return sum + (parseInt(qty) || 0);
}, 0);
}
function getDesignCounts() {
const counts = { image: 0, text: 0 };
const views = ['front', 'back', 'left', 'right'];
views.forEach((view) => {
const area =
document.querySelector(`.design-area[data-area="${view}"]`) ||
document.querySelector(`.product-view[data-view="${view}"] .design-area`) ||
document.querySelector(`#view-${view} .design-area`) ||
document.querySelector(`#${view} .design-area`);
if (!area) return;
area.querySelectorAll('.design-item').forEach((el) => {
const t = el?.dataset?.type;
if (t === 'image') counts.image++;
if (t === 'text') counts.text++;
});
});
return counts;
}
function getTierKeyForQty(totalQty) {
if (totalQty >= 8) return '8_plus';
if (totalQty >= 4) return '4_7';
if (totalQty >= 1) return '1_3';
return null;
}

function ozGetDimensionVariantId(technique, kind, tierName) {
  try {
    return (
      window.pricingDimensions &&
      window.pricingDimensions[technique] &&
      window.pricingDimensions[technique][kind] &&
      window.pricingDimensions[technique][kind][tierName]
    ) || 0;
  } catch (e) { return 0; }
}

function ozGetDimensionPriceCents(technique, kind, tierName) {
  try {
    return (
      window.pricingDimensionPrices &&
      window.pricingDimensionPrices[technique] &&
      window.pricingDimensionPrices[technique][kind] &&
      window.pricingDimensionPrices[technique][kind][tierName]
    ) || 0;
  } catch (e) { return 0; }
}

function ozGetAllDesignItems() {
  const views = ['front','back','left','right'];
  const out = [];
  views.forEach((view) => {
    const area = document.querySelector(`.product-view[data-view="${view}"] .design-area[data-area="${view}"]`)
      || document.querySelector(`.product-view[data-view="${view}"] .design-area`);
    if (!area) return;
    area.querySelectorAll('.design-item').forEach((item) => out.push({ view, area, item }));
  });
  return out;
}

function ozIsIncludedSourceSvgItem(item) {
  if (!item || !window.__ozSourceSvgProduct) return false;
  if (item.dataset.ozIncludedInBase === 'true') return true;

  const templateKind = String(item.dataset.templateKind || '').toLowerCase();
  if (templateKind === 'smart-svg') return true;

  const hasTemplateIdentity = !!(item.dataset.templateId || item.dataset.templateKey);
  const image = item.querySelector && item.querySelector('img');
  const originalName = String(image?.dataset?.originalName || '').toLowerCase();
  return hasTemplateIdentity && /\.svg(?:$|[?#])/.test(originalName);
}


function getPricePerMarking(technique, kind, count) {
if (!count || count <= 0) return 0;
if (technique === 'impression') {
if (kind === 'image') {
if (count >= 8) return 3.5;
if (count >= 4) return 4;
return 5;
}
if (kind === 'text') {
if (count >= 8) return 2;
if (count >= 4) return 2.5;
return 3;
}
}
if (technique === 'broderie') {
if (kind === 'image') {
if (count >= 8) return 6.5;
if (count >= 4) return 7;
return 8;
}
if (kind === 'text') {
if (count >= 8) return 5.5;
if (count >= 4) return 6;
return 7;
}
}
return 0;
}
/* ═══════════════════════════════════════════════════
   PRICING PAR DIMENSION — Paliers S/M/L/XL (mieux calibrés)
   - Image : on se base sur la + grande dimension (pctMax)
   - Texte : on se base sur la surface (pctArea) => plus logique pour une ligne de texte
   - Seuils différents pour Impression / Broderie
   ═══════════════════════════════════════════════════ */

const SIZE_TIER_RULES = {
  // Image  : S≤30% M≤55% L≤80% XL≤100% (scale 0.25/0.5/0.75/1.0 de la zone)
  // Texte  : S=5% M=9% L=14% XL=20% de areaW → pctMax calibré
  impression: {
    image: [
      { name: 'S',  maxPercent: 30,  multiplier: 0.7 },
      { name: 'M',  maxPercent: 55,  multiplier: 1.0 },
      { name: 'L',  maxPercent: 80,  multiplier: 1.4 },
      { name: 'XL', maxPercent: 100, multiplier: 1.8 }
    ],
    text: [
      { name: 'S',  maxPercent: 8,   multiplier: 0.7 },
      { name: 'M',  maxPercent: 18,  multiplier: 1.0 },
      { name: 'L',  maxPercent: 35,  multiplier: 1.4 },
      { name: 'XL', maxPercent: 100, multiplier: 1.8 }
    ]
  },
  broderie: {
    image: [
      { name: 'S',  maxPercent: 30,  multiplier: 0.7 },
      { name: 'M',  maxPercent: 55,  multiplier: 1.0 },
      { name: 'L',  maxPercent: 80,  multiplier: 1.4 },
      { name: 'XL', maxPercent: 100, multiplier: 1.8 }
    ],
    text: [
      { name: 'S',  maxPercent: 8,   multiplier: 0.7 },
      { name: 'M',  maxPercent: 18,  multiplier: 1.0 },
      { name: 'L',  maxPercent: 35,  multiplier: 1.4 },
      { name: 'XL', maxPercent: 100, multiplier: 1.8 }
    ]
  }
};

function getCurrentTechniqueSafe() {
  const t = String(window.currentTechnique || 'impression').toLowerCase();
  return (t === 'broderie') ? 'broderie' : 'impression';
}

function getItemKindSafe(item) {
  const raw = String(item?.dataset?.type || '').toLowerCase();
  return (raw === 'text' || raw === 'i-text') ? 'text' : 'image';
}

function getItemSizeMetrics(item, kind = getItemKindSafe(item)) {
  let area = (item && item.closest) ? item.closest('.design-area') : null;
  if (!area && item) {
    area = item.closest?.('[data-area]') || item.closest?.('.product-view')?.querySelector?.('.design-area') || null;
  }
  if (!area) return { pctW: 30, pctH: 30, pctMax: 30, pctArea: 10 };

  // ✅ TEXTE = on mesure la box orange (.design-item)
  // ✅ IMAGE = on mesure le contenu si possible
  let contentEl = item;
  if (kind !== 'text') {
    contentEl =
      item.querySelector('img') ||
      item.querySelector('canvas') ||
      item.querySelector('svg') ||
      item.querySelector('.di-content') ||
      item.querySelector('.text-content') ||
      item;
  }

  const areaRect = area.getBoundingClientRect();
  const itemRect = contentEl.getBoundingClientRect();

  let areaW = areaRect.width || area.clientWidth || area.offsetWidth || 0;
  let areaH = areaRect.height || area.clientHeight || area.offsetHeight || 0;

  // Fallback si l'area est cachée (vue non active) : lire depuis le style inline
  if (areaW === 0) {
    const sw = parseFloat(area.style.width) || 0;
    areaW = sw > 0 ? sw : 170; // 170px = valeur par défaut raisonnable
  }
  if (areaH === 0) {
    const sh = parseFloat(area.style.height) || 0;
    areaH = sh > 0 ? sh : 200;
  }

  let itemW = itemRect.width || contentEl.clientWidth || contentEl.offsetWidth || 0;
  let itemH = itemRect.height || contentEl.clientHeight || contentEl.offsetHeight || 0;

  // Fallback si l'item est caché : lire depuis le style inline (défini lors du placement)
  if (itemW === 0) {
    const sw = parseFloat((contentEl.style && contentEl.style.width) || (item.style && item.style.width)) || 0;
    itemW = sw;
  }
  if (itemH === 0) {
    const sh = parseFloat((contentEl.style && contentEl.style.height) || (item.style && item.style.height)) || 0;
    itemH = sh;
  }

  // Si toujours 0 après fallback style, utiliser les data-attributes si présents
  if (itemW === 0) itemW = parseFloat(item.dataset.w || item.dataset.width || 0);
  if (itemH === 0) itemH = parseFloat(item.dataset.h || item.dataset.height || 0);

  const pctW = areaW > 0 ? (itemW / areaW) * 100 : 30;
  const pctH = areaH > 0 ? (itemH / areaH) * 100 : 30;
  const pctMax = Math.max(pctW, pctH);

  const areaTotal = (areaW * areaH) || 1;
  const areaItem = (itemW * itemH) || 0;
  const pctArea = (areaItem / areaTotal) * 100;

  return { pctW, pctH, pctMax, pctArea };
}

function getItemSizePercent(item, technique = getCurrentTechniqueSafe(), kind = getItemKindSafe(item)) {
  // Image = plus grande dimension (pctMax), Texte = surface (pctArea)
  const m = getItemSizeMetrics(item, kind);
  return (kind === 'text') ? m.pctArea : m.pctMax;
}

function getItemSizeTier(item, technique = getCurrentTechniqueSafe(), kind = getItemKindSafe(item)) {
  const rulesTech = SIZE_TIER_RULES[technique] || SIZE_TIER_RULES.impression;
  const rules = rulesTech[kind] || rulesTech.image;

  const pct = getItemSizePercent(item, technique, kind);
  for (const tier of rules) {
    if (pct <= tier.maxPercent) return tier;
  }
  return rules[rules.length - 1];
}

function getItemSizeLabel(item, technique = getCurrentTechniqueSafe(), kind = getItemKindSafe(item)) {
  const tier = getItemSizeTier(item, technique, kind);
  return String(tier?.name || 'M').toUpperCase();
}

function updateItemSizeBadge(item) {
  if (!item || !item.closest('.design-area')) return;

  const technique = getCurrentTechniqueSafe();
  const kind = getItemKindSafe(item);

  let badge = item.querySelector('.di-size-badge');

  if (!badge) {
    badge = document.createElement('div');
    badge.className = 'di-size-badge';
    item.appendChild(badge);
  }

  const tier = getItemSizeTier(item, technique, kind);
  const metrics = getItemSizeMetrics(item, kind);
  const label = String((tier && tier.name) || 'M').toUpperCase();

  badge.textContent = label;

  if (metrics) {
    const metricTxt = kind === 'text'
      ? `surface ~${Math.round(metrics.pctArea || 0)}%`
      : `max ~${Math.round(metrics.pctMax || 0)}%`;

    badge.title =
      `${kind === 'text' ? 'Texte' : 'Image'} — ` +
      `${technique === 'broderie' ? 'Broderie' : 'Impression'} : ` +
      `${label} (${metricTxt})`;
  }

  /*
   * Le badge suit légèrement la taille du visuel,
   * mais reste lisible et surtout parfaitement centré.
   */
  const itemWidth = item.offsetWidth || parseFloat(item.style.width) || 0;
  const itemHeight = item.offsetHeight || parseFloat(item.style.height) || 0;
  const smallestSide = Math.max(1, Math.min(itemWidth, itemHeight));

  const badgeHeight = Math.max(
    18,
    Math.min(26, smallestSide * 0.12)
  );

  const badgeWidth = label.length > 1
    ? Math.max(badgeHeight * 1.45, 30)
    : Math.max(badgeHeight * 1.15, 24);

  const fontSize = Math.max(
    8,
    Math.min(12, badgeHeight * 0.46)
  );

  badge.style.position = 'absolute';
  badge.style.left = '50%';
  badge.style.top = '0';
  badge.style.transform = 'translate(-50%, -50%)';

  badge.style.display = 'flex';
  badge.style.alignItems = 'center';
  badge.style.justifyContent = 'center';

  badge.style.boxSizing = 'border-box';
  badge.style.width = badgeWidth + 'px';
  badge.style.minWidth = badgeWidth + 'px';
  badge.style.height = badgeHeight + 'px';
  badge.style.padding = '0';

  badge.style.border = '0';
  badge.style.borderRadius = Math.max(5, badgeHeight * 0.28) + 'px';

  badge.style.background = '#171717';
  badge.style.color = '#fff';

  badge.style.fontSize = fontSize + 'px';
  badge.style.fontWeight = '600';
  badge.style.fontFamily = 'Poppins, Arial, sans-serif';
  badge.style.lineHeight = '1';
  badge.style.letterSpacing = '0';
  badge.style.textAlign = 'center';

  badge.style.boxShadow = 'none';
  badge.style.zIndex = '30';
  badge.style.pointerEvents = 'none';
}
function updateAllSizeBadges() {
  document.querySelectorAll('.design-area .design-item').forEach(updateItemSizeBadge);
}

/* ========== MISE À JOUR PRIX LIVE SIDEBAR ========== */
function updatePriceLiveBlock() {
  var block = document.getElementById('priceLiveBlock');
  if (!block) return;

  // Ne montrer que si un produit est sélectionné
  if (!window.currentProduct) {
    block.style.display = 'none';
    return;
  }

  block.style.display = 'block';

  var baseEl    = document.getElementById('priceLiveBase');
  var customEl  = document.getElementById('priceLiveCustom');
  var customRow = document.getElementById('priceLiveCustomRow');
  var totalEl   = document.getElementById('priceLiveTotal');

  var base  = (typeof getBaseUnitPrice === 'function') ? getBaseUnitPrice() : 0;
  var extra = (typeof calculateCustomizationExtraPerUnit === 'function') ? calculateCustomizationExtraPerUnit(1) : 0;

  if (baseEl)  baseEl.textContent  = base.toFixed(2).replace('.', ',') + ' €';

  if (extra > 0) {
    if (customRow) customRow.style.display = 'flex';
    if (customEl) customEl.textContent = '+' + extra.toFixed(2).replace('.', ',') + ' €';
  } else {
    if (customRow) customRow.style.display = 'none';
  }

  var total = base + extra;
  if (totalEl) totalEl.textContent = total.toFixed(2).replace('.', ',') + ' €';
}
window.updatePriceLiveBlock = updatePriceLiveBlock;

var MULTI_DESIGN_DISCOUNT = 0.20;
var MULTI_DESIGN_FROM = 2;

function calculateCustomizationExtraPerUnit(totalQty) {
  if (window.currentProduct?.patch) return 0;
  const technique = String(window.currentTechnique || 'impression').toLowerCase();

  // Même logique que buildCustomizationCartLines() :
  // image/design = supplément image, text/i-text = supplément texte.
  const items = ozGetAllDesignItems()
    .map(x => x.item)
    .filter((it) => {
      if (!it) return false;
      // Tarif standard : un SVG intelligent est facturé comme un design/image normal.
      const type = String(it.dataset.type || '').toLowerCase();
      return type === 'image' || type === 'design' || type === 'text' || type === 'i-text';
    });

  if (!items.length) return 0;

  // Remise multi-design basée sur le nombre total de designs, comme à l'ajout panier.
  const totalDesigns = items.length;
  let extra = 0;

  items.forEach((item) => {
    const raw = String(item.dataset.type || '').toLowerCase();
    const kind = (raw === 'text' || raw === 'i-text') ? 'text' : 'image';
    const tier = getItemSizeTier(item, technique, kind);
    const tierName = (tier && tier.name) ? String(tier.name).toUpperCase() : 'M';

    const isDiscounted = (
      typeof MULTI_DESIGN_FROM !== 'undefined' &&
      typeof MULTI_DESIGN_DISCOUNT !== 'undefined' &&
      MULTI_DESIGN_DISCOUNT > 0 &&
      totalDesigns >= MULTI_DESIGN_FROM
    );

    const remiseTierName = isDiscounted ? (tierName + '-REMISE') : tierName;
    const remisePriceCents = isDiscounted ? ozGetDimensionPriceCents(technique, kind, remiseTierName) : 0;
    const basePriceCents = ozGetDimensionPriceCents(technique, kind, tierName);

    let price;
    if (isDiscounted && remisePriceCents > 0) {
      price = remisePriceCents / 100;
    } else if (basePriceCents > 0) {
      price = basePriceCents / 100;
      if (isDiscounted) price = price * (1 - MULTI_DESIGN_DISCOUNT);
    } else {
      const basePrice = getPricePerMarking(technique, kind, 1);
      price = basePrice * (tier && typeof tier.multiplier === 'number' ? tier.multiplier : 1);
      if (isDiscounted) price = price * (1 - MULTI_DESIGN_DISCOUNT);
    }

    extra += price;
  });

  return extra;
}
function getFinalUnitPrice(totalQty) {
const base  = getBaseUnitPrice();
const extra = calculateCustomizationExtraPerUnit(totalQty);
const pct   = vdGetPercent(totalQty);
const baseDiscounted = (pct > 0) ? (base * (1 - pct / 100)) : base;
return baseDiscounted + extra;
}
function getCanvasZoomScale() {
const canvas = document.getElementById('canvasContent');
if (!canvas) return 1;
const transform = window.getComputedStyle(canvas).transform;
if (!transform || transform === 'none') return 1;
const match = transform.match(/matrix\(([^)]+)\)/);
if (!match) return 1;
const values = match[1].split(',');
const scale = parseFloat(values[0]);
return isNaN(scale) ? 1 : scale;
}
function updateDesignLayers() {
const views = ['front', 'back', 'left', 'right'];
views.forEach(function(viewName) {
const area = document.querySelector(
'.product-view[data-view="' + viewName + '"] .design-area'
);
if (!area) return;
designLayers[viewName] = Array.from(
area.querySelectorAll('.design-item')
);
});
if (typeof updateSizeDrawerTotals === 'function') {
try {
updateSizeDrawerTotals();
} catch (e) {
}
}
}
window.currentProduct = currentProduct;
window.currentView = currentView;
window.currentTechnique = currentTechnique;
window.sizeQuantities = sizeQuantities;
window.variantBySize = variantBySize;
window.designLayers = designLayers;
window.designNote = designNote;
window.selectedItem = selectedItem;
function calculateOptimalImageScale(imgNaturalWidth, imgNaturalHeight, zoneKey = 'front') {
const productType = window.currentProduct ? detectProductType(window.currentProduct.handle) : 'front';
const actualZoneKey = (productType === 'accessory' || productType === 'cap' || productType === 'bag')
? productType
: zoneKey;
const zone = UNIVERSAL_ZONES[actualZoneKey];
if (!zone) {
return 1;
}
const imgRatio = imgNaturalWidth / imgNaturalHeight;
const zoneRatio = zone.maxImageWidth / zone.maxImageHeight;
let fitWidth = zone.maxImageWidth;
let fitHeight = zone.maxImageWidth / imgRatio;
if (fitHeight > zone.maxImageHeight) {
fitHeight = zone.maxImageHeight;
fitWidth = fitHeight * imgRatio;
}
const scale = (fitWidth / imgNaturalWidth) * 100;
return scale;
}
function detectDevice() {
const width = window.innerWidth;
const isMobile = width <= 1024;
document.body.classList.remove('is-mobile', 'is-tablet', 'is-desktop', 'is-touch');
if (width <= 768) {
document.body.classList.add('is-mobile');
} else if (width <= 1024) {
document.body.classList.add('is-tablet');
} else {
document.body.classList.add('is-desktop');
}
if ('ontouchstart' in window) {
document.body.classList.add('is-touch');
}
if (width <= 480) {
currentZoom = 85;
} else if (width <= 768) {
currentZoom = 90;
} else {
currentZoom = 100;
}
const mobileBar = document.getElementById('mobileActionBar');
if (mobileBar) {
mobileBar.style.display = isMobile ? 'grid' : 'none';
}
}
async function captureGlobalPlacement() {
const views = ['front', 'back', 'left', 'right'];
const availableViews = [];
for (const view of views) {
const items = designLayers[view];
if (items && items.length > 0) {
availableViews.push(view);
}
}
if (availableViews.length === 0) {
return null;
}
const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
const thumbWidth = 1050;
const thumbHeight = 1260;
canvas.width = thumbWidth * 2;
canvas.height = thumbHeight * 2;
ctx.clearRect(0, 0, canvas.width, canvas.height);
const positions = {
front: { x: 0, y: 0 },
back: { x: thumbWidth, y: 0 },
left: { x: 0, y: thumbHeight },
right: { x: thumbWidth, y: thumbHeight }
};
for (const view of availableViews) {
try {
const viewCanvas = await captureDesignCanvas(view);
if (!viewCanvas) continue;
const pos = positions[view];
ctx.drawImage(
viewCanvas,
0, 0, viewCanvas.width, viewCanvas.height,
pos.x, pos.y, thumbWidth, thumbHeight
);
ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
ctx.fillRect(pos.x, pos.y, thumbWidth, 60);
ctx.fillStyle = '#ffffff';
ctx.font = 'bold 40px Arial';
ctx.textAlign = 'center';
ctx.textBaseline = 'middle';
const labels = {
front: 'AVANT',
back: 'DOS',
left: 'MANCHE GAUCHE',
right: 'MANCHE DROITE'
};
ctx.fillText(labels[view], pos.x + thumbWidth / 2, pos.y + 30);
} catch (err) {
}
}
return canvas;
}
async function renderDesignItemToCanvas(ctx, item, designArea, scaleX, scaleY, strict) {
  const areaRect = designArea.getBoundingClientRect();
  const itemRect = item.getBoundingClientRect();
  const zoomScale = getCanvasZoomScale();
  const centerXScreen = ((itemRect.left + itemRect.right) / 2 - areaRect.left) / zoomScale;
  const centerYScreen = ((itemRect.top + itemRect.bottom) / 2 - areaRect.top) / zoomScale;
  const baseWidth = item.offsetWidth;
  const baseHeight = item.offsetHeight;
  const width = baseWidth * scaleX;
  const height = baseHeight * scaleY;
  const x = centerXScreen * scaleX;
  const y = centerYScreen * scaleY;
  const angle = parseFloat(item.dataset.angle || 0) || 0;
  const itemType = item.dataset.type;
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate((angle * Math.PI) / 180);
  if (itemType === 'image') {
    const img = item.querySelector('img');
    if (!img) {
      ctx.restore();
      return;
    }
    if (!img.complete || !img.naturalWidth) {
      try {
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
          setTimeout(() => reject(new Error('Timeout')), 5000);
        });
      } catch (e) {}
    }
    const src = img.currentSrc || img.src;
    try {
      const designImg = await loadImageForCanvas(src);
      const imgRatio = designImg.naturalWidth / designImg.naturalHeight;
      const targetRatio = width / height;
      let drawW = width;
      let drawH = height;
      if (imgRatio > targetRatio) {
        drawH = width / imgRatio;
      } else {
        drawW = height * imgRatio;
      }
      ctx.drawImage(designImg, -drawW / 2, -drawH / 2, drawW, drawH);
    } catch (err) {
      ctx.restore();
      if (strict) throw err;
      return;
    }
  } else if (itemType === 'text') {
    const textDiv = item.querySelector('.di-content > div');
    if (!textDiv) {
      ctx.restore();
      return;
    }
    const rawText = (textDiv.innerText || textDiv.textContent || '');
    if (!rawText) {
      ctx.restore();
      return;
    }
    const cs = window.getComputedStyle(textDiv);
    const baseFontSize = parseFloat(cs.fontSize) || 12;
    const fontSize = baseFontSize * scaleX; 
    const rawFontFamily = cs.fontFamily || 'Arial';
    const fontFamily = rawFontFamily.split(',')[0].replace(/['"]/g, '').trim();
    const color = cs.color;
    const fontWeight = cs.fontWeight || 'normal';
    await oazarEnsureFontLoaded(fontFamily, baseFontSize);
    ctx.fillStyle = color;
    ctx.font = `${cs.fontStyle || 'normal'} ${fontWeight} ${fontSize}px ${JSON.stringify(fontFamily)}`;
    ctx.textAlign = 'center'; 
    ctx.textBaseline = 'middle';
    const lineHeight = (parseFloat(cs.lineHeight) || baseFontSize * 1.1) * scaleY;
    const lines = rawText.split(/\r?\n/); 
    const totalTextHeight = lines.length * lineHeight;
    let startY = -(totalTextHeight / 2) + (lineHeight / 2);
    for (let i = 0; i < lines.length; i++) {
      ctx.fillText(lines[i], 0, startY + (i * lineHeight));
    }
  }
  ctx.restore();
}
function getPaintedProductImageRect(productImg) {
  if (!productImg) return null;
  const rect = productImg.getBoundingClientRect();
  const naturalWidth = productImg.naturalWidth;
  const naturalHeight = productImg.naturalHeight;
  if (!rect.width || !rect.height || !naturalWidth || !naturalHeight) return null;
  const fit = (window.getComputedStyle(productImg).objectFit || 'contain').toLowerCase();
  let ratio = 1;
  if (fit === 'contain' || fit === 'scale-down') {
    ratio = Math.min(rect.width / naturalWidth, rect.height / naturalHeight);
    if (fit === 'scale-down') ratio = Math.min(1, ratio);
  } else if (fit === 'cover') {
    ratio = Math.max(rect.width / naturalWidth, rect.height / naturalHeight);
  } else if (fit === 'fill') {
    return { left: rect.left, top: rect.top, width: rect.width, height: rect.height, naturalWidth, naturalHeight };
  } else {
    ratio = Math.min(rect.width / naturalWidth, rect.height / naturalHeight);
  }
  const width = naturalWidth * ratio;
  const height = naturalHeight * ratio;
  return {
    left: rect.left + (rect.width - width) / 2,
    top: rect.top + (rect.height - height) / 2,
    width, height, naturalWidth, naturalHeight
  };
}
async function captureViewWithProduct(viewName, targetWidth, targetHeight, strict) {
  const viewRoot = document.querySelector(`.product-view[data-view="${viewName}"]`);
  const designArea = viewRoot?.querySelector(`.design-area[data-area="${viewName}"]`);
  const imgId = 'productImage' + viewName.charAt(0).toUpperCase() + viewName.slice(1);
  const productImg = viewRoot?.querySelector('#' + imgId);

  if (!viewRoot || !designArea || !productImg || !(productImg.currentSrc || productImg.src)) return null;

  if (typeof productImg.decode === 'function') {
    try { await productImg.decode(); } catch (_) {}
  }

  // force recalcul zone avant capture
  try {
    if (typeof window.applyDesignZoneToDOM === 'function') window.applyDesignZoneToDOM(viewName);
    if (typeof window.refreshAllDesignZones === 'function') window.refreshAllDesignZones();
  } catch(e){}

  const items = designArea.querySelectorAll('.design-item');
  items.forEach(function(item) { if (item.dataset.type === 'text') updateOverflowState(item); });

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.width = targetWidth;
  canvas.height = targetHeight;

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // produit (contain)
  const baseSrc = productImg.currentSrc || productImg.src;
  const baseImg = await loadImageForCanvas(baseSrc);

  const productRatio = baseImg.naturalWidth / baseImg.naturalHeight;
  const targetRatio = targetWidth / targetHeight;

  let drawWidth, drawHeight, offsetX, offsetY;
  if (productRatio > targetRatio) {
    drawWidth = targetWidth;
    drawHeight = targetWidth / productRatio;
    offsetX = 0;
    offsetY = (targetHeight - drawHeight) / 2;
  } else {
    drawHeight = targetHeight;
    drawWidth = targetHeight * productRatio;
    offsetX = (targetWidth - drawWidth) / 2;
    offsetY = 0;
  }

  ctx.drawImage(baseImg, 0, 0, baseImg.naturalWidth, baseImg.naturalHeight, offsetX, offsetY, drawWidth, drawHeight);

  if (!items.length) return canvas;

  // Une zone est exprimée par rapport aux pixels réellement visibles de l'image.
  // Le conteneur peut avoir un autre ratio et laisser des marges avec object-fit.
  const paintedRect = getPaintedProductImageRect(productImg);
  const areaRect = designArea.getBoundingClientRect();

  if (!paintedRect) {
    if (strict) throw new Error('Zone du produit impossible à mesurer');
    return canvas;
  }

  const areaThumbX = offsetX + ((areaRect.left - paintedRect.left) / paintedRect.width) * drawWidth;
  const areaThumbY = offsetY + ((areaRect.top - paintedRect.top) / paintedRect.height) * drawHeight;
  const areaThumbW = (areaRect.width / paintedRect.width) * drawWidth;
  const areaThumbH = (areaRect.height / paintedRect.height) * drawHeight;

  const zoomScale = (typeof getCanvasZoomScale === 'function') ? getCanvasZoomScale() : 1;
  const logicalAreaWidth = areaRect.width / zoomScale;
  const logicalAreaHeight = areaRect.height / zoomScale;

  const scaleX = areaThumbW / logicalAreaWidth;
  const scaleY = areaThumbH / logicalAreaHeight;

  ctx.save();
  ctx.translate(areaThumbX, areaThumbY);

  for (const item of items) {
    await renderDesignItemToCanvas(ctx, item, designArea, scaleX, scaleY, strict);
  }

  ctx.restore();
  return canvas;
}
async function renderDesignItemOnMockup(ctx, item, x, y, width, height) {
const angle = parseFloat(item.dataset.angle || 0) || 0;
const itemType = item.dataset.type;
ctx.save();
ctx.translate(x + width / 2, y + height / 2);
ctx.rotate((angle * Math.PI) / 180);
ctx.translate(-width / 2, -height / 2);
if (itemType === 'image') {
const img = item.querySelector('img');
if (!img) {
ctx.restore();
return;
}
const src = img.dataset.originalSrc || img.src;
try {
const designImg = await loadImageForCanvas(src);
const imgRatio = designImg.naturalWidth / designImg.naturalHeight;
const targetRatio = width / height;
let drawW = width;
let drawH = height;
let offX = 0;
let offY = 0;
if (imgRatio > targetRatio) {
drawH = width / imgRatio;
offY = (height - drawH) / 2;
} else {
drawW = height * imgRatio;
offX = (width - drawW) / 2;
}
ctx.drawImage(designImg, offX, offY, drawW, drawH);
} catch (err) {
}
} else if (itemType === 'text') {
const textDiv = item.querySelector('.di-content > div');
if (!textDiv) {
ctx.restore();
return;
}
const text = (textDiv.textContent || '').trim();
if (!text) {
ctx.restore();
return;
}
const computedStyle = window.getComputedStyle(textDiv);
const baseFontSize = parseFloat(computedStyle.fontSize) || 12;
const rawFontFamily = computedStyle.fontFamily || 'Arial';
const fontFamily = rawFontFamily.split(',')[0].replace(/['"]/g, '').trim();
const color = computedStyle.color;
const fontWeight = computedStyle.fontWeight || 'normal';
const textAlign = computedStyle.textAlign || 'left';
ctx.fillStyle = color;
ctx.font = `${fontWeight} ${baseFontSize}px ${fontFamily}`;
ctx.textBaseline = 'middle';
let textX;
switch (textAlign) {
case 'center':
ctx.textAlign = 'center';
textX = width / 2;
break;
case 'right':
ctx.textAlign = 'right';
textX = width;
break;
default:
ctx.textAlign = 'left';
textX = 0;
}
const textY = height / 2;
ctx.strokeStyle = 'rgba(0,0,0,0.15)';
ctx.lineWidth = 1;
ctx.strokeText(text, textX, textY);
ctx.fillText(text, textX, textY);
}
ctx.restore();
}
async function createFrontBackComposite(width, height) {
const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
canvas.width = width * 2;
canvas.height = height;
ctx.fillStyle = '#ffffff';
ctx.fillRect(0, 0, canvas.width, canvas.height);
const frontCanvas = await captureDesignExact('front', width, height);
if (frontCanvas) {
ctx.drawImage(frontCanvas, 0, 0);
ctx.fillStyle = 'rgba(0, 0, 0, 0.8)';
ctx.fillRect(0, 0, width, 80);
ctx.fillStyle = '#ffffff';
ctx.font = 'bold 50px Arial';
ctx.textAlign = 'center';
ctx.fillText('AVANT', width / 2, 30);
}
const backCanvas = await captureDesignExact('back', width, height);
if (backCanvas) {
ctx.drawImage(backCanvas, width, 0);
ctx.fillStyle = 'rgba(0, 0, 0, 0.8)';
ctx.fillRect(width, 0, width, 80);
ctx.fillStyle = '#ffffff';
ctx.font = 'bold 50px Arial';
ctx.textAlign = 'center';
ctx.fillText('DOS', width + width / 2, 30);
}
return canvas;
}
async function saveToShopifyFiles(designs) {
try {
const formData = new FormData();
const firstDesign = Object.values(designs)[0];
if (!firstDesign?.url) return;
const response = await fetch(firstDesign.url);
const blob = await response.blob();
formData.append('file', blob, `customizer-${Date.now()}.png`);
formData.append('namespace', 'customizer');
formData.append('key', `design_${currentProduct?.handle || 'unknown'}_${Date.now()}`);
} catch (err) {
}
}
async function captureDesignOnly(viewName) {
const designArea = document.querySelector(`.design-area[data-area="${viewName}"]`);
if (!designArea) {
return null;
}
const items = designArea.querySelectorAll('.design-item');
if (items.length === 0) {
}
const areaRect = designArea.getBoundingClientRect();
const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
canvas.width = 2100;
canvas.height = 2520;
const scaleX = canvas.width / areaRect.width;
const scaleY = canvas.height / areaRect.height;
for (let i = 0; i < items.length; i++) {
const item = items[i];
try {
await renderDesignItemToCanvas(ctx, item, designArea, scaleX, scaleY);
} catch (err) {
}
}
return canvas;
}
function getIncomingCustomizerContext() {
const ctx = {
handle: null,
variantId: null,
qty: 1,
options: null,
source: null,
transferMode: false,
designProductHandle: null,
designZones: null,
designVariantId: null,
designPriceCents: null,
designTitle: null
};
try {
const params = new URLSearchParams(window.location.search || '');
const transferToken = String(params.get('transfer_token') || '').trim();
const transferMode = !!(
params.get('tpl') ||
params.get('template') ||
params.get('template_key') ||
params.get('template_name') ||
params.get('starter_template') ||
params.get('starter_template_name') ||
params.get('design_template') ||
params.get('tplstate') ||
params.get('template_state') ||
transferToken
);
const h = params.get('handle') || params.get('product_handle') || params.get('base_product_handle');
const v = params.get('variant') || params.get('variantId');
const designHandle = params.get('design_product') || params.get('design_product_handle');
const designVariant = params.get('design_variant') || params.get('design_variant_id');
const designPrice = Number(params.get('design_price'));
const designTitle = params.get('design_title');
const q = parseInt(params.get('qty') || '1', 10);
const optRaw = params.get('options');
if (h) ctx.handle = h;
if (v) ctx.variantId = v;
if (designHandle) ctx.designProductHandle = designHandle;
if (designVariant) ctx.designVariantId = designVariant;
if (Number.isFinite(designPrice) && designPrice > 0) ctx.designPriceCents = designPrice;
if (designTitle) ctx.designTitle = designTitle;
if (!isNaN(q) && q > 0) ctx.qty = q;
if (optRaw) {
try { ctx.options = JSON.parse(decodeURIComponent(optRaw)); } catch (e) {}
}
if (transferToken) {
try {
const transferRaw = sessionStorage.getItem('oazarCustomizerTransfer:' + transferToken);
const transfer = transferRaw ? JSON.parse(transferRaw) : null;
const transferHandle = transfer && String(
transfer.baseProductHandle || transfer.base_product_handle || ''
).trim();
if (!ctx.handle && transferHandle) ctx.handle = transferHandle;
} catch (transferError) {}
}
ctx.transferMode = transferMode;
if (transferMode && !ctx.handle) ctx.handle = 't-shirt-ecoresponsable-unisexe';
if (transferMode) ctx.source = 'transfer';
else if (ctx.handle || ctx.variantId) ctx.source = 'url';
} catch (e) {}
if (ctx.transferMode) {
try {
const raw = sessionStorage.getItem('oazar_customizer_context');
if (raw) {
const saved = JSON.parse(raw);
const maxAgeMs = 30 * 60 * 1000;
const isFresh = !saved.timestamp || (Date.now() - saved.timestamp) < maxAgeMs;
if (isFresh) {
if (!ctx.handle && saved.handle) ctx.handle = saved.handle;
if (!ctx.variantId && saved.variantId) ctx.variantId = saved.variantId;
if (!ctx.designProductHandle && (saved.designProductHandle || saved.design_product_handle)) ctx.designProductHandle = saved.designProductHandle || saved.design_product_handle;
if (saved.designZones && saved.designProductHandle === ctx.designProductHandle) ctx.designZones = saved.designZones;
if (!ctx.designVariantId && (saved.designVariantId || saved.design_variant_id)) ctx.designVariantId = saved.designVariantId || saved.design_variant_id;
if (!ctx.designPriceCents && Number(saved.designPriceCents || saved.design_price)) ctx.designPriceCents = Number(saved.designPriceCents || saved.design_price);
if (!ctx.designTitle && (saved.designTitle || saved.design_title)) ctx.designTitle = saved.designTitle || saved.design_title;
if ((!ctx.qty || ctx.qty < 1) && saved.qty) ctx.qty = parseInt(saved.qty, 10) || 1;
if (!ctx.options && saved.options) ctx.options = saved.options;
if (!ctx.source && (saved.handle || saved.variantId)) ctx.source = 'session';
}
}
} catch (e) {}
}
if (ctx.designZones) window.oazarIncomingDesignZones = ctx.designZones;
return ctx;
}
function getEditDesignIdFromUrl() {
try {
const params = new URLSearchParams(window.location.search || '');
return params.get('design_id') || null;
} catch (e) { return null; }
}
function enableEditModeLock() {
const ctx = getIncomingCustomizerContext();
const designId = getEditDesignIdFromUrl();
if (!designId) return;
window.CUSTOMIZER_EDIT_MODE = true;
window.CUSTOMIZER_LOCKED_HANDLE = ctx.handle || null;
}
enableEditModeLock();
function getEditMetaUrlFromUrl() {
try {
  const params = new URLSearchParams(window.location.search || '');
  const raw = params.get('meta_url') || '';
  return raw ? normalizeCustomizerAssetUrl(raw) : null;
} catch (e) { return null; }
}

function getPersistentImagePoolForDesign(d, viewName) {
const pool = [];
const push = (url, name) => {
  const clean = normalizeCustomizerAssetUrl(url);
  if (!/^https?:\/\//i.test(clean)) return;
  if (!pool.some(x => x.url === clean)) pool.push({ url: clean, name: String(name || '').trim() });
};
try {
  const originals = d?.views?.[viewName]?.originals || [];
  originals.forEach(x => push(
    x?.url || x?.original_url || x?.src || x?.image_url || x?.client_image_url || x?.client_image_path,
    x?.original_name || x?.originalName || x?.name || x?.filename
  ));
  const clientImages = d?.client_images || [];
  clientImages.forEach(x => push(
    x?.url || x?.original_url || x?.src || x?.image_url || x?.client_image_url || x?.client_image_path || x?.clientImagePath,
    x?.originalName || x?.original_name || x?.name || x?.filename
  ));
} catch (e) {}
return pool;
}

function repairSnapshotImageSources(d, viewName, snap) {
if (!snap || !Array.isArray(snap.items)) return snap;
const pool = getPersistentImagePoolForDesign(d, viewName);
let fallbackIndex = 0;
const clone = Object.assign({}, snap, { items: snap.items.map(item => Object.assign({}, item)) });
clone.items.forEach(item => {
  if (String(item.type || '').toLowerCase() !== 'image') return;
  const wantedName = String(item.originalName || '').trim();
  let replacement = null;
  if (wantedName) {
    replacement = pool.find(x => x.name && x.name === wantedName) || null;
  }
  if (!replacement && pool[fallbackIndex]) replacement = pool[fallbackIndex++];
  const currentRaw = String(item.originalSrc || item.src || '').trim();
  const current = normalizeCustomizerAssetUrl(currentRaw);
  const currentPersistent = /^https?:\/\//i.test(current);
  const itemFallbacks = [
    item.remoteOriginalSrc,
    item.clientImageSrc,
    item.clientImagePath,
    item.inlineSrc
  ].map(normalizeCustomizerAssetUrl).filter(url => /^(?:https?:\/\/|data:image\/)/i.test(url));
  if (replacement) {
    item.src = normalizeCustomizerAssetUrl(replacement.url);
    item.originalSrc = item.src;
    if (!item.originalName && replacement.name) item.originalName = replacement.name;
  } else if (itemFallbacks.length) {
    item.src = itemFallbacks[0];
    item.originalSrc = item.src;
  } else if (currentPersistent) {
    // Répare aussi les anciennes URL /uploads/... enregistrées sur le mauvais domaine.
    item.src = current;
    item.originalSrc = current;
  }
});
return clone;
}

async function restoreDesignFromServerIfEdit() {
const designId = getEditDesignIdFromUrl();
if (!designId) return;

let d = null;
try {
  const res = await fetch(
    'https://customizer.oazar-shop.com/get_design.php?design_id=' + encodeURIComponent(designId),
    { cache: 'no-store' }
  );
  const json = await res.json();
  if (json && json.success && json.design) d = json.design;
} catch (e) {
  console.warn('[restoreDesignFromServerIfEdit] get_design indisponible', e);
}

// Fallback fiable : le panier conserve déjà l'URL de customization.json.
const metaUrl = getEditMetaUrlFromUrl();
if (metaUrl) {
  try {
    const res = await fetch(metaUrl, { cache: 'no-store', mode: 'cors' });
    if (res.ok) {
      const meta = await res.json();
      if (d && meta && typeof meta === 'object') {
        // get_design.php peut renvoyer une version réduite sans les images
        // originales ; customization.json est l'archive complète du panier.
        d = Object.assign({}, d, meta, {
          views: Object.assign({}, d.views || {}, meta.views || {}),
          snapshots: meta.snapshots || d.snapshots,
          client_images: meta.client_images || d.client_images
        });
      } else if (meta) {
        d = meta;
      }
    }
  } catch (e) {
    console.warn('[restoreDesignFromServerIfEdit] meta_url indisponible', e);
  }
}

if (!d) {
  try {
    const raw = localStorage.getItem('oazar_design_' + designId);
    if (raw) d = JSON.parse(raw);
  } catch (e) {}
}

if (!d) {
  showNotification("Design introuvable. Ajoute de nouveau le produit au panier après cette correction.", "error");
  return;
}

if (d.editable && !d.snapshots) d = Object.assign({}, d, d.editable);
if (d.payload && !d.snapshots) d = Object.assign({}, d, d.payload);

const ctx = getIncomingCustomizerContext();
const handle = String(d.product_handle || d.product?.handle || ctx.handle || '').trim();

if (handle && typeof changeProduct === 'function') {
  try {
    await Promise.resolve(changeProduct(handle));
  } catch (e) {
    console.warn('[restoreDesignFromServerIfEdit] changeProduct failed', e);
  }
}

// La ligne du panier transmet variante + quantité : on restaure également la
// couleur et la taille sélectionnées, en plus des images, textes et designs.
try {
  applyIncomingVariantSelection(ctx);
} catch (e) {}

if (d.technique) {
  try {
    window.currentTechnique = String(d.technique).toLowerCase();
    currentTechnique = window.currentTechnique;
    if (typeof window.__ozSyncTechniqueUI === 'function') window.__ozSyncTechniqueUI(currentTechnique);
  } catch (e) {}
}
// Le produit reste prioritaire sur une ancienne technique sauvegardée.
// Exemple : un ancien design en impression ne peut pas réactiver l’impression
// si le produit est désormais configuré « broderie » uniquement.
if (typeof updateTechniquesAvailability === 'function') {
  updateTechniquesAvailability();
}

try {
  window.designNote = d.note || '';
  designNote = d.note || '';
} catch (e) {}

const rawSnaps = d.snapshots || d.editable?.snapshots || null;
if (!rawSnaps || !Object.keys(rawSnaps).length) {
  showNotification("Le design a été retrouvé, mais il ne contient pas l'état éditable. Ajoute-le de nouveau au panier après cette correction.", "warning");
  return;
}

const snaps = {};
['front','back','left','right'].forEach(v => {
  snaps[v] = repairSnapshotImageSources(d, v, rawSnaps[v]);
});

let tries = 0;
const timer = setInterval(() => {
  tries++;
  const frontArea = document.querySelector('.design-area[data-area="front"]');
  const productReady = !handle || !window.currentProduct || String(window.currentProduct.handle || '') === handle;
  const ready = !!frontArea && (productReady || tries > 25);

  if (ready || tries > 100) {
    clearInterval(timer);
    ['front','back','left','right'].forEach(v => {
      if (snaps[v] && snaps[v].items && typeof restoreSnapshot === 'function') {
        restoreSnapshot(v, snaps[v]);
      }
    });
    if (typeof updateDesignLayers === 'function') updateDesignLayers();
    if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
    if (typeof showNotification === 'function') showNotification('Design rechargé pour modification.', 'success');
  }
}, 100);
}

function findVariantFromContext(ctx) {
if (!currentProduct || !currentProduct.variants) return null;
const variants = currentProduct.variants;
if (ctx && ctx.variantId) {
const idStr = String(ctx.variantId);
const v = variants.find(x => String(x.id) === idStr);
if (v) return v;
}
const opt = ctx && ctx.options ? ctx.options : null;
if (opt && (opt.option1 || opt.option2 || opt.option3)) {
return variants.find(x =>
(!opt.option1 || x.option1 === opt.option1) &&
(!opt.option2 || x.option2 === opt.option2) &&
(!opt.option3 || x.option3 === opt.option3)
) || null;
}
return null;
}
function applyIncomingVariantSelection(ctx) {
const v = findVariantFromContext(ctx);
if (!v) return;
const color = v.option1;
const sizeWanted = ozNormalizeSizeLabel(v.option2);
const qty = (ctx && parseInt(ctx.qty, 10) > 0) ? parseInt(ctx.qty, 10) : 1;
let tries = 0;
const maxTries = 60;
const timer = setInterval(function () {
tries++;
const swatches = Array.from(document.querySelectorAll('.color-swatch'));
const sw = swatches.find(s => s?.dataset?.color === color);
if (sw) {
clearInterval(timer);
sw.click();
setTimeout(function () {
if (!sizeQuantities || typeof sizeQuantities !== 'object') return;
let sizeKey = sizeWanted;
if (!Object.prototype.hasOwnProperty.call(sizeQuantities, sizeKey)) {
const alt = Object.keys(sizeQuantities).find(k =>
String(k).toLowerCase() === String(sizeKey).toLowerCase()
);
if (alt) sizeKey = alt;
}
if (!Object.prototype.hasOwnProperty.call(sizeQuantities, sizeKey)) {
const keys = Object.keys(sizeQuantities);
if (keys.length === 1) sizeKey = keys[0];
}
if (Object.prototype.hasOwnProperty.call(sizeQuantities, sizeKey)) {
sizeQuantities[sizeKey] = qty;
window.sizeQuantities = sizeQuantities;
selectedVariantId = v.id;
window.selectedVariantId = selectedVariantId;
updateSizeSummary();
updateSelectSizesButton();
showAddToCartButton();
if (typeof window.__ozApplyCartEligibilityUI === 'function') window.__ozApplyCartEligibilityUI();
if (typeof updateSizeDrawerTotals === 'function') {
try { updateSizeDrawerTotals(); } catch (e) {}
}
}
}, 80);
}
if (tries >= maxTries) clearInterval(timer);
}, 50);
}
function normalizeProductReference(value) {
return String(value || '')
.normalize('NFD')
.replace(/[\u0300-\u036f]/g, '')
.toLowerCase()
.replace(/[^a-z0-9]+/g, ' ')
.trim();
}
function resolveProductHandle(reference) {
const wanted = String(reference || '').trim();
if (!wanted) return null;
if (productsData[wanted]) return wanted;

const wantedWords = normalizeProductReference(wanted);
const wantedCompact = wantedWords.replace(/\s+/g, '');
if (!wantedCompact) return null;
const entries = Object.entries(productsData || {});

const compactMatch = entries.find(function(entry) {
const product = entry[1] || {};
return [entry[0], product.handle, product.title].some(function(value) {
return normalizeProductReference(value).replace(/\s+/g, '') === wantedCompact;
});
});
if (compactMatch) return compactMatch[0];

const wantedTokens = wantedWords.split(/\s+/).filter(function(token) { return token.length > 1; });
let best = null;
let bestScore = 0;
entries.forEach(function(entry) {
const product = entry[1] || {};
const haystack = normalizeProductReference(entry[0] + ' ' + (product.handle || '') + ' ' + (product.title || ''));
const compact = haystack.replace(/\s+/g, '');
let score = wantedTokens.length
? wantedTokens.filter(function(token) { return haystack.indexOf(token) !== -1; }).length / wantedTokens.length
: 0;
if (wantedCompact.length > 9 && (compact.indexOf(wantedCompact) !== -1 || wantedCompact.indexOf(compact) !== -1)) {
score = Math.max(score, 0.95);
}
if (score > bestScore) {
bestScore = score;
best = entry[0];
}
});
return bestScore >= 0.72 ? best : null;
}
function findProductHandleFromContext(ctx) {
if (!ctx) return null;
const resolvedHandle = resolveProductHandle(ctx.handle);
if (resolvedHandle) return resolvedHandle;
if (ctx.variantId) {
const variantId = String(ctx.variantId);
const found = Object.entries(productsData || {}).find(function(entry) {
const product = entry[1];
return product &&
Array.isArray(product.variants) &&
product.variants.some(function(v) {
return String(v.id) === variantId;
});
});
if (found) return found[0];
}

if (ctx.transferMode || ctx.source === 'transfer') {
const teeCandidates = Object.entries(productsData || {}).filter(function(entry) {
const product = entry[1] || {};
const ref = normalizeProductReference(entry[0] + ' ' + (product.title || '')).replace(/\s+/g, '');
return ref.indexOf('tshirt') !== -1 || ref.indexOf('teeshirt') !== -1;
});
const unisexCandidate = teeCandidates.find(function(entry) {
return normalizeProductReference(entry[0] + ' ' + ((entry[1] || {}).title || '')).indexOf('unisexe') !== -1;
});
if (unisexCandidate) return unisexCandidate[0];
if (teeCandidates.length === 1) return teeCandidates[0][0];
}
return null;
}
function showProductChoiceOnDirectOpen() {
document.body.classList.add('oz-product-choice-preview');
const previewProduct = productsData['t-shirt-ecoresponsable-unisexe'];
const previewFront = document.getElementById('productImageFront');
if (previewProduct && previewFront) {
const previewImage = (previewProduct.images && previewProduct.images.front) ||
  (previewProduct.gallery || []).find(function(image) { return /avant|front/i.test(image.alt || ''); })?.src ||
  (previewProduct.gallery && previewProduct.gallery[0] && previewProduct.gallery[0].src) || '';
if (previewImage) previewFront.src = previewImage;
previewFront.alt = 'T-shirt écoresponsable unisexe, vue avant';
}
const colorSection = document.getElementById('colorSelection');
const sizeSection = document.getElementById('sizeSelection');
if (colorSection) colorSection.style.display = 'none';
if (sizeSection) sizeSection.style.display = 'none';
currentProduct = null;
window.currentProduct = null;

sizeQuantities = {};
variantBySize = {};

updateSizeSummary();
updateSelectSizesButton();
showAddToCartButton();

updateStudioProductOverview();
window.__ozCustomizerProductReady = false;
if (typeof updatePriceLiveBlock === 'function') updatePriceLiveBlock();
if (typeof showAddToCartButton === 'function') showAddToCartButton();
if (typeof window.__ozApplyCartEligibilityUI === 'function') window.__ozApplyCartEligibilityUI();
setTimeout(function() {
if (typeof window.openProductPicker === 'function') {
window.openProductPicker({ required: true });
}
}, 150);
}
function initCustomizerFromContext() {
const ctx = getIncomingCustomizerContext();
const hasSourceSvgProduct = !!ctx.designProductHandle;
window.__ozSourceSvgProduct = hasSourceSvgProduct ? {
handle: ctx.designProductHandle || '',
variantId: ctx.designVariantId ? String(ctx.designVariantId) : '',
priceCents: Number(ctx.designPriceCents) || 0,
title: ctx.designTitle || ''
} : null;

if (hasSourceSvgProduct && (!window.__ozSourceSvgProduct.variantId || !window.__ozSourceSvgProduct.priceCents)) {
const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
fetch(shopRoot + 'products/' + encodeURIComponent(ctx.designProductHandle) + '.js', { credentials: 'same-origin' })
.then(function(response) {
if (!response.ok) throw new Error('Produit SVG introuvable');
return response.json();
})
.then(function(sourceProduct) {
const variants = Array.isArray(sourceProduct.variants) ? sourceProduct.variants : [];
const requested = String(ctx.designVariantId || '');
const sourceVariant = variants.find(function(variant) { return String(variant.id) === requested; }) || variants[0];
if (!sourceVariant) return;
window.__ozSourceSvgProduct.variantId = String(sourceVariant.id);
window.__ozSourceSvgProduct.priceCents = Number(sourceVariant.price || sourceProduct.price || 0);
window.__ozSourceSvgProduct.title = window.__ozSourceSvgProduct.title || sourceProduct.title || '';
if (typeof updateStudioProductOverview === 'function') updateStudioProductOverview();
if (typeof updatePriceLiveBlock === 'function') updatePriceLiveBlock();
if (typeof updateSizeDrawerTotals === 'function') updateSizeDrawerTotals();
})
.catch(function() {});
}
const handles = Object.keys(productsData || {});
if (!handles.length) return;
const params = new URLSearchParams(window.location.search || '');
const isEditMode = !!params.get('design_id');
if (isEditMode) return;
const handleToLoad = findProductHandleFromContext(ctx);
if (!handleToLoad) {
showProductChoiceOnDirectOpen();
return;
}
const productChanged = changeProduct(handleToLoad);
if (productChanged === false) {
showProductChoiceOnDirectOpen();
return;
}
if (typeof window.closeProductPicker === 'function') window.closeProductPicker(true);
if (ctx.transferMode || ctx.source === 'transfer') {
const picker = document.getElementById('productPicker');
if (picker) {
picker.classList.remove('show');
picker.style.display = 'none';
picker.dataset.required = '0';
}
document.body.style.overflow = '';
}
setTimeout(function () {
applyIncomingVariantSelection(ctx);
if (typeof window.drawZoneLimits === 'function') window.drawZoneLimits();
if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
}, 120);
}
document.addEventListener('DOMContentLoaded', function() {
detectDevice();
try {
const productsEl = document.getElementById('products-data');
if (productsEl) {
productsData = JSON.parse(productsEl.textContent || '{}');
if (document.getElementById('mon-customizer')?.dataset.patchEnabled === 'false') {
  Object.keys(productsData).forEach(handle => { if (productsData[handle]?.patch) delete productsData[handle]; });
}
}
const sizeGuidesEl = document.getElementById('size-guides-data');
if (sizeGuidesEl) {
try {
sizeGuidesData = JSON.parse(sizeGuidesEl.textContent || '{}');
} catch (error) {
sizeGuidesData = {};
}
}
const designsEl = document.getElementById('designs-data-source');
if (designsEl) {
designLibrary = JSON.parse(designsEl.textContent || '{"categories":[]}');
}
const zonesEl = document.getElementById('zones-config');
if (zonesEl) {
zonesConfig = JSON.parse(zonesEl.textContent || '{}');
}
const categoriesEl = document.getElementById('categories-config');
if (categoriesEl) {
categoriesConfig = JSON.parse(categoriesEl.textContent || '{"categories":[]}');
}
initializeComponents();
setTimeout(function() {
initCustomizerFromContext();
restoreDesignFromServerIfEdit();
}, 50);
} catch (error) {
}
initializeViewButtonsFeedback();
initializeDoubleTapPrevention();
checkOrientation();
});
function initializeComponents() {
    initializeTechniqueSelector();
    initializeZoomControls(); 
    initCanvasBoundaries();   
    initializeDrawer();
    initializeTextControls();
    initializeImageUpload();
    initializeAiComingSoonGuard();
    initializeSmartTemplateAiButtonsGuard();
    initializeGlobalClickHandler();
    initializeMobileActions();
    initUndoRedo();
    document.addEventListener('keydown', handleKeyboard);
    window.addEventListener('resize', function() {
        detectDevice();
        handleResize();
        checkOrientation();
    });
    window.addEventListener('orientationchange', checkOrientation);
    if (isTouchDevice()) {
        document.body.classList.add('touch-device');
    }
}
/* ============================================================
   IA — SUPPRESSION DU CTA DANS LE PERSONNALISATEUR (MODÈLES SVG)
   customizer-ai.js injecte un bouton « Générer avec l'IA » sur les
   vignettes photo du panneau « Modèles intelligents ». Ce bouton n'a
   de sens que sur les emplacements qui déclarent réellement un endpoint
   IA dans le SVG (data-oz-ai-endpoint → attribut data-smart-ai-slot).
   Partout ailleurs on le retire, y compris s'il est injecté après coup
   ou re-injecté à chaque rendu du panneau.
   ============================================================ */
function initializeSmartTemplateAiButtonsGuard() {
  var MOTIFS = [
    'generer avec l ia',
    'generer avec l intelligence artificielle',
    'generer une image',
    'creer avec l ia'
  ];

  var SELECTEURS_IA = [
    '[data-ai-generate]',
    '[data-ai-trigger]',
    '[data-smart-ai-generate]',
    '[data-action="ai-generate"]',
    '.oz-ai-generate',
    '.oz-smarttpl-ai-btn',
    '.customizer-ai-button',
    '.ai-cta',
    '.ai-trigger'
  ].join(',');

  function normaliser(valeur) {
    return String(valeur || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u2018\u2019\u02bc'\`]/g, ' ')
      .replace(/[^a-zA-Z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function estCtaIa(el) {
    if (!el || el.nodeType !== 1 || !el.matches) return false;

    try {
      if (el.matches(SELECTEURS_IA)) return true;
    } catch (e) {}

    if (!el.matches('button, a, label, [role="button"], input[type="button"], input[type="submit"]')) return false;

    var txt = normaliser([
      el.textContent,
      el.value,
      el.getAttribute('aria-label'),
      el.getAttribute('title')
    ].filter(Boolean).join(' '));
    if (!txt) return false;

    for (var i = 0; i < MOTIFS.length; i++) {
      if (txt.indexOf(MOTIFS[i]) !== -1) return true;
    }
    return false;
  }

  /* On ne touche pas aux emplacements qui utilisent vraiment le détourage IA. */
  function estAutorise(el) {
    var slot = el.closest ? el.closest('[data-smart-ai-slot]') : null;
    return !!slot;
  }

  function nettoyer(racine) {
    var scope = racine && racine.querySelectorAll ? racine : document;

    var candidats = [];
    if (scope.nodeType === 1 && estCtaIa(scope)) candidats.push(scope);
    try {
      scope.querySelectorAll('button, a, label, [role="button"], input[type="button"], input[type="submit"], ' + SELECTEURS_IA)
        .forEach(function (el) { candidats.push(el); });
    } catch (e) {}

    candidats.forEach(function (el) {
      if (!el.isConnected) return;
      if (!el.closest('.oz-smarttpl-modal')) return;
      if (!estCtaIa(el)) return;
      if (estAutorise(el)) return;

      /* Si le bouton a été enveloppé dans un conteneur dédié, on retire
         le conteneur pour ne pas laisser de boîte vide dans la grille. */
      var wrapper = el.parentElement;
      var cible = el;
      if (
        wrapper &&
        wrapper !== document.body &&
        !wrapper.classList.contains('oz-smarttpl-image-slot') &&
        !wrapper.classList.contains('oz-smarttpl-image-actions') &&
        !wrapper.classList.contains('oz-smarttpl-image-grid') &&
        !wrapper.classList.contains('oz-smarttpl-controls') &&
        wrapper.children.length === 1
      ) {
        cible = wrapper;
      }

      cible.remove();
    });
  }

  nettoyer(document);

  if (typeof MutationObserver === 'undefined' || !document.body) return;

  var planifie = false;
  var observer = new MutationObserver(function (mutations) {
    var pertinent = false;
    for (var i = 0; i < mutations.length && !pertinent; i++) {
      var ajouts = mutations[i].addedNodes;
      for (var j = 0; j < ajouts.length; j++) {
        if (ajouts[j] && ajouts[j].nodeType === 1) { pertinent = true; break; }
      }
    }
    if (!pertinent || planifie) return;

    planifie = true;
    /* Le panneau reconstruit tout son HTML à chaque rendu : on regroupe
       les passages de nettoyage pour ne pas courir après chaque nœud. */
    (window.requestAnimationFrame || window.setTimeout)(function () {
      planifie = false;
      nettoyer(document);
    }, 0);
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

/* ============================================================
   IA — MODE « BIENTÔT »
   Le schéma Shopify expose oazar-ai-config.comingSoon.
   Quand il vaut true :
   - le bouton IA reste visible ;
   - il devient réellement non cliquable ;
   - aucun drawer/modal IA ne peut être ouvert par clic/touch/clavier ;
   - le blocage fonctionne aussi si customizer-ai.js crée le bouton après coup.
   ============================================================ */
function initializeAiComingSoonGuard() {
  let cfg = {};
  try {
    const cfgEl = document.getElementById('oazar-ai-config');
    cfg = cfgEl ? JSON.parse(cfgEl.textContent || '{}') : {};
  } catch (e) {
    cfg = {};
  }

  if (!cfg || cfg.comingSoon !== true) return;

  const explicitSelectors = [
    '#openAiDrawer',
    '#openAIDrawer',
    '#openAiBtn',
    '#openAIBtn',
    '#aiBtn',
    '#aiButton',
    '#aiGenerateBtn',
    '#mobileAiBtn',
    '#mobileAIBtn',
    '[data-ai-trigger]',
    '[data-ai-panel]',
    '[data-drawer-tab="ai"]',
    '[data-action="ai"]',
    '[data-action="open-ai"]',
    '[data-action="open_ai"]',
    '.oazar-ai-trigger',
    '.oz-ai-trigger',
    '.ai-trigger',
    '.ai-entry-btn',
    '.ai-cta',
    '.ai-tab',
    '.customizer-ai-button'
  ].join(',');

  const normalize = (value) => String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase('fr');

  const ctaLabel = normalize(cfg.ctaLabel || 'IA');
  const badgeLabel = normalize(cfg.comingSoonBadge || 'Bientôt');

  function getControlText(control) {
    return normalize([
      control?.textContent,
      control?.value,
      control?.getAttribute?.('aria-label'),
      control?.getAttribute?.('title')
    ].filter(Boolean).join(' '));
  }

  function isAiControl(control) {
    if (!control || !control.matches) return false;
    if (control.matches(explicitSelectors)) return true;

    const txt = getControlText(control);
    if (!txt) return false;

    // Le bouton généré par customizer-ai.js reprend normalement ctaLabel.
    if (ctaLabel && txt === ctaLabel) return true;
    if (ctaLabel && badgeLabel && txt === `${ctaLabel} ${badgeLabel}`) return true;
    if (ctaLabel && badgeLabel && txt.startsWith(`${ctaLabel} ${badgeLabel} `)) return true;

    return false;
  }

  function getAiControlFromTarget(target) {
    if (!target || !target.closest) return null;
    const control = target.closest('button, a, [role="button"], input[type="button"], input[type="submit"]');
    return isAiControl(control) ? control : null;
  }

  function disableControl(control) {
    if (!control || control.dataset.ozAiComingSoonDisabled === '1') return;

    control.dataset.ozAiComingSoonDisabled = '1';
    control.classList.add('oz-ai-coming-soon-disabled');
    control.setAttribute('aria-disabled', 'true');
    control.setAttribute('tabindex', '-1');
    control.setAttribute('data-coming-soon', 'true');

    if ('disabled' in control) {
      try { control.disabled = true; } catch (e) {}
    }
  }

  function applyComingSoonState(root) {
    const scope = root && root.querySelectorAll ? root : document;

    try {
      scope.querySelectorAll(explicitSelectors).forEach(disableControl);
    } catch (e) {}

    // Fallback : bouton dont le libellé correspond exactement au CTA configuré.
    scope.querySelectorAll('button, a, [role="button"], input[type="button"], input[type="submit"]').forEach((control) => {
      if (isAiControl(control)) disableControl(control);
    });
  }

  function hardBlockEvent(e) {
    const control = getAiControlFromTarget(e.target);
    if (!control) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    return false;
  }

  // Capture = passe avant les handlers de customizer-ai.js, même s'ils sont en bubbling.
  document.addEventListener('pointerdown', hardBlockEvent, true);
  document.addEventListener('pointerup', hardBlockEvent, true);
  document.addEventListener('mousedown', hardBlockEvent, true);
  document.addEventListener('mouseup', hardBlockEvent, true);
  document.addEventListener('touchstart', hardBlockEvent, true);
  document.addEventListener('click', hardBlockEvent, true);
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    hardBlockEvent(e);
  }, true);

  applyComingSoonState(document);

  // customizer-ai.js peut injecter le bouton après le DOMContentLoaded.
  if (document.body && typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!node || node.nodeType !== 1) return;
          if (isAiControl(node)) disableControl(node);
          applyComingSoonState(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Petits rechecks de sécurité pour les injections différées.
  [0, 100, 400, 1000, 2000].forEach((delay) => {
    setTimeout(() => applyComingSoonState(document), delay);
  });
}

function isTouchDevice() {
return ('ontouchstart' in window) ||
(navigator.maxTouchPoints > 0) ||
(navigator.msMaxTouchPoints > 0);
}
function initializeViewButtonsFeedback() {
const viewButtons = document.querySelectorAll('.view-button, .view-pill');
viewButtons.forEach(function(button) {
const newButton = button.cloneNode(true);
button.parentNode.replaceChild(newButton, button);
newButton.addEventListener('click', function(e) {
e.preventDefault();
e.stopPropagation();
const view = this.dataset.view;
this.style.transform = 'scale(0.95)';
setTimeout(function() {
newButton.style.transform = '';
}, 100);
changeView(view);
}, { passive: false });
newButton.addEventListener('touchstart', function(e) {
e.stopPropagation();
}, { passive: true });
newButton.addEventListener('touchend', function(e) {
e.stopPropagation();
}, { passive: true });
});
}
function initializeDoubleTapPrevention() {
if (window.innerWidth <= 1024) {
let lastTouchEnd = 0;
document.addEventListener('touchend', function(event) {
const target = event.target;
if (!(target instanceof Element)) return;
if (
  target.closest('.oz-smarttpl-modal, #customizationDrawer, #designFullDrawer, .picker-modal, input, textarea, select, button, a, label')
) {
  lastTouchEnd = Date.now();
  return;
}
const isCanvasInteraction = !!target.closest('#productCanvas, .product-preview-section, .design-area, .design-item');
if (!isCanvasInteraction) {
  lastTouchEnd = Date.now();
  return;
}
const now = Date.now();
if (now - lastTouchEnd <= 300) {
  event.preventDefault();
}
lastTouchEnd = now;
}, { passive: false });
}
}
function checkOrientation() {
    const warning = document.getElementById('landscape-warning');
    if (!warning) return;

    const isSmallScreen = window.innerWidth <= 1024; 
    const isLandscape = window.innerWidth > window.innerHeight;

    if (isSmallScreen && isLandscape) {
        // Force l'affichage en mode paysage sur petit écran
        warning.style.setProperty('display', 'flex', 'important');
        document.body.style.overflow = 'hidden'; // Bloque le scroll
    } else {
        // Cache le message en mode portrait
        warning.style.setProperty('display', 'none', 'important');
        document.body.style.overflow = ''; // Libère le scroll
    }
}
function initializeMobileActions() {
const mobileProductBtn = document.getElementById('mobileProductBtn');
const mobileColorBtn = document.getElementById('mobileColorBtn');
const mobileImageBtn = document.getElementById('mobileImageBtn');
const mobileTextBtn = document.getElementById('mobileTextBtn');
const mobileDesignsBtn = document.getElementById('mobileDesignsBtn');
const mobileNoteBtn = document.getElementById('mobileNoteBtn');
if (mobileProductBtn) {
mobileProductBtn.addEventListener('click', function() {
openProductPicker();
});
}
if (mobileColorBtn) {
mobileColorBtn.addEventListener('click', function() {
openColorDrawer();
});
}
if (mobileImageBtn) {
mobileImageBtn.addEventListener('click', function() {
if (typeof deselectAll === 'function') deselectAll();
openDrawer();
setDrawerMode('import');
});
}
if (mobileTextBtn) {
mobileTextBtn.addEventListener('click', function() {
if (typeof deselectAll === 'function') {
deselectAll();
}
openDrawer();
setDrawerMode('text');
});
}
if (mobileDesignsBtn) {
  mobileDesignsBtn.addEventListener('click', function() {
    openDrawer();
    setDrawerMode('designs');
  });
}
if (mobileNoteBtn) {
mobileNoteBtn.addEventListener('click', function(e) {
e.preventDefault();
e.stopPropagation();
openNoteModal();
});
}
initializeNoteModal();
}
function openColorDrawer() {
if (!currentProduct) {
showNotification('Veuillez d\'abord sélectionner un produit', 'warning');
return;
}
openDrawer();
setDrawerMode('colors');
}
function initializeNoteModal() {
const modal = document.getElementById('noteModalMobile');
if (!modal) return;
const textarea = document.getElementById('noteTextareaMobile');
const btnClose = document.getElementById('closeNoteModalMobile');
const btnSave = document.getElementById('saveNoteModalMobile');
const btnCancel = document.getElementById('cancelNoteModalMobile');
const backdrop = modal.querySelector('.note-modal-backdrop');
let scrollY = 0;
function lockScroll() {
scrollY = window.scrollY;
document.body.style.top = '-' + scrollY + 'px';
document.body.classList.add('note-modal-open');
}
function unlockScroll() {
document.body.classList.remove('note-modal-open');
document.body.style.top = '';
window.scrollTo(0, scrollY);
}
window.openNoteModal = function() {
if (!textarea) return;
textarea.value = designNote || '';
lockScroll();
modal.classList.add('is-open');
setTimeout(function() {
textarea.focus();
}, 200);
};
function closeModal() {
modal.classList.remove('is-open');
setTimeout(function() {
unlockScroll();
}, 200);
}
function saveNote() {
const note = (textarea.value || '').trim();
designNote = note;
const mobileNoteBtn = document.getElementById('mobileNoteBtn');
if (mobileNoteBtn) {
if (note) {
mobileNoteBtn.classList.add('has-note');
} else {
mobileNoteBtn.classList.remove('has-note');
}
}
showNotification(
note ? 'Consigne enregistrée !' : 'Consigne supprimée',
'success'
);
closeModal();
}
if (btnClose) {
btnClose.addEventListener('click', closeModal);
}
if (btnCancel) {
btnCancel.addEventListener('click', closeModal);
}
if (btnSave) {
btnSave.addEventListener('click', saveNote);
}
if (backdrop) {
backdrop.addEventListener('click', closeModal);
}
document.addEventListener('keydown', function(e) {
if (e.key === 'Escape' && modal.classList.contains('is-open')) {
closeModal();
}
});
if (textarea) {
textarea.addEventListener('keydown', function(e) {
if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
e.preventDefault();
saveNote();
}
});
}
}
function refreshProductView() {
const view = currentView || 'front';
// Keep the loaded image when switching views so the marking zone stays stable.
if (typeof window.applyDesignZoneToDOM === 'function') {
  window.applyDesignZoneToDOM(view);
}
document.querySelectorAll(`.product-view[data-view="${view}"] .design-item[data-type="text"]`).forEach(updateOverflowState);
if (window.fabricCanvases && window.fabricCanvases[view]) {
window.fabricCanvases[view].renderAll();
}
scheduleThumbnailUpdate();
}
function changeView(view) {
currentView = view;
window.currentView = view;
document.querySelectorAll('.view-button').forEach(function(btn) {
btn.classList.toggle('active', btn.dataset.view === view);
});
document.querySelectorAll('.view-pill').forEach(function(pill) {
pill.classList.toggle('active', pill.dataset.view === view);
});
document.querySelectorAll('.product-view').forEach(function(pv) {
const isActive = pv.dataset.view === view;
pv.classList.toggle('active', isActive);
pv.hidden = !isActive;
pv.style.setProperty('display', isActive ? 'flex' : 'none', 'important');
pv.setAttribute('aria-hidden', String(!isActive));
});
updateProductImages();
refreshProductView();
if (window.fabricCanvases && window.fabricCanvases[view]) {
window.fabricCanvases[view].renderAll();
}
refreshViewAvailability();
scheduleThumbnailUpdate();
updateUndoRedoUI();
if (typeof window.refreshAllDesignZones === "function") {
  setTimeout(window.refreshAllDesignZones, 30);
}
}
let thumbUpdateTimer = null;
function scheduleThumbnailUpdate() {
if (thumbUpdateTimer) {
clearTimeout(thumbUpdateTimer);
}
thumbUpdateTimer = setTimeout(updateViewThumbnails, 80);
}
async function updateViewThumbnails() {
var views = ['front', 'back', 'left', 'right'];
for (var i = 0; i < views.length; i++) {
var view = views[i];
var thumbEls = document.querySelectorAll(
'.view-thumb[data-view-thumb="' + view + '"]'
);
if (!thumbEls.length) continue;

// Afficher temporairement la vue si elle est cachée
var viewEl = document.querySelector('.product-view[data-view="' + view + '"]');
var wasHidden = false;
var previousViewStyles = null;
var previousHiddenAttribute = false;
if (viewEl && window.getComputedStyle(viewEl).display === 'none')
  {
  wasHidden = true;
  previousHiddenAttribute = viewEl.hidden;
  previousViewStyles = ['display', 'visibility', 'position', 'pointer-events'].map(function(property) {
    return { property: property, value: viewEl.style.getPropertyValue(property), priority: viewEl.style.getPropertyPriority(property) };
  });
  viewEl.style.setProperty('visibility', 'hidden', 'important');
  viewEl.style.setProperty('pointer-events', 'none', 'important');
  viewEl.hidden = false;
  viewEl.style.setProperty('display', 'flex', 'important');
  viewEl.style.setProperty('position', 'absolute', 'important');
}

try {
var canvas = await captureViewWithProduct(view, 160, 200);
if (canvas) {
  var url = canvas.toDataURL('image/png');
  thumbEls.forEach(function(el) {
    el.style.backgroundImage = 'url(' + url + ')';
  });
}
} catch (e) {}

// Remettre la vue cachée
if (wasHidden && viewEl) {
  previousViewStyles.forEach(function(previous) {
    if (previous.value) viewEl.style.setProperty(previous.property, previous.value, previous.priority);
    else viewEl.style.removeProperty(previous.property);
  });
  viewEl.hidden = previousHiddenAttribute;
}
}
}
function hasAnyCustomization() {
const hasItems = document.querySelectorAll('.design-area .design-item').length > 0;
const note = (window.designNote || '').trim();
return hasItems || note.length > 0;
}
function clearAllCustomization() {
const views = ['front', 'back', 'left', 'right'];
views.forEach(function (v) {
const area = document.querySelector(`.design-area[data-area="${v}"]`);
if (area) area.innerHTML = '';
if (window.designLayers && window.designLayers[v]) {
window.designLayers[v] = [];
}
HISTORY.past[v] = [];
HISTORY.future[v] = [];
pushHistory(v);
if (window.fabricCanvases && window.fabricCanvases[v]) {
try {
window.fabricCanvases[v].clear();
window.fabricCanvases[v].renderAll();
} catch (e) {}
}
});
if (typeof window.deselectAll === 'function') window.deselectAll();
window.selectedItem = null;
window.designNote = '';
const noteInput = document.getElementById('designNoteInput');
if (noteInput) noteInput.value = '';
const noteTextareaMobile = document.getElementById('noteTextareaMobile');
if (noteTextareaMobile) noteTextareaMobile.value = '';
try {
if (typeof updateProductImages === 'function') updateProductImages();
if (typeof refreshProductView === 'function') refreshProductView();
if (typeof refreshViewAvailability === 'function') refreshViewAvailability();
if (typeof updateUndoRedoUI === 'function') updateUndoRedoUI();
} catch (e) {}
if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
setTimeout(function () {
if (typeof updateViewThumbnails === 'function') updateViewThumbnails();
}, 120);
if (typeof saveDesignToLocalStorage === 'function') saveDesignToLocalStorage();
}
function attemptSwitchTechnique(nextTechnique) {
if (typeof window.__ozIsTechniqueAllowed === 'function' && !window.__ozIsTechniqueAllowed(nextTechnique)) {
if (typeof showNotification === 'function') showNotification('Cette technique n’est pas autorisée pour ce produit.', 'warning');
return;
}
const prev = currentTechnique || 'impression';
if (nextTechnique === prev) return;
const hadCustomization = hasAnyCustomization();
if (hadCustomization) {
showTechniqueConfirm(
"Attention : changer de technique va supprimer votre personnalisation actuelle.\n\nÊtes-vous sûr(e) ?",
() => { clearAllCustomization(); selectTechnique(nextTechnique); },
() => { selectTechnique(prev); }
);
return;
}
selectTechnique(nextTechnique);
resetHistoryForAllViews();
}
function showTechniqueConfirm(message, onConfirm, onCancel) {
const overlay = document.getElementById('oazarConfirmOverlay');
const msgEl = document.getElementById('oazarConfirmMessage');
const okBtn = document.getElementById('oazarConfirmOk');
const cancelBtn = document.getElementById('oazarConfirmCancel');
const closeBtn = document.getElementById('oazarConfirmClose');
if (overlay && overlay.parentElement !== document.body) {
document.body.appendChild(overlay);
}
if (!overlay || !msgEl || !okBtn || !cancelBtn) {
const ok = window.confirm(message);
return ok ? (onConfirm && onConfirm()) : (onCancel && onCancel());
}
msgEl.textContent = message;
overlay.classList.add('is-open');
overlay.style.display = 'flex';
overlay.setAttribute('aria-hidden', 'false');
document.body.classList.add('oazar-modal-open');
const cleanup = () => {
overlay.classList.remove('is-open');
overlay.style.display = '';
overlay.setAttribute('aria-hidden', 'true');
document.body.classList.remove('oazar-modal-open');
okBtn.removeEventListener('click', handleOk);
cancelBtn.removeEventListener('click', handleCancel);
if (closeBtn) closeBtn.removeEventListener('click', handleCancel);
overlay.removeEventListener('click', handleOverlayClick);
document.removeEventListener('keydown', handleKeydown);
};
const handleOk = () => { cleanup(); onConfirm && onConfirm(); };
const handleCancel = () => { cleanup(); onCancel && onCancel(); };
const handleOverlayClick = (e) => { if (e.target === overlay) handleCancel(); };
const handleKeydown = (e) => { if (e.key === 'Escape') handleCancel(); };
okBtn.addEventListener('click', handleOk);
cancelBtn.addEventListener('click', handleCancel);
if (closeBtn) closeBtn.addEventListener('click', handleCancel);
overlay.addEventListener('click', handleOverlayClick);
document.addEventListener('keydown', handleKeydown);
okBtn.focus();
}
function initializeTechniqueSelector() {
const impressionBtn = document.getElementById('techniqueImpression');
const broderieBtn = document.getElementById('techniqueBroderie');
const infoDiv = document.getElementById('techniqueInfo');
const mobileImpressionBtn = document.getElementById('mobileTechniqueImpression');
const mobileBroderieBtn = document.getElementById('mobileTechniqueBroderie');
const techniqueInfos = {
impression: '<strong>Impression numérique :</strong> Parfait pour les images en couleur, logos complexes et designs détaillés. Rendu vibrant et précis.',
broderie: '<strong>Broderie :</strong> Ajoutez du texte, une image ou un logo. Le rendu visuel reste indicatif et l’image est vérifiée avant paiement.'
};
function selectTechnique(technique) {
const previousTechnique = currentTechnique;
currentTechnique = technique;
window.currentTechnique = technique;
document.querySelectorAll('.technique-card, .mobile-technique-card').forEach(function(btn) {
const active = btn.dataset.technique === technique;
btn.classList.toggle('active', active);
btn.setAttribute('aria-pressed', String(active));
});
document.querySelectorAll('.technique-description').forEach(function(desc) {
const active = desc.dataset.technique === technique;
desc.classList.toggle('is-active', active);
desc.hidden = !active;
});
const grid = document.querySelector('.quick-actions-grid');
if (grid) grid.setAttribute('data-active-technique', technique);
updateDesignActionVisibility();
if (previousTechnique !== technique) {
  closeDrawer();
  if (typeof updatePriceLiveBlock === 'function') updatePriceLiveBlock();
  document.dispatchEvent(new CustomEvent('oazar:technique-changed', {detail:{technique:technique}}));
}
}
function attemptSwitchTechnique(nextTechnique) {
if (typeof window.__ozIsTechniqueAllowed === 'function' && !window.__ozIsTechniqueAllowed(nextTechnique)) {
if (typeof showNotification === 'function') showNotification('Cette technique n’est pas autorisée pour ce produit.', 'warning');
return;
}
const prev = currentTechnique || 'impression';
if (nextTechnique === prev) return;
const hadCustomization = hasAnyCustomization();
const skipConfirm = !!window.__skipTechniqueConfirm;
window.__skipTechniqueConfirm = false;
if (hadCustomization && currentProduct?.patch && !document.querySelector('.design-area .design-item[data-type="text"]')) {
  selectTechnique(nextTechnique);
  return;
}
if (hadCustomization && !skipConfirm) {
showTechniqueConfirm(
"Attention : changer de technique (broderie / impression) va supprimer votre personnalisation actuelle.\n\nÊtes-vous sûr(e) ?",
() => {
clearAllCustomization();
if (typeof showNotification === 'function') {
showNotification('Personnalisation supprimée suite au changement de technique.', 'warning');
}
selectTechnique(nextTechnique);
resetHistoryForAllViews();
},
() => {
selectTechnique(prev);
}
);
return;
}
if (hadCustomization) {
clearAllCustomization();
if (typeof showNotification === 'function') {
showNotification('Personnalisation supprimée suite au changement de technique.', 'warning');
}
}
selectTechnique(nextTechnique);
resetHistoryForAllViews();
}
if (impressionBtn) {
impressionBtn.addEventListener('click', function() {
attemptSwitchTechnique('impression');
});
}
if (broderieBtn) {
broderieBtn.addEventListener('click', function() {
attemptSwitchTechnique('broderie');
});
}
if (mobileImpressionBtn) {
mobileImpressionBtn.addEventListener('click', function() {
attemptSwitchTechnique('impression');
});
}
if (mobileBroderieBtn) {
mobileBroderieBtn.addEventListener('click', function() {
attemptSwitchTechnique('broderie');
});
}
window.__ozSyncTechniqueUI = selectTechnique;
selectTechnique('impression');
}
/* window.setZoom/zoomIn/zoomOut sont maintenant gérés par initializeZoomControls */
window.setZoom = function() {};
window.zoomIn = function() {};
window.zoomOut = function() {};
function preventPageScroll(e) {
    const target = e.target;

    // 1. Si on est dans un champ de texte (Note, Recherche...), on laisse faire
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return; 
    }

    // 2. Si on est dans un menu déroulant ou la sidebar
    // On cherche si l'élément parent est "scrollable"
    let el = target;
    while (el && el !== document.body) {
        // Si l'élément a une classe explicite de scroll
        if (el.classList.contains('scrollable-content') || 
            el.classList.contains('design-list') || 
            el.classList.contains('customization-sidebar') || 
            el.classList.contains('font-list-container') ||
            el.classList.contains('drawer-body')) {
            
            // Vérifie s'il y a vraiment quelque chose à scroller
            if (el.scrollHeight > el.clientHeight) {
                // On laisse le scroll passer (return)
                return; 
            }
        }
        el = el.parentElement;
    }

    // 3. Sinon, on bloque le scroll UNIQUEMENT si on est sur la zone du T-shirt (Canvas)
    // Cela permet de scroller le reste de la page si on est sur PC
    if (target.closest('#productCanvas') || target.closest('.product-preview-section')) {
        e.preventDefault();
    }
    // Si on n'est pas sur le canvas, on laisse le navigateur gérer (ex: scroll sidebar native)
}

// ============================================================
// MASTER ZOOM V-FINAL (Code incassable et autonome)
// ============================================================
function initializeZoomControls() {
    var container = document.getElementById('productCanvas');
    var content = document.getElementById('canvasContent');
    var slider = document.getElementById('zoomSlider');

    var zoomInBtn = document.getElementById('zoomIn');
    var zoomOutBtn = document.getElementById('zoomOut');
    var resetBtnPC = document.getElementById('resetViewBtn');
    var zoomInMob = document.getElementById('zoomInMobile');
    var zoomOutMob = document.getElementById('zoomOutMobile');
    var resetBtnMob = document.getElementById('resetViewBtnMobile');

    if (!container || !content) {
        return;
    }

    var state = { zoom: 1, pan: { x: 0, y: 0 } };
    var MIN_ZOOM = 0.2;
    var MAX_ZOOM = 4.0;

    // Force CSS
    container.style.touchAction = 'none';
    content.style.touchAction = 'none';
    content.style.transformOrigin = '0 0';

    function applyTransform() {
        content.style.transform = 'translate3d(' + state.pan.x + 'px, ' + state.pan.y + 'px, 0) scale(' + state.zoom + ')';
        window.currentZoom = state.zoom * 100;
        document.documentElement.style.setProperty('--canvas-zoom', state.zoom);
        window.canvasOffset = { x: state.pan.x, y: state.pan.y };
        canvasOffset.x = state.pan.x;
        canvasOffset.y = state.pan.y;
        if (slider) slider.value = window.currentZoom;
    }

    function fitContentToScreen() {
        var contRect = container.getBoundingClientRect();
        var isMobile = window.innerWidth <= 768;
        var isTablet = window.innerWidth > 768 && window.innerWidth <= 1024;

        var usableWidth = contRect.width;
        var usableHeight = contRect.height;

        usableWidth = Math.max(1, contRect.width - (isMobile ? 16 : 40));
        usableHeight = Math.max(1, contRect.height - (isMobile ? 16 : 40));

        var contentW = 500;
        var contentH = 500;

        var productImg = content.querySelector('.product-mockup img, .product-view img');
        if (productImg && productImg.offsetHeight > 0) {
            contentW = productImg.offsetWidth;
            contentH = productImg.offsetHeight;
        } else if (content.offsetWidth > 0) {
            contentW = content.offsetWidth;
            contentH = content.offsetHeight;
        }

        var scaleX = usableWidth / contentW;
        var scaleY = usableHeight / contentH;
        var safetyMargin = 0.90;
        var optimalZoom = Math.min(scaleX, scaleY) * safetyMargin;

        if (optimalZoom > 1) optimalZoom = 1;
        if (optimalZoom < 0.2) optimalZoom = 0.2;

        state.zoom = optimalZoom;

        // Centrage basé sur le container réel
        state.pan.x = (contRect.width - (contentW * state.zoom)) / 2;
        state.pan.y = (contRect.height - (contentH * state.zoom)) / 2;

        applyTransform();
    }

    function doZoom(newZoom, centerX, centerY) {
        var prevZoom = state.zoom;
        newZoom = Math.min(Math.max(newZoom, MIN_ZOOM), MAX_ZOOM);
        if (Math.abs(newZoom - prevZoom) < 0.001) return;

        var rect = container.getBoundingClientRect();
        var focusX = (centerX === undefined) ? rect.width / 2 : (centerX - rect.left);
        var focusY = (centerY === undefined) ? rect.height / 2 : (centerY - rect.top);

        state.pan.x = focusX - (focusX - state.pan.x) * (newZoom / prevZoom);
        state.pan.y = focusY - (focusY - state.pan.y) * (newZoom / prevZoom);
        state.zoom = newZoom;
        applyTransform();
    }

    // Handlers
    var handleZoomIn = function(e) { if(e) e.preventDefault(); content.style.transition = 'transform 0.2s'; doZoom(state.zoom * 1.2); };
    var handleZoomOut = function(e) { if(e) e.preventDefault(); content.style.transition = 'transform 0.2s'; doZoom(state.zoom / 1.2); };
    var handleReset = function(e) {
        if(e) e.preventDefault();
        content.style.transition = 'transform 0.3s ease-out';
        fitContentToScreen();
    };

    // Boutons PC
    if(zoomInBtn) zoomInBtn.onclick = handleZoomIn;
    if(zoomOutBtn) zoomOutBtn.onclick = handleZoomOut;
    if(resetBtnPC) resetBtnPC.onclick = handleReset;
    // Boutons Mobile
    if(zoomInMob) zoomInMob.onclick = handleZoomIn;
    if(zoomOutMob) zoomOutMob.onclick = handleZoomOut;
    if(resetBtnMob) resetBtnMob.onclick = handleReset;

    if (slider) slider.addEventListener('input', function(e) { doZoom(parseInt(e.target.value)/100); });

    // Expose pour compatibilité
    window.setZoom = function(level, focusPoint) {
        var newScale = Math.max(50, Math.min(400, level)) / 100;
        if (focusPoint) {
            doZoom(newScale, focusPoint.x, focusPoint.y);
        } else {
            content.style.transition = 'transform 0.2s ease-out';
            doZoom(newScale);
        }
    };
    window.zoomIn = function() { handleZoomIn(); };
    window.zoomOut = function() { handleZoomOut(); };

    // Molette souris
    container.addEventListener('wheel', function(e) {
        e.preventDefault();
        var factor = Math.exp(-e.deltaY * 0.0015);
        content.style.transition = 'none';
        doZoom(state.zoom * factor, e.clientX, e.clientY);
    }, { passive: false });

    // Pinch-to-zoom tactile
    var isPinching = false, startDist = 0, startZoom = 1, startPan = {x:0,y:0}, startMid = {x:0,y:0};

    container.addEventListener('touchstart', function(e) {
        if (e.touches.length === 2) {
            e.preventDefault(); e.stopImmediatePropagation();
            isPinching = true;
            startDist = Math.hypot(e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY);
            startZoom = state.zoom;
            startPan = { x: state.pan.x, y: state.pan.y };
            startMid = { x: (e.touches[0].clientX + e.touches[1].clientX)/2, y: (e.touches[0].clientY + e.touches[1].clientY)/2 };
            content.style.transition = 'none';
        }
    }, { passive: false, capture: true });

    container.addEventListener('touchmove', function(e) {
        if (!isPinching || e.touches.length !== 2) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var dist = Math.hypot(e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY);
        var mid = { x: (e.touches[0].clientX + e.touches[1].clientX)/2, y: (e.touches[0].clientY + e.touches[1].clientY)/2 };
        var rect = container.getBoundingClientRect();

        if (startDist > 0) {
            var ratio = dist / startDist;
            var newZoom = Math.min(Math.max(startZoom * ratio, MIN_ZOOM), MAX_ZOOM);
            var focusX = mid.x - rect.left;
            var focusY = mid.y - rect.top;

            state.pan.x = focusX - (focusX - startPan.x) * (newZoom / startZoom);
            state.pan.y = focusY - (focusY - startPan.y) * (newZoom / startZoom);
            state.pan.x += (mid.x - startMid.x);
            state.pan.y += (mid.y - startMid.y);

            state.zoom = newZoom;
            applyTransform();
        }
    }, { passive: false, capture: true });

    container.addEventListener('touchend', function(e) {
        if (e.touches.length < 2) { isPinching = false; content.style.transition = 'transform 0.2s'; }
    }, { passive: false, capture: true });

    // Initialisation
    setTimeout(fitContentToScreen, 100);
    window.addEventListener('resize', function() { setTimeout(fitContentToScreen, 100); });
    if (window.ResizeObserver) {
        var fitFrame;
        new ResizeObserver(function() {
            cancelAnimationFrame(fitFrame);
            fitFrame = requestAnimationFrame(fitContentToScreen);
        }).observe(container);
    }
}

function initCanvasBoundaries() {
    var checkInterval = setInterval(function() {
        var canvasVar = window.canvas || window.fabricCanvas;
        if (canvasVar) {
            clearInterval(checkInterval);
            console.log("🔒 Limites du canvas activées sur FabricJS");
            function keepInBounds(e) {
                var obj = e.target;
                if (!obj) return;               
                obj.setCoords(); 
                var rect = obj.getBoundingRect(); 
                var w = canvasVar.width;
                var h = canvasVar.height;
                var deltaLeft = 0, deltaTop = 0;
                if (rect.left < 0) deltaLeft = -rect.left;
                else if (rect.left + rect.width > w) deltaLeft = w - (rect.left + rect.width);
                if (rect.top < 0) deltaTop = -rect.top;
                else if (rect.top + rect.height > h) deltaTop = h - (rect.top + rect.height);
                if (deltaLeft !== 0 || deltaTop !== 0) {
                    obj.left += deltaLeft;
                    obj.top += deltaTop;
                    obj.setCoords();
                }
            }
            canvasVar.on('object:moving', keepInBounds);
            canvasVar.on('object:scaling', keepInBounds);
            canvasVar.on('object:rotating', keepInBounds);
        }
    }, 1000); 
}
function getDistance(touch1, touch2) {
const dx = touch2.clientX - touch1.clientX;
const dy = touch2.clientY - touch1.clientY;
return Math.sqrt(dx * dx + dy * dy);
}
function initializeDrawer() {
const drawer = document.getElementById('customizationDrawer');
const drawerBackdrop = document.getElementById('drawerBackdrop');
const closeBtn = document.getElementById('closeDrawer');
const backBtn = document.getElementById('drawerBack');
const designFullBack = document.getElementById('designFullBack');
const designFullClose = document.getElementById('designFullClose');
if (designFullBack) designFullBack.addEventListener('click', function() { closeDesignFullDrawer({ garderTiroir: true }); });
if (designFullClose) designFullClose.addEventListener('click', function() { closeDesignFullDrawer(); });
if (closeBtn) {
closeBtn.addEventListener('click', closeDrawer);
}
if (drawerBackdrop) {
drawerBackdrop.addEventListener('click', function() { closeDrawer(); });
}
document.addEventListener('keydown', function(event) {
if (event.key !== 'Escape') return;
const picker = document.getElementById('productPicker');
if (picker && picker.classList.contains('show')) {
window.closeProductPicker();
return;
}
const full = document.getElementById('designFullDrawer');
if (full && full.getAttribute('aria-hidden') === 'false') {
closeDesignFullDrawer({ garderTiroir: true });
return;
}
if (drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
});
if (backBtn) {
backBtn.addEventListener('click', function() {
const precedent = drawerHistory.pop();
if (precedent) {
setDrawerMode(precedent, { retour: true });
} else {
closeDrawer();
}
});
}
const imageBtn = document.getElementById('openImageDrawer');
const textBtn = document.getElementById('openTextDrawer');
const designsBtn = document.getElementById('openDesignsDrawer');
const openPickerBtn = document.getElementById('openProductPickerBtn');
const desktopColorBtn = document.getElementById('desktopColorBtn');
if (desktopColorBtn) desktopColorBtn.addEventListener('click', openColorDrawer);
if (imageBtn) {
imageBtn.addEventListener('click', function() {
if (typeof deselectAll === 'function') deselectAll();
openDrawer();
setDrawerMode('import');
});
}
if (textBtn) {
textBtn.addEventListener('click', function() {
if (typeof deselectAll === 'function') {
deselectAll();
}
openDrawer();
setDrawerMode('text');
});
}
if (designsBtn) {
  designsBtn.addEventListener('click', function() {
    openDrawer();
    setDrawerMode('designs');
  });
}
if (openPickerBtn) {
openPickerBtn.addEventListener('click', openProductPicker);
}
}
function openDrawer() {
const drawer = document.getElementById('customizationDrawer');
if (!drawer) return;
if (drawer.getAttribute('aria-hidden') !== 'false') {
/* Nouvelle ouverture : le mode encore en memoire est celui de la session
   precedente, il ne doit pas se retrouver dans la pile. */
drawerHistory = [];
drawerJustOpened = true;
}
drawer.setAttribute('aria-hidden', 'false');
syncSizesDrawerPresentation();
}
function closeDrawer() {
const drawer = document.getElementById('customizationDrawer');
if (!drawer) return;
drawer.setAttribute('aria-hidden', 'true');
drawer.removeAttribute('data-mode');
drawer.classList.remove('drawer--modal');
/* Sans cette remise a zero, le bouton Retour se fie au mode precedent
   et renvoie vers un ecran qui n'est plus affiche. */
drawerMode = 'import';
drawerHistory = [];
drawerJustOpened = false;
closeDesignFullDrawer({ garderTiroir: true });
syncSizesDrawerPresentation();
}
function isCategoryVisibleForTechnique(category, tech) {
  const t = (category && category.technique) ? String(category.technique) : 'impression';
  if (t === 'both') return true;
  return t === tech;
}

function cloneDesignLibraryCategory(category) {
  const cloned = Object.assign({}, category || {});
  cloned.items = Array.isArray(category && category.items)
    ? category.items.map(function(item) { return Object.assign({}, item || {}); })
    : [];
  return cloned;
}
function escapeDesignLibraryHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
function isSmartDesignLibraryItem(item) {
  if (!item || typeof item !== 'object') return false;
  const type = String(item.type || item.kind || '').trim().toLowerCase();
  return !!(
    item.isSmartTemplate ||
    item.smartTemplate ||
    item.smart_template ||
    item.smartTemplateData ||
    item.template ||
    item.templateId ||
    item.template_id ||
    item.templateKey ||
    item.template_key ||
    type === 'smart-template' ||
    type === 'smart_template'
  );
}
function getDesignLibraryPreview(item) {
  if (!item || typeof item !== 'object') return '';
  const direct = item.preview || item.thumbnail || item.card_preview || item.src || '';
  if (direct) return String(direct);
  const api = window.OazarSmartTemplates;
  if (api && typeof api.getPreviewForLibraryItem === 'function') {
    try {
      return String(api.getPreviewForLibraryItem(item) || '');
    } catch (e) {}
  }
  return '';
}
function getDesignLibraryLabel(item) {
  return String(
    (item && (item.title || item.name || item.label || item.templateTitle || item.template_title)) ||
    'Design'
  ).trim();
}
function getMergedVisibleDesignCategories(techOverride) {
  const tech = techOverride || (window.currentTechnique || currentTechnique || 'impression');
  const adventOnly = new URLSearchParams(location.search).get('advent') === '1' &&
    new URLSearchParams(location.search).get('handle') === 'calendrier-de-lavent-24-pochettes-personnalisees';
  const api = window.OazarSmartTemplates;
  if (api && typeof api.getDesignCategories === 'function') {
    try {
      const merged = api.getDesignCategories(tech, designLibrary);
      if (Array.isArray(merged) && merged.length) return adventOnly ? merged.filter(c => /^oazar-avent-/.test(c.id)) : merged;
    } catch (e) {
      console.warn('[smart templates] unable to merge designs categories', e);
    }
  }
  const cats = (designLibrary && Array.isArray(designLibrary.categories)) ? designLibrary.categories : [];
  return cats
    .filter(c => !adventOnly || /^oazar-avent-/.test(c.id))
    .filter(c => isCategoryVisibleForTechnique(c, tech))
    .filter(c => Array.isArray(c.items) && c.items.length > 0)
    .map(cloneDesignLibraryCategory);
}
function openSmartDesignFromLibraryItem(item) {
  const api = window.OazarSmartTemplates;
  if (!api || typeof api.openTemplateFromLibraryItem !== 'function') {
    if (typeof showNotification === 'function') {
      showNotification("La bibliothèque de designs personnalisables n'est pas prête.", 'error');
    } else {
      alert("La bibliothèque de designs personnalisables n'est pas prête.");
    }
    return;
  }
  closeDesignFullDrawer({ garderTiroir: true });
  closeDrawer();
  api.openTemplateFromLibraryItem(item);
}
function handleDesignLibraryItemClick(item) {
  if (isSmartDesignLibraryItem(item)) {
    openSmartDesignFromLibraryItem(item);
    return;
  }
  Promise.resolve(addLibraryDesignToCurrentViewAndUpload(item)).then(function() {
    closeDesignFullDrawer({ garderTiroir: true });
    closeDrawer();
  }).catch(function() {
    showNotification("Impossible d'ajouter ce design.", 'error');
  });
}
function buildDesignLibraryTileMarkup(item) {
  const label = escapeDesignLibraryHtml(getDesignLibraryLabel(item));
  const preview = escapeDesignLibraryHtml(getDesignLibraryPreview(item));
  const isSmart = isSmartDesignLibraryItem(item);

  const visual = (preview || isSmart)
    ? (
      '<span class="design-tile-preview-stack">' +
        (preview ? '<img src="' + preview + '" alt="' + label + '">' : '') +
        '<span class="design-tile-fallback"' + (preview ? ' hidden' : '') + '>' + (isSmart ? 'SVG' : 'IMG') + '</span>' +
      '</span>'
    )
    : '<span class="design-tile-fallback">' + (isSmart ? 'SVG' : 'IMG') + '</span>';

  /* Le nom reste disponible pour l'accessibilité via aria-label du bouton,
     mais le tiroir n'affiche plus de texte sous les vignettes. */
  return '' +
    '<span class="design-tile-visual" aria-label="' + label + '">' +
      visual +
    '</span>';
}

function hydrateDesignLibraryTile(tile, item) {
  if (!tile) return;
  const renderSvg = function(svgMarkup) {
    if (!svgMarkup || typeof DOMParser === 'undefined') return false;
    try {
      const parsed = new DOMParser().parseFromString(String(svgMarkup), 'image/svg+xml');
      const svg = parsed.documentElement;
      if (svg && svg.localName.toLowerCase() === 'svg' && !parsed.querySelector('parsererror')) {
        svg.querySelectorAll('script, foreignObject, iframe, object, embed').forEach(function(node) { node.remove(); });
        [svg].concat(Array.from(svg.querySelectorAll('*'))).forEach(function(node) {
          Array.from(node.attributes || []).forEach(function(attribute) {
            if (/^on/i.test(attribute.name) || /^(?:href|xlink:href)$/i.test(attribute.name) && /^\s*javascript:/i.test(attribute.value)) {
              node.removeAttribute(attribute.name);
            }
          });
        });
        if (!svg.hasAttribute('viewBox') && svg.hasAttribute('viewbox')) svg.setAttribute('viewBox', svg.getAttribute('viewbox'));
        if (!svg.hasAttribute('viewBox')) {
          const width = parseFloat(svg.getAttribute('width'));
          const height = parseFloat(svg.getAttribute('height'));
          if (width > 0 && height > 0) svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
        }
        svg.setAttribute('width', '100%');
        svg.setAttribute('height', '100%');
        svg.setAttribute('aria-hidden', 'true');
        const stack = tile.querySelector('.design-tile-preview-stack, .oz-smarttpl-card-thumb');
        if (stack) {
          stack.replaceChildren(document.importNode(svg, true));
          return true;
        }
      }
    } catch (error) {}
    return false;
  };
  renderSvg(item && (item.svgMarkup || item.inlineTemplate && item.inlineTemplate.svgMarkup));
  const api = window.OazarSmartTemplates;
  if (isSmartDesignLibraryItem(item) && api && typeof api.getSvgPreviewMarkupForLibraryItem === 'function') {
    Promise.resolve(api.getSvgPreviewMarkupForLibraryItem(item)).then(function(markup) {
      if (tile.isConnected) renderSvg(markup);
    }).catch(function() {});
  }
  const img = tile.querySelector('.design-tile-preview-stack img, .oz-smarttpl-card-thumb img');
  if (!img) return;

  let fallback = img.parentElement && img.parentElement.querySelector('.design-tile-fallback, .oz-smarttpl-card-fallback');
  const revealFallback = function() {
    img.style.display = 'none';
    if (!fallback && img.parentElement) {
      fallback = document.createElement('span');
      fallback.className = 'oz-smarttpl-card-fallback';
      fallback.textContent = 'SVG';
      img.parentElement.appendChild(fallback);
    }
    if (fallback) fallback.hidden = false;
  };

  img.addEventListener('error', revealFallback, { once: true });
  if (img.complete && !img.naturalWidth) revealFallback();
}

function getVisibleDesignCategories(techOverride) {
  return getMergedVisibleDesignCategories(techOverride);
}
function hasDesignsForTechnique(techOverride) {
  return getVisibleDesignCategories(techOverride).length > 0;
}
function setDisplayImportant(el, displayValue) {
  if (!el) return;
  el.style.setProperty('display', displayValue, 'important');
}
function updateDesignActionVisibility() {
  const tech = window.currentTechnique || 'impression';
  const patch = !!window.currentProduct?.patch;
  document.getElementById('mon-customizer')?.classList.toggle('oz-patch-product', patch);
  const showDesigns = !patch && (tech === 'impression' || hasDesignsForTechnique(tech));
  ['openTextDrawer','mobileTextBtn'].forEach(function(id) { setDisplayImportant(document.getElementById(id), patch ? 'none' : 'flex'); });
  const mobileDesignsBtn = document.getElementById('mobileDesignsBtn');
  const designsBtn = document.getElementById('openDesignsDrawer');
  setDisplayImportant(mobileDesignsBtn, showDesigns ? 'flex' : 'none');
  setDisplayImportant(designsBtn, showDesigns ? 'flex' : 'none');
  const mobileImageBtn = document.getElementById('mobileImageBtn');
  const imageBtn = document.getElementById('openImageDrawer');
  setDisplayImportant(mobileImageBtn, 'flex');
  setDisplayImportant(imageBtn, 'flex');
}
function openDesignFullDrawer(categoryId) {
const drawer = document.getElementById('designFullDrawer');
const titleEl = document.getElementById('designFullTitle');
const bodyEl = document.getElementById('designFullBody');
if (!drawer || !titleEl || !bodyEl) return;
const cats = getVisibleDesignCategories();
const category = cats.find(c => String(c.id) === String(categoryId));
if (!category) return;
titleEl.textContent = category.title || 'Designs';
drawer.dataset.ozCategoryId = String(category.id || '');
bodyEl.innerHTML = '';
const grid = document.createElement('div');
grid.className = 'design-full-grid';
(category.items || []).forEach((item) => {
const btn = document.createElement('button');
btn.type = 'button';
btn.className = 'design-full-tile' + (isSmartDesignLibraryItem(item) ? ' is-smart-template' : '');
btn.setAttribute('aria-label', getDesignLibraryLabel(item));
btn.innerHTML = buildDesignLibraryTileMarkup(item);
hydrateDesignLibraryTile(btn, item);
btn.addEventListener('click', function() {
closeDesignFullDrawer({ garderTiroir: true });
handleDesignLibraryItemClick(item);
});
grid.appendChild(btn);
});
bodyEl.appendChild(grid);
drawer.setAttribute('aria-hidden', 'false');
syncSizesDrawerPresentation();
}
/* options.garderTiroir : ne pas toucher au tiroir principal. A utiliser
   quand l'appelant enchaine lui-meme sur un autre ecran (ajout d'un design
   -> options, modele intelligent -> modale). Sans ce drapeau, fermer la
   bibliotheque ramene au menu de base, au lieu de laisser reapparaitre
   l'ecran d'import reste ouvert derriere. */
function closeDesignFullDrawer(options) {
const drawer = document.getElementById('designFullDrawer');
if (!drawer) return;
drawer.setAttribute('aria-hidden', 'true');
if (options && options.garderTiroir) {
syncSizesDrawerPresentation();
return;
}
closeDrawer();
}
function syncSizesDrawerPresentation() {
const drawer = document.getElementById('customizationDrawer');
if (!drawer) return;

/* Le voile est relu depuis le DOM : la constante du meme nom vit dans
   initializeDrawer, elle n'est pas visible ici. */
const backdrop = document.getElementById('drawerBackdrop');
const isOpen = drawer.getAttribute('aria-hidden') === 'false';
const fullDrawer = document.getElementById('designFullDrawer');
const fullOpen = !!(fullDrawer && fullDrawer.getAttribute('aria-hidden') === 'false');
const show = isOpen || fullOpen;
const editorVisible = isOpen && !fullOpen &&
  ['import', 'options', 'text'].includes(drawerMode);
const clearBackdrop = fullOpen || (isOpen && ['ai', 'designs'].includes(drawerMode));
drawer.classList.remove('drawer--modal');
if (backdrop) {
backdrop.hidden = !show;
backdrop.classList.toggle('is-open', show);
backdrop.classList.toggle('is-editor', editorVisible);
backdrop.classList.toggle('is-clear', clearBackdrop);
backdrop.setAttribute('aria-hidden', String(!show));
}
}
function setDrawerMode(mode, options) {
if (window.currentProduct?.patch && ['text','designs'].includes(mode)) {
  showNotification('Pour cet écusson, importez une image ou créez votre visuel avec l’IA.', 'warning');
  return;
}
if (mode === 'options' && window.OazarSmartTemplates && typeof window.OazarSmartTemplates.openForItem === 'function' && window.OazarSmartTemplates.openForItem(selectedItem)) {
  closeDrawer();
  return;
}
const opts = options || {};
const drawer = document.getElementById('customizationDrawer');
if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') openDrawer();
if (!opts.retour && !drawerJustOpened && drawerMode && drawerMode !== mode) {
drawerHistory.push(drawerMode);
if (drawerHistory.length > 8) drawerHistory.shift();
}
drawerJustOpened = false;
drawerMode = mode;
if (drawer) drawer.dataset.mode = mode;
if (drawer) drawer.classList.toggle('oz-patch-sizes', mode === 'sizes' && !!currentProduct?.patch);
const titleEl = document.getElementById('drawerTitle');
const bodyEl = document.getElementById('drawerBody');
if (!titleEl || !bodyEl) return;
const preparedTextScreen = mode === 'text' ? buildTextOptionsScreen() : null;
bodyEl.innerHTML = '';
switch (mode) {
case 'import':
titleEl.textContent = 'Importer une image';
buildImportScreen(bodyEl);
break;
case 'options':
titleEl.textContent = "Options de l'image";
bodyEl.appendChild(buildOptionsScreen());
break;
case 'text':
titleEl.textContent = 'Ajouter du texte';
bodyEl.appendChild(preparedTextScreen);
break;
case 'designs':
titleEl.textContent = 'Nos designs';
buildDesignsScreen(bodyEl);
break;
case 'ai':
titleEl.textContent = "Créer avec l’IA";
if (window.OazarAI && typeof window.OazarAI.renderInto === 'function') {
window.OazarAI.renderInto(bodyEl);
}
break;
case 'colors':
titleEl.textContent = 'Choisir une couleur';
bodyEl.appendChild(buildColorsScreen());
break;
case 'sizes':
titleEl.textContent = currentProduct?.patch ? 'Dimensions et quantité' : 'Choisir une taille';
const screen = buildSizesScreen();
bodyEl.appendChild(screen);
requestAnimationFrame(updateSizeDrawerTotals);
setTimeout(updateSizeDrawerTotals, 150);
break;
}

const retourEl = document.getElementById('drawerBack');
if (retourEl) retourEl.style.display = drawerHistory.length ? '' : 'none';

/* Même voile et même taille de tiroir pour tous les écrans. */
syncSizesDrawerPresentation();
}
function buildImportScreen(body) {
body.innerHTML =
'<div class="upload-section">' +
'<div class="upload-card" id="studioUploadDropzone">' +
'<div class="upload-icon">' +
'<svg viewBox="0 0 64 64" aria-hidden="true">' +
'<rect x="12" y="10" width="38" height="34" rx="4" fill="none" stroke="currentColor" stroke-width="2"/>' +
'<circle cx="40" cy="20" r="4" fill="none" stroke="currentColor" stroke-width="2"/>' +
'<path d="M17 39 27 29l7 7 5-5 10 10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
'</svg>' +
'<span class="upload-plus" aria-hidden="true">+</span>' +
'</div>' +
'<h3>Glissez-déposez votre image ici</h3>' +
'<p class="upload-subtitle">ou cliquez pour sélectionner un fichier</p>' +
'<button type="button" class="upload-primary-btn" id="chooseImageFile">Choisir un fichier</button>' +
'<small class="upload-formats">PNG, JPG, WEBP · Max 10 Mo</small>' +
'</div>' +
'<input type="file" id="imageUpload" accept="image/png,image/jpeg,image/jpg,image/webp,image/svg+xml" multiple hidden>' +
'<div class="upload-divider"><span>ou</span></div>' +
'<div class="upload-source-grid">' +
'<button type="button" class="upload-source-btn" id="uploadFromDevice">' +
'<svg viewBox="0 0 24 24" aria-hidden="true">' +
'<rect x="7" y="2.5" width="10" height="19" rx="2" fill="none" stroke="currentColor" stroke-width="1.7"/>' +
'<line x1="10" y1="18.5" x2="14" y2="18.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
'</svg>' +
'<span>Depuis votre appareil</span>' +
'</button>' +
'<button type="button" class="upload-source-btn" id="uploadFromUrl">' +
'<svg viewBox="0 0 24 24" aria-hidden="true">' +
'<path d="M10 13.8 8.2 15.6a3.4 3.4 0 0 1-4.8-4.8l3-3a3.4 3.4 0 0 1 4.8 0" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
'<path d="m14 10.2 1.8-1.8a3.4 3.4 0 0 1 4.8 4.8l-3 3a3.4 3.4 0 0 1-4.8 0" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
'<path d="m8.8 15.2 6.4-6.4" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
'</svg>' +
'<span>Depuis une URL</span>' +
'</button>' +
'</div>' +
'<div class="upload-url-panel" id="uploadUrlPanel" hidden>' +
'<label for="uploadUrlInput">Lien direct vers votre image</label>' +
'<div class="upload-url-row">' +
'<input type="url" id="uploadUrlInput" placeholder="https://exemple.com/image.png" autocomplete="off">' +
'<button type="button" id="confirmUploadUrl">Importer</button>' +
'</div>' +
'<small>Utilisez un lien direct vers une image PNG, JPG, WEBP ou SVG.</small>' +
'</div>' +
'<div class="recent-imports-card" id="recentImportsCard">' +
'<h4>Vos fichiers récents</h4>' +
'<div id="recentImportsGrid" class="recent-imports-grid"></div>' +
'<div id="recentImportsEmpty" class="recent-imports-empty" style="display:none;">Aucune image importée pour le moment.</div>' +
'</div>' +
'</div>';

initializeImageUpload();
if (window.currentProduct?.patch) {
  body.querySelector('#imageUpload')?.removeAttribute('multiple');
  const note = document.createElement('p');note.className = 'oz-patch-single-hint';note.textContent = 'Un seul visuel par écusson : une nouvelle image remplace la précédente.';body.prepend(note);
}
renderRecentImports();

const dropZone = body.querySelector('#studioUploadDropzone');
const uploadInput = body.querySelector('#imageUpload');
const chooseFileBtn = body.querySelector('#chooseImageFile');
const deviceBtn = body.querySelector('#uploadFromDevice');
const urlBtn = body.querySelector('#uploadFromUrl');
const urlPanel = body.querySelector('#uploadUrlPanel');
const urlInput = body.querySelector('#uploadUrlInput');
const confirmUrlBtn = body.querySelector('#confirmUploadUrl');

function openFilePicker() {
if (uploadInput) uploadInput.click();
}

if (chooseFileBtn) {
chooseFileBtn.addEventListener('click', function(event) {
event.preventDefault();
event.stopPropagation();
openFilePicker();
});
}

if (deviceBtn) {
deviceBtn.addEventListener('click', function(event) {
event.preventDefault();
openFilePicker();
});
}

if (urlBtn && urlPanel) {
urlBtn.addEventListener('click', function(event) {
event.preventDefault();
urlPanel.hidden = !urlPanel.hidden;
urlBtn.classList.toggle('is-active', !urlPanel.hidden);
if (!urlPanel.hidden && urlInput) {
setTimeout(function() { urlInput.focus(); }, 50);
}
});
}

function inferImageMime(url, blobType) {
if (blobType && /^image\//i.test(blobType)) return blobType;
const pathname = String(url || '').split('?')[0].toLowerCase();
if (pathname.endsWith('.png')) return 'image/png';
if (pathname.endsWith('.webp')) return 'image/webp';
if (pathname.endsWith('.svg')) return 'image/svg+xml';
if (pathname.endsWith('.jpg') || pathname.endsWith('.jpeg')) return 'image/jpeg';
return '';
}

async function importImageFromUrl() {
if (!urlInput || !uploadInput) return;
const rawUrl = urlInput.value.trim();
if (!rawUrl) {
showNotification('Collez le lien de votre image.', 'warning');
return;
}
let parsedUrl;
try {
parsedUrl = new URL(rawUrl);
} catch (error) {
showNotification('Le lien indiqué n’est pas valide.', 'error');
return;
}
if (parsedUrl.protocol !== 'https:' && parsedUrl.protocol !== 'http:') {
showNotification('Utilisez un lien commençant par http:// ou https://.', 'error');
return;
}
if (confirmUrlBtn) {
confirmUrlBtn.disabled = true;
confirmUrlBtn.textContent = 'Import...';
}
try {
const response = await fetch(rawUrl, {
method: 'GET',
mode: 'cors',
credentials: 'omit'
});
if (!response.ok) throw new Error('HTTP ' + response.status);
const blob = await response.blob();
const mime = inferImageMime(rawUrl, blob.type);
const allowed = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/svg+xml'];
if (!mime || !allowed.includes(mime)) {
throw new Error('Le lien ne correspond pas à une image prise en charge.');
}
const MAX_URL_IMAGE_SIZE = 10 * 1024 * 1024;
if (blob.size > MAX_URL_IMAGE_SIZE) {
showNotification('Image trop volumineuse (max 10 Mo).', 'error');
return;
}
let fileName = '';
try {
fileName = decodeURIComponent(parsedUrl.pathname.split('/').pop() || '');
} catch (error) {
fileName = '';
}
const extensions = {
'image/png': '.png',
'image/jpeg': '.jpg',
'image/jpg': '.jpg',
'image/webp': '.webp',
'image/svg+xml': '.svg'
};
if (!fileName || !/\.(png|jpe?g|webp|svg)$/i.test(fileName)) {
fileName = 'image-url-' + Date.now() + (extensions[mime] || '.png');
}
const remoteFile = new File([blob], fileName, {
type: mime,
lastModified: Date.now()
});
const transfer = new DataTransfer();
transfer.items.add(remoteFile);
uploadInput.files = transfer.files;
uploadInput.dispatchEvent(new Event('change', { bubbles: true }));
urlInput.value = '';
urlPanel.hidden = true;
urlBtn.classList.remove('is-active');
} catch (error) {
console.error('Import URL impossible :', error);
showNotification("Impossible de récupérer cette image. Le site qui l’héberge bloque peut-être l’import externe (CORS).", 'error');
} finally {
if (confirmUrlBtn) {
confirmUrlBtn.disabled = false;
confirmUrlBtn.textContent = 'Importer';
}
}
}

if (confirmUrlBtn) {
confirmUrlBtn.addEventListener('click', function(event) {
event.preventDefault();
importImageFromUrl();
});
}

if (urlInput) {
urlInput.addEventListener('keydown', function(event) {
if (event.key === 'Enter') {
event.preventDefault();
importImageFromUrl();
}
});
}

if (dropZone && uploadInput) {
dropZone.addEventListener('click', function(event) {
if (event.target.closest('button')) return;
openFilePicker();
});
['dragenter', 'dragover'].forEach(function(eventName) {
dropZone.addEventListener(eventName, function(event) {
event.preventDefault();
dropZone.classList.add('is-dragging');
});
});
['dragleave', 'drop'].forEach(function(eventName) {
dropZone.addEventListener(eventName, function(event) {
event.preventDefault();
dropZone.classList.remove('is-dragging');
});
});
dropZone.addEventListener('drop', function(event) {
const droppedFiles = event.dataTransfer && event.dataTransfer.files;
if (!droppedFiles || !droppedFiles.length) return;
try {
const transfer = new DataTransfer();
Array.from(droppedFiles).forEach(function(file) { transfer.items.add(file); });
uploadInput.files = transfer.files;
uploadInput.dispatchEvent(new Event('change', { bubbles: true }));
} catch (error) {
showNotification('Déposez une image PNG, JPG, WEBP ou SVG.', 'warning');
}
});
}
}
function buildOptionsScreen() {
const wrapper = document.createElement('div');
wrapper.className = 'text-options-screen image-options-screen';

if (!selectedItem || selectedItem.dataset.type !== 'image') {
wrapper.innerHTML = `
<p class="no-selection-msg">
Sélectionnez d'abord une image dans la zone de personnalisation.
</p>
`;
return wrapper;
}

const selectedImage = selectedItem.querySelector('img');
const currentScale = parseFloat(selectedItem.dataset.scale || '0.75');
const validScales = [0.25, 0.5, 0.75, 1.0];
const nearestScale = validScales.reduce((previous, current) =>
Math.abs(current - currentScale) < Math.abs(previous - currentScale) ? current : previous
);
const isLocked = selectedItem.dataset.locked === '1';
const imageSrc = selectedImage ? (selectedImage.currentSrc || selectedImage.src || '') : '';
const imageName = selectedImage
? (selectedImage.dataset.originalName || selectedImage.dataset.fileName || 'Votre visuel')
: 'Votre visuel';

wrapper.innerHTML = `
<div id="image-options-root">
<style>@layer oazar-legacy {
#image-options-root {
display:flex;
flex-direction:column;
gap:18px;
}
#image-options-root .image-selected-card {
display:grid;
grid-template-columns:90px minmax(0,1fr);
align-items:center;
gap:15px;
min-height:108px;
padding:11px;
margin:0;
border:1px solid #e0e2e6;
border-radius:11px;
background:#fff;
}
#image-options-root .image-selected-card img {
width:90px;
height:86px;
padding:8px;
box-sizing:border-box;
border-radius:8px;
background:#f7f7f7;
object-fit:contain;
}
#image-options-root .image-selected-card strong {
display:block;
margin-bottom:4px;
color:#111;
font-size:14px;
font-weight:600;
}
#image-options-root .image-selected-card span {
display:block;
overflow:hidden;
color:#78808d;
font-size:12px;
text-overflow:ellipsis;
white-space:nowrap;
}
#image-options-root .image-actions-row {
display:grid;
grid-template-columns:repeat(4,minmax(0,1fr));
gap:8px;
}
#image-options-root .image-action-btn {
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
gap:5px;
min-width:0;
min-height:64px;
padding:8px 4px;
border:1px solid #e1e3e7;
border-radius:10px;
background:#fff;
color:#111;
font-size:9px;
font-weight:500;
cursor:pointer;
box-shadow:none;
transform:none;
}
#image-options-root .image-action-btn:hover {
background:#f8f8f8;
border-color:#d6d8dc;
transform:none;
}
#image-options-root .image-action-btn svg {
width:21px;
height:21px;
}
#image-options-root .image-size-section {
margin:0;
padding:0;
border:0;
background:transparent;
}
#image-options-root .image-size-title {
margin:0 0 9px;
color:#171717;
font-size:10px;
font-weight:600;
line-height:1.3;
text-transform:none;
letter-spacing:0;
}
#image-options-root .scale-presets {
display:grid;
grid-template-columns:repeat(4,minmax(0,1fr));
gap:9px;
}
#image-options-root .preset-btn,
#image-options-root .preset-btn:hover {
min-height:43px;
padding:0;
border:1px solid #dfe2e7;
border-radius:999px;
background:#fff;
color:#111;
font-size:12px;
font-weight:500;
cursor:pointer;
box-shadow:none;
transform:none;
}
#image-options-root .preset-btn.active,
#image-options-root .preset-btn.active:hover {
background:#171717;
border-color:#171717;
color:#fff;
}
}
</style>

<div class="image-selected-card">
  <img src="${escapeDesignLibraryHtml(imageSrc)}" alt="">
  <div>
    <strong>Image sélectionnée</strong>
    <span>${escapeDesignLibraryHtml(imageName)}</span>
  </div>
</div>
${(window.currentTechnique || 'impression') === 'broderie' ? '<button type="button" class="oz-embroidery-preview-trigger" data-oz-embroidery-preview><span class="oz-embroidery-preview-trigger__icon" aria-hidden="true"><img src="' + escapeDesignLibraryHtml(document.getElementById('mon-customizer')?.dataset.iconBroderie || '') + '" alt=""></span><span><strong>Voir l’effet broderie</strong><small>Aperçu sur votre image et votre produit</small></span><span aria-hidden="true">→</span></button>' : ''}

<div class="image-actions-row">
  <button type="button" class="image-action-btn" data-image-action="replace" aria-label="Remplacer">
    ${oazarStudioIcon('image')}
    <span>Remplacer</span>
  </button>

  <button type="button" class="image-action-btn" data-image-action="duplicate" aria-label="Dupliquer">
    ${oazarStudioIcon('copy')}
    <span>Dupliquer</span>
  </button>

  <button type="button" class="image-action-btn" data-image-action="lock" aria-label="${isLocked ? 'Déverrouiller' : 'Verrouiller'}">
    ${oazarStudioIcon(isLocked ? 'unlock' : 'lock')}
    <span>${isLocked ? 'Déverrouiller' : 'Verrouiller'}</span>
  </button>

  <button type="button" class="image-action-btn" data-image-action="delete" aria-label="Supprimer">
    ${oazarStudioIcon('trash')}
    <span>Supprimer</span>
  </button>
</div>

<div class="image-size-section">
  <h4 class="image-size-title">Taille de l'image</h4>

  <div class="scale-presets">
    <button type="button" class="preset-btn ${nearestScale === 0.25 ? 'active' : ''}" data-scale="0.25">S</button>
    <button type="button" class="preset-btn ${nearestScale === 0.5 ? 'active' : ''}" data-scale="0.5">M</button>
    <button type="button" class="preset-btn ${nearestScale === 0.75 ? 'active' : ''}" data-scale="0.75">L</button>
    <button type="button" class="preset-btn ${nearestScale === 1.0 ? 'active' : ''}" data-scale="1.0">XL</button>
  </div>
</div>

</div>
`;

wrapper.querySelectorAll('.preset-btn[data-scale]').forEach(function(button) {
button.addEventListener('click', function() {
applyImageScale(parseFloat(button.dataset.scale));
wrapper.querySelectorAll('.preset-btn[data-scale]').forEach(function(otherButton) {
otherButton.classList.remove('active');
});
button.classList.add('active');
});
});
const embroideryPreviewButton = wrapper.querySelector('[data-oz-embroidery-preview]');
if (embroideryPreviewButton) embroideryPreviewButton.addEventListener('click', function() {
  if (typeof window.ozOpenEmbroideryPreview === 'function') window.ozOpenEmbroideryPreview(selectedImage);
});
if (window.OazarPatchStudio?.enabled && window.currentProduct?.patch) {
  const patchButton = document.createElement('button');
  patchButton.type = 'button';
  patchButton.className = 'oz-patch-trigger';
  patchButton.dataset.ozPatchOpen = 'true';
  patchButton.innerHTML = '<svg viewBox="0 0 28 28" fill="none" aria-hidden="true"><path d="M8 4h12l5 7-3 12-8 2-10-5-1-9z" stroke="currentColor" stroke-width="1.5"/><path d="M9 7h10l3 5-2 9-6 1-7-4-1-7z" stroke="currentColor" stroke-width="1.2" stroke-dasharray="2 2"/></svg><span><strong>' + (selectedImage.dataset.ozPatchConfig ? 'Modifier mon écusson' : 'Créer un contour d’écusson') + '</strong><small>Forme et couleur du contour brodé</small></span><span aria-hidden="true">→</span>';
  wrapper.querySelector('.image-actions-row').before(patchButton);
  wrapper.querySelectorAll('[data-image-action="duplicate"]').forEach(function(button) { button.remove(); });
  patchButton.addEventListener('click', () => window.OazarPatchStudio.open(selectedImage));
}

wrapper.querySelectorAll('[data-image-action]').forEach(function(button) {
button.addEventListener('click', function() {
const action = button.dataset.imageAction;

switch (action) {
case 'replace':
setDrawerMode('import');
break;

case 'duplicate':
duplicateSelected();
break;

case 'lock': {
if (!selectedItem) return;
const newLocked = selectedItem.dataset.locked !== '1';
selectedItem.dataset.locked = newLocked ? '1' : '0';
selectedItem.classList.toggle('locked', newLocked);
updateLockOnElement(selectedItem, newLocked);
toolsLockIsLocked = newLocked;
lockButtonWasClicked = true;
syncToolsLockButtons();

button.innerHTML =
oazarStudioIcon(newLocked ? 'unlock' : 'lock') +
'<span>' + (newLocked ? 'Déverrouiller' : 'Verrouiller') + '</span>';
button.setAttribute('aria-label', newLocked ? 'Déverrouiller' : 'Verrouiller');
break;
}

case 'delete': {
if (!selectedItem) return;
const trashBtn = selectedItem.querySelector('.di-trash');
if (trashBtn) trashBtn.click();
closeDrawer();
break;
}
}
});
});

return wrapper;
}
function bindImageScaleEvents(wrapper) {
wrapper.querySelectorAll('.preset-btn[data-scale]').forEach(btn => {
btn.addEventListener('click', () => {
wrapper.querySelectorAll('.preset-btn').forEach(b => b.classList.remove('active'));
btn.classList.add('active');
applyImageScale(parseFloat(btn.dataset.scale));
});
});
wrapper.querySelectorAll('[data-action]').forEach(btn => {
btn.addEventListener('click', () => {
if (!selectedItem) {
showNotification("Sélectionnez un élément d'abord", 'warning');
return;
}
const action = btn.dataset.action;
switch (action) {
case 'duplicate':
duplicateSelected();
break;
case 'lock': {
if (!selectedItem) return;
const isLocked = selectedItem.dataset.locked === '1';
const newLocked = !isLocked;
selectedItem.dataset.locked = newLocked ? '1' : '0';
selectedItem.classList.toggle('locked', newLocked);
updateLockOnElement(selectedItem, newLocked);
toolsLockIsLocked = newLocked;
lockButtonWasClicked = true;
syncToolsLockButtons();
break;
}
case 'delete': {
const trashBtn = selectedItem.querySelector('.di-trash');
if (trashBtn) trashBtn.click();
closeDrawer();
break;
}
case 'align-left':
alignSelected('left');
break;
case 'align-center-h':
alignSelected('centerX');
break;
case 'align-right':
alignSelected('right');
break;
case 'align-top':
alignSelected('top');
break;
case 'align-center-v':
alignSelected('centerY');
break;
case 'align-bottom':
alignSelected('bottom');
break;
}
});
});
}
function applyImageScale(scale) {
if (!selectedItem || selectedItem.dataset.type !== 'image') return;
const area = selectedItem.closest('.design-area');
if (!area) return;
const areaW = area.offsetWidth;
const areaH = area.offsetHeight;
const img = selectedItem.querySelector('img');
if (!img) return;
const nw = img.naturalWidth || img.width;
const nh = img.naturalHeight || img.height;
if (!nw || !nh) return;
const imgRatio = nw / nh;
const targetW = areaW * scale;
const targetH = areaH * scale;
let newWidth, newHeight;
if (imgRatio > targetW / targetH) {
  newWidth = targetW; newHeight = targetW / imgRatio;
} else {
  newHeight = targetH; newWidth = targetH * imgRatio;
}
selectedItem.style.width = newWidth + 'px';
selectedItem.style.height = newHeight + 'px';
selectedItem.style.left = ((areaW - newWidth) / 2) + 'px';
selectedItem.style.top = ((areaH - newHeight) / 2) + 'px';
selectedItem.dataset.scale = scale;
updateOverflowState(selectedItem);
if (typeof updateItemSizeBadge === 'function') updateItemSizeBadge(selectedItem);
}
function fitImageToZone() {
if (!selectedItem || selectedItem.dataset.type !== 'image') return;
const area = selectedItem.closest('.design-area');
if (!area) return;
const areaRect = area.getBoundingClientRect();
const img = selectedItem.querySelector('img');
if (!img) return;
const originalWidth = img.naturalWidth || img.width;
const originalHeight = img.naturalHeight || img.height;
const originalRatio = originalWidth / originalHeight;
const maxWidth = areaRect.width * 0.85;
const maxHeight = areaRect.height * 0.85;
let fitWidth = maxWidth;
let fitHeight = maxWidth / originalRatio;
if (fitHeight > maxHeight) {
fitHeight = maxHeight;
fitWidth = fitHeight * originalRatio;
}
selectedItem.style.width = fitWidth + 'px';
selectedItem.style.height = fitHeight + 'px';
const left = (areaRect.width - fitWidth) / 2;
const top = (areaRect.height - fitHeight) / 2;
selectedItem.style.left = left + 'px';
selectedItem.style.top = top + 'px';
const fitScale = fitWidth / originalWidth;
selectedItem.dataset.scale = fitScale;
updateScaleDisplay(fitScale);
updateOverflowState(selectedItem);
}
function updateScaleDisplay(scale) {
const validScales = [0.25, 0.5, 0.75, 1.0];
const nearest = validScales.reduce((p,c) => Math.abs(c-scale)<Math.abs(p-scale)?c:p);
document.querySelectorAll('.preset-btn[data-scale]').forEach(b => {
  b.classList.toggle('active', parseFloat(b.dataset.scale) === nearest);
});
}
function buildTextOptionsScreen() {
  const wrapper = document.createElement('div');
  wrapper.className = 'text-options-screen';
  ensureTextItem(); // crée l'élément ET set dataset.textScale='l' si nouveau
  wrapper._ozTextTarget = selectedItem;
  let currentText = 'Votre texte';
  let currentFont = 'Poppins';
  let currentColor = '#000000';
  if (selectedItem && selectedItem.dataset.type === 'text') {
    const textDiv = selectedItem.querySelector('.di-content > div');
    if (textDiv) {
      currentText = textDiv.innerText || textDiv.textContent || 'Votre texte';
      const cs = window.getComputedStyle(textDiv);
      currentFont = cs.fontFamily.replace(/['"]/g, '').split(',')[0];
      currentColor = rgbToHex(cs.color);
    }
  }
  wrapper.innerHTML = `
    <div id="text-options-root">
      <style>@layer oazar-legacy {
        #text-options-root .option-group {
            background: #fff;
            border: 1px solid #e5e7eb;
            padding: 16px;
            border-radius: 8px;
            margin-top: 18px;
        }
        #text-options-root h4 { margin: 0 0 12px 0; font-size: 15px; font-weight: 400; color: #3e3e3e; }
        #text-options-root textarea.text-input {
          width: 100%;
          border: 1px solid #cbd5e1;
          border-radius: 6px;
          padding: 12px;
          font-size: 16px; 
          background: #fff;
          resize: vertical;
          outline: none;
          min-height: 80px;
          font-family: inherit;
          line-height: 1.4;
      }
        .font-list-container {
            max-height: 250px;
            overflow-y: auto;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            background: #fff;
            padding: 0;
        }
        .font-option-label {
            display: flex; align-items: center; padding: 10px 14px;
            cursor: pointer; border-bottom: 1px solid #f3f4f6; transition: background 0.15s;
        }
        .font-option-label:hover { background: #f9fafb; }
        .font-option-label input[type="radio"] {
            margin-right: 12px; accent-color: #111; width: 16px; height: 16px; cursor: pointer;
        }
        .font-name-display { font-size: 16px; color: #333; }

        #text-options-root .txt-size-row {
            display: flex; align-items: center; gap: 10px;
        }
        #text-options-root .txt-size-btn {
            width: 36px; height: 36px; flex-shrink: 0;
            border: 1px solid #d1d5db; background: white;
            border-radius: 8px; cursor: pointer;
            font-size: 20px; font-weight: 400; color: #374151;
            display: flex; align-items: center; justify-content: center;
            transition: background 0.15s;
        }
        #text-options-root .txt-size-btn:hover { background: #f3f4f6; }
        #text-options-root .txt-size-btn:active { background: #e5e7eb; }
        #text-options-root .txt-slider {
            flex: 1; -webkit-appearance: none; appearance: none;
            height: 6px; background: #e5e7eb; border-radius: 3px; outline: none;
        }
        #text-options-root .txt-slider::-webkit-slider-thumb {
            -webkit-appearance: none; width: 22px; height: 22px;
            border-radius: 50%; background: #111827; cursor: pointer;
            border: 2px solid #fff; box-shadow: 0 1px 4px rgba(0,0,0,0.25);
        }
        #text-options-root .txt-size-label {
            min-width: 38px; text-align: right;
            font-size: 13px; font-weight: 600; color: #374151;
        }

        #text-options-root .color-picker-wrapper {
            display: flex; align-items: center; gap: 10px; padding: 6px;
            border: 1px solid #cbd5e1; border-radius: 8px; background: white; cursor: pointer;
        }
        #text-options-root input[type=color] {
            width: 40px; height: 40px; border: none; padding: 0; background: none; cursor: pointer; border-radius: 4px;
        }
        .color-label { font-size: 14px; font-family: monospace; color: #555; }
        #text-options-root .tools-row { display: flex; justify-content: space-between; gap: 12px; }
        #text-options-root .tool-button {
            flex: 1; height: 44px; background: white; border: 1px solid #d1d5db;
            border-radius: 8px; cursor: pointer; font-size: 18px;
            display: flex; align-items: center; justify-content: center;
        }
        #text-options-root .tool-button:hover { background: #f3f4f6; }
        #text-options-root .tool-button.danger { color: #ef4444; border-color: #fca5a5; }
        #text-options-root .tool-button.danger:hover { background: #fee2e2; }
      }</style>
      <div class="option-group">
        <h4>Mon texte</h4>
        <textarea id="textContent" class="text-input" rows="3">${escapeDesignLibraryHtml(currentText)}</textarea>
      </div>
      <div class="option-group">
        <h4>Police</h4>
        <div class="font-slide-shell">
          <button type="button" class="font-slide-arrow" data-font-slide="-1" aria-label="Polices précédentes">‹</button>
          <div class="font-list-container">
          ${OAZAR_FONT_LIST.map(f => `
            <label class="font-option-label">
                <input type="radio" name="fontFamilyRadio" value="${f}" ${currentFont === f ? 'checked' : ''}>
                <span class="font-sample" style="font-family: ${String(oazarFontCss(f)).replace(/\"/g,'&quot;')}, sans-serif;">Aa</span>
                <span class="font-name-display">${f}</span>
            </label>
          `).join('')}
          </div>
          <button type="button" class="font-slide-arrow" data-font-slide="1" aria-label="Polices suivantes">›</button>
        </div>
      </div>
      <div class="option-group">
        <h4>Couleur</h4>
        <div class="color-picker-wrapper" style="--oz-current-color:${currentColor};--oz-current-ink:${oazarStudioColorInk(currentColor)}">
          <span class="color-label">${oazarStudioColorName(currentColor)}</span>
          ${oazarStudioIcon('edit')}
          <input type="color" id="textColorPicker" value="${currentColor}" aria-label="Choisir une couleur personnalisée">
        </div>
      </div>
      <div class="option-group">
        <h4>Outils</h4>
        <div class="tools-row">
          <button class="tool-button" data-action="duplicate" title="Dupliquer">
    <svg id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g><g fill="#60b7ff">
    <path d="m454.31 68.405-34.29-62.778h-223.507c-12.27 0-22.217 9.947-22.217 22.217v397.247c0 12.27 9.947 22.217 22.217 22.217h264.068c12.27 0 22.217-9.947 22.217-22.217v-1.515h16.325v-325.969z"/>
    <path d=""/></g><g><g><path d="m458.678 159.613h-231.06c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h231.06c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z" fill="#0055a3"/></g><g><path d="m458.678 218.858h-231.06c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h231.06c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z" fill="#0055a3"/></g><g><path d="m458.678 278.105h-231.06c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h231.06c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z" fill="#0055a3"/></g><g><path d="m458.678 337.351h-231.06c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h231.06c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z" fill="#0055a3"/></g></g><path d="m482.798 86.969v338.122c0 12.27-9.947 22.217-22.217 22.217h29.202c12.27 0 22.217-9.947 22.217-22.217v-327.484z" fill="#26a6fe"/><path d="m442.237 97.607h69.763l-91.98-91.98v69.763c0 12.27 9.947 22.217 22.217 22.217z" fill="#004281"/><g fill="#eaf6ff"><path d="m333.91 496.578c-.499.739-1.042 1.446-1.624 2.118.582-.672 1.125-1.379 1.624-2.118z"/><path d="m286.285 506.373c12.27 0 22.217-9.947 22.217-22.217v-.486h13.944v-326.998l-45.843-34.08-30.879-57.9h-223.507c-12.27 0-22.217 9.947-22.217 22.217v397.247c0 12.27 9.947 22.217 22.217 22.217z"/></g><path d="m308.502 127.47v29.202 327.484c0 12.27-9.947 22.217-22.217 22.217h29.202c12.27 0 22.217-9.947 22.217-22.217v-327.484z" fill="#d8ecfe"/><path d="m267.942 156.672h69.763l-91.98-91.98v69.763c-.001 12.27 9.946 22.217 22.217 22.217z" fill="#b3dafe"/><g><g><path d="m284.382 218.858h-231.06c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h231.06c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z" fill="#82aee3"/></g><g><path d="m284.382 278.105h-231.06c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h231.06c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z" fill="#82aee3"/></g><g><path d="m284.382 337.351h-231.06c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h231.06c4.268 0 7.726 3.459 7.726 7.726s-3.458 7.726-7.726 7.726z" fill="#82aee3"/></g><g><path d="m284.382 396.598h-231.06c-4.268 0-7.726-3.459-7.726-7.726 0-4.268 3.459-7.726 7.726-7.726h231.06c4.268 0 7.726 3.459 7.726 7.726.001 4.267-3.458 7.726-7.726 7.726z" fill="#82aee3"/></g></g></g>
    </svg>
</button>
          <button class="tool-button" data-action="lock" title="Verrouiller">${toolsLockIsLocked ? '🔒' : '🔓'}</button>
          <button class="tool-button danger" data-action="delete" title="Supprimer">🗑️</button>
        </div>
      </div>
    </div>
  `;
  const root = wrapper.querySelector('#text-options-root');
  const fontGroup = root.querySelector('.font-list-container')?.closest('.option-group');
  if (fontGroup) {
    const fontSelect = document.createElement('select');
    fontSelect.className = 'studio-font-select';
    fontSelect.setAttribute('aria-label', 'Police');
    OAZAR_FONT_LIST.forEach(function(font) {
      const option = document.createElement('option');
      option.value = font;
      option.textContent = font;
      fontSelect.appendChild(option);
    });
    fontSelect.value = OAZAR_FONT_LIST.includes(currentFont) ? currentFont : 'Arial';
    const applySelectedFont = function() {
      wrapper.dataset.fontChanged = '1';
      const radio = Array.from(root.querySelectorAll('input[name="fontFamilyRadio"]')).find(function(input) { return input.value === fontSelect.value; });
      if (radio) radio.checked = true;
      updateTextDesign(wrapper);
    };
    fontSelect.addEventListener('input', applySelectedFont);
    fontSelect.addEventListener('change', applySelectedFont);
    fontGroup.appendChild(fontSelect);
  }
  const styleGroup = document.createElement('div');
  styleGroup.className = 'option-group studio-text-style-group';
  styleGroup.innerHTML = '<h4>Style</h4><div class="studio-text-style-row">' +
    [['normal','Aa','Normal'],['italic','Aa','Italique'],['underline','Aa','Souligné'],['outline','Aa','Contour']].map(function(entry) {
      return '<button type="button" class="studio-style-btn' + (entry[0] === 'normal' ? ' is-active' : '') + '" data-text-style="' + entry[0] + '"><strong>' + entry[1] + '</strong><span>' + entry[2] + '</span></button>';
    }).join('') + '</div>';
  fontGroup?.insertAdjacentElement('afterend', styleGroup);
  const compactAlign = document.createElement('div');
  compactAlign.className = 'option-group studio-text-align-group';
  compactAlign.innerHTML = '<h4>Alignement</h4><div class="studio-text-align-row">' +
    [['left','Gauche','left'],['center','Centre','centerH'],['right','Droite','right']].map(function(entry) {
      return '<button type="button" data-placement-align="' + entry[0] + '" class="' + (entry[0] === 'center' ? 'is-active' : '') + '">' + oazarStudioIcon(entry[2]) + '<span>' + entry[1] + '</span></button>';
    }).join('') + '</div>';
  root.appendChild(compactAlign);
  styleGroup.querySelectorAll('[data-text-style]').forEach(function(button) {
    button.addEventListener('click', function() {
      styleGroup.querySelectorAll('button').forEach(function(item) { item.classList.toggle('is-active', item === button); });
      updateTextDesign(wrapper);
    });
  });
  compactAlign.querySelectorAll('[data-placement-align]').forEach(function(button) {
    button.addEventListener('click', function() {
      compactAlign.querySelectorAll('button').forEach(function(item) { item.classList.toggle('is-active', item === button); });
      const placement = button.dataset.placementAlign;
      alignSelected(placement === 'center' ? 'centerX' : placement);
      if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
      pushHistoryDebounced(currentView, 300);
    });
  });
  const textGroups = wrapper.querySelectorAll('#text-options-root > .option-group');
  textGroups.forEach(function(group) {
    if (group.querySelector('#textContent')) group.classList.add('text-content-group');
    if (group.querySelector('.font-list-container')) group.classList.add('text-font-group');
    if (group.querySelector('#textColorPicker')) group.classList.add('text-color-group');
    if (group.querySelector('.tools-row')) group.classList.add('text-tools-group');
  });
  const toolLabels = { duplicate: 'Dupliquer', lock: toolsLockIsLocked ? 'Déverrouiller' : 'Verrouiller', delete: 'Supprimer' };
  wrapper.querySelectorAll('.tools-row [data-action]').forEach(function(button) {
    const action = button.dataset.action;
    button.innerHTML = oazarStudioIcon(action === 'duplicate' ? 'copy' : action === 'delete' ? 'trash' : toolsLockIsLocked ? 'lock' : 'unlock');
    button.setAttribute('aria-label', toolLabels[action] || action);
  });
  const refreshText = () => updateTextDesign(wrapper);
  wrapper.querySelector('#textContent').addEventListener('input', refreshText);
  wrapper.addEventListener('change', function(event) {
    if (!event.target.matches('input[name="fontFamilyRadio"]')) return;
    const select = wrapper.querySelector('.studio-font-select');
    if (select) select.value = event.target.value;
    refreshText();
  });
  oazarTextFontsReady.then(function(fonts) {
    const select = wrapper.querySelector('.studio-font-select');
    const rail = wrapper.querySelector('.font-list-container');
    if (!select || !rail) return;
    // Keep a choice already made while the remaining fonts were loading.
    const activeFont = wrapper.dataset.fontChanged === '1' ? select.value : currentFont;
    const selectedFont = fonts.includes(activeFont) ? activeFont : 'Arial';
    select.replaceChildren(...fonts.map(function(font) {
      const option = document.createElement('option');
      option.value = option.textContent = font;
      return option;
    }));
    select.value = selectedFont;
    rail.innerHTML = fonts.map(function(font) {
      return '<label class="font-option-label"><input type="radio" name="fontFamilyRadio" value="' + escapeDesignLibraryHtml(font) + '"' + (font === selectedFont ? ' checked' : '') + '><span class="font-sample">Aa</span><span class="font-name-display">' + escapeDesignLibraryHtml(font) + '</span></label>';
    }).join('');
    rail.querySelectorAll('.font-sample').forEach(function(sample, index) {
      sample.style.fontFamily = oazarFontCss(fonts[index]) + ', sans-serif';
    });
  });
  const fontRail = wrapper.querySelector('.font-slide-shell');
  if (fontRail) fontRail.addEventListener('click', function(event) { event.stopPropagation(); });
  wrapper.querySelectorAll('[data-font-slide]').forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      const slider = wrapper.querySelector('.font-list-container');
      if (slider) slider.scrollBy({ left: Number(button.dataset.fontSlide) * slider.clientWidth * .8, behavior: 'smooth' });
    });
  });
  const colorPicker = wrapper.querySelector('#textColorPicker');
  colorPicker.addEventListener('input', e => {
    const colorBar = wrapper.querySelector('.color-picker-wrapper');
    colorBar.style.setProperty('--oz-current-color', e.target.value);
    colorBar.style.setProperty('--oz-current-ink', oazarStudioColorInk(e.target.value));
    wrapper.querySelector('.color-label').textContent = oazarStudioColorName(e.target.value);
    wrapper.querySelectorAll('.text-color-swatch').forEach(function(button) {
      const active = button.dataset.color === e.target.value.toLowerCase();
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    refreshText();
  });
  const palette = OAZAR_STUDIO_PALETTE.map(function(entry) { return entry.slice(); });
  if (!palette.some(function(entry) { return entry[1] === currentColor.toLowerCase(); })) {
    palette.unshift([oazarStudioColorName(currentColor), currentColor.toLowerCase()]);
  }
  const colorRow = document.createElement('div');
  colorRow.className = 'text-color-swatches';
  palette.forEach(function(entry) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'text-color-swatch oz-color-option' + (entry[1] === currentColor.toLowerCase() ? ' is-active' : '');
    button.dataset.color = entry[1];
    button.style.setProperty('--text-swatch', entry[1]);
    button.style.setProperty('--oz-swatch', entry[1]);
    button.title = entry[0];
    button.setAttribute('aria-label', entry[0]);
    button.setAttribute('aria-pressed', String(entry[1] === currentColor.toLowerCase()));
    button.innerHTML = '<span class="oz-color-option-chip"></span><span class="oz-color-option-label">' + entry[0] + '</span>' + oazarStudioIcon('check');
    button.addEventListener('click', function() {
      colorPicker.value = entry[1];
      colorPicker.dispatchEvent(new Event('input', { bubbles: true }));
    });
    colorRow.appendChild(button);
  });
  const colorGroup = wrapper.querySelector('.text-color-group');
  if (colorGroup) colorGroup.appendChild(colorRow);
  refreshText();
  wrapper.querySelectorAll('[data-action]').forEach(btn => {
    btn.addEventListener('click', () => {
      const action = btn.dataset.action;
      switch (action) {
        case 'duplicate':
          duplicateSelected();
          break;
        case 'lock': {
          if (!selectedItem) return;
          const isLocked = selectedItem.dataset.locked === '1';
          const newLocked = !isLocked;
          selectedItem.dataset.locked = newLocked ? '1' : '0';
          selectedItem.classList.toggle('locked', newLocked);
          updateLockOnElement(selectedItem, newLocked);
          toolsLockIsLocked = newLocked;
          lockButtonWasClicked = true;
          syncToolsLockButtons();
          break;
        }
        case 'delete':
          const trash = selectedItem.querySelector('.di-trash');
          if (trash) trash.click();
          closeDrawer();
          break;
      }
    });
  });
  return wrapper;
}
let oazarTextUpdateSeq = 0;

// Calcule fontSize en fonction de la zone (S=5% M=9% L=14% XL=20%)
function getTextFontSizeForScale(scaleKey) {
  const area = selectedItem
    ? selectedItem.closest('.design-area')
    : document.querySelector('.design-area');
  const areaW = area ? area.offsetWidth : 170;
  const ratios = { s: 0.05, m: 0.09, l: 0.14, xl: 0.20 };
  const ratio = ratios[String(scaleKey).toLowerCase()] || 0.14;
  return Math.round(areaW * ratio);
}

function updateTextDesign(scopeRoot) {
  const scope = scopeRoot || document;
  const textInput = scope.querySelector('#textContent');
  const fontRadio = scope.querySelector('input[name="fontFamilyRadio"]:checked'); 
  const colorPicker = scope.querySelector('#textColorPicker');
  if (!textInput) return;
  const rawText = (textInput.value ?? '').toString();
  const fontSelect = scope.querySelector('.studio-font-select');
  const requestedFont = fontSelect ? fontSelect.value : (fontRadio ? fontRadio.value : 'Arial');
  const font = OAZAR_FONT_LIST.includes(requestedFont) ? requestedFont : 'Arial';
  scope.dataset.fontChanged = '1'; 
  const color = colorPicker ? (colorPicker.value || '#000000') : '#000000';
  const displayTextForMeasure = rawText.length ? rawText : '\u00A0';
  let target = scope._ozTextTarget && scope._ozTextTarget.isConnected ? scope._ozTextTarget : selectedItem;
  if (!target || target.dataset.type !== 'text') {
    target = (designLayers[currentView] || []).find(el => el.dataset.type === 'text') || null;
  }
  // Conserver la taille obtenue en redimensionnant le texte sur le produit.
  let fontSize = null;
  if (!fontSize && target) {
    const existingDiv = target.querySelector('.di-content > div');
    if (existingDiv) {
      const cs = window.getComputedStyle(existingDiv);
      const sz = parseFloat(cs.fontSize);
      if (!isNaN(sz) && sz > 0) fontSize = sz;
    }
  }
  const sizeControl = scope.querySelector('.studio-size-control input');
  if (sizeControl) fontSize = Math.max(12, Math.min(120, Number(sizeControl.value) || 32));
  if (!fontSize) fontSize = 32;
  const textStyle = scope.querySelector('.studio-style-btn.is-active')?.dataset.textStyle || 'normal';
  const inlineAlign = 'center';
  const fontWeight = '700';
  if (!target) {
    const html =
      '<div class="oazar-text-node" style="font-family:' + oazarFontCss(font) + ', sans-serif;' +
      'color:' + color + ';' +
      'font-size:' + fontSize + 'px;' +
      'font-weight:' + fontWeight + ';' +
      'text-align:center;' +
      'white-space:nowrap;' + // CHANGEMENT ICI (nowrap au lieu de pre-wrap)
      'min-width:max-content;' + // AJOUT ICI
      'line-height:1.1;' +
      'padding:5px;' +
      'margin:0;display:inline-block;' +
      'word-break:normal;' +
      'text-shadow:1px 1px 2px rgba(0,0,0,0.1);">' +
      escapeDesignLibraryHtml(rawText) +
      '</div>';
    addDesignToCurrentView(html, 'text');
    return;
  }
  oazarLoadGoogleFonts([font]);
  let contentEl = target.querySelector('.di-content');
  if (!contentEl) {
    contentEl = document.createElement('div');
    contentEl.className = 'di-content';
    const controls = target.querySelector('.di-controls');
    target.insertBefore(contentEl, controls || target.firstChild);
  }
  let textDiv = contentEl.querySelector('.oazar-text-node');
  if (!textDiv) {
    textDiv = contentEl.querySelector('div') || document.createElement('div');
    textDiv.className = 'oazar-text-node';
    if (!textDiv.parentNode) contentEl.appendChild(textDiv);
  }
  textDiv.innerText = rawText; 
  // The chosen font belongs to the product text, independently of UI/theme fonts.
  textDiv.style.setProperty('font-family', oazarFontCss(font) + ', sans-serif', 'important');
  target.dataset.fontFamily = font;
  textDiv.style.color = color;
  textDiv.style.fontSize = fontSize + 'px';
  textDiv.style.fontWeight = fontWeight;
  textDiv.style.textAlign = inlineAlign;
  textDiv.style.fontStyle = textStyle === 'italic' ? 'italic' : 'normal';
  textDiv.style.textDecoration = textStyle === 'underline' ? 'underline' : 'none';
  textDiv.style.webkitTextStroke = textStyle === 'outline' ? '1px ' + color : '';
  if (textStyle === 'outline') textDiv.style.color = 'transparent';
  textDiv.style.whiteSpace = 'nowrap'; 
  textDiv.style.minWidth = 'max-content'; 
  textDiv.style.lineHeight = '1.1';
  textDiv.style.padding = '5px';
  textDiv.style.margin = '0';
  textDiv.style.display = 'inline-block';
  textDiv.style.wordBreak = 'normal';
  const seq = ++oazarTextUpdateSeq;
  oazarEnsureFontLoaded(font, fontSize, fontWeight).then(function() {
    if (seq !== oazarTextUpdateSeq || !target.isConnected) return;
    textDiv.style.setProperty('font-family', oazarFontCss(font) + ', sans-serif', 'important');
    const m = oazarMeasureText(displayTextForMeasure, font, fontSize, fontWeight);
    const w = Math.ceil(m.w) + 20; 
    const h = Math.ceil(m.h) + 10;
    const centerX = target.offsetLeft + target.offsetWidth / 2;
    const centerY = target.offsetTop + target.offsetHeight / 2;
    target.style.width = w + 'px';
    target.style.height = h + 'px';
    target.dataset.w = String(w);
    target.dataset.h = String(h);
    target.style.left = (centerX - w / 2) + 'px';
    target.style.top = (centerY - h / 2) + 'px';
    if (target.dataset.justCreatedText === '1') {
      delete target.dataset.justCreatedText;
      setTimeout(function() {
        if (!target.isConnected || selectedItem !== target) return;
        alignSelected('centerX');
        alignSelected('centerY');
      }, 30);
    }
    updateOverflowState(target);
    if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
    pushHistoryDebounced(currentView, 300);
  });
}
function autosizeTextWrapper(target) {
if (!target || target.dataset.type !== 'text') return;
const contentEl = target.querySelector('.di-content');
if (!contentEl) return;
const textDiv = contentEl.querySelector('div');
if (textDiv) {
target.style.width = Math.ceil(textDiv.scrollWidth + 10) + 'px';
target.style.height = Math.ceil(textDiv.scrollHeight) + 'px';
updateOverflowState(target);
}
}
function ensureTextItem() {
if (window.currentProduct?.patch) return null;
  if (selectedItem && selectedItem.dataset.type === 'text') return;
  const defaultHTML = '<div class="oazar-text-node" style="font-family: Poppins, sans-serif; color: #000; font-size: 32px; font-weight: bold; text-align: center; white-space: nowrap; min-width: max-content; line-height: 1.1; padding: 5px; margin: 0; display: inline-block;">Votre texte</div>';
  const created = addDesignToCurrentView(defaultHTML, 'text');
  if (created) created.dataset.justCreatedText = '1';
}
function buildDesignsScreen(body) {
body.innerHTML = `
<div class="designs-library">
<div class="designs-slider" id="designsSlider">
<!-- Écran 1 : liste catégories -->
<div class="designs-panel designs-panel--list">
<div class="search-section">
 <input type="search" id="designSearch" placeholder="Trouver un design…" class="search-input" aria-label="Rechercher un design">
 </div>
 <div id="designCategories" class="categories-list"></div>
</div>
<!-- Écran 2 : "Voir tout" -->
<div class="designs-panel designs-panel--full">
<div id="designCategoryFull"></div>
</div>
</div>
</div>
`;
const slider = document.getElementById('designsSlider');
const full = document.getElementById('designCategoryFull');
if (slider) slider.classList.remove('is-full');
if (full) full.innerHTML = '';
renderDesignCategories();
const searchInput = body.querySelector('#designSearch');
if (searchInput) {
 searchInput.addEventListener('input', function(e) {
 if (slider) slider.classList.remove('is-full');
 if (full) full.innerHTML = '';
 renderDesignCategories(e.target.value);
});
}
}
function buildColorsScreen() {
  const wrapper = document.createElement('div');
  wrapper.className = 'colors-drawer-screen';
  if (!currentProduct) {
    wrapper.innerHTML = '<div class="no-product">Veuillez d\'abord sélectionner un produit</div>';
    return wrapper;
  }
  const colors = new Map();
  currentProduct.variants.forEach(function(v) {
    if (v.option1) colors.set(v.option1, v);
  });
  if (!colors.size) {
    wrapper.innerHTML = '<div class="no-color">Ce produit n\'a pas de couleurs disponibles</div>';
    return wrapper;
  }
  const grid = document.createElement('div');
  grid.className = 'color-drawer-grid';
  wrapper.appendChild(grid);
  const makeCheck = function() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'color-drawer-check');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'currentColor');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z');
    svg.appendChild(path);
    return svg;
  };
  const activeDesktop = document.querySelector('.color-swatch.active');
  const activeColor = activeDesktop ? activeDesktop.dataset.color : (colors.keys().next().value || '');
  const colorPreviewUrl = function(color) {
    const view = currentView || 'front';
    const sameColor = currentProduct.variants.find(function(item) {
      return item.option1 === color && item.image;
    });
    if (sameColor && sameColor.image) return sameColor.image;
    const viewImage = typeof findImageByViewAndColor === 'function' ? findImageByViewAndColor(view, color) : '';
    if (viewImage) return viewImage;
    const fallback = currentProduct.images && (currentProduct.images[view] || currentProduct.images.front || currentProduct.images[0]);
    return typeof fallback === 'string' ? fallback : (fallback && (fallback.src || fallback.url)) || '';
  };
  const preview = document.createElement('div');
  preview.className = 'color-selected-preview';
  const previewImage = document.createElement('img');
  previewImage.src = colorPreviewUrl(activeColor);
  previewImage.alt = currentProduct.title || 'Produit sélectionné';
  const previewCopy = document.createElement('div');
  const previewCaption = document.createElement('span');
  previewCaption.textContent = 'Couleur sélectionnée';
  const previewName = document.createElement('strong');
  previewName.textContent = activeColor || colors.keys().next().value || '';
  previewCopy.append(previewCaption, previewName);
  preview.append(previewImage, previewCopy);
  wrapper.insertBefore(preview, grid);
  const toneTabs = document.createElement('div');
  toneTabs.className = 'color-tone-tabs';
  const toneNames = [['all', 'Toutes'], ['light', 'Claires'], ['dark', 'Foncées'], ['neutral', 'Neutres']];
  toneNames.forEach(function(entry) {
    const tab = document.createElement('button');
    tab.type = 'button';
    tab.textContent = entry[1];
    tab.classList.toggle('is-active', entry[0] === 'all');
    tab.addEventListener('click', function() {
      toneTabs.querySelectorAll('button').forEach(function(button) { button.classList.toggle('is-active', button === tab); });
      grid.querySelectorAll('.color-drawer-card').forEach(function(card) { card.hidden = entry[0] !== 'all' && card.dataset.tone !== entry[0]; });
    });
    toneTabs.appendChild(tab);
  });
  wrapper.insertBefore(toneTabs, grid);
  const listTitle = document.createElement('h3');
  listTitle.textContent = 'Couleurs disponibles';
  wrapper.insertBefore(listTitle, grid);
  colors.forEach(function(variant, color) {
    const isAvailable = currentProduct.variants.some(function(v) {
      return v.option1 === color && v.available;
    });
    const colorCard = document.createElement('button');
    colorCard.className = 'color-drawer-card oz-color-option' + (isAvailable ? '' : ' disabled');
    const normalizedColor = color.toLocaleLowerCase('fr').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    colorCard.dataset.tone = /blanc|clair|ciel|rose|beige|naturel|creme|ecru|jaune|pastel/.test(normalizedColor) ? 'light' : /noir|fonce|marine|bordeaux|chocolat|prune|saphir|sapin|anthracite/.test(normalizedColor) ? 'dark' : 'neutral';
    colorCard.type = 'button';
    colorCard.setAttribute('aria-pressed', String(activeColor === color));
    const sw = document.createElement('div');
    sw.className = 'color-drawer-swatch';
    applySwatchStyle(sw, color, currentProduct);
    const name = document.createElement('span');
    name.className = 'color-drawer-name';
    name.textContent = color;
    colorCard.appendChild(sw);
    colorCard.appendChild(name);
    if (activeColor && activeColor === color) {
      colorCard.classList.add('active');
      colorCard.appendChild(makeCheck());
    }
    if (isAvailable) {
      colorCard.addEventListener('click', function() {
        wrapper.querySelectorAll('.color-drawer-card').forEach(function(c) {
          c.classList.remove('active');
          c.setAttribute('aria-pressed', 'false');
          const check = c.querySelector('.color-drawer-check');
          if (check) check.remove();
        });
        colorCard.classList.add('active');
        colorCard.appendChild(makeCheck());
        previewName.textContent = color;
        const nextPreview = colorPreviewUrl(color);
        if (nextPreview) previewImage.src = nextPreview;
        const desktopSwatch = document.querySelector('.color-swatch[data-color="' + color + '"]');
        if (desktopSwatch) {
          selectColor(desktopSwatch);
        }
        const mobileColorBtn = document.getElementById('mobileColorBtn');
        if (mobileColorBtn) {
          mobileColorBtn.classList.add('has-color');
          mobileColorBtn.style.setProperty('--oz-mobile-bg', oazarMobileSwatchBackground(sw, color));
        }
        colorCard.setAttribute('aria-pressed', 'true');
      });
    }
    grid.appendChild(colorCard);
  });
  const availabilityNote = document.createElement('p');
  availabilityNote.className = 'color-availability-note';
  availabilityNote.textContent = 'La disponibilité peut varier selon la taille.';
  wrapper.appendChild(availabilityNote);
  const confirmButton = document.createElement('button');
  confirmButton.type = 'button';
  confirmButton.className = 'color-confirm-btn';
  confirmButton.textContent = 'Valider la couleur →';
  confirmButton.addEventListener('click', closeDrawer);
  wrapper.appendChild(confirmButton);
  return wrapper;
}
let lastDesignSearchQuery = '';
let designCategoryRailObservers = [];
async function remoteUrlToFile(remoteUrl, filename) {
const res = await fetch(remoteUrl, { mode: 'cors' });
if (!res.ok) throw new Error('Fetch remote failed: ' + res.status);
const blob = await res.blob();
const type = blob.type || 'image/png';
const safeName = filename || ('design_' + Date.now() + '.png');
return new File([blob], safeName, { type });
}
async function addLibraryDesignToCurrentViewAndUpload(item) {
if (window.currentProduct?.patch && item?.origin !== 'ai') throw new Error('Choisissez une image importée ou un visuel créé avec l’IA pour cet écusson.');
const raw = (item && item.src) ? String(item.src) : '';
const src = normalizeToAbsoluteUrl(normalizeToHttpsUrl(raw));
if (!src) return;
const wantedName =
(item && item.name ? String(item.name) : '') ||
filenameFromUrl(src) ||
'design.png';
try {
let file = await remoteUrlToFile(src, wantedName);
const isAdventAsset = window.currentProduct?.handle === 'calendrier-de-lavent-24-pochettes-personnalisees' &&
  /oazar-advent-model[12]-(?:\d{2}|21-rouge)\.(?:png|svg)(?:\?|$)/i.test(src);
if (window.OazarDesignBounds && !isAdventAsset) file = await window.OazarDesignBounds.prepareFile(file);
const inlineSrc = await makeRecoverableImageDataUrl(file);
const blobUrl = URL.createObjectURL(file);
addDesignToCurrentView(blobUrl, 'image', file.name, item?.origin || 'design');
const designArea = document.querySelector(`.design-area[data-area="${currentView}"]`);
const imgEl = designArea?.querySelector('.design-item:last-child img');
if (!imgEl) return;
imgEl.dataset.originalName = file.name;
imgEl.dataset.fileName = file.name;
imgEl.dataset.remoteOriginalSrc = src;
imgEl.dataset.inlineSrc = inlineSrc;
imgEl.dataset.pendingFile = 'true';
imgEl.dataset.uploadSubType = 'designs';
if (!window.pendingUploads) window.pendingUploads = new Map();
window.pendingUploads.set(imgEl, file);
} catch (e) {
console.warn('[design library] remoteUrlToFile failed (CORS probable). On garde l’URL distante, upload au panier.', e);
addDesignToCurrentView(src, 'image', wantedName, item?.origin || 'design');
const designArea = document.querySelector(`.design-area[data-area="${currentView}"]`);
const imgEl = designArea?.querySelector('.design-item:last-child img');
if (imgEl) {
imgEl.dataset.originalName = wantedName;
imgEl.dataset.remoteOriginalSrc = src;
imgEl.dataset.uploadSubType = 'designs';
imgEl.dataset.originalSrc = src;
}
}
}
function isCategoryVisibleForTechnique(category, tech) {
  const t = (category && category.technique) ? String(category.technique) : 'impression';
  if (t === 'both') return true;
  return t === tech;
}
function getVisibleDesignCategories() {
  return getMergedVisibleDesignCategories(currentTechnique || 'impression');
}
function renderDesignCategories(searchQuery) {
 searchQuery = searchQuery || '';
 lastDesignSearchQuery = searchQuery;
 const container = document.getElementById('designCategories');
 if (!container) return;
 designCategoryRailObservers.forEach(function(observer) { observer.disconnect(); });
 designCategoryRailObservers = [];
const query = searchQuery.toLowerCase().trim();
container.innerHTML = '';
let hasResults = false;
getVisibleDesignCategories().forEach(function(category) {
const items = Array.isArray(category.items) ? category.items : [];
const filteredItems = items.filter(function(item) {
if (!query) return true;
const haystack = [
category.title || '',
(category.tags || []).join(' '),
item.title || '',
item.name || '',
item.label || '',
item.description || '',
(item.tags || []).join(' ')
].join(' ').toLowerCase();
return haystack.indexOf(query) !== -1;
});
if (filteredItems.length === 0) return;
hasResults = true;
const categoryEl = document.createElement('div');
categoryEl.className = 'design-category';
categoryEl.dataset.categoryId = String(category.id || '');
 categoryEl.innerHTML =
 '<div class="category-header">' +
   '<div class="category-heading">' +
     '<h4>' + escapeDesignLibraryHtml(category.title || 'Designs') + '</h4>' +
   '</div>' +
   '<button type="button" class="design-see-all" data-category-id="' + escapeDesignLibraryHtml(category.id || '') + '" aria-label="Voir tous les designs de ' + escapeDesignLibraryHtml(category.title || 'cette catégorie') + '">' +
     escapeDesignLibraryHtml(category.see_all_label || 'Voir tout') +
   '</button>' +
 '</div>' +
 '<div class="design-category-rail"><button type="button" class="design-category-prev" aria-label="Afficher les designs précédents dans ' + escapeDesignLibraryHtml(category.title || 'cette catégorie') + '" hidden><span aria-hidden="true">‹</span></button><div class="designs-grid"></div>' +
 '<button type="button" class="design-category-next" aria-label="Afficher les designs suivants dans ' + escapeDesignLibraryHtml(category.title || 'cette catégorie') + '" hidden><span aria-hidden="true">›</span></button></div>';
const grid = categoryEl.querySelector('.designs-grid');
filteredItems.slice(0, 8).forEach(function(item) {
const tile = document.createElement('button');
tile.type = 'button';
tile.className = 'design-tile' + (isSmartDesignLibraryItem(item) ? ' is-smart-template' : '');
tile.setAttribute('aria-label', getDesignLibraryLabel(item));
tile.innerHTML = buildDesignLibraryTileMarkup(item);
hydrateDesignLibraryTile(tile, item);
tile.addEventListener('click', function() {
handleDesignLibraryItemClick(item);
});
grid.appendChild(tile);
});
 const seeAllBtn = categoryEl.querySelector('.design-see-all');
 seeAllBtn.addEventListener('click', function() {
 openDesignCategoryFull(category.id);
 });
 container.appendChild(categoryEl);
 const prevButton = categoryEl.querySelector('.design-category-prev');
 const nextButton = categoryEl.querySelector('.design-category-next');
 const updateNavButtons = function() {
   const hasOverflow = grid.scrollWidth > grid.clientWidth + 2;
   prevButton.hidden = !hasOverflow || grid.scrollLeft <= 2;
   nextButton.hidden = !hasOverflow || grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
 };
 prevButton.addEventListener('click', function() {
   grid.scrollBy({ left: -Math.max(grid.clientWidth * 0.8, 120), behavior: 'smooth' });
 });
 nextButton.addEventListener('click', function() {
   grid.scrollBy({ left: Math.max(grid.clientWidth * 0.8, 120), behavior: 'smooth' });
 });
 grid.addEventListener('scroll', updateNavButtons, { passive: true });
 if (typeof ResizeObserver !== 'undefined') {
   const observer = new ResizeObserver(updateNavButtons);
   observer.observe(grid);
   designCategoryRailObservers.push(observer);
 }
 updateNavButtons();
 requestAnimationFrame(updateNavButtons);
 });
if (!hasResults) {
  if (query) {
    container.innerHTML = '<div class="no-results">Aucun design trouvé pour votre recherche.</div>';
  } else {
    const label = (currentTechnique === 'broderie') ? 'la broderie' : "l'impression";
    container.innerHTML = '<div class="no-results">Aucun design disponible pour ' + label + ' pour le moment.<br><button type="button" class="designs-import-fallback">Importer un visuel</button></div>';
    container.querySelector('.designs-import-fallback').addEventListener('click', function() {
      setDrawerMode('import');
    });
  }
}
}
function openDesignCategoryFull(categoryId) {
openDesignFullDrawer(categoryId);
}
function cleanSizeGuideMeasure(value) {
return String(value || '')
.replace(/\s*cm\s*$/i, '')
.replace(/([,.])00$/, '')
.trim();
}
function parseSizeGuideTable(raw) {
if (!raw) return [];
const lines = String(raw)
.split(/\r?\n/)
.map(function(line) { return line.trim(); })
.filter(Boolean);
if (!lines.length) return [];
const firstLineIsHeader = /^taille\s*\|/i.test(lines[0]);
const dataLines = firstLineIsHeader ? lines.slice(1) : lines;
return dataLines.map(function(line) {
const parts = line.split('|').map(function(part) { return part.trim(); });
if (parts.length < 3 || !parts[0]) return null;
return {
size: parts[0],
width: cleanSizeGuideMeasure(parts[1] || ''),
height: cleanSizeGuideMeasure(parts[2] || '')
};
}).filter(Boolean);
}
function getCurrentProductSizeGuideData() {
if (!currentProduct) return { table: '', visual: '' };
const stored = (sizeGuidesData && sizeGuidesData[currentProduct.handle]) || null;
if (stored && typeof stored === 'object' && !Array.isArray(stored)) {
return {
table: stored.table || stored.tableau || stored.text || '',
visual: stored.visual || stored.image || stored.visuel || ''
};
}
return {
table: stored || currentProduct.sizeGuide || currentProduct.sizeGuideText || '',
visual: currentProduct.sizeGuideVisual || currentProduct.sizeGuideImage || ''
};
}
function getCurrentProductSizeGuideRows() {
const guide = getCurrentProductSizeGuideData();
const raw = guide.table;
if (Array.isArray(raw)) {
return raw.map(function(row) {
if (!row) return null;
return {
size: String(row.size || row.taille || '').trim(),
width: cleanSizeGuideMeasure(row.width || row.largeur || row.chest || ''),
height: cleanSizeGuideMeasure(row.height || row.hauteur || '')
};
}).filter(function(row) { return row && row.size; });
}
return parseSizeGuideTable(raw);
}
function getCurrentProductSizeGuideVisual() {
const guide = getCurrentProductSizeGuideData();
return String(guide.visual || '').trim();
}
function buildSizeGuideMarkup(rows, visual) {
if (!Array.isArray(rows) || !rows.length) return '';
const visualMarkup = visual
? '<img class="sizes-guide-product-visual" src="' + escapeDesignLibraryHtml(visual) + '" alt="Schéma de mesures du produit" loading="lazy">'
: '<svg viewBox="0 0 220 210" aria-hidden="true">' +
'<path d="M75 35 L45 52 L20 85 L48 105 L62 91 L62 190 L158 190 L158 91 L172 105 L200 85 L175 52 L145 35 C137 54 83 54 75 35Z" fill="none" stroke="currentColor" stroke-width="2"/>' +
'<path d="M82 39 C89 60 131 60 138 39" fill="none" stroke="currentColor" stroke-width="2"/>' +
'<line x1="70" y1="105" x2="150" y2="105" stroke="currentColor" stroke-width="1.5" stroke-dasharray="5 4"/>' +
'<line x1="70" y1="99" x2="70" y2="111" stroke="currentColor"/>' +
'<line x1="150" y1="99" x2="150" y2="111" stroke="currentColor"/>' +
'<text x="110" y="96" text-anchor="middle" font-size="13" font-weight="600">A</text>' +
'<line x1="150" y1="65" x2="150" y2="180" stroke="currentColor" stroke-width="1.5" stroke-dasharray="5 4"/>' +
'<line x1="144" y1="65" x2="156" y2="65" stroke="currentColor"/>' +
'<line x1="144" y1="180" x2="156" y2="180" stroke="currentColor"/>' +
'<text x="139" y="128" text-anchor="middle" font-size="13" font-weight="600">B</text>' +
'</svg>';
return '<div class="sizes-guide-panel">' +
'<div class="sizes-guide-heading">' +
'<span class="sizes-guide-icon" aria-hidden="true">' +
'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">' +
'<path d="M8 4 3 7l2 5 3-1v9h8v-9l3 1 2-5-5-3c0 3-8 3-8 0Z"/>' +
'</svg>' +
'</span>' +
'<div class="sizes-guide-copy"><strong>Guide des tailles</strong><small>A = demi-largeur poitrine · B = hauteur, en cm. Mesures indicatives.</small></div>' +
'</div>' +
'<div class="sizes-guide-content">' +
'<div class="sizes-guide-shirt">' + visualMarkup + '</div>' +
'<div class="sizes-guide-table">' +
'<div class="sizes-guide-row sizes-guide-head"><span>Taille</span><span>A · ½ poitrine</span><span>B · Hauteur</span></div>' +
rows.map(function(row) {
const size = String(row.size || '').trim();
const active = (parseInt(sizeQuantities[size]) || 0) > 0 ? ' is-active' : '';
return '<div class="sizes-guide-row' + active + '" data-guide-size="' + escapeDesignLibraryHtml(size) + '">' +
'<span>' + escapeDesignLibraryHtml(size) + '</span>' +
'<span>' + escapeDesignLibraryHtml(row.width || '') + '</span>' +
'<span>' + escapeDesignLibraryHtml(row.height || '') + '</span>' +
'</div>';
}).join('') +
'</div>' +
'</div>' +
'</div>';
}
function syncSizeGuideActiveRows(root) {
const scope = root && root.querySelectorAll ? root : document;
scope.querySelectorAll('.sizes-guide-row[data-guide-size]').forEach(function(row) {
const size = row.dataset.guideSize || '';
const qty = parseInt(sizeQuantities[size]) || 0;
row.classList.toggle('is-active', qty > 0);
});
}

function ozIsUniqueSizeValue(value) {
  const normalized = String(value == null ? '' : value)
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s_-]+/g, ' ');

  return (
    normalized === '' ||
    normalized === 'taille unique' ||
    normalized === 'unique' ||
    normalized === 'tu' ||
    normalized === 'one size' ||
    normalized === 'onesize' ||
    normalized === 'os'
  );
}

function ozNormalizeSizeLabel(value) {
  return ozIsUniqueSizeValue(value)
    ? 'Taille unique'
    : String(value || '').trim();
}

function ozVariantMatchesSize(variant, size) {
  if (!variant) return false;

  const wanted = ozNormalizeSizeLabel(size);
  const variantSize = ozNormalizeSizeLabel(variant.option2);

  return variantSize === wanted;
}

function mountPatchDimensions(wrapper) {
  if (!currentProduct?.patch || !window.OazarPatchStudio?.resize) return;
  const image = document.querySelector('#mon-customizer .design-area img[data-oz-patch-config]');
  const config = image ? window.OazarPatchStudio.readConfig(image) : window.OazarPatchStudio.getConfig(), handle = currentProduct.handle;
  const panel = document.createElement('fieldset');panel.className = 'oz-patch-size-editor';
  panel.innerHTML = '<legend>Dimensions de l’écusson</legend>' +
    '<div class="oz-patch-dimension-grid"><label>Largeur (cm)<input type="number" name="patch_width_cm" min="1" max="12" step="0.01" inputmode="decimal" aria-label="Largeur de l’écusson en centimètres"></label>' +
    '<label>Hauteur (cm)<input type="number" name="patch_height_cm" min="1" max="12" step="0.01" inputmode="decimal" aria-label="Hauteur de l’écusson en centimètres"></label></div>' +
    '<p class="oz-patch-size-note">De 1 à 12 cm, contour compris. ' + (['rectangle','shield'].includes(config.shape) ? 'Largeur et hauteur au choix.' : 'Les proportions de votre écusson sont conservées.') + '</p>' +
    '<button type="button" data-patch-resize disabled>Appliquer les dimensions</button>' +
    '<p class="oz-patch-size-status" role="status" aria-live="polite"></p>';
  wrapper.prepend(panel);
  const width = panel.querySelector('[name="patch_width_cm"]'), height = panel.querySelector('[name="patch_height_cm"]');
  const button = panel.querySelector('[data-patch-resize]'), status = panel.querySelector('[role="status"]');
  width.value = config.width_cm;height.value = config.height_cm;
  let busy = false;
  panel.addEventListener('input', function(event) {
    if (event.target !== width && event.target !== height) return;
    if (!['rectangle','shield'].includes(config.shape)) {
      const ratio = config.shape === 'free' ? Number(config.width_cm) / Number(config.height_cm) : 1;
      if (event.target === width) height.value = width.value ? String(Math.round(Number(width.value) / ratio * 100) / 100) : '';
      else width.value = height.value ? String(Math.round(Number(height.value) * ratio * 100) / 100) : '';
    }
    const dirty = Number(width.value) !== Number(config.width_cm) || Number(height.value) !== Number(config.height_cm);
    const valid = !!width.value && !!height.value && width.checkValidity() && height.checkValidity();
    wrapper.dataset.patchDimensionsDirty = dirty ? '1' : '0';
    button.disabled = busy || !dirty || !valid;
    width.setAttribute('aria-invalid', String(!width.value || !width.checkValidity()));height.setAttribute('aria-invalid', String(!height.value || !height.checkValidity()));
    status.textContent = !valid ? 'Choisissez une largeur et une hauteur entre 1 et 12 cm.' : dirty ? 'Appliquez les dimensions pour actualiser l’aperçu et le prix.' : '';
    updateSizeDrawerTotals();
  });
  button.addEventListener('click', async function() {
    if (busy || button.disabled) return;
    busy = true;button.disabled = true;width.disabled = true;height.disabled = true;
    status.textContent = 'Mise à jour de votre écusson…';
    try {
      await window.OazarPatchStudio.resize(image, {width_cm:width.value, height_cm:height.value});
      if (!wrapper.isConnected || currentProduct?.handle !== handle) return;
      setDrawerMode('sizes', {retour:true});
      const message = document.querySelector('#drawerBody .oz-patch-size-status');
      if (message) message.textContent = 'Dimensions et prix mis à jour.';
    } catch (error) {
      if (wrapper.isConnected) {status.textContent = error.message || 'Les dimensions n’ont pas pu être mises à jour.';button.disabled = false;}
    } finally {busy = false;width.disabled = false;height.disabled = false;}
  });
}
function buildSizesScreen() {
const wrapper = document.createElement('div');
wrapper.className = 'sizes-drawer-screen';
if (!currentProduct) {
wrapper.innerHTML = '<div class="no-product">Veuillez d\'abord sélectionner un produit</div>';
return wrapper;
}
const selectedColor = document.querySelector('.color-swatch.active');
if (!selectedColor || !selectedColor.dataset.color) {
wrapper.innerHTML = '<div class="no-color">Veuillez d\'abord sélectionner une couleur</div>';
return wrapper;
}
const colorValue = selectedColor.dataset.color;
if (currentProduct.patch?.pricing && !getPatchPricingVariant()) {
  wrapper.innerHTML = '<div class="no-product">Le tarif de ces dimensions est indisponible. Choisissez une autre taille pour votre écusson.</div>';mountPatchDimensions(wrapper);return wrapper;
}
if (currentProduct.patch?.pricing) syncPatchPricingSize();
const variantsForColor = currentProduct.variants.filter(function(v) {
return v.option1 === colorValue && (!currentProduct.patch?.pricing || v.id === getPatchPricingVariant()?.id);
});
const sizes = Array.from(new Set(variantsForColor.map(function(v) {
return ozNormalizeSizeLabel(v.option2);
}))).sort(function(a, b) {
const order = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL'];
const aIndex = order.indexOf(a.toUpperCase());
const bIndex = order.indexOf(b.toUpperCase());
return (aIndex < 0 ? order.length : aIndex) - (bIndex < 0 ? order.length : bIndex) || a.localeCompare(b, 'fr', { numeric: true });
});
const sizeGuideRows = getCurrentProductSizeGuideRows();
const sizeGuideVisual = getCurrentProductSizeGuideVisual();
const sizeGuideMarkup = buildSizeGuideMarkup(sizeGuideRows, sizeGuideVisual);
wrapper.innerHTML =
'<div class="sizes-header">' +
'<div class="sizes-available-section">' +
'<h4>' + (currentProduct.patch ? 'Votre écusson' : 'Tailles disponibles') + '</h4>' +
'<div class="sizes-available-list" id="sizesAvailableList"></div>' +
'</div>' +
sizeGuideMarkup +
'<div class="sizes-quantity-heading"><h4>' + (currentProduct.patch ? 'Quantité' : 'Quantité par taille') + '</h4><p>' + (currentProduct.patch ? 'Précisez le nombre d’écussons souhaité.' : 'Précisez la quantité souhaitée pour chaque taille.') + '</p></div>' +
'<div class="sizes-list" id="sizesListDrawer"></div>' +
'<div class="sizes-footer">' +
'<div id="pricingInfo" style="display:none;padding:12px 16px;border-top:1px solid rgba(15,23,42,.10);background:#fff;">' +
'<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 0;font-size:13px;">' +
'<div style="display:flex;align-items:center;gap:6px;">' +
'<span style="color:#e11d48;font-weight:700;">Remise</span>' +
'<span id="OZ-SZ-Hint" style="color:#e11d48;font-size:12px;opacity:.9;"></span>' +
'</div>' +
'<div id="OZ-SZ-Pct" style="color:#e11d48;font-weight:800;white-space:nowrap;">%</div>' +
'</div>' +
'<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 0;font-size:13px;border-top:1px solid rgba(15,23,42,.08);">' +
'<div>Par produits</div>' +
'<div style="display:flex;align-items:baseline;gap:10px;white-space:nowrap;">' +
'<s id="OZ-SZ-UnitOld" style="opacity:.45;font-size:12px;">—</s>' +
'<strong id="unitPrice" style="font-weight:850;font-size:14px;">—</strong>' +
'</div>' +
'</div>' +
'<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 0;font-size:13px;border-top:1px solid rgba(15,23,42,.08);">' +
'<div style="display:flex;align-items:center;gap:6px;">' +
'<strong style="font-size:14px;">Total TTC</strong>' +
'<span title="Total estimé selon les tailles choisies." ' +
'style="display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;border-radius:999px;border:1px solid rgba(15,23,42,.18);font-size:11px;opacity:.7;">i</span>' +
'</div>' +
'<div style="display:flex;align-items:baseline;gap:10px;white-space:nowrap;">' +
'<s id="OZ-SZ-TotalOld" style="opacity:.45;font-size:12px;">—</s>' +
'<strong id="totalPrice" style="font-weight:900;font-size:18px;">—</strong>' +
'</div>' +
'</div>' +
'<div id="OZ-SZ-SaveLine" style="display:none;align-items:center;justify-content:space-between;gap:12px;padding:10px 0;font-size:13px;border-top:1px solid rgba(15,23,42,.08);">' +
'<div>Vous économisez</div>' +
'<div style="white-space:nowrap;font-weight:900;" id="OZ-SZ-Save">—</div>' +
'</div>' +
'</div>' +
'<button class="add-to-cart-final" id="addToCartFinal" data-oz-label="Sélectionnez au moins une taille" disabled type="button">Sélectionnez au moins une taille</button>' +
'</div>' +
'</div>';
mountPatchDimensions(wrapper);
const backBtn = wrapper.querySelector('#backToSidebarBtn');
if (backBtn) {
backBtn.addEventListener('click', function(e) {
e.preventDefault();
closeDrawer();
});
}
const sizesList = wrapper.querySelector('#sizesListDrawer');
const availableList = wrapper.querySelector('#sizesAvailableList');
if (!sizes.length) {
  sizesList.textContent = 'Aucune taille disponible pour cette couleur.';
}
sizes.forEach(function(size) {
const variant = variantsForColor.find(function(v) {
return ozVariantMatchesSize(v, size) && v.available;
}) || variantsForColor.find(function(v) {
return ozVariantMatchesSize(v, size);
});
const isAvailable = variant ? variant.available : false;
variantBySize[size] = variant ? variant.id : null;
if (!isAvailable) sizeQuantities[size] = 0;
if (!sizeQuantities[size]) {
sizeQuantities[size] = 0;
}
const sizeRow = document.createElement('div');
sizeRow.className = 'size-quantity-row' + (isAvailable ? '' : ' disabled');
sizeRow.dataset.size = size;
sizeRow.innerHTML = '<div class="size-label">' + (currentProduct.patch ? 'Mon écusson' : size) + '</div>' +
'<div class="quantity-controls">' +
'<button class="qty-decrease" ' + (!isAvailable ? 'disabled' : '') + ' type="button">−</button>' +
'<input type="number" class="qty-value" aria-label="Quantité taille ' + size + '" inputmode="numeric" value="' + sizeQuantities[size] + '" min="0" ' + (!isAvailable ? 'disabled' : '') + '>' +
'<button class="qty-increase" ' + (!isAvailable ? 'disabled' : '') + ' type="button">+</button>' +
'</div>';
if (isAvailable) {
const decreaseBtn = sizeRow.querySelector('.qty-decrease');
const increaseBtn = sizeRow.querySelector('.qty-increase');
const input = sizeRow.querySelector('.qty-value');
const availableButton = document.createElement('button');
availableButton.type = 'button';
availableButton.className = 'size-available-button' + ((sizeQuantities[size] || 0) > 0 ? ' is-active' : '') + (isAvailable ? '' : ' disabled');
availableButton.textContent = currentProduct.patch ? 'Mon écusson' : size;
availableButton.disabled = !isAvailable;
availableButton.setAttribute('aria-pressed', String((sizeQuantities[size] || 0) > 0));
availableButton.addEventListener('click', function() {
  const nextQuantity = (parseInt(input.value) || 0) > 0 ? 0 : 1;
  input.value = nextQuantity;
  sizeQuantities[size] = nextQuantity;
  availableButton.classList.toggle('is-active', nextQuantity > 0);
  availableButton.setAttribute('aria-pressed', String(nextQuantity > 0));
  updateSizeDrawerTotals();
});
if (availableList) availableList.appendChild(availableButton);
decreaseBtn.addEventListener('click', function(e) {
e.preventDefault();
const currentQty = parseInt(input.value) || 0;
const newQty = Math.max(0, currentQty - 1);
input.value = newQty;
sizeQuantities[size] = newQty;
availableButton.classList.toggle('is-active', newQty > 0);
availableButton.setAttribute('aria-pressed', String(newQty > 0));
requestAnimationFrame(function() {
updateSizeDrawerTotals();
});
});
increaseBtn.addEventListener('click', function(e) {
e.preventDefault();
const currentQty = parseInt(input.value) || 0;
const newQty = currentQty + 1;
input.value = newQty;
sizeQuantities[size] = newQty;
availableButton.classList.toggle('is-active', newQty > 0);
availableButton.setAttribute('aria-pressed', String(newQty > 0));
updateSizeDrawerTotals();
});
input.addEventListener('input', function() {
const newQty = Math.max(0, parseInt(input.value) || 0);
input.value = newQty;
sizeQuantities[size] = newQty;
availableButton.classList.toggle('is-active', newQty > 0);
availableButton.setAttribute('aria-pressed', String(newQty > 0));
updateSizeDrawerTotals();
});
}
sizesList.appendChild(sizeRow);
});
const finalBtn = wrapper.querySelector('#addToCartFinal');
if (finalBtn) {
finalBtn.addEventListener('click', function(e) {
e.preventDefault();
e.stopPropagation();
const totalQty = Object.values(sizeQuantities).reduce(function(sum, qty) {
return sum + (parseInt(qty) || 0);
}, 0);
if (totalQty > 0) {
if (wrapper.dataset.patchDimensionsDirty === '1') return;
showSizesConfirmModal();
} else {
showNotification('Sélectionnez au moins une taille', 'warning');
}
});
}

requestAnimationFrame(function() {
  updateSizeDrawerTotals();
});

return wrapper;
}
function updateSizeDrawerTotals() {
syncSizeGuideActiveRows(document);
const totalQty = Object.values(sizeQuantities).reduce((sum, qty) => {
return sum + (parseInt(qty) || 0);
}, 0);
const pricingInfo  = document.getElementById('pricingInfo');
const addToCartBtn  = document.getElementById('addToCartFinal');
const unitPriceEl   = document.getElementById('unitPrice');
const totalPriceEl  = document.getElementById('totalPrice');
const pctEl     = document.getElementById('OZ-SZ-Pct');
const hintEl    = document.getElementById('OZ-SZ-Hint');
const unitOldEl = document.getElementById('OZ-SZ-UnitOld');
const totalOldEl= document.getElementById('OZ-SZ-TotalOld');
const saveLine  = document.getElementById('OZ-SZ-SaveLine');
const saveEl    = document.getElementById('OZ-SZ-Save');
if (totalQty > 0) {
if (pricingInfo) pricingInfo.style.display = 'block';
if (addToCartBtn) {
addToCartBtn.disabled = false;
addToCartBtn.textContent = hasEmbroideryImageForReview()
  ? 'Faire vérifier ma broderie (' + totalQty + ')'
  : 'Valider (' + totalQty + ' article' + (totalQty > 1 ? 's' : '') + ')';
addToCartBtn.dataset.ozLabel = addToCartBtn.textContent;
}
const base = (typeof getBaseUnitPrice === 'function') ? getBaseUnitPrice() : 0;
const extra = (typeof calculateCustomizationExtraPerUnit === 'function') ? calculateCustomizationExtraPerUnit(totalQty) : 0;
const unitOld = base + extra;
const unitNew = getFinalUnitPrice(totalQty);
const totalOld = totalQty * unitOld;
const totalNew = totalQty * unitNew;
const saveTotal = Math.max(totalOld - totalNew, 0);
// Afficher le prix barré seulement s'il y a une vraie remise
const hasDiscount = unitNew < unitOld - 0.005;
if (unitOldEl) {
  unitOldEl.textContent = unitOld.toFixed(2).replace('.', ',') + ' €';
  unitOldEl.style.display = hasDiscount ? '' : 'none';
}
if (totalOldEl) {
  totalOldEl.textContent = totalOld.toFixed(2).replace('.', ',') + ' €';
  totalOldEl.style.display = hasDiscount ? '' : 'none';
}
if (unitPriceEl)  unitPriceEl.textContent  = unitNew.toFixed(2).replace('.', ',') + ' €';
if (totalPriceEl) totalPriceEl.textContent = totalNew.toFixed(2).replace('.', ',') + ' €';
const pct = vdGetPercent(totalQty);
if (pctEl) pctEl.textContent = pct > 0 ? (pct + '%') : '—%';
if (hintEl) {
const next = vdGetNextTier(totalQty);
if (pct <= 0 && next) {
hintEl.textContent = '(encore ' + (next.min - totalQty) + ' pour ' + next.pct + '%)';
} else if (next) {
hintEl.textContent = '(encore ' + (next.min - totalQty) + ' pour ' + next.pct + '%)';
} else {
hintEl.textContent = '';
}
}
if (saveLine && saveEl) {
if (saveTotal > 0) {
saveLine.style.display = 'flex';
saveEl.textContent = saveTotal.toFixed(2).replace('.', ',') + ' €';
} else {
saveLine.style.display = 'none';
saveEl.textContent = '—';
}
}
} else {
if (pricingInfo) pricingInfo.style.display = 'none';
if (addToCartBtn) {
addToCartBtn.disabled = true;
addToCartBtn.textContent = 'Sélectionnez au moins une taille';
addToCartBtn.dataset.ozLabel = addToCartBtn.textContent;
}
if (pctEl) pctEl.textContent = '—%';
if (hintEl) hintEl.textContent = '';
if (saveLine) saveLine.style.display = 'none';
}
updateSizeSummary();
updateSelectSizesButton();
showAddToCartButton();
if (typeof window.__ozApplyCartEligibilityUI === 'function') window.__ozApplyCartEligibilityUI();
if (addToCartBtn && document.querySelector('#drawerBody .sizes-drawer-screen')?.dataset.patchDimensionsDirty === '1') {
  addToCartBtn.disabled = true;
  addToCartBtn.textContent = 'Appliquez les nouvelles dimensions';
  addToCartBtn.dataset.ozLabel = addToCartBtn.textContent;
}
if (addToCartBtn && currentProduct?.patch && !document.querySelector('#mon-customizer .design-area img[data-oz-patch-config]')) {
  addToCartBtn.disabled = true;
  addToCartBtn.textContent = 'Importez votre image pour continuer';
  addToCartBtn.dataset.ozLabel = addToCartBtn.textContent;
}
}
function updateSizeSummary() {
const summary = document.getElementById('sizeSummary');
const summaryItems = document.getElementById('summaryItems');
if (!summary || !summaryItems) return;
const selectedSizes = Object.entries(sizeQuantities).filter(function(entry) {
return entry[1] > 0;
});
if (selectedSizes.length === 0) {
summary.style.display = 'none';
return;
}
summary.style.display = 'block';
summaryItems.innerHTML = selectedSizes.map(function(entry) {
return '<div class="summary-item"><span>' + entry[0] + '</span><span class="qty">×' + entry[1] + '</span></div>';
}).join('');
}
function updateSelectSizesButton() {
const btn = document.getElementById('selectSizesBtn');
if (!btn) return;
const totalQty = Object.values(sizeQuantities).reduce(function(sum, qty) {
return sum + (parseInt(qty) || 0);
}, 0);
if (totalQty > 0) {
const active = vdIsActive(totalQty);
btn.classList.add('has-selection');
btn.innerHTML =
'<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">' +
'<path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>' +
'</svg>' +
(currentProduct?.patch ? 'Modifier la quantité' : 'Modifier les tailles') +
(active ? '<span class="vd-mini-badge">-' + vdGetPercent(totalQty) + '%</span>' : '') +
'<span class="selection-count">' + totalQty + '</span>';
btn.dataset.ozLabel = 'Modifier les tailles';
} else {
btn.classList.remove('has-selection');
btn.innerHTML =
'<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">' +
'<path d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"/>' +
'</svg>' + (currentProduct?.patch ? 'Choisir la quantité' : 'Sélectionner les tailles');
btn.dataset.ozLabel = 'Sélectionner les tailles';
}
}
function dataURLtoBlob(dataURL) {
const [meta, data] = dataURL.split(",");
const mime = (meta.match(/data:([^;]+)/) || [])[1] || "image/png";
const bin = atob(data);
const arr = new Uint8Array(bin.length);
for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
return new Blob([arr], { type: mime });
}
function getVariantIdForSize(size) {
  if (currentProduct?.patch?.pricing) return getPatchPricingVariant()?.id || null;
  if (variantBySize && Object.prototype.hasOwnProperty.call(variantBySize, size)) {
    return variantBySize[size];
  }

  const normalizedSize = ozNormalizeSizeLabel(size);

  const matchingKey = Object.keys(variantBySize || {}).find(function(key) {
    return ozNormalizeSizeLabel(key) === normalizedSize;
  });

  if (matchingKey) {
    return variantBySize[matchingKey];
  }

  if (currentProduct && Array.isArray(currentProduct.variants)) {
    const selectedColorEl = document.querySelector('.color-swatch.active');
    const selectedColor = selectedColorEl && selectedColorEl.dataset
      ? selectedColorEl.dataset.color
      : null;

    const variant = currentProduct.variants.find(function(v) {
      return (
        (!selectedColor || v.option1 === selectedColor) &&
        ozVariantMatchesSize(v, normalizedSize) &&
        v.available
      );
    });

    if (variant) return variant.id;
  }

  return null;
}
function showAddToCartButton() {
  const totalQty = Object.values(sizeQuantities || {}).reduce(function(sum, qty) {
    return sum + (parseInt(qty, 10) || 0);
  }, 0);

  let btn = document.getElementById('addToCartMainBtn');
  const finalActions = document.querySelector('.final-actions');
  const selectBtn = document.getElementById('selectSizesBtn');

  if (!finalActions) return;

  if (!btn) {
    btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'addToCartMainBtn';
    btn.className = 'add-to-cart-btn';

    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (btn.disabled) return;

      if (typeof addToCart === 'function') {
        await addToCart(e);
      }
    });

    finalActions.insertBefore(
      btn,
      selectBtn ? selectBtn.nextSibling : null
    );
  }

  const hasProduct = !!currentProduct;
  const canAdd = hasProduct && totalQty > 0;

  btn.style.display = 'flex';
  btn.disabled = !canAdd;

  btn.innerHTML =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
      '<path d="M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5H5.21L4.27,3H1M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z"/>' +
    '</svg>' +
    (canAdd
      ? 'Ajouter au panier (' + totalQty + ')'
      : 'Ajouter au panier');

  btn.dataset.ozLabel = canAdd
    ? 'Ajouter au panier (' + totalQty + ')'
    : 'Ajouter au panier';

  if (typeof window.__ozUpdateCartButtons === 'function') {
    window.__ozUpdateCartButtons();
  }

  if (typeof window.__ozApplyCartEligibilityUI === 'function') {
    window.__ozApplyCartEligibilityUI();
  }
}
async function downscaleImageFile(file, maxDimension = 3200, outputType = 'image/jpeg', quality = 0.9) {
return new Promise((resolve, reject) => {
const img = new Image();
img.onload = () => {
let { width, height } = img;
if (width <= maxDimension && height <= maxDimension) {
resolve(file);
return;
}
const scale = Math.min(maxDimension / width, maxDimension / height);
const targetW = Math.round(width * scale);
const targetH = Math.round(height * scale);
const canvas = document.createElement('canvas');
canvas.width = targetW;
canvas.height = targetH;
const ctx = canvas.getContext('2d');
ctx.drawImage(img, 0, 0, targetW, targetH);
canvas.toBlob((blob) => {
if (!blob) {
resolve(file);
return;
}
const newName = file.name.replace(/\.[^.]+$/, '') + '_resized.jpg';
const newFile = new File([blob], newName, { type: outputType });
resolve(newFile);
}, outputType, quality);
};
img.onerror = reject;
img.src = URL.createObjectURL(file);
});
}
const RECENT_IMPORTS_KEY = 'customizer_recent_imports_v1';
const RECENT_IMPORTS_MAX = 3;
function getRecentImports() {
try {
const raw = localStorage.getItem(RECENT_IMPORTS_KEY);
const arr = raw ? JSON.parse(raw) : [];
return Array.isArray(arr) ? arr : [];
} catch (e) {
return [];
}
}
function setRecentImports(arr) {
try {
localStorage.setItem(RECENT_IMPORTS_KEY, JSON.stringify(arr));
return true;
} catch (e) {
return false;
}
}
function fileToDataURL(file) {
return new Promise((resolve) => {
const reader = new FileReader();
reader.onload = () => resolve(String(reader.result || ''));
reader.onerror = () => resolve('');
reader.readAsDataURL(file);
});
}
async function fileToThumbDataURL(file, maxSize = 160) {
try {
const src = await fileToDataURL(file);
if (!src) return '';
const img = await new Promise((resolve, reject) => {
const i = new Image();
i.onload = () => resolve(i);
i.onerror = reject;
i.src = src;
});
const ratio = Math.min(maxSize / img.width, maxSize / img.height, 1);
const w = Math.max(1, Math.round(img.width * ratio));
const h = Math.max(1, Math.round(img.height * ratio));
const canvas = document.createElement('canvas');
canvas.width = w;
canvas.height = h;
const ctx = canvas.getContext('2d');
ctx.clearRect(0, 0, w, h);
ctx.drawImage(img, 0, 0, w, h);
return canvas.toDataURL('image/png');
} catch (e) {
return '';
}
}
async function fileToScaledDataURL(file, maxDim = 1400, mime = 'image/jpeg', quality = 0.92) {
try {
if ((file.type || '').includes('svg')) {
return await fileToDataURL(file);
}
const src = await fileToDataURL(file);
if (!src) return '';
const img = await new Promise((resolve, reject) => {
const im = new Image();
im.onload = () => resolve(im);
im.onerror = reject;
im.src = src;
});
const ratio = Math.min(maxDim / img.width, maxDim / img.height, 1);
const w = Math.max(1, Math.round(img.width * ratio));
const h = Math.max(1, Math.round(img.height * ratio));
const canvas = document.createElement('canvas');
canvas.width = w;
canvas.height = h;
const ctx = canvas.getContext('2d');
ctx.clearRect(0, 0, w, h);
ctx.drawImage(img, 0, 0, w, h);
return canvas.toDataURL(mime, quality);
} catch (e) {
return '';
}
}
async function makeRecoverableImageDataUrl(file) {
  // Copie réduite intégrée à l'état éditable : elle ne sert qu'en secours si
  // l'hébergement de l'image originale ne répond plus lors d'une modification.
  const dataUrl = await fileToScaledDataURL(file, 960, 'image/jpeg', 0.86);
  return dataUrl && dataUrl.length <= 700000 ? dataUrl : '';
}
async function pushRecentImport(file) {
if (!file) return;
const id = `${file.name}|${file.size}|${file.lastModified || ''}|${file.type || ''}`;
const isPng = (file.type === 'image/png') || (file.name || '').toLowerCase().endsWith('.png');
const mime = isPng ? 'image/png' : 'image/jpeg';
const quality = isPng ? 1 : 0.92;
let dataUrl = await fileToScaledDataURL(file, 1400, mime, quality);
if (!dataUrl) dataUrl = await fileToDataURL(file);
if (!dataUrl) return;
let thumb = await fileToThumbDataURL(file);
if (!thumb) thumb = dataUrl;
const current = getRecentImports();
const filtered = current.filter(x => x && x.id !== id);
filtered.unshift({
id,
name: file.name || 'image',
type: file.type || '',
thumb,
dataUrl,
ts: Date.now()
});
let next = filtered.slice(0, RECENT_IMPORTS_MAX);
let ok = setRecentImports(next);
if (!ok) {
next = next.slice(0, 1);
ok = setRecentImports(next);
}
if (!ok && typeof showNotification === 'function') {
showNotification("Impossible d'enregistrer l'image dans 'récemment importés' (quota navigateur).", 'error');
}
}
function dataURLToFile(dataUrl, filename) {
const parts = dataUrl.split(',');
const mimeMatch = parts[0].match(/data:(.*?);base64/);
const mime = mimeMatch ? mimeMatch[1] : 'image/png';
const bstr = atob(parts[1] || '');
let n = bstr.length;
const u8 = new Uint8Array(n);
while (n--) u8[n] = bstr.charCodeAt(n);
return new File([u8], filename, { type: mime });
}
function renderRecentImports() {
const grid = document.getElementById('recentImportsGrid');
const empty = document.getElementById('recentImportsEmpty');
if (!grid) return;
const items = getRecentImports();
grid.innerHTML = '';
if (empty) empty.style.display = items.length ? 'none' : 'block';
items.slice(0, RECENT_IMPORTS_MAX).forEach(item => {
const cell = document.createElement('button');
cell.type = 'button';
cell.className = 'recent-imports-item';
cell.style.cursor = 'pointer';
const img = document.createElement('img');
img.alt = item.name || 'Import';
img.src = item.thumb || item.dataUrl || '';
cell.appendChild(img);
cell.addEventListener('click', async (e) => {
e.preventDefault();
e.stopPropagation();
const fullDataUrl = item.dataUrl;
if (!fullDataUrl) return;
const originalName = item.name || `import_${Date.now()}.png`;
const file = dataURLToFile(fullDataUrl, originalName);
const localURL = URL.createObjectURL(file);
addDesignToCurrentView(localURL, 'image', file.name);
const designArea = document.querySelector(`.design-area[data-area="${currentView}"]`);
const lastImg = designArea?.querySelector('.design-item:last-child img');
if (lastImg) {
lastImg.dataset.inlineSrc = fullDataUrl.length <= 700000 ? fullDataUrl : '';
lastImg.dataset.pendingFile = 'true';
lastImg.dataset.fileName = file.name;
lastImg.dataset.originalName = file.name;
lastImg.dataset.uploadSubType = 'images';
if (!window.pendingUploads) window.pendingUploads = new Map();
window.pendingUploads.set(lastImg, file);
}
if (lastImg && typeof lastImg.decode === 'function') await lastImg.decode().catch(function() {});
openDrawer();
setDrawerMode('options');
});
grid.appendChild(cell);
});
}
function initializeImageUpload() {
const originalInput = document.getElementById('imageUpload');
if (!originalInput) {
return;
}
const input = originalInput.cloneNode(true);
originalInput.replaceWith(input);
input.addEventListener('change', async (event) => {
const files = Array.from(event.target.files || []);
if (!files.length) return;
if (window.currentProduct?.patch && files.length > 1) {
  showNotification('Choisissez une seule image pour votre écusson.','warning');event.target.value='';return;
}
event.target.value = '';
const HARD_MAX_SIZE_BYTES = 10 * 1024 * 1024;
const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/svg+xml'];
for (const originalFile of files) {
if (originalFile.size > HARD_MAX_SIZE_BYTES) {
showNotification('Fichier trop volumineux (max 10 Mo)', 'error');
continue;
}
if (!ALLOWED_TYPES.includes(originalFile.type)) {
showNotification('Format non supporté. Utilise PNG, JPG, WEBP ou SVG.', 'error');
continue;
}
try {
// Remove empty export margins before the selection frame is created.
const file = window.OazarDesignBounds ? await window.OazarDesignBounds.prepareFile(originalFile) : originalFile;
const inlineSrc = await makeRecoverableImageDataUrl(file);
const localURL = URL.createObjectURL(file);
await pushRecentImport(originalFile);
if (drawerMode === 'import') {
renderRecentImports();
}
addDesignToCurrentView(
localURL,
'image',
originalFile.name
);
const designArea = document.querySelector(`.design-area[data-area="${currentView}"]`);
if (designArea) {
const lastItem = designArea.querySelector('.design-item:last-child img');
if (lastItem) {
lastItem.dataset.inlineSrc = inlineSrc;
lastItem.dataset.pendingFile = 'true';
lastItem.dataset.fileName = originalFile.name;
lastItem.dataset.uploadSubType = 'images';
if (!window.pendingUploads) window.pendingUploads = new Map();
window.pendingUploads.set(lastItem, file);
if (typeof lastItem.decode === 'function') await lastItem.decode().catch(function() {});
openDrawer();
setDrawerMode('options');
}
}
} catch (err) {
showNotification("Une erreur s'est produite avec ce fichier.", 'error');
}
}
});
}
function initializeTextControls() {}
function initializeGlobalClickHandler() {
document.addEventListener('click', function(e) {
if (e.target.closest('.design-item, .di-controls, #customizationDrawer, .customization-sidebar, button, input, textarea, select')) {
return;
}
const drawer = document.getElementById('customizationDrawer');
if (drawer && drawer.getAttribute('aria-hidden') === 'false' && ['options', 'text'].includes(drawerMode)) {
closeDrawer();
}
deselectAll();
});
}
function updateStudioProductOverview() {
const titleEl = document.getElementById('studioProductTitle');
const priceEl = document.getElementById('studioProductPrice');
const detailsEl = document.getElementById('studioProductDetails');
const product = window.currentProduct || currentProduct;
if (!product) {
if (titleEl) titleEl.textContent = 'Choisissez un produit';
if (priceEl) priceEl.textContent = '';
if (detailsEl) {
detailsEl.hidden = true;
detailsEl.removeAttribute('href');
}
return;
}
if (titleEl) titleEl.textContent = product.title || 'Produit personnalisé';
if (priceEl) {
// Tarif standard : afficher le prix du vêtement sélectionné, même avec un modèle SVG.
let formatted = String(product.priceFormatted || '').trim();
if (!formatted && Number.isFinite(Number(product.price))) {
formatted = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Number(product.price) / 100);
}
priceEl.textContent = formatted;
}
if (detailsEl) {
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
detailsEl.href = root + 'products/' + encodeURIComponent(product.handle || '');
detailsEl.hidden = !product.handle;
}
}
async function tightenPreservedImage(item, productHandle, generation) {
  const image = item.querySelector('.di-content > img');
  if (!image || !window.OazarDesignBounds?.measureImage) return;
  try {
    await image.decode();
    const source = image.src, file = window.pendingUploads?.get(image);
    // SVG export margins are handled by prepareSvg without rasterizing vectors.
    if (file?.type.includes('svg') || /\.svg$/i.test(image.dataset.originalName || '') || /\.svg(?:[?#]|$)|^data:image\/svg/i.test(source)) return;
    const bounds = window.OazarDesignBounds.measureImage(image);
    if (!bounds || (bounds.width > .995 && bounds.height > .995)) return;
    const oldWidth = parseFloat(item.style.width) || item.offsetWidth, oldHeight = parseFloat(item.style.height) || item.offsetHeight;
    const placement = item.getAttribute('style');
    const x = Math.floor(bounds.x * image.naturalWidth), y = Math.floor(bounds.y * image.naturalHeight);
    const canvas = document.createElement('canvas');
    canvas.width = Math.min(image.naturalWidth - x, Math.ceil(bounds.width * image.naturalWidth));
    canvas.height = Math.min(image.naturalHeight - y, Math.ceil(bounds.height * image.naturalHeight));
    canvas.getContext('2d').drawImage(image, x, y, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
    const pixelScale = Math.min(oldWidth / image.naturalWidth, oldHeight / image.naturalHeight);
    const width = canvas.width * pixelScale, height = canvas.height * pixelScale;
    const dx = (oldWidth - image.naturalWidth * pixelScale) / 2 + x * pixelScale + width / 2 - oldWidth / 2;
    const dy = (oldHeight - image.naturalHeight * pixelScale) / 2 + y * pixelScale + height / 2 - oldHeight / 2;
    const angle = (parseFloat(item.dataset.angle) || 0) * Math.PI / 180;
    const left = (parseFloat(item.style.left) || 0) + oldWidth / 2 + dx * Math.cos(angle) - dy * Math.sin(angle) - width / 2;
    const top = (parseFloat(item.style.top) || 0) + oldHeight / 2 + dx * Math.sin(angle) + dy * Math.cos(angle) - height / 2;
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    if (!blob || !item.isConnected || currentProduct?.handle !== productHandle || window.__ozProductChangeGeneration !== generation || image.src !== source || item.getAttribute('style') !== placement) return;
    const cropped = new File([blob], image.dataset.originalName || 'image.png', {type:'image/png'}), url = URL.createObjectURL(cropped);
    const inlineSrc = await makeRecoverableImageDataUrl(cropped);
    if (!item.isConnected || currentProduct?.handle !== productHandle || window.__ozProductChangeGeneration !== generation || image.src !== source || item.getAttribute('style') !== placement) return;
    image.src = url;image.dataset.originalSrc = url;image.dataset.inlineSrc = inlineSrc;
    item.style.width = width + 'px';item.style.height = height + 'px';item.style.left = left + 'px';item.style.top = top + 'px';
    item.dataset.originalRatio = String(canvas.width / canvas.height);item.dataset.w = width.toFixed(1);item.dataset.h = height.toFixed(1);
    window.pendingUploads ||= new Map();window.pendingUploads.set(image, cropped);
  } catch (_) { /* A remote image may forbid reading pixels; keep its visual intact. */ }
}
function changeProduct(productHandle) {
if (window.CUSTOMIZER_EDIT_MODE && window.CUSTOMIZER_LOCKED_HANDLE) {
if (productHandle !== window.CUSTOMIZER_LOCKED_HANDLE) return false;
}
const nextProduct = productsData && productsData[productHandle];
if (!nextProduct) {
window.__ozCustomizerProductReady = false;
return false;
}
document.body.classList.remove('oz-product-choice-preview');
const previousProductHandle = currentProduct && currentProduct.handle;
if (previousProductHandle === productHandle) return true;
const productChangeGeneration = window.__ozProductChangeGeneration = (window.__ozProductChangeGeneration || 0) + 1;
// A patch belongs to its selected support. Carry only the original visual
// when selecting another product, before saving its placement and history.
if (previousProductHandle && window.OazarPatchStudio?.resetForProductChange) {
  window.OazarPatchStudio.resetForProductChange();
}
const preservedDesign = previousProductHandle ? ['front', 'back', 'left', 'right'].map(function(view) {
  const area = document.querySelector('.design-area[data-area="' + view + '"]');
  return area && {
    view: view,
    width: area.clientWidth || area.offsetWidth || 0,
    height: area.clientHeight || area.offsetHeight || 0,
    items: Array.from(area.querySelectorAll('.design-item')).map(function(item) {
      const image = item.querySelector('.di-content > img');
      const width = parseFloat(item.style.width) || item.offsetWidth;
      const height = parseFloat(item.style.height) || item.offsetHeight;
      const ratio = image?.complete && image.currentSrc === image.src && image.naturalWidth && image.naturalHeight ? image.naturalWidth / image.naturalHeight : Number(item.dataset.originalRatio);
      // Repair a frame stretched by an earlier product change without scaling
      // the contained image: its painted rectangle becomes the selection frame.
      if (image && Number.isFinite(ratio) && ratio > 0 && width > 0 && height > 0 && getComputedStyle(image).objectFit === 'contain') {
        const paintedWidth = Math.min(width, height * ratio), paintedHeight = paintedWidth / ratio;
        if (Math.abs(paintedWidth - width) > 1 || Math.abs(paintedHeight - height) > 1) {
          item.style.left = ((parseFloat(item.style.left) || 0) + (width - paintedWidth) / 2) + 'px';
          item.style.top = ((parseFloat(item.style.top) || 0) + (height - paintedHeight) / 2) + 'px';
          item.style.width = paintedWidth + 'px';item.style.height = paintedHeight + 'px';
        }
        item.dataset.originalRatio = String(ratio);
      }
      return {
        item: item,
        left: item.style.left,
        top: item.style.top,
        width: item.style.width || item.offsetWidth + 'px',
        height: item.style.height || item.offsetHeight + 'px'
      };
    })
  };
}).filter(Boolean) : [];
const hasPreservedDesign = preservedDesign.some(function(view) { return view.items.length > 0; });
if (previousProductHandle && previousProductHandle !== productHandle) {
  window.oazarIncomingDesignZones = null;
}
window.__ozCustomizerProductReady = false;
if (!hasPreservedDesign) {
  ['front', 'back', 'left', 'right'].forEach(function(view) {
    var area = document.querySelector('.design-area[data-area="' + view + '"]');
    if (area) area.querySelectorAll('.design-item').forEach(function(item) { item.remove(); });
    if (typeof designLayers !== 'undefined' && designLayers[view]) designLayers[view] = [];
  });
  if (typeof selectedItem !== 'undefined') selectedItem = null;
  try { localStorage.removeItem('customizerDesign'); } catch(e) {}
} else if (typeof deselectAll === 'function') {
  deselectAll();
}

currentProduct = nextProduct;
window.currentProduct = currentProduct;
updateStudioProductOverview();
updateTechniquesAvailability();
sizeQuantities = {};
variantBySize = {};
updateProductImages();
changeView(currentView || "front");
updateColorOptions();
const colorSection = document.getElementById('colorSelection');
const sizeSection = document.getElementById('sizeSelection');
if (colorSection) colorSection.style.display = 'block';
if (sizeSection) sizeSection.style.display = 'block';
updateSizeSummary();
updateSelectSizesButton();
showAddToCartButton();
if (typeof updatePriceLiveBlock === 'function') updatePriceLiveBlock();
if (typeof window.__ozApplyCartEligibilityUI === 'function') window.__ozApplyCartEligibilityUI();
refreshViewAvailability();
if (typeof scheduleThumbnailUpdate === 'function') {
  scheduleThumbnailUpdate();
}
if (typeof window.refreshAllDesignZones === "function") {
  setTimeout(window.refreshAllDesignZones, 50);
}
if (hasPreservedDesign) {
  setTimeout(async function() {
    if (currentProduct?.handle !== productHandle || window.__ozProductChangeGeneration !== productChangeGeneration) return;
    preservedDesign.forEach(function(saved) {
      var area = document.querySelector('.design-area[data-area="' + saved.view + '"]');
      if (!area) return;
      var ratioX = saved.width > 0 ? (area.clientWidth || area.offsetWidth || saved.width) / saved.width : 1;
      var ratioY = saved.height > 0 ? (area.clientHeight || area.offsetHeight || saved.height) / saved.height : 1;
      saved.items.forEach(function(savedItem) {
        var item = savedItem.item;
        // Move the centre to the matching position on the new support.
        // The artwork keeps its width and height; scaling each axis by the
        // product zone separately used to leave empty space inside its frame.
        ['width', 'height'].forEach(function(property) {
          item.style[property] = savedItem[property];
        });
        [['left', 'width', ratioX], ['top', 'height', ratioY]].forEach(function(entry) {
          var position = parseFloat(savedItem[entry[0]]), size = parseFloat(savedItem[entry[1]]);
          if (Number.isFinite(position) && Number.isFinite(size)) item.style[entry[0]] = ((position + size / 2) * entry[2] - size / 2) + 'px';
        });
        item.dataset.w = (parseFloat(item.style.width) || item.offsetWidth).toFixed(1);
        item.dataset.h = (parseFloat(item.style.height) || item.offsetHeight).toFixed(1);
        if (typeof updateItemSizeBadge === 'function') updateItemSizeBadge(item);
        if (typeof updateOverflowState === 'function') updateOverflowState(item);
      });
    });
    await Promise.all(preservedDesign.flatMap(function(saved) { return saved.items.map(function(savedItem) { return tightenPreservedImage(savedItem.item, productHandle, productChangeGeneration); }); }));
    if (currentProduct?.handle !== productHandle || window.__ozProductChangeGeneration !== productChangeGeneration) return;
    preservedDesign.forEach(function(saved) {saved.items.forEach(function(savedItem) {
      if (typeof updateOverflowState === 'function') updateOverflowState(savedItem.item);
      if (typeof updateItemSizeBadge === 'function') updateItemSizeBadge(savedItem.item);
    });});
    ['front', 'back', 'left', 'right'].forEach(function(view) {
      HISTORY.past[view] = [];
      HISTORY.future[view] = [];
      if (typeof pushHistory === 'function') pushHistory(view);
    });
    if (typeof updateUndoRedoUI === 'function') updateUndoRedoUI();
    if (typeof updateDesignLayers === 'function') updateDesignLayers();
    if (typeof saveDesignToLocalStorage === 'function') saveDesignToLocalStorage();
    if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
  }, 180);
}

window.__ozCustomizerProductReady = true;
document.dispatchEvent(new CustomEvent('oazar:product-changed',{detail:{handle:productHandle}}));
if (typeof window.closeProductPicker === 'function') window.closeProductPicker(true);

if (typeof window.ozApplyPendingGalleryDesign === 'function') {
  setTimeout(window.ozApplyPendingGalleryDesign, 450);
}
if (typeof window.ozApplyPendingStarterTemplate === 'function') {
  setTimeout(window.ozApplyPendingStarterTemplate, 120);
}
return true;
}
function updateTechniquesAvailability() {
if (!currentProduct) return;
const impressionBtn = document.getElementById('techniqueImpression');
const broderieBtn = document.getElementById('techniqueBroderie');
const mobileImpressionBtn = document.getElementById('mobileTechniqueImpression');
const mobileBroderieBtn = document.getElementById('mobileTechniqueBroderie');
let techniques = currentProduct.techniques;
if (Array.isArray(techniques)) {
techniques = techniques.join(',');
}
if (techniques && typeof techniques === 'object') {
techniques = techniques.value || techniques.name || '';
if (Array.isArray(techniques)) techniques = techniques.join(',');
}
if (typeof techniques !== 'string') {
techniques = String(techniques || '');
}
let raw = (techniques || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
raw = raw.replace(/[\[\]"']/g, '');
raw = raw.replace(/[;/|]/g, ',');
raw = raw.replace(/\s*,\s*/g, ',');
const parts = raw.includes(',') ? raw.split(',') : raw.split(/\s+/);
let techniquesArray = parts
.map(function (t) {
t = (t || '').trim();
if (!t) return '';
if (t.includes('brod')) return 'broderie';
if (t.includes('impr')) return 'impression';
return '';
})
.filter(Boolean);
techniquesArray = Array.from(new Set(techniquesArray));
const impressionAllowed =
techniquesArray.length === 0 || techniquesArray.indexOf('impression') !== -1;
const broderieAllowed =
techniquesArray.length === 0 || techniquesArray.indexOf('broderie') !== -1;
window.__ozAllowedTechniques = {
impression: impressionAllowed,
broderie: broderieAllowed
};
window.__ozIsTechniqueAllowed = function (technique) {
return window.__ozAllowedTechniques[String(technique || '').toLowerCase()] !== false;
};
function setButtonState(btn, allowed) {
if (!btn) return;
btn.disabled = !allowed;
btn.setAttribute('aria-disabled', String(!allowed));
btn.classList.toggle('is-technique-disabled', !allowed);
btn.title = allowed ? '' : 'Cette technique n’est pas autorisée pour ce produit';
btn.style.opacity = allowed ? '1' : '0.38';
btn.style.cursor = allowed ? 'pointer' : 'not-allowed';
btn.style.filter = allowed ? 'none' : 'grayscale(100%)';
btn.style.pointerEvents = allowed ? 'auto' : 'none';
}
setButtonState(impressionBtn, impressionAllowed);
setButtonState(broderieBtn, broderieAllowed);
setButtonState(mobileImpressionBtn, impressionAllowed);
setButtonState(mobileBroderieBtn, broderieAllowed);
function autoClickNoConfirm(btn1, btn2) {
const target = btn1 && !btn1.disabled ? btn1 : btn2;
// Availability can select the required technique for a new support. This
// automatic selection must not run the manual action that erases designs.
if (target && !target.disabled && typeof window.__ozSyncTechniqueUI === 'function') {
  window.__ozSyncTechniqueUI(target.dataset.technique);
  return;
}
window.__skipTechniqueConfirm = true;
if (target && !target.disabled) target.click();
window.__skipTechniqueConfirm = false;
}
if (currentTechnique === 'impression' && !impressionAllowed && broderieAllowed) {
autoClickNoConfirm(broderieBtn, mobileBroderieBtn);
} else if (currentTechnique === 'broderie' && !broderieAllowed && impressionAllowed) {
autoClickNoConfirm(impressionBtn, mobileImpressionBtn);
}
if (!impressionAllowed && !broderieAllowed) {
setButtonState(impressionBtn, true);
setButtonState(mobileImpressionBtn, true);
if (currentTechnique !== 'impression') {
autoClickNoConfirm(impressionBtn, mobileImpressionBtn);
}
}
}
function updateProductImages() {
  if (!currentProduct) return;
  const activeSwatch = document.querySelector('.color-swatch.active');
  const selectedColor = activeSwatch ? activeSwatch.dataset.color : '';
  const views = ['front', 'back', 'left', 'right'];
  views.forEach(function(view) {
    const imgEl = document.getElementById(
      'productImage' + view.charAt(0).toUpperCase() + view.slice(1)
    );
    if (!imgEl) return;
    let imageUrl = null;
    if (selectedColor && (view === 'front' || view === 'avant')) {
       const variantSameColor = currentProduct.variants.find(function(v) {
         return v.option1 === selectedColor && v.image;
       });
       if (variantSameColor) {
         imageUrl = variantSameColor.image;
       }
    }
    if (!imageUrl && selectedColor) {
      imageUrl = findImageByViewAndColor(view, selectedColor);
    }
    if (!imageUrl && currentProduct.images && currentProduct.images[view]) {
      imageUrl = currentProduct.images[view];
    }
    if (!imageUrl && currentProduct.gallery) {
      const frontAliases = ['front', 'avant'];
      const match = currentProduct.gallery.find(img =>
        frontAliases.some(a => (img.alt || '').toLowerCase().includes(a))
      );
      if (match) imageUrl = match.src;
      if (!imageUrl && view === 'front' && currentProduct.gallery[0]) {
        imageUrl = currentProduct.gallery[0].src;
      }
    }
    if (!imageUrl && currentProduct.variants && currentProduct.variants.length > 0) {
      if (selectedColor) {
         const variantSameColor = currentProduct.variants.find(function(v) {
           return v.option1 === selectedColor && v.image;
         });
         if (variantSameColor) imageUrl = variantSameColor.image;
      }
      if (!imageUrl) {
        const firstVariantWithImg = currentProduct.variants.find(function(v) {
          return v.image;
        });
        if (firstVariantWithImg) imageUrl = firstVariantWithImg.image;
      }
    }
    if (currentProduct.patch) imageUrl = view === 'front' ? currentProduct.images.front : null;
    if (imageUrl) {
      // Forcer la haute résolution Shopify
      imageUrl = imageUrl.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|\d*x\d+)(\.[a-z]+)/i, '$1');
      if (imageUrl.indexOf('?') === -1) {
        imageUrl += '?width=1200';
      } else if (imageUrl.indexOf('width=') === -1) {
        imageUrl += '&width=1200';
      }
      if (imgEl.getAttribute('src') !== imageUrl) {
          imgEl.src = imageUrl;
          imgEl.alt = currentProduct.patch ? 'Aperçu de votre écusson personnalisé' : imgEl.alt;
      }
      imgEl.style.display = 'block';
    } else {
      imgEl.style.display = 'none';
    }
  });
}
function escapeRegExp(str) {
  return String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function normColor(str) {
  return normalizeColorName(String(str || '').replace(/[_-]+/g, ' '));
}
function colorKey(label) {
  const cleaned = normColor(label);
  const parts = splitMultiColorLabel(cleaned)
    .map(p => normColor(p))
    .filter(Boolean)
    .sort();
  return parts.join('|');
}
function altHasView(altNorm, aliases) {
  return aliases.some(alias => {
    const a = normColor(alias);
    return new RegExp(`\\b${escapeRegExp(a)}\\b`, 'i').test(altNorm);
  });
}
function stripViewFromAlt(altNorm, aliases) {
  let s = String(altNorm || '');
  aliases.forEach(alias => {
    const a = normColor(alias);
    s = s.replace(new RegExp(`\\b${escapeRegExp(a)}\\b`, 'ig'), ' ');
  });
  s = s.replace(/[_-]+/g, ' ');
  s = s.replace(/\s+/g, ' ').trim();
  return s;
}
function findImageByViewAndColor(view, color) {
  if (!currentProduct || !currentProduct.gallery) return null;
  const viewAliases = {
    front: ['front', 'avant'],
    back:  ['back', 'dos', 'arrière'],
    left:  ['left', 'gauche', 'manche gauche'],
    right: ['right', 'droite', 'manche droite']
  };
  const aliases = viewAliases[view] || [view];
  const wantedKey = colorKey(color);
  if (!wantedKey) return null;
  const exact = currentProduct.gallery.find(img => {
    const altNorm = normColor(img.alt || '');
    if (!altHasView(altNorm, aliases)) return false;
    const altColorZone = stripViewFromAlt(altNorm, aliases);
    const altKey = colorKey(altColorZone);
    return altKey && altKey === wantedKey;
  });
  if (exact) return exact.src;
  const wantedParts = splitMultiColorLabel(color).map(p => normColor(p)).filter(Boolean);
  if (wantedParts.length >= 2) {
    const fallback = currentProduct.gallery.find(img => {
      const altNorm = normColor(img.alt || '');
      if (!altHasView(altNorm, aliases)) return false;
      return wantedParts.every(p => new RegExp(`\\b${escapeRegExp(p)}\\b`, 'i').test(altNorm));
    });
    if (fallback) return fallback.src;
  }
  return null;
}
function updateColorOptions() {
if (!currentProduct) return;
const colorGrid = document.getElementById('colorOptions');
const colorSection = document.getElementById('colorSelection');
if (!colorGrid || !colorSection) return;
const colors = new Map();
currentProduct.variants.forEach(function(v) {
if (v.option1) colors.set(v.option1, v);
});
if (!colors.size) {
colorSection.style.display = 'none';
return;
}
colorSection.style.display = 'block';
colorGrid.innerHTML = '';
let firstAvailable = null;
colors.forEach(function(variant, color) {
const isAvailable = currentProduct.variants.some(function(v) {
return v.option1 === color && v.available;
});
if (isAvailable && !firstAvailable) {
firstAvailable = color;
}
const swatch = document.createElement('div');
swatch.className = 'color-swatch' + (isAvailable ? '' : ' disabled');
swatch.dataset.color = color;
applySwatchStyle(swatch, color, currentProduct);
swatch.addEventListener('click', function() {
selectColor(swatch);
});
colorGrid.appendChild(swatch);
});
if (firstAvailable) {
const firstSwatch = colorGrid.querySelector('[data-color="' + firstAvailable + '"]');
if (firstSwatch) {
firstSwatch.click();
}
}
}
function selectColor(swatchElement) {
  if (swatchElement.classList.contains('disabled')) return;
  document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
  swatchElement.classList.add('active');
  const color = swatchElement.dataset.color;
  const selectedColorEl = document.getElementById('selectedColor');
  const selectedSwatchEl = document.getElementById('selectedColorSwatch');
  if (selectedColorEl) selectedColorEl.textContent = color;
  if (selectedSwatchEl) applySwatchStyle(selectedSwatchEl, color, currentProduct);
  const mobileColorBtn = document.getElementById('mobileColorBtn');
  if (mobileColorBtn) {
    mobileColorBtn.classList.add('has-color');
    const tempSw = document.createElement('div');
    applySwatchStyle(tempSw, color, currentProduct);
    mobileColorBtn.style.setProperty('--oz-mobile-bg', oazarMobileSwatchBackground(tempSw, color));
  }
  sizeQuantities = {};
  window.sizeQuantities = sizeQuantities;
  updateSizeOptionsForColor(color);
  updateProductImages();
  refreshProductView();
  refreshViewAvailability();
  if (typeof scheduleThumbnailUpdate === 'function') {
    scheduleThumbnailUpdate();
  }
}
function updateSizeOptionsForColor(selectedColor) {
if (!currentProduct) return;
const variantsForColor = currentProduct.variants.filter(v =>
v.option1 === selectedColor && v.available
);
variantBySize = {};
sizeQuantities = {};
window.variantBySize = variantBySize;
window.sizeQuantities = sizeQuantities;
variantsForColor.forEach(variant => {
const size = ozNormalizeSizeLabel(variant.option2);
if (size) {
variantBySize[size] = variant.id;
sizeQuantities[size] = 0;
}
});
const availableSizesList = document.getElementById('availableSizesList');
if (availableSizesList) {
availableSizesList.replaceChildren();
Object.keys(variantBySize).sort(function(a, b) {
const order = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL'];
const ai = order.indexOf(a.toUpperCase());
const bi = order.indexOf(b.toUpperCase());
return (ai < 0 ? order.length : ai) - (bi < 0 ? order.length : bi) || a.localeCompare(b, 'fr', { numeric: true });
}).forEach(function(size) {
const pill = document.createElement('span');
pill.className = 'studio-size-pill';
pill.textContent = size;
availableSizesList.appendChild(pill);
});
}
updateSizeSummary();
updateSelectSizesButton();
showAddToCartButton();
if (typeof window.__ozApplyCartEligibilityUI === 'function') window.__ozApplyCartEligibilityUI();
}
function refreshViewAvailability() {
if (!currentProduct) return;
const selectedColorEl = document.querySelector('.color-swatch.active');
const selectedColor = selectedColorEl ? selectedColorEl.dataset.color : '';
const views = ['front', 'back', 'left', 'right'];
const available = views.filter(function(view) {
return findImageByViewAndColor(view, selectedColor);
});
views.forEach(function(view) {
const btn = document.querySelector('.view-button[data-view="' + view + '"]');
const pill = document.querySelector('.view-pill[data-view="' + view + '"]');
const viewEl = document.querySelector('.product-view[data-view="' + view + '"]');
const isAvailable = available.indexOf(view) !== -1;
if (btn) btn.style.display = isAvailable ? '' : 'none';
if (pill) pill.style.display = isAvailable ? '' : 'none';
if (viewEl) viewEl.style.display = (isAvailable && view === currentView) ? 'flex' : 'none';
});
if (available.indexOf(currentView) === -1 && available.length) {
changeView(available[0]);
}
}
function normalizeColorName(name) {
if (!name) return '';
return name
.toLowerCase()
.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
.replace(/\s+/g, ' ')
.trim();
}
function getShopifySwatchData(colorName, product = window.currentProduct) {
const swatches = product && product.swatches;
if (!swatches || !colorName) return null;
if (swatches[colorName]) return swatches[colorName];
const target = normalizeColorName(colorName);
const key = Object.keys(swatches).find(k => normalizeColorName(k) === target);
return key ? swatches[key] : null;
}
function getSwatchColorOnly(colorName, product = window.currentProduct) {
const sw = getShopifySwatchData(colorName, product);
if (sw && typeof sw.color === 'string' && sw.color.trim()) return sw.color.trim();
return getColorCode(colorName, product);
}
function splitMultiColorLabel(label) {
const raw = (label || '').toString().trim();
if (!raw) return [];
const hasSep = /[\/|,+&]/.test(raw) || /\set\s/i.test(raw);
if (!hasSep) return [raw];
let parts = raw.split(/\s*(?:\/|\||,|\+|&)\s*/).filter(Boolean);
if (parts.length <= 1 && /\set\s/i.test(raw)) {
parts = raw.split(/\s+et\s+/i).filter(Boolean);
}
const out = [];
for (const p of parts) {
const t = p.trim();
if (t && !out.includes(t)) out.push(t);
}
return out;
}
function conicGradientWithSeparators(colors) {
const sep = 'rgba(255,255,255,0.95)';
const c = colors.filter(Boolean);
if (c.length === 2) {
return `conic-gradient(${c[0]} 0 49%, ${sep} 49% 51%, ${c[1]} 51% 100%)`;
}
if (c.length >= 3) {
return `conic-gradient(${c[0]} 0 32.5%, ${sep} 32.5% 34%, ${c[1]} 34% 65.5%, ${sep} 65.5% 67%, ${c[2]} 67% 100%)`;
}
return c[0] || '#cccccc';
}
function applySwatchStyle(el, colorName, product = window.currentProduct) {
if (!el) return;
const sw = getShopifySwatchData(colorName, product);
const img = sw && sw.image ? String(sw.image).trim() : '';
const col = sw && sw.color ? String(sw.color).trim() : '';
if (img) {
el.style.backgroundImage = `url(${img})`;
el.style.backgroundSize = 'cover';
el.style.backgroundPosition = 'center';
el.style.backgroundRepeat = 'no-repeat';
el.style.backgroundColor = 'transparent';
return;
}
if (col) {
el.style.backgroundImage = 'none';
el.style.background = col;
return;
}
const parts = splitMultiColorLabel(colorName).slice(0, 3);
if (parts.length >= 2) {
const cols = parts.map(p => getSwatchColorOnly(p, product) || getColorCode(p, product) || '#cccccc');
el.style.backgroundImage = 'none';
el.style.background = conicGradientWithSeparators(cols);
return;
}
el.style.backgroundImage = 'none';
el.style.background = getColorCode(colorName, product);
}
function oazarMobileSwatchBackground(swatch, colorName) {
  const image = swatch.style.backgroundImage;
  if (image && image !== 'none' && image !== 'initial' && image !== 'unset') return image;
  const color = swatch.style.backgroundColor;
  if (color && color !== 'transparent' && color !== 'initial' && color !== 'unset') return color;
  return getColorCode(colorName, null) || '#cccccc';
}
function getSwatchInlineStyle(colorName, product = window.currentProduct) {
  const sw = getShopifySwatchData(colorName, product);
  const img = sw && sw.image ? String(sw.image).trim() : '';
  const col = sw && sw.color ? String(sw.color).trim() : '';

  if (img) {
    return "background-image:url(" + img + ");background-size:cover;background-position:center;background-repeat:no-repeat;background-color:transparent;";
  }
  if (col) {
    return "background:" + col + ";background-image:none;";
  }

  const parts = splitMultiColorLabel(colorName).slice(0, 3);
  if (parts.length >= 2) {
    const cols = parts.map(p => getSwatchColorOnly(p, product) || getColorCode(p, product) || '#cccccc');
    return "background:" + conicGradientWithSeparators(cols) + ";background-image:none;";
  }

  const fb = getColorCode(colorName, product) || '#cccccc';
  return "background:" + fb + ";background-image:none;";
}
function getColorCode(colorName, product = window.currentProduct) {
if (!colorName) return '#cccccc';
const baseName = normalizeColorName(colorName);
// 1) Priorité: couleur stockée sur la variante (si tu l'injectes dans productsData)
if (product && Array.isArray(product.variants)) {
const v = product.variants.find(variant =>
variant &&
normalizeColorName(variant.option1) === baseName &&
typeof variant.color_hex === 'string' &&
variant.color_hex.trim().length
);
if (v) return v.color_hex.trim();
}
// 2) Si la valeur ressemble déjà à une couleur CSS, on la garde
const raw = String(colorName).trim();
if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(raw)) return raw;
if (/^rgb\(/i.test(raw) || /^hsl\(/i.test(raw)) return raw;
// 3) Fallback mapping
const colorMap = {
'blanc': '#ffffff',
'off white': '#f5f5f5',
'ecru': '#f5f1e6',
'noir': '#000000',
'anthracite': '#252525',
'gris': '#808080',
'gris clair': '#d3d3d3',
'gris chine': '#bfbfbf',
'gris chine clair': '#cfcfcf',
'bleu': '#0000ff',
'bleu marine': '#001f3f',
'marine': '#001f3f',
'bleu roi': '#0050ff',
'bleu royal': '#0050ff',
'bleu ciel': '#87ceeb',
'bleu clair': '#87ceeb',
'bleu turquoise': '#40e0d0',
'rouge': '#ff0000',
'bordeaux': '#800020',
'brique': '#b22222',
'corail': '#ff7f50',
'rose': '#ffc0cb',
'rose pale': '#ffd1dc',
'fuchsia': '#ff00aa',
'vert': '#008000',
'vert clair': '#32cd32',
'vert bouteille': '#004225',
'vert kaki': '#6b8e23',
'kaki': '#6b8e23',
'olive': '#556b2f',
'menthe': '#98ff98',
'jaune': '#ffff00',
'jaune pastel': '#fffbcc',
'moutarde': '#e0b000',
'orange': '#ffa500',
'marron': '#8b4513',
'chocolat': '#5a2d0c',
'camel': '#c19a6b',
'tabac': '#b9804d',
'beige': '#f5f5dc',
'sable': '#e3d3b8',
'violet': '#8000ff',
'lavande': '#b57edc',
'lilas': '#c8a2c8',
'turquoise': '#40e0d0',
'dore': '#d4af37',
'doré': '#d4af37',
'or': '#d4af37',
'argent': '#c0c0c0'
};
if (colorMap[baseName]) return colorMap[baseName];
const hit = Object.keys(colorMap).find(key =>
baseName === key || baseName.includes(key) || key.includes(baseName)
);
if (hit) return colorMap[hit];
return '#cccccc';
}
function addDesignToCurrentView(content, type, originalName, origin = 'import') {
const patch = !!window.currentProduct?.patch;
if (patch && (type !== 'image' || !['import','ai'].includes(origin))) {
  showNotification('Pour cet écusson, choisissez une image importée ou un visuel IA.','warning');return null;
}
const area = document.querySelector('[data-view="' + currentView + '"] .design-area');
if (!area) return null;
const wrapper = document.createElement('div');
wrapper.className = 'design-item';
wrapper.dataset.type = type;
wrapper.dataset.angle = '0';
wrapper.dataset.locked = '0';
wrapper.dataset.uid = genUid();
if (patch) { wrapper.hidden = true; wrapper._ozVisualSequence = window.__ozPatchVisualSequence = (window.__ozPatchVisualSequence || 0) + 1; }
const contentEl = document.createElement('div');
contentEl.className = 'di-content';
if (type === 'image') {
const img = document.createElement('img');
img.src = content;
img.dataset.originalSrc = content;
img.dataset.ozVisualOrigin = origin;
if (originalName) {
img.dataset.originalName = originalName;
}
img.alt = 'Design personnalisé';
img.draggable = false;
img.onload = function () {
if (wrapper.dataset.inited === '1') {
  if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
  return;
}
if (patch && window.currentProduct?.patch) {
  if (wrapper._ozVisualSequence !== window.__ozPatchVisualSequence) { window.pendingUploads?.delete(img); wrapper.remove(); return; }
  wrapper.hidden = false;
  document.querySelectorAll('#mon-customizer .design-area .design-item').forEach(function(item) {
    if (item === wrapper) return;
    item.querySelectorAll('img').forEach(function(old) { window.pendingUploads?.delete(old); });
    const view = item.closest('.design-area')?.dataset.area || 'front';
    if (designLayers[view]) designLayers[view] = designLayers[view].filter(function(layer) { return layer !== item; });
    item.remove();
  });
}
const imgRatio = img.naturalWidth / img.naturalHeight;
wrapper.dataset.originalRatio = imgRatio;
if (wrapper.dataset.inited === '1') {
if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
return;
}
wrapper.dataset.inited = '1';
var areaW = area.offsetWidth;
var areaH = area.offsetHeight;
var defaultScale = 0.75;
var targetW = areaW * defaultScale;
var targetH = areaH * defaultScale;
var finalWidth, finalHeight;
if (imgRatio > targetW / targetH) {
finalWidth = targetW; finalHeight = targetW / imgRatio;
} else {
finalHeight = targetH; finalWidth = targetH * imgRatio;
}
wrapper.style.width = finalWidth + 'px';
wrapper.style.height = finalHeight + 'px';
var left = (areaW - finalWidth) / 2;
var top = (areaH - finalHeight) / 2;
wrapper.style.left = left + 'px';
wrapper.style.top = top + 'px';
wrapper.dataset.scale = defaultScale;
// ✅ Sauvegarder les dimensions pour le fallback tier (vue cachée au moment addToCart)
wrapper.dataset.w = finalWidth.toFixed(1);
wrapper.dataset.h = finalHeight.toFixed(1);
updateOverflowState(wrapper);
updateDesignLayers();
if (typeof updateItemSizeBadge === 'function') updateItemSizeBadge(wrapper);
if (typeof updatePriceLiveBlock === 'function') updatePriceLiveBlock();
if (typeof saveDesignToLocalStorage === 'function') saveDesignToLocalStorage();
if (typeof drawZoneLimits === 'function') drawZoneLimits();
if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
pushHistory(currentView);
};
if (patch) img.onerror = function () { window.pendingUploads?.delete(img); designLayers[currentView] = designLayers[currentView].filter(function(item) { return item !== wrapper; }); wrapper.remove(); showNotification('Cette image ne peut pas être ouverte. Essayez un autre fichier.','error'); };
contentEl.appendChild(img);
} else if (type === 'text') {
contentEl.innerHTML = content;
setTimeout(function() {
const textDiv = contentEl.querySelector('div');
if (textDiv) {
const tempSpan = document.createElement('span');
tempSpan.style.cssText = textDiv.style.cssText;
tempSpan.style.position = 'absolute';
tempSpan.style.visibility = 'hidden';
tempSpan.style.whiteSpace = 'nowrap';
tempSpan.textContent = textDiv.textContent;
document.body.appendChild(tempSpan);
const textWidth = tempSpan.offsetWidth;
const textHeight = tempSpan.offsetHeight;
document.body.removeChild(tempSpan);
wrapper.style.width = (textWidth + 20) + 'px';
wrapper.style.height = (textHeight + 10) + 'px';
var areaW = area.offsetWidth;
var areaH = area.offsetHeight;
var left = (areaW - (textWidth + 20)) / 2;
var top = (areaH - (textHeight + 10)) / 2;
wrapper.style.left = left + 'px';
wrapper.style.top = top + 'px';
// ✅ Sauvegarder les dimensions pour le fallback tier
wrapper.dataset.w = (textWidth + 20).toFixed(1);
wrapper.dataset.h = (textHeight + 10).toFixed(1);
}
}, 0);
}
wrapper.appendChild(contentEl);
area.appendChild(wrapper);
wrapper.dataset.locked = '0';
designLayers[currentView].push(wrapper);
updateDesignLayers();
makeInteractive(wrapper);
if (typeof updateItemSizeBadge === 'function') updateItemSizeBadge(wrapper);
selectItem(wrapper);
refreshProductView();
if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
if (!patch) pushHistory(currentView);
return wrapper;
}
function makeInteractive(element) {
const area = element.closest('.design-area');
if (!area) return;
element.querySelectorAll('.di-controls').forEach(function(ctrl) {
ctrl.remove();
});
const controls = document.createElement('div');
controls.className = 'di-controls';
controls.innerHTML = `
    <!-- POUBELLE - SVG simple sans fond -->
    <button type="button" class="di-handle-btn di-trash" data-action="delete" title="Supprimer" aria-label="Supprimer cet élément">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="300" width="300">
        <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/>
      </svg>
    </button>

    <!-- ROTATION - SVG simple sans fond -->
    <button type="button" class="di-handle rot di-handle-btn di-rotate" data-action="rotate" title="Pivoter" aria-label="Pivoter cet élément">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" height="300" width="300"><path fill="currentColor" d="M500.7 138.7L512 149.4L512 96C512 78.3 526.3 64 544 64C561.7 64 576 78.3 576 96L576 224C576 241.7 561.7 256 544 256L416 256C398.3 256 384 241.7 384 224C384 206.3 398.3 192 416 192L463.9 192L456.3 184.8C456.1 184.6 455.9 184.4 455.7 184.2C380.7 109.2 259.2 109.2 184.2 184.2C109.2 259.2 109.2 380.7 184.2 455.7C259.2 530.7 380.7 530.7 455.7 455.7C463.9 447.5 471.2 438.8 477.6 429.6C487.7 415.1 507.7 411.6 522.2 421.7C536.7 431.8 540.2 451.8 530.1 466.3C521.6 478.5 511.9 490.1 501 501C401 601 238.9 601 139 501C39.1 401 39 239 139 139C238.9 39.1 400.7 39 500.7 138.7z"/>
      </svg>
    </button>

    <!-- REDIMENSIONNEMENT - SVG simple sans fond -->
    <button type="button" class="di-handle se di-handle-btn di-resize" data-action="resize" title="Redimensionner" aria-label="Redimensionner cet élément">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" height="300" width="300" transform="rotate(90)"><path fill="currentColor" d="M416 64C398.3 64 384 78.3 384 96C384 113.7 398.3 128 416 128L466.7 128L361.3 233.4C348.8 245.9 348.8 266.2 361.3 278.7C373.8 291.2 394.1 291.2 406.6 278.7L512 173.3L512 224C512 241.7 526.3 256 544 256C561.7 256 576 241.7 576 224L576 96C576 78.3 561.7 64 544 64L416 64zM278.6 361.4C266.1 348.9 245.8 348.9 233.3 361.4L128 466.7L128 416C128 398.3 113.7 384 96 384C78.3 384 64 398.3 64 416L64 544C64 561.7 78.3 576 96 576L224 576C241.7 576 256 561.7 256 544C256 526.3 241.7 512 224 512L173.3 512L278.7 406.6C291.2 394.1 291.2 373.8 278.7 361.3z"></path></svg>
    </button>
  `;

  // Calculer la taille adaptative des boutons
  const updateControlSizes = () => {
    const width = element.offsetWidth;
    const height = element.offsetHeight;
    const minDimension = Math.min(width, height);
    
    // Taille du bouton : entre 30px (petit élément) et 50px (grand élément)
    let buttonSize = Math.max(30, Math.min(50, minDimension * 0.15));
    
    // Si l'élément est très petit, limiter la taille
    if (minDimension < 100) {
      buttonSize = 28;
    }
    
    // Appliquer la taille aux boutons
    const buttons = controls.querySelectorAll('.di-handle-btn');
    buttons.forEach(btn => {
      btn.style.width = buttonSize + 'px';
      btn.style.height = buttonSize + 'px';
    });
  };
  
  // Appliquer les tailles initiales
  updateControlSizes();
  
  // Observer les changements de taille
  const resizeObserver = new ResizeObserver(() => {
    updateControlSizes();
  });
  resizeObserver.observe(element);
  
  // Nettoyer l'observer quand l'élément est supprimé
  element._resizeObserver = resizeObserver;

  controls.querySelector('.di-trash').innerHTML = oazarStudioIcon('trash');
  controls.querySelector('.di-rotate').innerHTML = oazarStudioIcon('rotate');
  controls.querySelector('.di-resize').innerHTML = oazarStudioIcon('resize');
  element.appendChild(controls);
setupDragHandler(element, area);
setupResizeHandlers(element, area);
setupRotationHandler(element);
setupDeleteHandler(element);
setupLockHandler(element);
if (element.dataset.type === 'text') {
element.addEventListener('click', function(e) {
if (e.target.closest('.di-controls')) return;
e.stopPropagation();
selectItem(element);
const drawer = document.getElementById('customizationDrawer');
if (drawer.getAttribute('aria-hidden') === 'true') openDrawer();
setDrawerMode('text');
setTimeout(function() {
const textarea = document.getElementById('textContent');
if (textarea && window.innerWidth > 768) textarea.focus();
}, 100);
});
}
if (element.dataset.type === 'image') {
element.addEventListener('click', function(e) {
if (e.target.closest('.di-controls')) return;
e.stopPropagation();
if (element._ozMovedDuringPointer || Date.now() - (element._ozLastDragAt || 0) < 300) return;
const changedSelection = selectedItem !== element;
selectItem(element);
const drawer = document.getElementById('customizationDrawer');
const wasClosed = !drawer || drawer.getAttribute('aria-hidden') !== 'false';
if (wasClosed) openDrawer();
if (wasClosed || changedSelection || drawerMode !== 'options') setDrawerMode('options');
});
}
}
function setupLockHandler(element) {
const lockBtn = element.querySelector('.di-lock');
if (!lockBtn) return;
lockBtn.addEventListener('click', function(e) {
e.stopPropagation();
e.preventDefault();
if (selectedItem !== element) {
selectItem(element);
}
const isLocked = element.dataset.locked === '1';
const newLocked = !isLocked;
toggleLockSelected(newLocked);
updateLockOnElement(element, newLocked);
toolsLockIsLocked = newLocked;
syncToolsLockButtons();
});
}
function setupDragHandler(element, area) {
let isDragging = false;
let startX = 0;
let startY = 0;
let startLeft = 0;
let startTop = 0;
element.addEventListener('pointerdown', function(e) {
if (e.target.closest('.di-controls')) return;
element._ozMovedDuringPointer = false;
if (element.dataset.locked === '1') {
e.stopPropagation();
if (selectedItem !== element) {
selectItem(element);
}
return;
}
const canvas = document.getElementById('canvasContent');
const transform = window.getComputedStyle(canvas).transform;
let scale = 1;
if (transform && transform !== 'none') {
const matrix = transform.match(/matrix\((.+)\)/);
if (matrix) {
const values = matrix[1].split(', ');
scale = parseFloat(values[0]);
}
}
startX = e.clientX;
startY = e.clientY;
startLeft = parseFloat(element.style.left) || 0;
startTop = parseFloat(element.style.top) || 0;
isDragging = true;
if (selectedItem !== element) {
selectItem(element);
}
area.classList.add('show-guides');
const rect = area.getBoundingClientRect();
const centerX = (rect.width - parseFloat(element.style.width || element.offsetWidth)) / 2;
const centerY = (rect.height - parseFloat(element.style.height || element.offsetHeight)) / 2;
function onMove(moveEvent) {
if (element.dataset.locked === '1') return;
if (!isDragging) return;
const deltaX = (moveEvent.clientX - startX) / scale;
const deltaY = (moveEvent.clientY - startY) / scale;
if (Math.abs(moveEvent.clientX - startX) > 4 || Math.abs(moveEvent.clientY - startY) > 4) {
element._ozMovedDuringPointer = true;
}
let newLeft = startLeft + deltaX;
let newTop = startTop + deltaY;
if (Math.abs(newLeft - centerX) < SNAP_TOL) {
newLeft = centerX;
area.classList.add('snapped-x');
} else {
area.classList.remove('snapped-x');
}
if (Math.abs(newTop - centerY) < SNAP_TOL) {
newTop = centerY;
area.classList.add('snapped-y');
} else {
area.classList.remove('snapped-y');
}
element.style.left = newLeft + 'px';
element.style.top = newTop + 'px';
updateOverflowState(element);
}
function onEnd() {
window.removeEventListener('pointermove', onMove);
window.removeEventListener('pointerup', onEnd);
if (element._ozMovedDuringPointer) element._ozLastDragAt = Date.now();
isDragging = false;
area.classList.remove('show-guides', 'snapped-x', 'snapped-y');
if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
pushHistory(getViewNameFromElement(element));
}
window.addEventListener('pointermove', onMove);
window.addEventListener('pointerup', onEnd);
});
}
function setupResizeHandlers(element, area) {
element.querySelectorAll('.di-resize').forEach(function(handle) {
handle.addEventListener('pointerdown', function(e) {
e.stopPropagation();
e.preventDefault();
const direction = 'se';
const isImage = element.dataset.type === 'image';
const isText = element.dataset.type === 'text';
const canvas = document.getElementById('canvasContent');
const transform = window.getComputedStyle(canvas).transform;
let scale = 1;
if (transform && transform !== 'none') {
const matrix = transform.match(/matrix\((.+)\)/);
if (matrix) {
const values = matrix[1].split(', ');
scale = parseFloat(values[0]);
}
}
const startPos = { x: e.clientX, y: e.clientY };
const baseLeft = parseFloat(element.style.left) || 0;
const baseTop = parseFloat(element.style.top) || 0;
const baseWidth = element.offsetWidth;
const baseHeight = element.offsetHeight;
const baseRatio = baseWidth / baseHeight;
let baseFontSize = null;
if (isText) {
const textDiv = element.querySelector('.di-content > div');
if (textDiv) {
const cs = window.getComputedStyle(textDiv);
baseFontSize = parseFloat(cs.fontSize) || 32;
}
}
element.style.transition = 'none';
function onMove(ev) {
if (selectedItem !== element) {
selectItem(element);
}
const rawDx = (ev.clientX - startPos.x) / scale;
const rawDy = (ev.clientY - startPos.y) / scale;
const angleDeg = parseFloat(element.dataset.angle || '0') || 0;
const a = angleDeg * Math.PI / 180;
const cos = Math.cos(a);
const sin = Math.sin(a);
const dx = rawDx * cos + rawDy * sin;
const dy = -rawDx * sin + rawDy * cos;
let scaleFactor = 1;
switch (direction) {
case 'se':
scaleFactor = 1 + Math.max(dx / baseWidth, dy / baseHeight);
break;
case 's':
scaleFactor = 1 + (dy / baseHeight);
break;
case 'e':
scaleFactor = 1 + (dx / baseWidth);
break;
case 'ne':
scaleFactor = 1 + Math.max(dx / baseWidth, -dy / baseHeight);
break;
case 'n':
scaleFactor = 1 + (-dy / baseHeight);
break;
case 'nw':
scaleFactor = 1 + Math.max(-dx / baseWidth, -dy / baseHeight);
break;
case 'w':
scaleFactor = 1 + (-dx / baseWidth);
break;
case 'sw':
scaleFactor = 1 + Math.max(-dx / baseWidth, dy / baseHeight);
break;
}
const minScale = 0.2;
const maxScale = 5;
if (scaleFactor < minScale) scaleFactor = minScale;
if (scaleFactor > maxScale) scaleFactor = maxScale;
const newWidth = baseWidth * scaleFactor;
const newHeight = (isImage || isText) ? newWidth / baseRatio : baseHeight * scaleFactor;
const deltaW = newWidth - baseWidth;
const deltaH = newHeight - baseHeight;
let shiftLocalX = 0;
let shiftLocalY = 0;
if (direction.includes('w')) shiftLocalX = -deltaW / 2;
if (direction.includes('e')) shiftLocalX =  deltaW / 2;
if (direction.includes('n')) shiftLocalY = -deltaH / 2;
if (direction.includes('s')) shiftLocalY =  deltaH / 2;
const shiftX = (shiftLocalX * cos) - (shiftLocalY * sin);
const shiftY = (shiftLocalX * sin) + (shiftLocalY * cos);
const baseCenterX = baseLeft + baseWidth / 2;
const baseCenterY = baseTop + baseHeight / 2;
const newCenterX = baseCenterX + shiftX;
const newCenterY = baseCenterY + shiftY;
let newLeft = newCenterX - newWidth / 2;
let newTop  = newCenterY - newHeight / 2;
element.style.left = newLeft + 'px';
element.style.top = newTop + 'px';
element.style.width = newWidth + 'px';
element.style.height = newHeight + 'px';
if (isText && baseFontSize) {
let newFontSize = baseFontSize * scaleFactor;
newFontSize = Math.max(6, Math.min(newFontSize, 200));
const textDiv = element.querySelector('.di-content > div');
if (textDiv) {
textDiv.style.fontSize = newFontSize + 'px';
}
}
updateOverflowState(element);

if (typeof updateItemSizeBadge === 'function') {
  updateItemSizeBadge(element);
}
}
function onEnd() {
  window.removeEventListener('pointermove', onMove);
  window.removeEventListener('pointerup', onEnd);
  element.style.transition = '';

  // ✅ Sauvegarder les dimensions dans le dataset (fallback si vue cachée au moment du addToCart)
  const finalW = parseFloat(element.style.width) || element.offsetWidth;
  const finalH = parseFloat(element.style.height) || element.offsetHeight;
  if (finalW > 0) element.dataset.w = finalW.toFixed(1);
  if (finalH > 0) element.dataset.h = finalH.toFixed(1);

  if (typeof scheduleThumbnailUpdate === 'function') {
    scheduleThumbnailUpdate();
  }
  pushHistory(getViewNameFromElement(element));
  
  // ✅ RECALCUL PRIX après redimensionnement
  if (typeof updateSizeDrawerTotals === 'function') {
    updateSizeDrawerTotals();
  }
  // Mettre à jour le badge de dimension sur l'élément
  if (typeof updateItemSizeBadge === 'function') {
    updateItemSizeBadge(element);
  }
}
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onEnd);
  });
});
}

function setupRotationHandler(element) {
  const rotateHandle = element.querySelector('.di-rotate');
  if (!rotateHandle) return;

  rotateHandle.addEventListener('pointerdown', function(e) {
    e.stopPropagation();
    e.preventDefault();
    element.style.transition = 'none';

    const rect = element.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    // --- CORRECTION ANTI-TELEPORTATION (START) ---
    // 1. On calcule l'angle exact de la souris au moment du clic
    const startDx = e.clientX - centerX;
    const startDy = e.clientY - centerY;
    const startMouseAngle = Math.atan2(startDy, startDx) * 180 / Math.PI;

    // 2. On récupère l'angle actuel de l'élément (ou 0 si pas encore tourné)
    const currentElementAngle = parseFloat(element.dataset.angle || 0);

    // 3. On stocke la différence (l'offset). C'est le "cran" de la prise en main.
    const rotationOffset = startMouseAngle - currentElementAngle;
    // --- CORRECTION ANTI-TELEPORTATION (END) ---

    function onMove(moveEvent) {
      const dx = moveEvent.clientX - centerX;
      const dy = moveEvent.clientY - centerY;

      // --- CALCUL DU NOUVEL ANGLE ---
      const mouseAngle = Math.atan2(dy, dx) * 180 / Math.PI;
      
      // On applique l'angle de la souris MOINS le décalage initial
      let angle = mouseAngle - rotationOffset;

      element.style.transform = 'rotate(' + angle + 'deg)';
      element.dataset.angle = angle.toFixed(2);
      updateOverflowState(element);
      element.dataset.scaleX = element.dataset.scaleX || "1";
      element.dataset.scaleY = element.dataset.scaleY || "1";
    }

    function onEnd() {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onEnd);
      element.style.transition = '';
      if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
      pushHistory(getViewNameFromElement(element));
    }

    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onEnd);
  });
}
function setupDeleteHandler(element) {
  const deleteBtn = element.querySelector('.di-trash');
  if (!deleteBtn) return;
  deleteBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    if (element._resizeObserver) element._resizeObserver.disconnect();
    if (element.dataset.type === 'image') {
      const imgEl = element.querySelector('img');
      if (imgEl && window.pendingUploads && window.pendingUploads.has(imgEl)) {
        window.pendingUploads.delete(imgEl);
      }
      const src = imgEl?.src || '';
      if (src.startsWith('blob:')) {
        try {
          const stillUsedInDom = Array.from(document.querySelectorAll('img'))
            .some(other => other !== imgEl && other.src === src);
          const stillUsedInHistory = isBlobUrlReferencedInHistory(src);
          if (!stillUsedInDom && !stillUsedInHistory) URL.revokeObjectURL(src);
        } catch (err) {}
      }
    }
    const view = element.closest('.product-view');
    const viewName = view ? view.dataset.view : currentView;
    const layers = designLayers[viewName] || [];
    const index = layers.indexOf(element);
    if (index > -1) layers.splice(index, 1);
    element.remove();
    deselectAll();
    updateDesignLayers();
    if (typeof updateAllCartButtons === 'function') updateAllCartButtons();
    if (typeof closeDrawer === 'function') {
        closeDrawer();
    }
    if (element.dataset.templateId) {
      const smartClose = document.querySelector('.oz-smarttpl-modal:not([hidden]) .oz-smarttpl-editor-close');
      if (smartClose) smartClose.click();
    }
    if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
    pushHistory(viewName);
    if (typeof updateAllSizeBadges === 'function') setTimeout(updateAllSizeBadges, 50);
if (typeof updateSizeDrawerTotals === 'function') setTimeout(updateSizeDrawerTotals, 50);
  });
}
function selectItem(element) {
if (selectedItem === element) return;
if (selectedItem) {
selectedItem.classList.remove('selected');
}
selectedItem = element;
element.classList.add('selected');
element.style.transformOrigin = 'center center';
}
function deselectAll() {
if (selectedItem) {
selectedItem.classList.remove('selected');
selectedItem = null;
}
}
function ozEnsureOverflowWarningOverlay(element) {
  if (!element) return null;

  let overlay = element.querySelector(':scope > .oob-warning-overlay');

  if (overlay) return overlay;

  overlay = document.createElement('div');
  overlay.className = 'oob-warning-overlay';
  overlay.setAttribute('aria-hidden', 'true');

  ['top', 'bottom', 'left', 'right'].forEach(function(side) {
    const fragment = document.createElement('div');

    fragment.className =
      'oob-warning-fragment oob-warning-fragment--' + side;

    overlay.appendChild(fragment);
  });

  const controls = element.querySelector(':scope > .di-controls');

  if (controls) {
    element.insertBefore(overlay, controls);
  } else {
    element.appendChild(overlay);
  }

  return overlay;
}

function ozSetOverflowFragment(
  fragment,
  insetTop,
  insetRight,
  insetBottom,
  insetLeft,
  visible
) {
  if (!fragment) return;

  if (!visible) {
    fragment.style.display = 'none';
    return;
  }

  fragment.style.display = 'block';

  const clip =
    'inset(' +
    Math.max(0, insetTop) + 'px ' +
    Math.max(0, insetRight) + 'px ' +
    Math.max(0, insetBottom) + 'px ' +
    Math.max(0, insetLeft) + 'px)';

  fragment.style.clipPath = clip;
  fragment.style.webkitClipPath = clip;
}

function ozUpdatePartialOverflowWarning(element, area) {
  const overlay = ozEnsureOverflowWarningOverlay(element);

  if (!overlay || !area) return;

  const width = element.offsetWidth;
  const height = element.offsetHeight;

  if (!width || !height) {
    overlay.style.display = 'none';
    return;
  }

  const left = element.offsetLeft;
  const top = element.offsetTop;

  const areaWidth = area.offsetWidth;
  const areaHeight = area.offsetHeight;

  const outsideLeft = Math.min(
    width,
    Math.max(0, -left)
  );

  const outsideRight = Math.min(
    width,
    Math.max(0, left + width - areaWidth)
  );

  const outsideTop = Math.min(
    height,
    Math.max(0, -top)
  );

  const outsideBottom = Math.min(
    height,
    Math.max(0, top + height - areaHeight)
  );

  const hasVisibleOverflow =
    outsideLeft > 0 ||
    outsideRight > 0 ||
    outsideTop > 0 ||
    outsideBottom > 0;

  overlay.style.display = hasVisibleOverflow ? 'block' : 'none';

  if (!hasVisibleOverflow) return;

  const topFragment =
    overlay.querySelector('.oob-warning-fragment--top');

  const bottomFragment =
    overlay.querySelector('.oob-warning-fragment--bottom');

  const leftFragment =
    overlay.querySelector('.oob-warning-fragment--left');

  const rightFragment =
    overlay.querySelector('.oob-warning-fragment--right');

  /*
   * Chaque fragment est maintenant simplement un rectangle orange
   * translucide. Il recouvre uniquement la partie hors zone.
   */
  ozSetOverflowFragment(
    topFragment,
    0,
    0,
    height - outsideTop,
    0,
    outsideTop > 0
  );

  ozSetOverflowFragment(
    bottomFragment,
    height - outsideBottom,
    0,
    0,
    0,
    outsideBottom > 0
  );

  const middleHeight =
    height - outsideTop - outsideBottom;

  ozSetOverflowFragment(
    leftFragment,
    outsideTop,
    width - outsideLeft,
    outsideBottom,
    0,
    outsideLeft > 0 && middleHeight > 0
  );

  ozSetOverflowFragment(
    rightFragment,
    outsideTop,
    0,
    outsideBottom,
    width - outsideRight,
    outsideRight > 0 && middleHeight > 0
  );
}

// Text overflow uses the painted glyphs, excluding the selection frame,
// its padding, the line box and leading/trailing whitespace.
const ozTextInkMetricsCache = new Map();
function ozGetTextInkBounds(element) {
  const node = element.querySelector('.oazar-text-node, .di-content > div');
  if (!node) return null;
  const cs = getComputedStyle(node);
  const text = node.innerText || node.textContent || '';
  if (!text.trim()) return { empty: true };
  const key = [text, cs.font, cs.fontFamily, cs.fontSize, cs.fontWeight,
    cs.fontStyle, cs.lineHeight, cs.letterSpacing, cs.textDecorationLine,
    cs.webkitTextStrokeWidth].join('|');
  let ink = ozTextInkMetricsCache.get(key);
  if (!ink) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
    if ('letterSpacing' in ctx) ctx.letterSpacing = cs.letterSpacing;
    ctx.direction = cs.direction;
    ctx.textAlign = 'left';
    const probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;left:-10000px;top:0;visibility:hidden;pointer-events:none;white-space:nowrap;padding:0;border:0;margin:0;';
    ['fontFamily','fontSize','fontWeight','fontStyle','lineHeight','letterSpacing'].forEach(p => probe.style[p] = cs[p]);
    const marker = document.createElement('span');
    marker.style.cssText = 'display:inline-block;width:0;height:0;padding:0;border:0;margin:0;vertical-align:baseline;';
    probe.append(marker, document.createTextNode('Égj'));
    document.body.appendChild(probe);
    const baseline = marker.getBoundingClientRect().top - probe.getBoundingClientRect().top;
    const lineHeight = probe.getBoundingClientRect().height;
    probe.remove();
    const lines = text.split(/\n/).map((line,index) => {
      const m = ctx.measureText(line);
      const stroke = (parseFloat(cs.webkitTextStrokeWidth) || 0) / 2;
      return { advance: m.width,
        left: -m.actualBoundingBoxLeft - stroke,
        right: m.actualBoundingBoxRight + stroke,
        top: baseline + index * lineHeight - m.actualBoundingBoxAscent - stroke,
        bottom: baseline + index * lineHeight + m.actualBoundingBoxDescent + stroke,
        empty: !line.trim() };
    });
    ink = { lines, baseline, lineHeight };
    if (ozTextInkMetricsCache.size > 150) ozTextInkMetricsCache.clear();
    ozTextInkMetricsCache.set(key, ink);
  }
  let x = element.clientLeft, y = element.clientTop, parent = node;
  while (parent && parent !== element) {
    x += parent.offsetLeft; y += parent.offsetTop; parent = parent.offsetParent;
  }
  if (parent !== element) return null;
  const padLeft = parseFloat(cs.paddingLeft) || 0;
  const padRight = parseFloat(cs.paddingRight) || 0;
  const padTop = parseFloat(cs.paddingTop) || 0;
  const contentWidth = node.clientWidth - padLeft - padRight;
  const polygons = ink.lines.filter(line => !line.empty).map(line => {
    const align = cs.textAlign;
    const inset = align === 'center' ? (contentWidth - line.advance) / 2
      : (align === 'right' || (align === 'start' && cs.direction === 'rtl')) ? contentWidth - line.advance : 0;
    const left = x + node.clientLeft + padLeft + inset + line.left;
    const right = x + node.clientLeft + padLeft + inset + line.right;
    const top = y + node.clientTop + padTop + line.top;
    let bottom = y + node.clientTop + padTop + line.bottom;
    if (cs.textDecorationLine.includes('underline')) {
      bottom = Math.max(bottom, y + padTop + ink.baseline + (parseFloat(cs.fontSize) || 32) * .15);
    }
    return [{x:left,y:top},{x:right,y:top},{x:right,y:bottom},{x:left,y:bottom}];
  });
  return { polygons, empty: !polygons.length };
}
function ozTextPointInArea(element, point) {
  const angle = (parseFloat(element.dataset.angle) || 0) * Math.PI / 180;
  const cx = element.offsetWidth / 2, cy = element.offsetHeight / 2;
  return { x: element.offsetLeft + cx + (point.x-cx)*Math.cos(angle) - (point.y-cy)*Math.sin(angle),
    y: element.offsetTop + cy + (point.x-cx)*Math.sin(angle) + (point.y-cy)*Math.cos(angle) };
}
function ozUpdateTextInkWarning(element, area, ink, isOverflow) {
  const overlay = ozEnsureOverflowWarningOverlay(element);
  overlay.style.display = isOverflow ? 'block' : 'none';
  if (!isOverflow) return;
  const polygons = ink.polygons || [];
  // Clip each line's ink to the four outside half-planes. Use local coordinates
  // for the overlay, so zoom and rotation do not move the warning off the text.
  ['top','bottom','left','right'].forEach(side => {
    const distance = p => {
      const a = ozTextPointInArea(element,p);
      return side === 'top' ? -a.y : side === 'bottom' ? a.y-area.offsetHeight
        : side === 'left' ? -a.x : a.x-area.offsetWidth;
    };
    const clipped = polygons.map(poly => {
      const out = [];
      for(let i=0;i<poly.length;i++){
        const p=poly[i],q=poly[(i+1)%poly.length],dp=distance(p),dq=distance(q);
        if(dp>0)out.push(p);
        if((dp>0)!==(dq>0)){const t=dp/(dp-dq);out.push({x:p.x+t*(q.x-p.x),y:p.y+t*(q.y-p.y)});}
      }
      return out;
    }).filter(poly=>poly.length>=3);
    const fragment = overlay.querySelector('.oob-warning-fragment--'+side);
    fragment.style.display = clipped.length ? 'block' : 'none';
    // One fragment per line keeps multiline whitespace out of the warning.
    fragment.style.setProperty('background', 'transparent', 'important');
    fragment.style.clipPath = 'none'; fragment.style.webkitClipPath = 'none';
    fragment.replaceChildren(...clipped.map(poly => {
      const part=document.createElement('div');
      part.style.cssText='position:absolute;inset:0;background:rgba(255,145,0,.22);';
      part.style.clipPath='polygon('+poly.map(p=>p.x+'px '+p.y+'px').join(',')+')';
      return part;
    }));
  });
}
if (document.fonts) document.fonts.addEventListener('loadingdone', function() {
  ozTextInkMetricsCache.clear();
  document.querySelectorAll('.design-area .design-item[data-type="text"]').forEach(updateOverflowState);
  if (typeof scheduleThumbnailUpdate === 'function') scheduleThumbnailUpdate();
});

function updateOverflowState(element) {
  const area = element && element.closest
    ? element.closest('.design-area')
    : null;

  if (!area || !element) return;
  if (element.dataset.type === 'text' && (!area.offsetWidth || !area.offsetHeight)) return;

  const itemLeft = element.offsetLeft;
  const itemTop = element.offsetTop;
  const itemWidth = element.offsetWidth;
  const itemHeight = element.offsetHeight;

  const areaWidth = area.offsetWidth;
  const areaHeight = area.offsetHeight;

  /*
   * On garde la détection avec rotation pour le blocage panier.
   */
  const angleDeg = parseFloat(element.dataset.angle || '0') || 0;
  const angle = angleDeg * Math.PI / 180;

  const absCos = Math.abs(Math.cos(angle));
  const absSin = Math.abs(Math.sin(angle));

  const rotatedHalfWidth =
    (itemWidth * absCos + itemHeight * absSin) / 2;

  const rotatedHalfHeight =
    (itemWidth * absSin + itemHeight * absCos) / 2;

  const centerX = itemLeft + itemWidth / 2;
  const centerY = itemTop + itemHeight / 2;

  const visualLeft = centerX - rotatedHalfWidth;
  const visualRight = centerX + rotatedHalfWidth;
  const visualTop = centerY - rotatedHalfHeight;
  const visualBottom = centerY + rotatedHalfHeight;

  const tolerance = 1;

  const textInk = element.dataset.type === 'text' ? ozGetTextInkBounds(element) : null;
  const isOverflow = textInk ? (!textInk.empty && textInk.polygons.some(poly => poly.some(point => {
    const p = ozTextPointInArea(element, point);
    return p.x < -tolerance || p.y < -tolerance || p.x > areaWidth + tolerance || p.y > areaHeight + tolerance;
  }))) :
    visualLeft < -tolerance ||
    visualTop < -tolerance ||
    visualRight > areaWidth + tolerance ||
    visualBottom > areaHeight + tolerance;

  element.classList.toggle('oob', isOverflow);
  element.setAttribute(
    'data-out-of-bounds',
    isOverflow ? 'true' : 'false'
  );

  /*
   * Visuellement, seule la partie réellement située hors du
   * rectangle de personnalisation reçoit la teinte orange.
   * La copie est resynchronisée pour les images, textes, SVG
   * et designs HTML.
   */
  if (textInk) ozUpdateTextInkWarning(element, area, textInk, isOverflow);
  else ozUpdatePartialOverflowWarning(element, area);

  area.classList.toggle(
    'has-oob-item',
    !!area.querySelector('.design-item.oob')
  );

  if (typeof window.__ozApplyCartEligibilityUI === 'function') {
    window.__ozApplyCartEligibilityUI();
  }
}
function ozHasActualCustomization() {
  return Array.from(document.querySelectorAll('.design-area .design-item')).some(function(item) {
    const type = String(item.dataset.type || '').toLowerCase();
    if (type === 'text' || type === 'i-text') {
      const content = item.querySelector('.design-text, .di-content');
      return !!(content && content.textContent.trim());
    }
    if (type === 'image') {
      const image = item.querySelector('img');
      return !!(image && (image.currentSrc || image.src));
    }
    return type === 'design';
  });
}
(function() {
  const MSG = "⚠️ Un élément dépasse la zone de personnalisation (cadre orange). Replacez-le entièrement dans la zone pour ajouter au panier.";
  function getOobItems() {
    const els = Array.prototype.slice.call(document.querySelectorAll('.design-item.oob'));
    return els.map(function(el) {
      const area = el.closest ? el.closest('.design-area') : null;
      return {
        el: el,
        uid: (el.dataset && el.dataset.uid) ? el.dataset.uid : null,
        type: (el.dataset && el.dataset.type) ? el.dataset.type : null,
        view: (area && area.dataset && area.dataset.area) ? area.dataset.area : null
      };
    });
  }
  function totalSelectedQty() {
    try {
      return Object.values(window.sizeQuantities || {}).reduce(function(s, q) {
        return s + (parseInt(q, 10) || 0);
      }, 0);
    } catch (e) {
      return 0;
    }
  }
  function hasAnyDesign() {
    return ozHasActualCustomization();
  }
  function applyUI() {
    const oob = getOobItems();
    const qty = totalSelectedQty();
    const noDesign = !hasAnyDesign();
    const shouldBlock = noDesign || (oob.length > 0 && qty > 0);
    const buttons = [
      document.getElementById('addToCartMainBtn'),
      document.getElementById('addToCartFinal'),
      document.getElementById('goToCartFromSizes')
    ].filter(Boolean);
    buttons.forEach(function(btn) {
      if (!btn || !btn.dataset) return;
      if (btn.dataset.ozOobBlocked !== '1' && btn.dataset.ozNoDesign !== '1') {
        btn.dataset.ozLastNormalLabel = btn.innerHTML;
      }
      if (shouldBlock) {
        if (!btn.dataset.ozLastNormalLabel) btn.dataset.ozLastNormalLabel = btn.innerHTML;
        btn.disabled = true;
        btn.dataset.ozOobBlocked = noDesign ? '' : '1';
        btn.dataset.ozNoDesign = noDesign ? '1' : '';
        btn.innerHTML = noDesign ? 'Personnalisez votre produit' : 'Ajustez votre design';
        btn.title = noDesign ? 'Ajoutez un texte, une image ou un design avant le panier.' : MSG;
      } else if (btn.dataset.ozOobBlocked === '1' || btn.dataset.ozNoDesign === '1') {
        btn.dataset.ozOobBlocked = '';
        btn.dataset.ozNoDesign = '';
        if (btn.dataset.ozLabel && btn.id !== 'goToCartFromSizes') {
          btn.textContent = btn.dataset.ozLabel;
        } else if (btn.dataset.ozLastNormalLabel) {
          btn.innerHTML = btn.dataset.ozLastNormalLabel;
        }
        btn.title = '';
        if (btn.id === 'addToCartFinal' || btn.id === 'addToCartMainBtn') {
          btn.disabled = (qty <= 0);
        } else if (btn.id === 'goToCartFromSizes') {
          btn.disabled = qty <= 0;
        }
      }
    });
  }
  let rafId = null;
  function schedule() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function() {
      rafId = null;
      applyUI();
    });
  }
  window.__ozGetOobItems = getOobItems;
  window.__ozScheduleCartEligibilityUpdate = schedule;
  window.__ozApplyCartEligibilityUI = applyUI;
  window.addEventListener('load', function() {
    setTimeout(applyUI, 200);
  });
  window.addEventListener('resize', schedule);
})();

// Keep the visible product preview aligned with the actual mobile drawer height.
(function () {
  function initMobileDrawerHeight() {
    const drawers = ['customizationDrawer', 'designFullDrawer']
      .map(id => document.getElementById(id)).filter(Boolean);
    if (!drawers.length) return;
    const update = () => {
      const open = drawers.find(drawer => drawer.getAttribute('aria-hidden') === 'false');
      if (open) {
        document.documentElement.style.setProperty('--oz-active-drawer-height', Math.ceil(open.getBoundingClientRect().height) + 'px');
      } else {
        document.documentElement.style.removeProperty('--oz-active-drawer-height');
      }
    };
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(update);
      drawers.forEach(drawer => resizeObserver.observe(drawer));
    }
    const mutations = new MutationObserver(update);
    drawers.forEach(drawer => mutations.observe(drawer, {attributes: true, attributeFilter: ['aria-hidden', 'data-mode']}));
    window.addEventListener('resize', update, {passive: true});
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMobileDrawerHeight, {once: true});
  else initMobileDrawerHeight();
})();
function presetSelected(preset) {
if (!selectedItem) return;
const area = selectedItem.closest('.design-area');
const areaRect = {width: area.clientWidth, height: area.clientHeight};
switch (preset) {
case 'max':
selectedItem.style.width = (areaRect.width * 0.6) + 'px';
alignSelected('centerX');
alignSelected('centerY');
if (selectedItem.dataset.type === 'text') {
const textElement = selectedItem.querySelector('.di-content > div');
if (textElement) {
textElement.style.fontSize = '64px';
const tempSpan = document.createElement('span');
tempSpan.style.cssText = textElement.style.cssText;
tempSpan.style.position = 'absolute';
tempSpan.style.visibility = 'hidden';
tempSpan.style.whiteSpace = 'nowrap';
tempSpan.textContent = textElement.textContent;
document.body.appendChild(tempSpan);
const actualWidth = tempSpan.offsetWidth;
const actualHeight = tempSpan.offsetHeight;
document.body.removeChild(tempSpan);
selectedItem.style.width = (actualWidth + 30) + 'px';
selectedItem.style.height = (actualHeight + 20) + 'px';
alignSelected('centerX');
alignSelected('centerY');
}
}
break;
case 'coeur':
if (selectedItem.dataset.type === 'text') {
const textElement = selectedItem.querySelector('.di-content > div');
if (textElement) {
textElement.style.fontSize = '32px';
const tempSpan = document.createElement('span');
tempSpan.style.cssText = textElement.style.cssText;
tempSpan.style.position = 'absolute';
tempSpan.style.visibility = 'hidden';
tempSpan.style.whiteSpace = 'nowrap';
tempSpan.textContent = textElement.textContent;
document.body.appendChild(tempSpan);
const actualWidth = tempSpan.offsetWidth;
const actualHeight = tempSpan.offsetHeight;
document.body.removeChild(tempSpan);
selectedItem.style.width = (actualWidth + 20) + 'px';
selectedItem.style.height = (actualHeight + 10) + 'px';
}
} else {
selectedItem.style.width = (areaRect.width * 0.12) + 'px';
selectedItem.style.height = 'auto';
}
selectedItem.style.left = (areaRect.width * 0.62) + 'px';
selectedItem.style.top = (areaRect.height * 0.30) + 'px';
break;
case 'anticoeur':
if (selectedItem.dataset.type === 'text') {
const textElement = selectedItem.querySelector('.di-content > div');
if (textElement) {
textElement.style.fontSize = '32px';
const tempSpan = document.createElement('span');
tempSpan.style.cssText = textElement.style.cssText;
tempSpan.style.position = 'absolute';
tempSpan.style.visibility = 'hidden';
tempSpan.style.whiteSpace = 'nowrap';
tempSpan.textContent = textElement.textContent;
document.body.appendChild(tempSpan);
const actualWidth = tempSpan.offsetWidth;
const actualHeight = tempSpan.offsetHeight;
document.body.removeChild(tempSpan);
selectedItem.style.width = (actualWidth + 20) + 'px';
selectedItem.style.height = (actualHeight + 10) + 'px';
}
} else {
selectedItem.style.width = (areaRect.width * 0.12) + 'px';
selectedItem.style.height = 'auto';
}
selectedItem.style.left = (areaRect.width * 0.18) + 'px';
selectedItem.style.top = (areaRect.height * 0.30) + 'px';
break;
}
updateOverflowState(selectedItem);
}
function alignSelected(direction) {
if (!selectedItem) return;
const area = selectedItem.closest('.design-area');
if (!area) return;
const areaRect = area.getBoundingClientRect();
const elementRect = selectedItem.getBoundingClientRect();
const zoom = getCanvasZoomScale() || 1;
// Shift the existing local coordinates, including rotated objects, in logical pixels.
let newLeft = selectedItem.offsetLeft;
let newTop = selectedItem.offsetTop;
const innerLeft = areaRect.left + area.clientLeft * zoom;
const innerTop = areaRect.top + area.clientTop * zoom;
const innerWidth = area.clientWidth * zoom;
const innerHeight = area.clientHeight * zoom;
switch (direction) {
case 'left':
newLeft += (innerLeft - elementRect.left) / zoom;
break;
case 'right':
newLeft += (innerLeft + innerWidth - elementRect.right) / zoom;
break;
case 'centerX':
newLeft += (innerLeft + innerWidth / 2 - (elementRect.left + elementRect.width / 2)) / zoom;
break;
case 'top':
newTop += (innerTop - elementRect.top) / zoom;
break;
case 'bottom':
newTop += (innerTop + innerHeight - elementRect.bottom) / zoom;
break;
case 'centerY':
newTop += (innerTop + innerHeight / 2 - (elementRect.top + elementRect.height / 2)) / zoom;
break;
}
selectedItem.style.left = newLeft + 'px';
selectedItem.style.top = newTop + 'px';
updateOverflowState(selectedItem);
}
function duplicateSelected() {
if (window.currentProduct?.patch) { showNotification('Un écusson contient un seul visuel. Vous pouvez remplacer votre image.','warning');return; }
if (!selectedItem) return;
const clone = selectedItem.cloneNode(true);
clone.dataset.uid = genUid();
delete clone.dataset.ozIncludedInBase;
clone.querySelectorAll('.di-controls').forEach(function (ctrl) {
ctrl.remove();
});
if (clone.dataset.type === 'image') {
const origImg = selectedItem.querySelector('img');
const cloneImg = clone.querySelector('img');
if (origImg && cloneImg) {
cloneImg.dataset.id = genUid();
if (origImg._ozEmbroiderySourceFile) cloneImg._ozEmbroiderySourceFile = origImg._ozEmbroiderySourceFile;
if (origImg._ozEmbroideryOriginalUrl) cloneImg._ozEmbroideryOriginalUrl = origImg._ozEmbroideryOriginalUrl;
if (window.pendingUploads && window.pendingUploads.has(origImg)) {
const file = window.pendingUploads.get(origImg);
try {
const newBlobUrl = URL.createObjectURL(file);
cloneImg.src = newBlobUrl;
} catch (e) {
cloneImg.src = origImg.src;
}
cloneImg.dataset.pendingFile = 'true';
cloneImg.dataset.fileName = file.name;
cloneImg.dataset.uploadSubType = origImg.dataset.uploadSubType || 'images';
cloneImg.dataset.originalName = origImg.dataset.originalName || file.name;
window.pendingUploads.set(cloneImg, file);
} else {
cloneImg.src = origImg.src;
if (origImg.dataset.originalSrc) cloneImg.dataset.originalSrc = origImg.dataset.originalSrc;
if (origImg.dataset.originalName) cloneImg.dataset.originalName = origImg.dataset.originalName;
if (origImg.dataset.uploadSubType) cloneImg.dataset.uploadSubType = origImg.dataset.uploadSubType;
}
}
}
selectedItem.after(clone);
const currentLeft = parseFloat(selectedItem.style.left) || 0;
const currentTop = parseFloat(selectedItem.style.top) || 0;
clone.style.left = (currentLeft + 20) + 'px';
clone.style.top = (currentTop + 20) + 'px';
const view = clone.closest('.product-view');
const viewName = view ? view.dataset.view : currentView;
if (!designLayers[viewName]) designLayers[viewName] = [];
designLayers[viewName].push(clone);
makeInteractive(clone);
selectItem(clone);
scheduleThumbnailUpdate();
pushHistory(viewName);
}
function updateLockOnElement(element, locked) {
if (!element) return;
element.style.pointerEvents = locked ? 'auto' : 'auto';
element.querySelectorAll('.di-handle, .di-rotate').forEach(el => {
el.style.pointerEvents = locked ? 'none' : '';
el.style.opacity = locked ? '0.3' : '';
});
element.style.cursor = locked ? 'not-allowed' : 'move';
}
function toggleLockSelected(newLocked) {
if (!selectedItem) return;
selectedItem.dataset.locked = newLocked ? '1' : '0';
selectedItem.classList.toggle('locked', newLocked);
selectedItem.querySelectorAll('.di-handle, .di-rotate')
.forEach(el => {
el.style.pointerEvents = newLocked ? 'none' : '';
el.style.opacity = newLocked ? '0.3' : '';
});
pushHistory(currentView);
}
function refreshAllLockUI() {
syncToolsLockButtons();
}
function handleKeyboard(e) {
if (document.getElementById('productPicker')?.classList.contains('show')) return;
const isMac = /Mac|iPhone|iPad|iPod/.test(navigator.platform);
const ctrlOrCmd = isMac ? e.metaKey : e.ctrlKey;
if (ctrlOrCmd && (e.key === 'z' || e.key === 'Z')) {
e.preventDefault();
if (e.shiftKey) redo();
else undo();
return;
}
if (ctrlOrCmd && (e.key === 'y' || e.key === 'Y')) {
e.preventDefault();
redo();
return;
}
const isTyping = e.target.tagName === 'INPUT' ||
e.target.tagName === 'TEXTAREA' ||
e.target.isContentEditable;
if (isTyping || !selectedItem || selectedItem.dataset.locked === '1') return;
const step = e.shiftKey ? 10 : 1;
const currentLeft = parseFloat(selectedItem.style.left) || 0;
const currentTop = parseFloat(selectedItem.style.top) || 0;
let newLeft = currentLeft;
let newTop = currentTop;
switch (e.key) {
case 'ArrowLeft':
e.preventDefault();
newLeft = currentLeft - step;
break;
case 'ArrowRight':
e.preventDefault();
newLeft = currentLeft + step;
break;
case 'ArrowUp':
e.preventDefault();
newTop = currentTop - step;
break;
case 'ArrowDown':
e.preventDefault();
newTop = currentTop + step;
break;
case 'Delete':
case 'Backspace':
e.preventDefault();
var trashBtn = selectedItem.querySelector('.di-trash');
if (trashBtn) trashBtn.click();
return;
}
selectedItem.style.left = newLeft + 'px';
selectedItem.style.top = newTop + 'px';
updateOverflowState(selectedItem);
pushHistoryDebounced(currentView, 200);
}
function handleResize() {
document.querySelectorAll('.design-item').forEach(updateOverflowState);
}
function getPickerCategoryDefinitions() {
  const configured =
    categoriesConfig &&
    Array.isArray(categoriesConfig.categories)
      ? categoriesConfig.categories.filter(function(cat) {
          return cat && cat.slug && cat.name;
        })
      : [];

  const definitions = configured.length ? configured : [
    {
      slug: 't-shirts',
      name: 'T-shirts',
      mode: 'auto',
      keywords: ['t-shirt', 'tshirt', 'tee shirt', 'tee-shirt', 'tee']
    },
    {
      slug: 'polos',
      name: 'Polos',
      mode: 'auto',
      keywords: ['polo']
    },
    {
      slug: 'sweats',
      name: 'Sweats',
      mode: 'auto',
      keywords: ['sweat', 'sweatshirt', 'hoodie']
    },
    {
      slug: 'vestes',
      name: 'Vestes',
      mode: 'auto',
      keywords: [
        'veste',
        'jacket',
        'softshell',
        'teddy',
        'bomber',
        'doudoune',
        'bodywarmer',
        'coupe-vent',
        'coupe vent',
        'imperméable',
        'impermeable'
      ]
    },
    {
      slug: 'casquettes',
      name: 'Casquettes',
      mode: 'auto',
      keywords: ['casquette', 'cap', 'snapback', 'baseball cap', 'trucker cap']
    },
    {
      slug: 'sacs',
      name: 'Sacs',
      mode: 'auto',
      keywords: ['sac', 'tote', 'bag']
    },
    {
      slug: 'accessoires',
      name: 'Accessoires',
      mode: 'auto',
      keywords: [
        'accessoire',
        'mug',
        'tasse',
        'gobelet',
        'parapluie',
        'tablier',
        'poncho',
        'patch'
      ]
    }
  ];
  const patches = Object.values(productsData || {}).some(function(product) { return !!product.patch; });
  const result = (patches ? [{slug:'ecussons',name:'Écussons',mode:'auto',keywords:['écusson','ecusson','patch']}] : [])
    .concat(definitions.filter(function(cat) { return cat.slug !== 'ecussons'; }));
  [{slug:'sacs',name:'Sacs',mode:'auto',keywords:['sac','tote','bag']},
   {slug:'mugs',name:'Mugs',mode:'auto',keywords:['mug','tasse']},
   {slug:'enfants',name:'Enfants',mode:'auto',keywords:['enfant','bébé','baby','body','bavoir']}].forEach(function(cat) {
    if (!result.some(function(item) { return item.slug === cat.slug; })) result.push(cat);
  });
  result.forEach(function(cat) { if (normalizePickerCategoryText(cat.name).includes('sweat')) cat.name = 'Sweats'; });
  const rank = function(cat) {
    const name = normalizePickerCategoryText(cat.name);
    return name.includes('t shirt') ? 0 : name.includes('sweat') ? 1 : name.includes('sac') ? 2 : name.includes('casquette') ? 3 : cat.slug === 'mugs' ? 4 : cat.slug === 'enfants' ? 5 : cat.slug === 'ecussons' ? 6 : 20;
  };
  return result.sort(function(a,b) { return rank(a) - rank(b); });
}

function getPickerTechniques(product) {
  let raw = product?.techniques;
  if (raw && !Array.isArray(raw) && typeof raw === 'object') raw = raw.value || raw.name || '';
  const text = normalizePickerCategoryText(Array.isArray(raw) ? raw.join(' ') : raw);
  const techniques = [];
  if (text.indexOf('brod') !== -1) techniques.push('broderie');
  if (text.indexOf('impr') !== -1) techniques.push('impression');
  return techniques.length ? techniques : ['broderie','impression'];
}
function pickerCategoryIcon(slug, name) {
  const text = normalizePickerCategoryText(name || slug);
  if (text.includes('veste')) slug = 'vestes';
  else if (text.includes('bonnet')) slug = 'bonnets';
  else if (text.includes('casquette')) slug = 'casquettes';
  else if (text.includes('sac')) slug = 'sacs';
  else if (text.includes('chapeau')) slug = 'chapeaux';
  else if (text.includes('bavoir')) slug = 'bavoirs';
  else if (text.includes('body') || text.includes('bodys')) slug = 'bodys';
  else if (text.includes('tablier')) slug = 'tabliers';
  else if (text.includes('accessoire') || text.includes('mug') || text.includes('tasse')) slug = 'accessoires';
  const paths = {
    all:'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
    ecussons:'M12 3c4 0 8 4 8 8s-4 9-8 10C8 20 4 15 4 11s4-8 8-8zM8 8l8 8M16 8l-8 8',
    sacs:'M5 8h14l1 12H4L5 8zM8 8V6a4 4 0 0 1 8 0v2',
    casquettes:'M4 14a8 8 0 0 1 16 0H4zM11 14h9l2 3H11M12 6v8',
    bonnets:'M5 15V11a7 7 0 0 1 14 0v4M4 15h16v5H4zM12 4v11',
    vestes:'M9 3h6l5 4v13h-6V9h-4v11H4V7l5-4zM12 3v6',
    accessoires:'M5 5h12v13H5zM17 8h2a3 3 0 0 1 0 6h-2M3 21h16',
    chapeaux:'M7 14l2-8h6l2 8M3 14h18v4H3z',
    bavoirs:'M8 3a4 4 0 0 0 8 0l3 4v10a7 7 0 0 1-14 0V7l3-4z',
    bodys:'M8 3h8l5 4-3 5-2-1v5l-4 5-4-5v-5l-2 1-3-5 5-4zM10 17h4',
    tabliers:'M9 3h6v5l4 3v10H5V11l4-3V3zM9 14h6v4H9z'
  };
  const path = paths[slug] || 'M8 3h8l5 4-3 5-2-1v10H8V11l-2 1-3-5 5-4zM8 3c0 4 8 4 8 0';
  return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+path+'" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" stroke-linecap="round"/></svg>';
}
function renderDynamicCategories() {
  const container = document.querySelector('.picker-categories');
  if (!container) return;

  container.innerHTML = '';

  const allBtn = document.createElement('button');
  allBtn.type = 'button';
  allBtn.className =
    'category-tab product-picker-category' +
    (currentFilter === 'all' ? ' active' : '');
  allBtn.dataset.category = 'all';
  allBtn.setAttribute('aria-pressed', String(currentFilter === 'all'));
  allBtn.innerHTML = pickerCategoryIcon('all') + '<span>Tous</span><span class="picker-category-count">' + productsCache.length + '</span>';
  container.appendChild(allBtn);

  let shown = 0;
  getPickerCategoryDefinitions().forEach(function(cat) {
    const count = productsCache.filter(function(item) { return item.categories.indexOf(cat.slug) !== -1; }).length;
    if (!count) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className =
      'category-tab product-picker-category' +
      (currentFilter === cat.slug ? ' active' : '');
    btn.dataset.category = cat.slug;
    btn.setAttribute('aria-pressed', String(currentFilter === cat.slug));
    if (cat.slug === 'ecussons') btn.classList.add('product-picker-category--patch');
    if (++shown > 7) { btn.classList.add('picker-category-extra'); btn.hidden = !window.__ozPickerCategoriesExpanded && currentFilter !== cat.slug; }
    btn.innerHTML = pickerCategoryIcon(cat.slug, cat.name) + '<span>'+escapeHtml(cat.name)+'</span><span class="picker-category-count">'+count+'</span>';
    container.appendChild(btn);
  });
  if (shown > 7) {
    const more = document.createElement('button');
    more.type = 'button'; more.className = 'product-picker-category picker-categories-more';
    more.setAttribute('aria-expanded', String(!!window.__ozPickerCategoriesExpanded));
    more.textContent = window.__ozPickerCategoriesExpanded ? 'Moins de catégories −' : 'Autres catégories +';
    more.addEventListener('click', function() {
      window.__ozPickerCategoriesExpanded = !window.__ozPickerCategoriesExpanded;
      container.querySelectorAll('.picker-category-extra').forEach(function(btn) { btn.hidden = !window.__ozPickerCategoriesExpanded && btn.dataset.category !== currentFilter; });
      more.setAttribute('aria-expanded', String(window.__ozPickerCategoriesExpanded));
      more.textContent = window.__ozPickerCategoriesExpanded ? 'Moins de catégories −' : 'Autres catégories +';
    });
    container.appendChild(more);
  }
}
window.openProductPicker = function(options) {
options = options || {};
const required = !!options.required;
if (window.CUSTOMIZER_EDIT_MODE) {
showNotification("Mode modification : changement de produit désactivé.", "error");
return;
}
const picker = document.getElementById('productPicker');
if (!picker) return;
if (!picker.classList.contains('show')) window.__ozPickerPreviousFocus = document.activeElement;
closeDrawer();
if (window.__ozPickerCloseTimer) {
clearTimeout(window.__ozPickerCloseTimer);
window.__ozPickerCloseTimer = null;
}
picker.dataset.required = required ? '1' : '0';
const closeBtn = picker.querySelector('.picker-close');
if (closeBtn) {
closeBtn.style.display = required ? 'none' : '';
}
const title = document.getElementById('pickerTitle');
if (title && required) {
title.textContent = 'Choisissez votre produit !';
}
const subtitle = picker.querySelector('.picker-subtitle');
if (subtitle && required) {
subtitle.textContent = 'Choisissez le support parfait pour votre personnalisation.';
}
currentFilter = 'all';
currentSearchQuery = '';
currentPickerTechnique = 'all';
currentPickerSort = 'recommended';
picker.querySelectorAll('[data-picker-technique]').forEach(function(button) { button.setAttribute('aria-pressed', String(button.dataset.pickerTechnique === 'all')); });
const sort = document.getElementById('productPickerSort');
if (sort) sort.value = 'recommended';
const search = document.getElementById('productSearchInput');
if (search) search.value = '';
buildProductsCache();
if (typeof renderDynamicCategories === 'function') {
renderDynamicCategories();
}
renderProductCards();
initializeFilters();
picker.style.display = 'flex';
document.body.style.overflow = 'hidden';
requestAnimationFrame(function() {
picker.classList.add('show');
if (search) search.focus({preventScroll:true});
});
};
window.closeProductPicker = function(force) {
const picker = document.getElementById('productPicker');
if (!picker) return;
if (picker.dataset.required === '1' && !window.currentProduct && force !== true) {
return;
}
picker.classList.remove('show');
if (window.__ozPickerCloseTimer) clearTimeout(window.__ozPickerCloseTimer);
window.__ozPickerCloseTimer = setTimeout(function() {
if (picker.classList.contains('show')) return;
picker.style.display = 'none';
document.body.style.overflow = '';
picker.dataset.required = '0';
const closeBtn = picker.querySelector('.picker-close');
if (closeBtn) closeBtn.style.display = '';
window.__ozPickerCloseTimer = null;
if (window.__ozPickerPreviousFocus?.isConnected) window.__ozPickerPreviousFocus.focus({preventScroll:true});
}, 300);
};
function buildProductsCache() {
productsCache = [];
Object.entries(productsData).forEach(function(entry) {
const handle = entry[0];
const product = entry[1];
const firstImage = getProductImage(product);
const colors = getProductColors(product);
const minPrice = getProductPrice(product);
const badges = getBadges(product, minPrice);
const categories = getCategories(product);
productsCache.push({
handle: handle,
product: product,
firstImage: firstImage,
colors: colors,
minPrice: minPrice,
badges: badges,
categories: categories,
isCurrentProduct: currentProduct ? currentProduct.handle === handle : false
});
});
}
function getProductImage(product) {
const source = (product.gallery && product.gallery[0] ? product.gallery[0].src : null) ||
(product.images ? product.images.front : null) ||
(product.variants && product.variants[0] ? product.variants[0].image : null) || '';
if (!source) return '';
try {
  const url = new URL(source, location.href);
  if (url.hostname === 'cdn.shopify.com' && !url.pathname.endsWith('.svg')) {
    url.searchParams.set('width','480');
    return url.toString();
  }
} catch (_) {}
return source;
}
function getProductColors(product) {
  if (!product || !Array.isArray(product.variants)) return [];

  return Array.from(new Set(
    product.variants
      .filter(function(v) {
        return v && v.available === true && v.option1;
      })
      .map(function(v) {
        return String(v.option1).trim();
      })
      .filter(Boolean)
  ));
}
function getProductPrice(product) {
const prices = product.variants
.filter(function(v) { return v.available; })
.map(function(v) {
if (typeof v.price === 'string') return parsePriceToNumber(v.price);
return typeof v.price === 'number' ? v.price / 100 : null;
})
.filter(function(p) { return Number.isFinite(p) && p > 0; });
const fallback = typeof product.price === 'number' ? product.price / 100 : parsePriceToNumber(product.priceFormatted || product.price);
return prices.length ? Math.min.apply(Math, prices) : Number.isFinite(fallback) && fallback > 0 ? fallback : null;
}
function getBadges(product, price) {
const badges = [];
const title = product.title.toLowerCase();
if (price && price < 6) badges.push({ class: 'badge-eco', text: 'Économique' });
if (title.indexOf('bio') !== -1) badges.push({ class: 'badge-bio', text: 'Bio' });
if (title.indexOf('broderie') !== -1) badges.push({ class: 'badge-broderie', text: 'Broderie' });
if (title.indexOf('new') !== -1) badges.push({ class: 'badge-new', text: 'Nouveau' });
if (title.indexOf('promo') !== -1) badges.push({ class: 'badge-promo', text: 'Promo' });
return badges;
}
function normalizePickerCategoryText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function pickerKeywordMatches(text, keyword) {
  const normalizedText = normalizePickerCategoryText(text);
  const normalizedKeyword = normalizePickerCategoryText(keyword);

  if (!normalizedText || !normalizedKeyword) return false;

  return (
    (' ' + normalizedText + ' ')
      .indexOf(' ' + normalizedKeyword + ' ') !== -1
  );
}

function getCategories(product) {
  const categories = ['all'];

  const productTitle = String(product.title || '');
  const productHandle = String(product.handle || '');
  const searchableText = productTitle + ' ' + productHandle;

  getPickerCategoryDefinitions().forEach(function(cat) {
    if (!cat || !cat.slug) return;
    if (cat.slug === 'ecussons') {
      if (product.patch || productHandle.indexOf('ecusson-') === 0) categories.push(cat.slug);
      return;
    }

    if (cat.mode === 'manual') {
      const manualProducts = Array.isArray(cat.manualProducts)
        ? cat.manualProducts
        : [];

      if (manualProducts.indexOf(product.handle) !== -1) {
        categories.push(cat.slug);
      }

      return;
    }

    const keywords = Array.isArray(cat.keywords)
      ? cat.keywords.filter(Boolean)
      : [];

    const hasKeyword = keywords.some(function(keyword) {
      return pickerKeywordMatches(searchableText, keyword);
    });

    if (hasKeyword) {
      categories.push(cat.slug);
    }
  });

  return Array.from(new Set(categories));
}
function updatePickerResultsCount(count) {
const el = document.getElementById('pickerResultsCount');
if (el) el.textContent = String(count || 0);
const label = document.getElementById('pickerResultsLabel');
if (label) label.textContent = count === 1 ? 'produit' : 'produits';
const title = document.getElementById('pickerCategoryTitle');
if (title) title.textContent = currentFilter === 'all' ? 'Tous les produits' : (getPickerCategoryDefinitions().find(function(cat) { return cat.slug === currentFilter; })?.name || 'Produits');
const clear = document.getElementById('productSearchClear');
if (clear) clear.hidden = !currentSearchQuery;
}
function escapeHtml(str) {
return String(str || '')
.replace(/&/g, '&amp;')
.replace(/</g, '&lt;')
.replace(/>/g, '&gt;')
.replace(/"/g, '&quot;')
.replace(/'/g, '&#039;');
}
function getPickerOptions() {
const picker = document.getElementById('productPicker');
return {
showPrices: picker ? picker.dataset.showPrices !== 'false' : true,
showSwatches: picker ? picker.dataset.showSwatches !== 'false' : true,
ctaLabel: 'Personnaliser'
};
}
function renderProductCards() {
const list = document.getElementById('productPickerList');
const empty = document.getElementById('pickerEmpty');
if (!list) return;
list.innerHTML = '';
const filtered = productsCache.filter(function(item) {
const categoryMatch = currentFilter === 'all' || item.categories.indexOf(currentFilter) !== -1;
const text = normalizePickerCategoryText(item.product.title + ' ' + item.colors.join(' '));
const searchMatch = !currentSearchQuery || currentSearchQuery.split(' ').every(function(word) { return text.indexOf(word) !== -1; });
const techniqueMatch = currentPickerTechnique === 'all' || getPickerTechniques(item.product).indexOf(currentPickerTechnique) !== -1;
return categoryMatch && searchMatch && techniqueMatch;
});
filtered.sort(function(a,b) {
  if (currentPickerSort === 'price-asc') return (a.minPrice ?? Infinity) - (b.minPrice ?? Infinity);
  if (currentPickerSort === 'price-desc') return (b.minPrice ?? -Infinity) - (a.minPrice ?? -Infinity);
  if (currentPickerSort === 'name') return String(a.product.title).localeCompare(String(b.product.title),'fr');
  return Number(!!a.product.patch) - Number(!!b.product.patch);
});
updatePickerResultsCount(filtered.length);
if (filtered.length === 0) {
if (empty) empty.style.display = 'flex';
return;
}
if (empty) empty.style.display = 'none';
filtered.forEach(function(item) {
list.appendChild(createCard(item));
});
}
function createCard(item) {
  const handle = item.handle;
  const product = item.product;
  const firstImage = item.firstImage;
  const minPrice = item.minPrice;
  const colors = Array.isArray(item.colors) ? item.colors : [];

  const isAvailable =
    product.variants &&
    product.variants.some(function(variant) {
      return variant && variant.available === true;
    });

  const price = Number.isFinite(minPrice) && minPrice > 0
    ? minPrice.toFixed(2).replace('.', ',')
    : null;

  const card = document.createElement('button');

  card.type = 'button';
  card.className = 'product-picker-card';
  card.dataset.productHandle = handle;
  card.setAttribute('aria-label', 'Personnaliser ' + product.title);
  card.setAttribute('aria-pressed', String(item.isCurrentProduct));
  if (product.patch) card.classList.add('product-picker-card--patch');

  if (item.isCurrentProduct) {
    card.classList.add('current');
  }

  if (!isAvailable) {
    card.classList.add('unavailable');
    card.disabled = true;
    card.setAttribute('aria-disabled', 'true');
    card.setAttribute('title', 'Produit indisponible');
  }

  const imageHtml = firstImage
    ? (
      '<img src="' +
      escapeHtml(firstImage) +
      '" alt="' +
      escapeHtml(product.title) +
      '" loading="lazy" decoding="async" width="480" height="480">'
    )
    : (
      '<div class="product-picker-no-image">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="M4 5h16v14H4zM6 16l4-4 3 3 2-2 3 3" fill="none" stroke="currentColor" stroke-width="1.5"/>' +
        '</svg>' +
      '</div>'
    );

  const visibleColors = colors.slice(0, 6);
  const techniques = getPickerTechniques(product);
  const techniqueHtml = '<div class="product-picker-techniques">' + techniques.map(function(technique) {
    return '<span class="product-picker-technique">' + (technique === 'broderie' ? 'Broderie' : 'Impression') + '</span>';
  }).join('') + '</div>';

  const colorsHtml = colors.length
    ? (
      '<div class="product-picker-card-colors" aria-label="' +
        escapeHtml(colors.length + ' couleurs disponibles') +
      '">' +
        visibleColors.map(function(color) {
          return (
            '<span class="product-picker-color-dot" ' +
              'title="' + escapeHtml(color) + '" ' +
              'style="' + getSwatchInlineStyle(color, product) + '">' +
            '</span>'
          );
        }).join('') +
        (
          colors.length > visibleColors.length
            ? '<span class="product-picker-color-more">+' +
                (colors.length - visibleColors.length) +
              '</span>'
            : ''
        ) +
      '</div>'
    )
    : '<div class="product-picker-card-colors product-picker-card-colors--empty"></div>';

  card.innerHTML =
    '<div class="product-picker-card-media">' +
      imageHtml +
      (item.isCurrentProduct ? '<span class="product-picker-selected">✓ Votre produit</span>' : '') +
      (product.patch ? '<span class="product-picker-patch-size">12 × 12 cm max.</span>' : '') +
    '</div>' +

    '<div class="product-picker-card-info">' +
      '<h4 class="product-picker-card-title">' +
        escapeHtml(product.title) +
      '</h4>' +

      techniqueHtml +
      (product.patch ? '<p class="product-picker-patch-detail">Forme et contour au choix</p>' : (getPickerOptions().showSwatches ? colorsHtml : '')) +

      '<div class="product-picker-card-footer">' +
        (getPickerOptions().showPrices ? '<span class="product-picker-card-price">' +
          (price ? '<small>À partir de </small>' + price + ' €' : 'Prix indisponible') +
        '</span>' : '<span></span>') +

        '<span class="product-picker-card-arrow" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24">' +
            '<path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</span>' +
      '</div>' +
    '</div>';

  card.addEventListener('click', function() {
    if (!isAvailable) return;

    if (changeProduct(handle)) {
      window.closeProductPicker(true);
      showNotification(product.title + ' sélectionné', 'success');
    }
  });

  return card;
}
function initializeFilters() {
document.querySelectorAll('#productPicker .category-tab').forEach(function(tab) {
tab.replaceWith(tab.cloneNode(true));
});
document.querySelectorAll('#productPicker .category-tab').forEach(function(tab) {
function selectCategory() {
if (currentFilter === tab.dataset.category) return;
document.querySelectorAll('#productPicker .category-tab').forEach(function(t) {
t.classList.remove('active');
t.setAttribute('aria-pressed', 'false');
});
tab.classList.add('active');
tab.setAttribute('aria-pressed', 'true');
currentFilter = tab.dataset.category;
renderProductCards();
const content = document.querySelector('#productPicker .product-picker-content');
if (content) content.scrollTop = 0;
}
tab.addEventListener('click', selectCategory);
});
const search = document.getElementById('productSearchInput');
if (search && !search.dataset.ozPickerBound) {
search.dataset.ozPickerBound = 'true';
search.addEventListener('input', function(e) {
currentSearchQuery = normalizePickerCategoryText(e.target.value);
renderProductCards();
});
}
var pickerEl = document.getElementById('productPicker');
if (pickerEl && !pickerEl.dataset.ozPickerBound) {
pickerEl.dataset.ozPickerBound = 'true';
pickerEl.querySelectorAll('[data-picker-technique]').forEach(function(button) {
  button.addEventListener('click', function() {
    currentPickerTechnique = button.dataset.pickerTechnique;
    pickerEl.querySelectorAll('[data-picker-technique]').forEach(function(other) { other.setAttribute('aria-pressed', String(other === button)); });
    renderProductCards();
  });
});
const sort = document.getElementById('productPickerSort');
if (sort) sort.addEventListener('change', function() { currentPickerSort = sort.value; renderProductCards(); });
const clear = document.getElementById('productSearchClear');
if (clear) clear.addEventListener('click', function() { currentSearchQuery = ''; search.value = ''; renderProductCards(); search.focus(); });
const reset = document.getElementById('productPickerReset');
if (reset) reset.addEventListener('click', function() {
  currentSearchQuery = ''; search.value = ''; currentPickerTechnique = 'all'; currentFilter = 'all';
  pickerEl.querySelectorAll('.category-tab').forEach(function(button) { const active = button.dataset.category === 'all'; button.classList.toggle('active',active); button.setAttribute('aria-pressed',String(active)); });
  pickerEl.querySelectorAll('[data-picker-technique]').forEach(function(button) { button.setAttribute('aria-pressed',String(button.dataset.pickerTechnique === 'all')); });
  renderProductCards(); search.focus();
});
pickerEl.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') { event.preventDefault(); window.closeProductPicker(); }
  if (event.key !== 'Tab') return;
  const controls = [...pickerEl.querySelectorAll('button:not([disabled]),input,select')].filter(function(el) { return el.getClientRects().length && !el.hidden; });
  const first = controls[0], last = controls.at(-1);
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
  else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
});
pickerEl.addEventListener('click', function(e) {
if (e.target.id === 'productPicker') window.closeProductPicker();
});
}
}
function showCartSuccessModal() {
const modal = document.getElementById('cartSuccessModal');
if (!modal) return;
closeDrawer();
modal.classList.add('show');
modal.setAttribute('aria-hidden', 'false');
document.body.style.overflow = 'hidden';
const closeBtn = document.getElementById('closeCartModal');
const continueBtn = document.getElementById('continueDesignBtn');
const cartBtn = document.getElementById('goToCartBtn');
if (closeBtn) {
const newCloseBtn = closeBtn.cloneNode(true);
closeBtn.replaceWith(newCloseBtn);
newCloseBtn.addEventListener('click', closeCartSuccessModal);
}
if (continueBtn) {
const newContinueBtn = continueBtn.cloneNode(true);
continueBtn.replaceWith(newContinueBtn);
newContinueBtn.addEventListener('click', closeCartSuccessModal);
}
if (cartBtn) {
const newCartBtn = cartBtn.cloneNode(true);
cartBtn.replaceWith(newCartBtn);
newCartBtn.addEventListener('click', async function() {
newCartBtn.disabled = true;
try { await performAddToCart(); } finally { newCartBtn.disabled = false; }
});
}
modal.addEventListener('click', function(e) {
if (e.target === modal) {
closeCartSuccessModal();
}
});
}
function closeCartSuccessModal() {
const modal = document.getElementById('cartSuccessModal');
if (!modal) return;
modal.classList.remove('show');
modal.setAttribute('aria-hidden', 'true');
document.body.style.overflow = '';
}
window.openSizeDrawer = function() {
openDrawer();
setDrawerMode('sizes');
};
window.addNote = function() {
const noteBlock = document.getElementById('noteBlock');
const textarea = document.getElementById('designNoteInput');
if (!noteBlock || !textarea) return;
const isHidden = noteBlock.hasAttribute('hidden');
if (isHidden) {
noteBlock.removeAttribute('hidden');
textarea.value = designNote || '';
setTimeout(function() { textarea.focus(); }, 100);
} else {
noteBlock.setAttribute('hidden', '');
}
const saveBtn = document.getElementById('saveNoteBtn');
const cancelBtn = document.getElementById('cancelNoteBtn');
if (saveBtn && !saveBtn.hasAttribute('data-bound')) {
saveBtn.setAttribute('data-bound', 'true');
saveBtn.addEventListener('click', function() {
designNote = textarea.value.trim();
window.designNote = designNote;
noteBlock.setAttribute('hidden', '');
const noteBtn = document.querySelector('.note-btn');
if (noteBtn) {
if (designNote) {
noteBtn.style.color = 'var(--success)';
noteBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>Modifier la consigne';
} else {
noteBtn.style.color = '';
noteBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"/></svg>Ajouter une consigne';
}
}
showNotification(designNote ? 'Consigne enregistrée' : 'Consigne supprimée', 'success');
});
}
if (cancelBtn && !cancelBtn.hasAttribute('data-bound')) {
cancelBtn.setAttribute('data-bound', 'true');
cancelBtn.addEventListener('click', function() {
noteBlock.setAttribute('hidden', '');
});
}
};
function showSizesConfirmModal() {
const modal = document.getElementById('sizesConfirmModal');
if (!modal) return;
const summary = document.getElementById('sizesConfirmSummary');
if (summary) {
const selectedSizes = Object.entries(sizeQuantities).filter(function(entry) {
return entry[1] > 0;
});
if (!selectedSizes.length) {
showNotification('Sélectionnez au moins une taille', 'warning');
return;
}
const totalQty = selectedSizes.reduce(function(sum, entry) {
return sum + parseInt(entry[1]);
}, 0);
summary.innerHTML = '<h4>Votre sélection</h4>' +
'<div class="sizes-confirm-list">' +
selectedSizes.map(function(entry) {
return '<div class="sizes-confirm-item">' +
'<span class="sizes-confirm-item-size">' + entry[0] + '</span>' +
'<span class="sizes-confirm-item-qty">× ' + entry[1] + '</span>' +
'</div>';
}).join('') +
'</div>' +
'<div class="sizes-confirm-total">' +
'<span>Total</span>' +
'<span>' + totalQty + ' article' + (totalQty > 1 ? 's' : '') + '</span>' +
'</div>';
}
closeDrawer();
modal.classList.add('show');
modal.setAttribute('aria-hidden', 'false');
document.body.style.overflow = 'hidden';
const closeBtn = document.getElementById('closeSizesConfirm');
const continueBtn = document.getElementById('continueCustomizing');
const cartBtn = document.getElementById('goToCartFromSizes');
const pendingEmbroidery = hasEmbroideryImageForReview();
const subtitle = modal.querySelector('.sizes-confirm-subtitle');
if (subtitle) subtitle.textContent = pendingEmbroidery
  ? 'Votre création sera examinée avant qu’un paiement soit proposé.'
  : 'Votre sélection est prête pour le panier.';
if (cartBtn) cartBtn.textContent = pendingEmbroidery ? 'Envoyer ma création à validation' : 'Ajouter au panier';
if (closeBtn) {
closeBtn.onclick = closeSizesConfirmModal;
}
if (continueBtn) {
continueBtn.onclick = closeSizesConfirmModal;
}
if (cartBtn) {
cartBtn.onclick = async function() {
cartBtn.disabled = true;
closeSizesConfirmModal();
try { await performAddToCart(); } finally { cartBtn.disabled = false; }
};
}
modal.addEventListener('click', function(e) {
if (e.target === modal) {
closeSizesConfirmModal();
}
});
}
function closeSizesConfirmModal() {
const modal = document.getElementById('sizesConfirmModal');
if (!modal) return;
modal.classList.remove('show');
modal.setAttribute('aria-hidden', 'true');
document.body.style.overflow = '';
}

async function uploadToApp(blob, meta = {}) {
if (!blob || !(blob instanceof Blob)) {
throw new Error('Fichier invalide');
}
if (blob.size > MAX_UPLOAD_SIZE) {
throw new Error('Fichier trop volumineux (max 10MB)');
}
const fd = new FormData();
fd.append('file', blob, `preview-${Date.now()}.png`);
const metadata = {
timestamp: window.CUSTOMIZER.CURRENT_DATE,
user: window.CUSTOMIZER.CURRENT_USER,
productHandle: window.currentProduct?.handle,
view: meta.view || 'unknown',
technique: window.currentTechnique || 'impression',
};
fd.append('metadata', JSON.stringify(metadata));
try {
const resp = await fetch(window.CUSTOMIZER.endpoints.upload, {
method: 'POST',
body: fd,
credentials: 'same-origin'
});
if (!resp.ok) {
const text = await resp.text().catch(() => '');
throw new Error(`Upload échoué (${resp.status}): ${text}`);
}
const result = await resp.json();
if (!result.ok || !result.secure_url) {
throw new Error('Réponse Cloudinary invalide');
}
return {
url: result.secure_url,
publicId: result.public_id,
thumbnail: result.secure_url,
metadata: metadata
};
} catch (err) {
throw err;
}
}

const O2_UPLOAD_URL = 'https://customizer.oazar-shop.com/upload.php';
const O2_ASSET_ORIGIN = 'https://customizer.oazar-shop.com';
const MAX_SIZE_BYTES = 30 * 1024 * 1024;
function normalizeCustomizerAssetUrl(value) {
  let s = String(value || '').trim();
  if (!s) return '';
  if (s.startsWith('//')) return 'https:' + s;
  if (s.startsWith('blob:') || s.startsWith('data:')) return s;
  try {
    const u = new URL(s, window.location.href);
    // Anciennes sauvegardes : /uploads/... a parfois été résolu sur oazar-shop.com.
    if (u.pathname.startsWith('/uploads/') && u.hostname !== 'customizer.oazar-shop.com') {
      return O2_ASSET_ORIGIN + u.pathname + u.search + u.hash;
    }
    if (/^https?:$/i.test(u.protocol)) return u.href;
  } catch (e) {}
  if (s.startsWith('/')) return O2_ASSET_ORIGIN + s;
  if (s.startsWith('uploads/')) return O2_ASSET_ORIGIN + '/' + s;
  return s;
}
function getViewContext(viewName) {
const viewRoot = document.querySelector(`.product-view[data-view="${viewName}"]`);
const designArea = viewRoot?.querySelector(`.design-area[data-area="${viewName}"]`);
const imgId = 'productImage' + viewName.charAt(0).toUpperCase() + viewName.slice(1);
const productImg = viewRoot?.querySelector('#' + imgId);
if (!viewRoot || !designArea || !productImg || !productImg.src) {
return null;
}
return { viewRoot, designArea, productImg };
}
async function capturePrintCanvas(viewName, strict) {
const designArea = document.querySelector(`.design-area[data-area="${viewName}"]`);
if (!designArea) return null;
const items = designArea.querySelectorAll('.design-item');
if (!items.length) return null;
if (typeof window.applyDesignZoneToDOM === 'function') window.applyDesignZoneToDOM(viewName);
const areaRect = designArea.getBoundingClientRect();
if (!areaRect.width || !areaRect.height) throw new Error('Zone de marquage non mesurable');
const canvas = document.createElement('canvas');
const printScale = Math.min(2100 / areaRect.width, 4200 / areaRect.height);
canvas.width = Math.max(1, Math.round(areaRect.width * printScale));
canvas.height = Math.max(1, Math.round(areaRect.height * printScale));
const ctx = canvas.getContext('2d');
ctx.clearRect(0, 0, canvas.width, canvas.height);
const zoomScale = getCanvasZoomScale();
const logicalAreaWidth = areaRect.width / zoomScale;
const logicalAreaHeight = areaRect.height / zoomScale;
const scaleX = canvas.width / logicalAreaWidth;
const scaleY = canvas.height / logicalAreaHeight;
for (const item of items) {
await renderDesignItemToCanvas(ctx, item, designArea, scaleX, scaleY, strict);
}
return canvas;
}
window.addDesignToCurrentView = addDesignToCurrentView;
window.changeView = changeView;
window.setupResizeHandlers = setupResizeHandlers;
window.captureMockupPrecise = capturePrintCanvas;
function getElementRotationRadians(el) {
const style = window.getComputedStyle(el);
const transform =
style.transform ||
style.webkitTransform ||
style.mozTransform ||
style.msTransform ||
style.oTransform;
if (!transform || transform === 'none') return 0;
const match = transform.match(/matrix\(([^)]+)\)/);
if (!match) return 0;
const values = match[1].split(',').map(v => parseFloat(v.trim()));
if (values.length < 4) return 0;
const a = values[0];
const b = values[1];
return Math.atan2(b, a);
}
async function uploadToO2Switch(file, filename, bucket = 'uploads') {
if (!file) throw new Error('Aucun fichier à uploader');
const fd = new FormData();
const finalName = filename || file.name || 'upload';
fd.append('file', file, finalName);
const effectiveBucket = (window.currentCommandeFolder && String(window.currentCommandeFolder).trim()) ? window.currentCommandeFolder : bucket;
fd.append('bucket', effectiveBucket);
fd.append('original_name', file.name || finalName);
fd.append('mime_type', file.type || '');
const resp = await fetch('https://customizer.oazar-shop.com/upload.php', {
method: 'POST',
body: fd
});
if (!resp.ok) {
const text = await resp.text().catch(() => '');
throw new Error(`Upload échoué (${resp.status}): ${text}`);
}
const data = await resp.json();
if (!data.success) {
throw new Error(data.error || 'Upload O2switch échoué');
}
return {
url: normalizeCustomizerAssetUrl(data.url),
filename: data.filename,
originalName: data.original_name,
width: data.width,
height: data.height
};
}
async function blobUrlToFile(blobUrl, filename) {
try {
const response = await fetch(blobUrl);
const blob = await response.blob();
return new File([blob], filename, { type: blob.type });
} catch (err) {
throw err;
}
}
async function verifyDesignSizes(viewName) {
try {
const data = await collectDesignData(viewName);
if (!data || !data.items || !data.items.length) {
return true;
}
let allOK = true;
data.items.forEach((item, index) => {
if (item.type === 'image') {
const ratio = item.aspectRatio || (item.naturalWidth / item.naturalHeight);
const finalRatio = item.finalWidthPx / item.finalHeightPx;
const diff = Math.abs(ratio - finalRatio);
const isOK = diff < 0.01;
if (!isOK) allOK = false;
} else if (item.type === 'text') {
}
});
return allOK;
} catch (err) {
return false;
}
}
window.verifyDesignSizes = verifyDesignSizes;
window.blobUrlToFile = blobUrlToFile;
async function captureProductOnly(viewName) {
const viewRoot = document.querySelector(`.product-view[data-view="${viewName}"]`);
const designArea = viewRoot?.querySelector(`.design-area[data-area="${viewName}"]`);
const imgId = 'productImage' + viewName.charAt(0).toUpperCase() + viewName.slice(1);
const productImg = viewRoot?.querySelector('#' + imgId);
if (!viewRoot || !productImg || !productImg.src) {
throw new Error('Image produit non trouvée');
}
const allDesigns = designArea?.querySelectorAll('.design-item');
const originalDisplays = [];
if (allDesigns) {
allDesigns.forEach(item => {
originalDisplays.push(item.style.display);
item.style.display = 'none';
});
}
const controls = viewRoot.querySelectorAll('.di-controls, .preview-controls, .zoom-controls');
controls.forEach(el => el.style.display = 'none');
await new Promise(r => setTimeout(r, 100));
try {
const canvas = await html2canvas(viewRoot, {
backgroundColor: null,
scale: 2,
useCORS: true,
allowTaint: true,
logging: false
});
if (allDesigns) {
allDesigns.forEach((item, i) => {
item.style.display = originalDisplays[i] || '';
});
}
controls.forEach(el => el.style.display = '');
return canvas;
} catch (err) {
if (allDesigns) {
allDesigns.forEach((item, i) => {
item.style.display = originalDisplays[i] || '';
});
}
controls.forEach(el => el.style.display = '');
throw err;
}
}
async function getProductImageDirect(viewName) {
const imgId = 'productImage' + viewName.charAt(0).toUpperCase() + viewName.slice(1);
const productImg = document.getElementById(imgId);
if (!productImg || !productImg.src) {
throw new Error('Image produit non trouvée');
}
const imageUrl = productImg.src;
return {
url: imageUrl,
width: productImg.naturalWidth,
height: productImg.naturalHeight
};
}
async function calculateDesignPositions(viewName) {
const viewRoot = document.querySelector(`.product-view[data-view="${viewName}"]`);
const designArea = viewRoot?.querySelector(`.design-area[data-area="${viewName}"]`);
const imgId = 'productImage' + viewName.charAt(0).toUpperCase() + viewName.slice(1);
const productImg = document.getElementById(imgId);
if (!viewRoot || !designArea || !productImg) {
return [];
}
const items = designArea.querySelectorAll('.design-item');
if (!items.length) return [];
const productWidth = productImg.naturalWidth;
const productHeight = productImg.naturalHeight;
const productRect = productImg.getBoundingClientRect();
const scaleX = productWidth / productRect.width;
const scaleY = productHeight / productRect.height;
const designData = [];
for (let i = 0; i < items.length; i++) {
const item = items[i];
const itemType = item.dataset.type;
const itemRect = item.getBoundingClientRect();
const relX = itemRect.left - productRect.left;
const relY = itemRect.top - productRect.top;
const x = relX * scaleX;
const y = relY * scaleY;
const width = itemRect.width * scaleX;
const height = itemRect.height * scaleY;
const rotation = parseFloat(item.dataset.angle || 0);
if (itemType === 'image') {
const imgEl = item.querySelector('img');
if (!imgEl?.src) continue;
let finalUrl = imgEl.src;
if (imgEl.src.startsWith('blob:')) {
try {
let file = null;
if (window.pendingUploads?.has(imgEl)) {
file = window.pendingUploads.get(imgEl);
} else {
const filename = imgEl.dataset.originalName || `design_${Date.now()}.png`;
file = await blobUrlToFile(imgEl.src, filename);
}
const uploadResult = await uploadFileToO2Switch(file, file.name, getActiveCommandeBucket('client_uploads'), (imgEl.dataset.uploadSubType || 'images'));
finalUrl = uploadResult.url;
if (window.pendingUploads?.has(imgEl)) {
window.pendingUploads.delete(imgEl);
}
} catch (uploadErr) {
continue;
}
}
const imgRatio = imgEl.naturalWidth / imgEl.naturalHeight;
let finalWidth = width;
let finalHeight = height;
const displayRatio = width / height;
if (Math.abs(imgRatio - displayRatio) > 0.01) {
if (imgRatio > displayRatio) {
finalHeight = width / imgRatio;
} else {
finalWidth = height * imgRatio;
}
}
designData.push({
type: 'image',
url: finalUrl,
x: Math.round(x),
y: Math.round(y),
width: Math.round(finalWidth),
height: Math.round(finalHeight),
rotation: rotation,
originalRatio: imgRatio,
naturalWidth: imgEl.naturalWidth,
naturalHeight: imgEl.naturalHeight
});
} else if (itemType === 'text') {
const textDiv = item.querySelector('.di-content > div');
if (!textDiv) continue;
const text = (textDiv.textContent || '').trim();
if (!text) continue;
const cs = window.getComputedStyle(textDiv);
const screenFontSize = parseFloat(cs.fontSize);
const productFontSize = screenFontSize * scaleY;
designData.push({
type: 'text',
text: text,
x: Math.round(x),
y: Math.round(y),
width: Math.round(width),
height: Math.round(height),
rotation: rotation,
font: {
family: cs.fontFamily.replace(/['"]/g, '').split(',')[0],
size: Math.round(productFontSize),
weight: cs.fontWeight
},
color: rgbToHex(cs.color)
});
}
}
return designData;
}
async function calculateDesignPositionsInZone(viewName) {
const viewRoot = document.querySelector(`.product-view[data-view="${viewName}"]`);
const designArea = viewRoot?.querySelector(`.design-area[data-area="${viewName}"]`);
const imgId = 'productImage' + viewName.charAt(0).toUpperCase() + viewName.slice(1);
const productImg = document.getElementById(imgId);
if (!viewRoot || !designArea || !productImg) {
return [];
}
const items = designArea.querySelectorAll('.design-item');
if (!items.length) return [];
const productWidth = productImg.naturalWidth;
const productHeight = productImg.naturalHeight;
const zoneConfig = getDesignZoneConfig(viewName);
const zoneRealX = (zoneConfig.x / 100) * productWidth;
const zoneRealY = (zoneConfig.y / 100) * productHeight;
const zoneRealWidth = (zoneConfig.width / 100) * productWidth;
const zoneRealHeight = (zoneConfig.height / 100) * productHeight;
const designAreaRect = designArea.getBoundingClientRect();
const scaleX = zoneRealWidth / designAreaRect.width;
const scaleY = zoneRealHeight / designAreaRect.height;
const designData = [];
for (let i = 0; i < items.length; i++) {
const item = items[i];
const itemType = item.dataset.type;
const itemRect = item.getBoundingClientRect();
const relX = itemRect.left - designAreaRect.left;
const relY = itemRect.top - designAreaRect.top;
const xInZone = relX * scaleX;
const yInZone = relY * scaleY;
const widthInZone = itemRect.width * scaleX;
const heightInZone = itemRect.height * scaleY;
const finalX = zoneRealX + xInZone;
const finalY = zoneRealY + yInZone;
const rotation = parseFloat(item.dataset.angle || 0);
if (itemType === 'image') {
const imgEl = item.querySelector('img');
if (!imgEl?.src) continue;
let finalUrl = imgEl.src;
if (imgEl.src.startsWith('blob:')) {
try {
let file = null;
if (window.pendingUploads?.has(imgEl)) {
file = window.pendingUploads.get(imgEl);
} else {
const filename = imgEl.dataset.originalName || `design_${Date.now()}.png`;
file = await blobUrlToFile(imgEl.src, filename);
}
const uploadResult = await uploadFileToO2Switch(file, file.name, getActiveCommandeBucket('client_uploads'), (imgEl.dataset.uploadSubType || 'images'));
finalUrl = uploadResult.url;
if (window.pendingUploads?.has(imgEl)) {
window.pendingUploads.delete(imgEl);
}
} catch (uploadErr) {
continue;
}
}
const imgRatio = imgEl.naturalWidth / imgEl.naturalHeight;
let finalWidth = widthInZone;
let finalHeight = heightInZone;
const displayRatio = widthInZone / heightInZone;
if (Math.abs(imgRatio - displayRatio) > 0.01) {
if (imgRatio > displayRatio) {
finalHeight = widthInZone / imgRatio;
} else {
finalWidth = heightInZone * imgRatio;
}
}
designData.push({
type: 'image',
url: finalUrl,
x: Math.round(finalX),
y: Math.round(finalY),
width: Math.round(finalWidth),
height: Math.round(finalHeight),
rotation: rotation,
originalRatio: imgRatio,
naturalWidth: imgEl.naturalWidth,
naturalHeight: imgEl.naturalHeight
});
} else if (itemType === 'text') {
const textDiv = item.querySelector('.di-content > div');
if (!textDiv) continue;
const text = (textDiv.textContent || '').trim();
if (!text) continue;
const cs = window.getComputedStyle(textDiv);
const screenFontSize = parseFloat(cs.fontSize);
const zoneFontSize = screenFontSize * scaleY;
designData.push({
type: 'text',
text: text,
x: Math.round(finalX),
y: Math.round(finalY),
width: Math.round(widthInZone),
height: Math.round(heightInZone),
rotation: rotation,
font: {
family: cs.fontFamily.replace(/['"]/g, '').split(',')[0],
size: Math.round(zoneFontSize),
weight: cs.fontWeight
},
color: rgbToHex(cs.color)
});
}
}
return designData;
}
async function detectDesignZoneOnProduct(viewName) {
const designArea = document.querySelector(`.design-area[data-area="${viewName}"]`);
const imgId = 'productImage' + viewName.charAt(0).toUpperCase() + viewName.slice(1);
const productImg = document.getElementById(imgId);
if (!designArea || !productImg) {
throw new Error('Éléments manquants');
}
const designRect = designArea.getBoundingClientRect();
const paintedRect = getPaintedProductImageRect(productImg);
if (!paintedRect) throw new Error('Image produit non mesurable');
const realW = paintedRect.naturalWidth;
const realH = paintedRect.naturalHeight;
const zoneScreenX      = designRect.left - paintedRect.left;
const zoneScreenY      = designRect.top - paintedRect.top;
const zoneScreenWidth  = designRect.width;
const zoneScreenHeight = designRect.height;
const scaleX = realW / paintedRect.width;
const scaleY = realH / paintedRect.height;
const result = {
product: {
width: realW,
height: realH,
screenWidth: paintedRect.width,
screenHeight: paintedRect.height,
offsetX: paintedRect.left,
offsetY: paintedRect.top
},
zoneScreen: {
x: zoneScreenX,
y: zoneScreenY,
width: zoneScreenWidth,
height: zoneScreenHeight
},
zoneReal: {
x: Math.round(zoneScreenX * scaleX),
y: Math.round(zoneScreenY * scaleY),
width:  Math.round(zoneScreenWidth  * scaleX),
height: Math.round(zoneScreenHeight * scaleY)
},
scale: {
x: scaleX,
y: scaleY
}
};
return result;
}
async function calculateExactDesignPositions(viewName) {
const designArea = document.querySelector(`.design-area[data-area="${viewName}"]`);
if (!designArea) {
return [];
}
const items = designArea.querySelectorAll('.design-item');
if (!items.length) {
return [];
}
const zoneInfo = await detectDesignZoneOnProduct(viewName);
const zone = zoneInfo.zoneReal;
const areaRect = designArea.getBoundingClientRect();
const zoomScale = getCanvasZoomScale();
const logicalAreaWidth = areaRect.width / zoomScale;
const logicalAreaHeight = areaRect.height / zoomScale;
const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
canvas.width = Math.round(zone.width);
canvas.height = Math.round(zone.height);
const scaleX = canvas.width / logicalAreaWidth;
const scaleY = canvas.height / logicalAreaHeight;
ctx.clearRect(0, 0, canvas.width, canvas.height);
for (let i = 0; i < items.length; i++) {
const item = items[i];
try {
await renderDesignItemToCanvas(ctx, item, designArea, scaleX, scaleY);
} catch (e) {
}
}
let finalUrl;
try {
const blob = await canvasToBlob(canvas, 'image/png', 1);
const filename = `zone_${viewName}_${Date.now()}.png`;
const uploadResult = await uploadFileToO2Switch(blob, filename, getActiveCommandeBucket('client_images'), 'renders');
finalUrl = uploadResult.url;
} catch (e) {
return [];
}
const designData = [{
type: 'image',
url: finalUrl,
x: Math.round(zone.x),
y: Math.round(zone.y),
width: Math.round(zone.width),
height: Math.round(zone.height),
rotation: 0,
isComposite: true
}];
return designData;
}
async function renderOnO2Switch(viewName) {
try {
const productData = await getProductImageDirect(viewName);
const designPositions = await calculateExactDesignPositions(viewName);
if (!designPositions.length) {
return productData.url;
}
const payload = {
product_url: productData.url,
product_width: productData.width,
product_height: productData.height,
designs: designPositions,
view: viewName
};
const response = await fetch('https://customizer.oazar-shop.com/render_final.php', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify(payload)
});
if (!response.ok) {
const text = await response.text();
throw new Error(`Fusion échouée (${response.status}): ${text}`);
}
const result = await response.json();
if (!result.success) {
throw new Error(result.error || 'Rendu échoué');
}
try {
const bucketBase = getActiveCommandeBucket('client_images');
if (bucketBase && isHttpUrl(result.final_url) && !isAlreadyOnCustomizerUploads(result.final_url)) {
const copy = await uploadRemoteUrlToServer(result.final_url, `final_${viewName}.png`, bucketBase, 'renders');
if (copy && copy.url) return normalizeCustomizerAssetUrl(copy.url);
}
} catch (eCopy) {
console.warn('[renderOnO2Switch] copy final_url failed', eCopy);
}
return normalizeCustomizerAssetUrl(result.final_url);
} catch (err) {
throw err;
}
}
async function createOverviewFromDesignViews(designViews) {
try {
const order = ['front', 'back', 'left', 'right'];
const labels = {
front: 'AVANT',
back: 'DOS',
left: 'MANCHE GAUCHE',
right: 'MANCHE DROITE'
};
const viewsWithMockup = order.filter(v => designViews[v]?.mockup);
if (!viewsWithMockup.length) {
return null;
}
const thumbWidth = 1050;
const thumbHeight = 1260;
const cols = 2;
const rows = 2;
const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
canvas.width = cols * thumbWidth;
canvas.height = rows * thumbHeight;
ctx.fillStyle = '#ffffff';
ctx.fillRect(0, 0, canvas.width, canvas.height);
const positions = {
front: { x: 0, y: 0 },
back:  { x: thumbWidth, y: 0 },
left:  { x: 0, y: thumbHeight },
right: { x: thumbWidth, y: thumbHeight }
};
for (const view of viewsWithMockup) {
const mockupUrl = designViews[view].mockup;
if (!mockupUrl) continue;
try {
const img = await loadImageForCanvas(mockupUrl);
const pos = positions[view] || { x: 0, y: 0 };
const ratio = Math.min(
thumbWidth / img.width,
thumbHeight / img.height
);
const drawW = img.width * ratio;
const drawH = img.height * ratio;
const offsetX = pos.x + (thumbWidth - drawW) / 2;
const offsetY = pos.y + (thumbHeight - drawH) / 2;
ctx.drawImage(img, offsetX, offsetY, drawW, drawH);
ctx.fillStyle = 'rgba(0,0,0,0.75)';
ctx.fillRect(pos.x, pos.y, thumbWidth, 60);
ctx.fillStyle = '#ffffff';
ctx.font = 'bold 40px Arial';
ctx.textAlign = 'center';
ctx.textBaseline = 'middle';
ctx.fillText(labels[view], pos.x + thumbWidth / 2, pos.y + 30);
} catch (e) {
}
}
const blob = await canvasToBlob(canvas, 'image/png', 0.95);
const filename = `overview_${Date.now()}.png`;
const upload = await uploadFileToO2Switch(blob, filename, getActiveCommandeBucket('client_images'), 'overview');
return upload.url;
} catch (err) {
return null;
}
}
function getOazarPrecommandeBucket() {
  if (!window.__oazarPrecommandeBucket) {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const stamp = d.getFullYear() + pad(d.getMonth()+1) + pad(d.getDate()) + '-' + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds());
    window.__oazarPrecommandeBucket = 'precommandes/session-' + stamp + '-' + Math.random().toString(16).slice(2, 8);
  }
  return window.__oazarPrecommandeBucket;
}
function getActiveCommandeBucket(fallback = 'client_images') {
  const folder = (window.currentCommandeFolder && String(window.currentCommandeFolder).trim()) ? String(window.currentCommandeFolder).trim() : '';
  if (folder) return folder;
  // Avant le clic panier, on évite les vieux dossiers génériques "designs" / "client_images".
  // Les vrais fichiers de commande seront rangés dans Commande_xxxxxx après new_commande.php.
  if (!fallback || fallback === 'designs' || fallback === 'client_images' || fallback === 'client_uploads' || fallback === 'designs_remote') {
    return getOazarPrecommandeBucket();
  }
  return fallback;
}
function revealViewForExport(viewRoot) {
  if (!viewRoot || window.getComputedStyle(viewRoot).display !== 'none') return function () {};
  const prior = ['display', 'visibility', 'pointer-events'].map(function (name) {
    return { name, value: viewRoot.style.getPropertyValue(name), priority: viewRoot.style.getPropertyPriority(name) };
  });
  const wasHidden = viewRoot.hidden;
  viewRoot.hidden = false;
  viewRoot.style.setProperty('display', 'flex', 'important');
  viewRoot.style.setProperty('visibility', 'hidden', 'important');
  viewRoot.style.setProperty('pointer-events', 'none', 'important');
  return function () {
    prior.forEach(function (old) {
      if (old.value) viewRoot.style.setProperty(old.name, old.value, old.priority);
      else viewRoot.style.removeProperty(old.name);
    });
    viewRoot.hidden = wasHidden;
  };
}
function describeViewPlacement(viewName) {
  const area = document.querySelector(`.design-area[data-area="${viewName}"]`);
  if (!area) return null;
  const width = area.clientWidth || area.offsetWidth || 1;
  const height = area.clientHeight || area.offsetHeight || 1;
  return {
    zone_percent: typeof window.getDesignZoneConfig === 'function' ? window.getDesignZoneConfig(viewName) : null,
    elements: Array.from(area.querySelectorAll('.design-item')).map(function (item) {
      const content = item.querySelector('.di-content > div');
      const image = item.querySelector('img');
      return {
        type: item.dataset.type || '',
        x_percent: Math.round(item.offsetLeft / width * 10000) / 100,
        y_percent: Math.round(item.offsetTop / height * 10000) / 100,
        width_percent: Math.round(item.offsetWidth / width * 10000) / 100,
        height_percent: Math.round(item.offsetHeight / height * 10000) / 100,
        rotation_degrees: Number(item.dataset.angle || 0) || 0,
        text: content ? String(content.textContent || '').trim() : '',
        original_name: image ? String(image.dataset.originalName || '') : ''
        ,visual_origin: image ? String(image.dataset.ozVisualOrigin || 'import') : ''
        ,patch: image?.dataset.ozPatchConfig ? JSON.parse(image.dataset.ozPatchConfig) : null
      };
    })
  };
}
async function saveAllDesigns() {
if (window.OazarSmartTemplates && window.OazarSmartTemplates.flushPreview) {
  await window.OazarSmartTemplates.flushPreview();
}
// Archive the current SVG, including the client's latest colours and texts.
for (const image of document.querySelectorAll('.design-item[data-type="image"] img')) {
  if (!/^data:image\/svg\+xml/i.test(image.src)) continue;
  const response = await fetch(image.src);
  const blob = await response.blob();
  const file = new File([blob], image.dataset.originalName || 'design-client.svg', {type:'image/svg+xml'});
  if (!window.pendingUploads) window.pendingUploads = new Map();
  window.pendingUploads.set(image, file);
  image.dataset.uploadSubType = 'designs';
}
const bucketBase = getActiveCommandeBucket('client_images');
const views = ['front', 'back', 'left', 'right'];

// IMPORTANT : capturer les miniatures AVANT de remplacer les blob: locaux par leurs URL serveur.
// Cela garantit que la miniature contient réellement les images importées par le client,
// même si le serveur d'uploads n'autorise pas encore le canvas en CORS.
const preCapturedThumbBlobs = {};
const preCapturedMockupBlobs = {};
const preCapturedPrintBlobs = {};
// Copie légère conservée uniquement dans le navigateur. Elle permet au panier
// d'afficher le visuel immédiatement, même si une URL distante est brièvement
// indisponible après l'ajout au panier.
const localCartPreviews = {};
for (const viewName of views) {
  const viewRoot = document.querySelector(`.product-view[data-view="${viewName}"]`);
  const designArea = document.querySelector(`.design-area[data-area="${viewName}"]`);
  if (!viewRoot || !designArea || !designArea.querySelector('.design-item')) continue;
  const restoreView = revealViewForExport(viewRoot);
  try {
    await new Promise(r => requestAnimationFrame(r));
    const thumbCanvas = await captureViewWithProduct(viewName, 600, 720);
    if (thumbCanvas) {
      preCapturedThumbBlobs[viewName] = await canvasToBlob(thumbCanvas, 'image/png', 0.96);

      // Miniature compacte de secours, identique au rendu de l'atelier.
      const previewWidth = 240;
      const previewHeight = Math.max(1, Math.round(previewWidth * thumbCanvas.height / thumbCanvas.width));
      const previewCanvas = document.createElement('canvas');
      previewCanvas.width = previewWidth;
      previewCanvas.height = previewHeight;
      const previewContext = previewCanvas.getContext('2d');
      if (previewContext) {
        previewContext.fillStyle = '#ffffff';
        previewContext.fillRect(0, 0, previewWidth, previewHeight);
        previewContext.drawImage(thumbCanvas, 0, 0, previewWidth, previewHeight);
        const dataUrl = previewCanvas.toDataURL('image/jpeg', 0.82);
        // Garde-fou contre les quotas localStorage trop restreints.
        if (dataUrl.length <= 350000) localCartPreviews[viewName] = dataUrl;
      }
    }
    try {
      const productImg = viewRoot.querySelector('#productImage' + viewName.charAt(0).toUpperCase() + viewName.slice(1));
      if (productImg && typeof productImg.decode === 'function') await productImg.decode();
      const naturalWidth = productImg && productImg.naturalWidth || 1;
      const naturalHeight = productImg && productImg.naturalHeight || 1;
      const renderScale = 1600 / Math.max(naturalWidth, naturalHeight);
      const fullCanvas = await captureViewWithProduct(
        viewName,
        Math.max(1, Math.round(naturalWidth * renderScale)),
        Math.max(1, Math.round(naturalHeight * renderScale)),
        true
      );
      if (fullCanvas) preCapturedMockupBlobs[viewName] = await canvasToBlob(fullCanvas, 'image/png', 1);
    } catch (fullCaptureError) {
      console.warn('[saveAllDesigns] full mockup capture failed', viewName, fullCaptureError);
    }
    try {
      const printCanvas = await capturePrintCanvas(viewName, true);
      if (printCanvas) preCapturedPrintBlobs[viewName] = await canvasToBlob(printCanvas, 'image/png', 1);
    } catch (printCaptureError) {
      console.warn('[saveAllDesigns] print capture failed', viewName, printCaptureError);
    }
  } catch (e) {
    console.warn('[saveAllDesigns] pre-capture view-thumb failed', viewName, e);
  } finally {
    restoreView();
  }
}

await ensureDesignsInClientImages(bucketBase);
const clientImageUploads = await uploadClientImagesSeparately(bucketBase);
const designViews = {};
const cartThumbs = {};
const exportFailures = [];
let hasAnyDesign = false;

for (const viewName of views) {
  const viewRoot = document.querySelector(`.product-view[data-view="${viewName}"]`);
  const designArea = document.querySelector(`.design-area[data-area="${viewName}"]`);
  if (!viewRoot || !designArea) continue;

  const items = designArea.querySelectorAll('.design-item');
  const hasDesignHere = items.length > 0;
  if (hasDesignHere) hasAnyDesign = true;

  let finalUrl = '';
  let printUrl = '';
  const texts = [];
  const originals = [];
  const restoreView = revealViewForExport(viewRoot);
  await new Promise(r => requestAnimationFrame(r));

  try {
    if (hasDesignHere) {
      // Sauvegarde une vraie miniature identique à la view-thumb de l'atelier.
      // La vue est rendue visible juste au-dessus pour garder la bonne position du design.
      try {
        let thumbBlob = preCapturedThumbBlobs[viewName] || null;
        if (!thumbBlob) {
          const thumbCanvas = await captureViewWithProduct(viewName, 600, 720);
          if (thumbCanvas) thumbBlob = await canvasToBlob(thumbCanvas, 'image/png', 0.96);
        }
        if (thumbBlob) {
          const thumbUpload = await uploadFileToO2Switch(
            thumbBlob,
            `view-thumb-${viewName}-${Date.now()}.png`,
            bucketBase,
            // Le serveur de rendu gère les aperçus dans « renders ». L'ancien
            // sous-type « cart_previews » n'était pas garanti côté upload :
            // l'échec était attrapé plus bas et Shopify recevait alors une URL
            // vide, donc uniquement l'image catalogue dans le mini-panier.
            'renders'
          );
          if (thumbUpload?.url) cartThumbs[viewName] = normalizeCustomizerAssetUrl(thumbUpload.url);
        }
      } catch (eThumb) {
        console.warn('[saveAllDesigns] view-thumb upload failed', viewName, eThumb);
      }

      if (preCapturedMockupBlobs[viewName]) {
        try {
          const savedMockup = await uploadFileToO2Switch(
            preCapturedMockupBlobs[viewName], `final_${viewName}_${Date.now()}.png`, bucketBase, 'renders'
          );
          finalUrl = normalizeCustomizerAssetUrl(savedMockup.url);
        } catch (clientMockupError) {
          console.warn('[saveAllDesigns] exact mockup upload failed', viewName, clientMockupError);
        }
      }
      if (preCapturedPrintBlobs[viewName]) {
        try {
          const savedPrint = await uploadFileToO2Switch(
            preCapturedPrintBlobs[viewName], `print_${viewName}_${Date.now()}.png`, bucketBase, 'prints'
          );
          printUrl = normalizeCustomizerAssetUrl(savedPrint.url);
        } catch (clientPrintError) {
          console.warn('[saveAllDesigns] print upload failed', viewName, clientPrintError);
        }
      }
      if (!finalUrl) {
        try {
          const serverUrl = await renderOnO2Switch(viewName);
          if (!finalUrl) finalUrl = serverUrl;
        } catch (serverRenderError) {
          throw serverRenderError;
        }
      }
      if (!printUrl) throw new Error('Le fichier PNG transparent n’a pas pu être enregistré. Réessayez.');

      for (const item of items) {
        if (item.dataset.type === 'image') {
          const imgEl = item.querySelector('img');
          if (imgEl?.dataset.originalSrc || imgEl?.src) {
            originals.push({
              url: normalizeCustomizerAssetUrl(imgEl.dataset.originalSrc || imgEl.src),
              original_name: imgEl.dataset.originalName || 'design.png',
              width: imgEl.naturalWidth || 0,
              height: imgEl.naturalHeight || 0
            });
            if (imgEl.dataset.ozEmbroiderySourceUrl) originals.push({
              url: normalizeCustomizerAssetUrl(imgEl.dataset.ozEmbroiderySourceUrl),
              original_name: imgEl.dataset.ozEmbroiderySourceName || 'image-originale.png',
              source_for_embroidery: true
            });
          }
        } else if (item.dataset.type === 'text') {
          const textDiv = item.querySelector('.di-content > div');
          if (textDiv) {
            const text = (textDiv.textContent || '').trim();
            if (text) {
              const cs = window.getComputedStyle(textDiv);
              texts.push({
                content: text,
                font: {
                  family: cs.fontFamily.replace(/["']/g, '').split(',')[0],
                  size: parseFloat(cs.fontSize),
                  weight: cs.fontWeight
                },
                color: rgbToHex(cs.color)
              });
            }
          }
        }
      }
    }

    if (finalUrl) {
      designViews[viewName] = {
        mockup: finalUrl,
        print: printUrl,
        originals: originals,
        patches: Array.from(items).filter(item => item.querySelector('img')?.dataset.ozPatchConfig).map(item => ({element_id:item.dataset.uid || '', ...JSON.parse(item.querySelector('img').dataset.ozPatchConfig)})),
        texts: texts,
        placement: describeViewPlacement(viewName)
      };
    }
  } catch (err) {
    console.warn('[saveAllDesigns] view failed', viewName, err);
    if (hasDesignHere) exportFailures.push(viewName);
  } finally {
    restoreView();
  }
}

if (exportFailures.length) {
  throw new Error('Sauvegarde incomplète (' + exportFailures.join(', ') + '). Votre création est conservée dans l’atelier ; réessayez l’enregistrement.');
}
if (!hasAnyDesign) {
  throw new Error('Aucun design à sauvegarder');
}

const overviewUrl = await createOverviewFromDesignViews(designViews);
const design_id = 'design_' + Date.now() + '_' + Math.random().toString(16).slice(2);

const snapshots = {
  front: (typeof snapshotView === 'function') ? snapshotView('front') : null,
  back:  (typeof snapshotView === 'function') ? snapshotView('back') : null,
  left:  (typeof snapshotView === 'function') ? snapshotView('left') : null,
  right: (typeof snapshotView === 'function') ? snapshotView('right') : null
};

const serverPayload = {
  success: true,
  design_id,
  folder: bucketBase,
  product_handle: window.currentProduct?.handle || null,
  product_id: window.currentProduct?.id || null,
  product_title: window.currentProduct?.title || null,
  technique: window.currentTechnique || 'impression',
  note: window.designNote || '',
  overview: overviewUrl || null,
  views: designViews,
  cart_thumbs: cartThumbs,
  // Conserve une miniature légère dans l'archive serveur. Le mini-panier peut
  // ainsi l'afficher après un rechargement ou sur un autre navigateur.
  local_previews: localCartPreviews,
  snapshots,
  client_images: clientImageUploads || [],
  saved_at: new Date().toISOString()
};

let metaUrl = null;
try {
  metaUrl = await uploadCustomizationMeta(bucketBase, serverPayload);
} catch (e) {
  console.warn('[saveAllDesigns] uploadCustomizationMeta failed', e);
}

const browserPayload = Object.assign({}, serverPayload, {
  local_previews: localCartPreviews
});

// Le payload complet (images originales + snapshots) peut dépasser le quota de
// localStorage. La miniature du panier est donc aussi stockée seule, dans une
// entrée très courte et indépendante : elle reste disponible au mini-panier
// même si l'archivage complet ci-dessous échoue.
const cartPreviewForBrowser = localCartPreviews.front
  || localCartPreviews.back
  || localCartPreviews.left
  || localCartPreviews.right
  || '';
try {
  if (cartPreviewForBrowser) {
    localStorage.setItem('oazar_cart_preview_' + design_id, cartPreviewForBrowser);
  }
} catch (_) {}

try {
  localStorage.setItem('oazar_design_' + design_id, JSON.stringify(browserPayload));
} catch (_) {}

return {
  ...serverPayload,
  meta_url: metaUrl || null,
  local_previews: localCartPreviews
};
}

async function uploadCustomizationMeta(bucketBase, payloadObj) {
try {
const jsonStr = JSON.stringify(payloadObj, null, 2);
const jsonBlob = new Blob([jsonStr], { type: 'application/json' });
const jsonFile = new File([jsonBlob], 'customization.json', { type: 'application/json' });
const jsonRes = await uploadFileToO2Switch(jsonFile, jsonFile.name, bucketBase, 'meta');
const jsonUrl = jsonRes?.url || null;
try {
  const viewLabels = { front: 'Avant', back: 'Dos', left: 'Gauche', right: 'Droite' };
  const fiche = [
    'FICHE ATELIER OAZAR',
    'Dossier : ' + (payloadObj.folder || ''),
    'Design : ' + (payloadObj.design_id || ''),
    'Produit : ' + (payloadObj.product_title || ''),
    'Technique : ' + (payloadObj.technique || ''),
    'Créé le : ' + (payloadObj.saved_at || ''),
    ''
  ];
  Object.entries(payloadObj.views || {}).forEach(([viewName, viewData]) => {
    fiche.push((viewLabels[viewName] || viewName).toUpperCase());
    fiche.push('Aperçu produit : ' + (viewData.mockup || ''));
    fiche.push('Fichier impression : ' + (viewData.print || ''));
    const place = viewData.placement || {};
    if (place.zone_percent) fiche.push('Zone produit (%) : ' + JSON.stringify(place.zone_percent));
    (place.elements || []).forEach((element, index) => {
      fiche.push('Élément ' + (index + 1) + ' : ' + element.type +
        ' ; x=' + element.x_percent + '% ; y=' + element.y_percent +
        '% ; largeur=' + element.width_percent + '% ; hauteur=' + element.height_percent +
        '% ; rotation=' + element.rotation_degrees + '°' +
        (element.text ? ' ; texte=' + element.text : '') +
        (element.original_name ? ' ; fichier=' + element.original_name : ''));
    });
    fiche.push('');
  });
  const ficheBlob = new Blob([fiche.join('\n') + '\n'], { type: 'text/plain' });
  await uploadFileToO2Switch(new File([ficheBlob], 'fiche_atelier.txt', { type: 'text/plain' }), 'fiche_atelier.txt', bucketBase, 'meta');
} catch (ficheError) {
  console.warn('[uploadCustomizationMeta] fiche_atelier.txt failed', ficheError);
}
try {
const lines = [];
const views = payloadObj?.views || {};
Object.entries(views).forEach(([viewName, viewData]) => {
const texts = Array.isArray(viewData?.texts) ? viewData.texts : [];
texts.forEach((t) => {
const val = (t?.content || t?.text || '').toString().trim();
if (!val) return;
lines.push(`[${viewName}] ${val}`);
});
});
const content = lines.join('\n').trim();
if (content) {
const txtBlob = new Blob([content + '\n'], { type: 'text/plain' });
const txtFile = new File([txtBlob], 'texts.txt', { type: 'text/plain' });
await uploadFileToO2Switch(txtFile, txtFile.name, bucketBase, 'meta');
}
} catch (e2) {
console.warn('[uploadCustomizationMeta] texts.txt failed', e2);
}
return jsonUrl;
} catch (e) {
console.warn('[uploadCustomizationMeta] failed', e);
return null;
}
}
async function captureAndUploadMockup(viewName) {
const viewRoot = document.querySelector(`.product-view[data-view="${viewName}"]`);
if (!viewRoot) throw new Error('Vue non trouvée');
const imgId = 'productImage' + viewName.charAt(0).toUpperCase() + viewName.slice(1);
const productImg = viewRoot.querySelector('#' + imgId);
if (!productImg || !productImg.naturalWidth) {
throw new Error('Image produit non chargée');
}
const naturalWidth = productImg.naturalWidth;
const naturalHeight = productImg.naturalHeight;
const naturalRatio = naturalWidth / naturalHeight;
const controls = viewRoot.querySelectorAll('.di-controls, .di-handle, .di-rotate, .di-trash');
controls.forEach(el => el.style.display = 'none');
const designArea = viewRoot.querySelector('.design-area');
const originalBorder = designArea?.style.border;
const originalOutline = designArea?.style.outline;
if (designArea) {
designArea.style.border = 'none';
designArea.style.outline = 'none';
}
viewRoot.querySelectorAll('.design-item.selected').forEach(el => {
el.classList.remove('selected');
});
const originalDisplay = viewRoot.style.display;
viewRoot.style.display = 'block';
await new Promise(r => setTimeout(r, 50));
try {
const canvas = await html2canvas(viewRoot, {
backgroundColor: null,
scale: 2,
useCORS: true,
allowTaint: true,
logging: false,
imageTimeout: 10000,
ignoreElements: (el) => {
return el.classList?.contains('di-controls') ||
el.classList?.contains('preview-controls') ||
el.classList?.contains('zoom-controls') ||
el.classList?.contains('view-navigator');
}
});
viewRoot.style.display = originalDisplay;
controls.forEach(el => el.style.display = '');
if (designArea) {
designArea.style.border = originalBorder || '';
designArea.style.outline = originalOutline || '';
}
const blob = await canvasToBlob(canvas, 'image/png', 0.95);
const filename = `mockup_${viewName}_${Date.now()}.png`;
const result = await uploadFileToO2Switch(blob, filename, getActiveCommandeBucket('client_images'), filename && filename.indexOf('print_') === 0 ? 'prints' : 'renders');
return result.url;
} catch (err) {
viewRoot.style.display = originalDisplay;
controls.forEach(el => el.style.display = '');
if (designArea) {
designArea.style.border = originalBorder || '';
designArea.style.outline = originalOutline || '';
}
throw err;
}
}
async function captureAndUploadPrint(viewName) {
const designArea = document.querySelector(`.design-area[data-area="${viewName}"]`);
if (!designArea) return null;
const items = Array.from(designArea.querySelectorAll('.design-item'));
if (!items.length) return null;
const areaRect = designArea.getBoundingClientRect();
const PRINT_WIDTH = 2100;
const scale = PRINT_WIDTH / areaRect.width;
const PRINT_HEIGHT = Math.round(areaRect.height * scale);
const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
canvas.width = PRINT_WIDTH;
canvas.height = PRINT_HEIGHT;
ctx.clearRect(0, 0, PRINT_WIDTH, PRINT_HEIGHT);
for (const item of items) {
const itemRect = item.getBoundingClientRect();
const centerX = (itemRect.left + itemRect.right) / 2;
const centerY = (itemRect.top + itemRect.bottom) / 2;
const baseWidth = item.offsetWidth;
const baseHeight = item.offsetHeight;
const x = (centerX - areaRect.left) * scale;
const y = (centerY - areaRect.top) * scale;
const w = baseWidth * scale;
const h = baseHeight * scale;
const angle = parseFloat(item.dataset.angle || 0) || 0;
ctx.save();
ctx.translate(x, y);
ctx.rotate((angle * Math.PI) / 180);
if (item.dataset.type === 'image') {
const imgEl = item.querySelector('img');
if (imgEl) {
try {
const img = await loadImageForCanvas(imgEl.dataset.originalSrc || imgEl.src);
const imgRatio = img.naturalWidth / img.naturalHeight;
let drawW = w;
let drawH = h;
if (imgRatio > w / h) {
drawH = w / imgRatio;
} else {
drawW = h * imgRatio;
}
ctx.drawImage(img, -drawW / 2, -drawH / 2, drawW, drawH);
} catch (e) {
}
}
} else if (item.dataset.type === 'text') {
const span = item.querySelector('.design-text');
const cs = window.getComputedStyle(span);
const fontSize = parseFloat(cs.fontSize) * scale;
ctx.font = `${cs.fontWeight} ${fontSize}px ${cs.fontFamily}`;
ctx.fillStyle = cs.color;
ctx.textAlign = cs.textAlign || 'center';
ctx.textBaseline = 'middle';
const text = span?.textContent || '';
ctx.fillText(text, 0, 0);
}
ctx.restore();
}
const blob = await canvasToBlob(canvas, 'image/png', 1);
const filename = `print_${viewName}_${Date.now()}.png`;
const result = await uploadFileToO2Switch(blob, filename, getActiveCommandeBucket('client_images'), filename && filename.indexOf('print_') === 0 ? 'prints' : 'renders');
return result.url;
}
window.CUSTOMIZER = window.CUSTOMIZER || {};
window.CUSTOMIZER.endpoints = {
upload: 'https://customizer.oazar-shop.com/upload.php',
saveDesign: 'https://customizer.oazar-shop.com/save_design.php',
mockup: 'https://customizer.oazar-shop.com/render_mockup.php'
};
async function buildCustomizationCartLines(totalQty) {
  if (window.currentProduct?.patch) return [];
  const sizeQties = (window.sizeQuantities && Object.keys(window.sizeQuantities).length)
    ? window.sizeQuantities
    : { __total: totalQty || getTotalQty() };

  const technique = String(window.currentTechnique || 'impression').toLowerCase();

  const designItems = ozGetAllDesignItems()
    .map((x) => x.item)
    .filter((it) => {
      if (!it) return false;
      // Tarif standard : le modèle SVG compte comme une personnalisation normale.
      const t = String(it.dataset.type || '').toLowerCase();
      return t === 'image' || t === 'text' || t === 'design' || t === 'i-text';
    });

  if (!designItems.length) return [];

  const handlesRoot = window.pricingDimensionHandles || {};
  const legacyRoot = window.pricingProducts || {};
  const legacyCfg = legacyRoot[technique] || {};

  const multiDiscountFrom = (typeof MULTI_DESIGN_FROM !== 'undefined') ? MULTI_DESIGN_FROM : 2;
  const multiDiscountActive = (typeof MULTI_DESIGN_DISCOUNT !== 'undefined') && MULTI_DESIGN_DISCOUNT > 0;

  // 1. On compte le TOTAL des designs pour activer la remise
  const totalDesignsCount = designItems.length;

  const linesById = new Map();

  for (let designIdx = 0; designIdx < designItems.length; designIdx++) {
    const item = designItems[designIdx];
    const raw = String(item.dataset.type || '').toLowerCase();
    const kind = (raw === 'text' || raw === 'i-text') ? 'text' : 'image';

    const viewEl = item.closest('.product-view');
    let wasHidden = false;
    if (viewEl && window.getComputedStyle(viewEl).display === 'none') {
      wasHidden = true;
      viewEl.style.display = 'flex';
      viewEl.style.visibility = 'hidden';
      viewEl.style.position = 'absolute';
      viewEl.style.pointerEvents = 'none';
    }

    const tier = getItemSizeTier(item, technique, kind);

    if (wasHidden && viewEl) {
      viewEl.style.display = 'none';
      viewEl.style.visibility = '';
      viewEl.style.position = '';
      viewEl.style.pointerEvents = '';
    }

    const tierName = (tier && tier.name ? String(tier.name) : 'M').toUpperCase();

    // 2. Remise activée si le nombre TOTAL de designs atteint le seuil
    const isDiscounted = multiDiscountActive && totalDesignsCount >= multiDiscountFrom;
    const remiseTierName = isDiscounted ? (tierName + '-REMISE') : tierName;

    let variantId = null;
    const handleRemise = isDiscounted
      ? (handlesRoot?.[technique]?.[kind]?.[remiseTierName] || ADDON_HANDLES?.[technique]?.[kind]?.[remiseTierName])
      : null;
    const handleNormal = handlesRoot?.[technique]?.[kind]?.[tierName] || ADDON_HANDLES?.[technique]?.[kind]?.[tierName];
    const handle = handleRemise || handleNormal;

    if (handle && typeof fetchVariantId === 'function') {
      variantId = await fetchVariantId(handle);
    }
    if (!variantId) {
      const v = ozGetDimensionVariantId(technique, kind, isDiscounted ? remiseTierName : tierName);
      if (v) variantId = v;
    }
    if (!variantId && isDiscounted) {
      const v = ozGetDimensionVariantId(technique, kind, tierName);
      if (v) variantId = v;
    }
    if (!variantId) {
      const tierKey = getTierKeyForQty(getTotalQty());
      if (tierKey && legacyCfg?.[kind]?.[tierKey]) variantId = legacyCfg[kind][tierKey];
    }
    if (!variantId) continue;

    const effectiveTier = isDiscounted ? remiseTierName : tierName;
    const techName = (technique === 'impression') ? 'Impression' : 'Broderie';
    const label = (kind === 'image' ? 'Image' : 'Texte') + ' en ' + techName + ' (' + tierName + ')';

    for (const [tshirtSize, tshirtQty] of Object.entries(sizeQties)) {
      const qty = parseInt(tshirtQty, 10) || 0;
      if (qty <= 0) continue;

      const key = String(variantId) + '_' + tshirtSize + '_' + kind + '_' + effectiveTier;
      const existing = linesById.get(key) || {
        variantId: Number(variantId),
        handle: handle || '',
        quantity: 0,
        designCount: 0,
        kind,
        tier: effectiveTier,
        tierDisplay: tierName,
        tshirtSize,
        label,
        discounted: isDiscounted
      };

      existing.quantity += qty;
      existing.designCount += 1;
      linesById.set(key, existing);
    }
  }

  return Array.from(linesById.values());
}
function getAddOnLinesForCart() {
const totalQty = getTotalQty();
return buildCustomizationCartLines(totalQty);
}
window.getAddOnLinesForCart = getAddOnLinesForCart;
function hideCustomizerCartLoader() {
const el = document.getElementById('customizer-cart-loader');
if (!el) return;
el.hidden = true;
el.setAttribute('aria-hidden', 'true');
}
window.showCustomizerCartLoader = function () {
const el = document.getElementById('customizer-cart-loader');
if (!el) return;
el.hidden = false;
el.classList.add('is-active');
document.body.classList.add('customizer-loading');
el.setAttribute('aria-hidden', 'false');
};
window.hideCustomizerCartLoader = function () {
const el = document.getElementById('customizer-cart-loader');
if (!el) return;
el.classList.remove('is-active');
document.body.classList.remove('customizer-loading');
el.setAttribute('aria-hidden', 'true');
setTimeout(() => { el.hidden = true; }, 160);
};
function getParam(name) {
try {
return new URLSearchParams(window.location.search || '').get(name);
} catch (e) {
return null;
}
}
function getEditBundleId() {
// IMPORTANT : seul bundle_id signifie « remplacer un article déjà présent dans le panier ».
// design_id sert aussi à ouvrir un design sauvegardé sans forcément modifier le panier.
return getParam('bundle_id') || null;
}
async function removeBundleFromCart(bundleId) {
if (!bundleId) return [];

const cartRes = await fetch('/cart.js', {
cache: 'no-store',
headers: { 'Accept': 'application/json' }
});
if (!cartRes.ok) throw new Error('Impossible de lire le panier avant modification.');

const cart = await cartRes.json();
const bundleItems = (cart.items || []).filter((item) => {
const props = item.properties || {};
return String(props._BundleID || '') === String(bundleId);
});

if (!bundleItems.length) return [];

// Sauvegarde complète permettant de remettre l'ancien article si le nouvel ajout échoue.
const backup = bundleItems.map((item) => {
const saved = {
id: Number(item.variant_id || item.id),
quantity: Number(item.quantity || 1),
properties: Object.assign({}, item.properties || {})
};
try {
const sellingPlanId = item?.selling_plan_allocation?.selling_plan?.id;
if (sellingPlanId) saved.selling_plan = Number(sellingPlanId);
} catch (_) {}
return saved;
});

const updates = {};
bundleItems.forEach((item) => {
if (item.key) updates[item.key] = 0;
});

if (!Object.keys(updates).length) return [];

const removeRes = await fetch('/cart/update.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ updates })
});

if (!removeRes.ok) {
const txt = await removeRes.text().catch(() => '');
throw new Error('Impossible de remplacer l’ancien article du panier.' + (txt ? ' ' + txt : ''));
}

return backup;
}

async function restoreBundleToCart(backupItems) {
if (!Array.isArray(backupItems) || !backupItems.length) return false;
try {
const res = await fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: backupItems })
});
if (!res.ok) {
console.warn('[restoreBundleToCart] restauration impossible', await res.text().catch(() => ''));
return false;
}
return true;
} catch (e) {
console.warn('[restoreBundleToCart] restauration impossible', e);
return false;
}
}
(function () {
if (typeof window.showNotification === 'function') return;
function ensureContainer() {
let c = document.getElementById('oazar-toast-container');
if (!c) {
c = document.createElement('div');
c.id = 'oazar-toast-container';
document.body.appendChild(c);
}
return c;
}
window.showNotification = function (message, type = 'info', title = '') {
const container = ensureContainer();
const toast = document.createElement('div');
toast.className = `oazar-toast oazar-toast--${type}`;
toast.innerHTML = `
<div class="oazar-toast__bar"></div>
<div class="oazar-toast__content">
${title ? `<p class="oazar-toast__title">${title}</p>` : ''}
<p class="oazar-toast__msg">${String(message || '')}</p>
</div>
<button class="oazar-toast__close" type="button" aria-label="Fermer">×</button>
`;
const closeBtn = toast.querySelector('.oazar-toast__close');
const remove = () => {
toast.style.opacity = '0';
toast.style.transform = 'translateY(-6px)';
setTimeout(() => toast.remove(), 160);
};
closeBtn.addEventListener('click', remove);
container.appendChild(toast);
setTimeout(remove, 3200);
};
})();

const __addonCache = new Map();

async function getAddonVariantByHandle(handle) {
  if (__addonCache.has(handle)) return __addonCache.get(handle);

  const res = await fetch(`/products/${handle}.js`);
  if (!res.ok) throw new Error(`Produit addon introuvable: ${handle}`);

  const product = await res.json();
  const variant = product?.variants?.[0];
  if (!variant?.id) throw new Error(`Aucune variante pour: ${handle}`);

  const out = { id: Number(variant.id), price: Number(variant.price) }; // price en centimes
  __addonCache.set(handle, out);
  return out;
}

// === Mapping EXACT de tes produits techniques (handles Shopify) ===
const ADDON_HANDLES = {
  impression: {
    image: {
      S: 'impression-image-small', M: 'impression-image-medium', L: 'impression-image-large', XL: 'impression-image-xlarge',
      'S-REMISE': 'impression-image-small-remise', 'M-REMISE': 'impression-image-medium-remise',
      'L-REMISE': 'impression-image-large-remise', 'XL-REMISE': 'impression-image-xlarge-remise'
    },
    text: {
      S: 'impression-text-small', M: 'impression-text-medium', L: 'impression-text-large', XL: 'impression-text-xlarge',
      'S-REMISE': 'impression-text-small-remise', 'M-REMISE': 'impression-text-medium-remise',
      'L-REMISE': 'impression-text-large-remise', 'XL-REMISE': 'impression-text-xlarge-remise'
    }
  },
  broderie: {
    image: {
      S: 'broderie-image-small', M: 'broderie-image-medium', L: 'broderie-image-large', XL: 'broderie-image-xlarge',
      'S-REMISE': 'broderie-image-small-remise', 'M-REMISE': 'broderie-image-medium-remise',
      'L-REMISE': 'broderie-image-large-remise', 'XL-REMISE': 'broderie-image-xlarge-remise'
    },
    text: {
      S: 'broderie-text-small', M: 'broderie-text-medium', L: 'broderie-text-large', XL: 'broderie-text-xlarge',
      'S-REMISE': 'broderie-text-small-remise', 'M-REMISE': 'broderie-text-medium-remise',
      'L-REMISE': 'broderie-text-large-remise', 'XL-REMISE': 'broderie-text-xlarge-remise'
    }
  }
};

// Remplit window.pricingDimensions + window.pricingDimensionPrices depuis les produits Shopify
async function initAddonPricingFromProducts() {
  window.pricingDimensions = window.pricingDimensions || {};
  window.pricingDimensionPrices = window.pricingDimensionPrices || {};

  const techniques = Object.keys(ADDON_HANDLES);

  for (const tech of techniques) {
    window.pricingDimensions[tech] = window.pricingDimensions[tech] || {};
    window.pricingDimensionPrices[tech] = window.pricingDimensionPrices[tech] || {};

    for (const kind of ['image', 'text']) {
      window.pricingDimensions[tech][kind] = window.pricingDimensions[tech][kind] || {};
      window.pricingDimensionPrices[tech][kind] = window.pricingDimensionPrices[tech][kind] || {};

      for (const tier of ['S', 'M', 'L', 'XL', 'S-REMISE', 'M-REMISE', 'L-REMISE', 'XL-REMISE']) {
        const handle = ADDON_HANDLES?.[tech]?.[kind]?.[tier];
        if (!handle) continue;

        try {
          const v = await getAddonVariantByHandle(handle); // {id, price}
          window.pricingDimensions[tech][kind][tier] = v.id;
          window.pricingDimensionPrices[tech][kind][tier] = v.price;
        } catch (e) {
          // Produit remise absent = pas bloquant
          console.warn('[pricing] handle introuvable:', handle);
        }
      }
    }
  }

  // refresh prix live si ton bloc existe
  if (typeof window.updatePriceLiveBlock === 'function') window.updatePriceLiveBlock();
}

// Lance au chargement
initAddonPricingFromProducts().catch(console.warn);

function hasEmbroideryImageForReview() {
  if (window.currentProduct?.patch) return true;
  return String(window.currentTechnique || currentTechnique || 'impression').toLowerCase() === 'broderie'
    && !!document.querySelector('#mon-customizer .design-area .design-item[data-type="image"] img');
}
function addToCart(e) {
if (e && e.preventDefault) e.preventDefault();
showSizesConfirmModal();
}
async function performAddToCart(e) {
if (e && e.preventDefault) e.preventDefault();
const btn =
document.getElementById('addToCartMainBtn') ||
document.getElementById('addToCartFinal');
let originalHTML = '';
const setLoading = (on, label) => {
if (!btn) return;
if (!originalHTML) originalHTML = btn.innerHTML;
btn.innerHTML = on ? (label || '⏳ Ajout au panier...') : (originalHTML || 'Ajouter au panier');
btn.disabled = !!on;
if (on) {
if (typeof window.showCustomizerCartLoader === 'function') window.showCustomizerCartLoader();
} else {
if (typeof window.hideCustomizerCartLoader === 'function') window.hideCustomizerCartLoader();
}
};
setLoading(true, '⏳ Préparation...');
const oldBundleId = (typeof getEditBundleId === 'function') ? getEditBundleId() : null;
const isEditMode = !!oldBundleId;
try {
if (window.__ozPatchRefreshPromise) await window.__ozPatchRefreshPromise;
if (!window.currentProduct || !window.currentProduct.id) {
throw new Error("Veuillez sélectionner un produit d'abord");
}
const selectedTechnique = String(window.currentTechnique || currentTechnique || 'impression').toLowerCase();
if (typeof window.__ozIsTechniqueAllowed === 'function' && !window.__ozIsTechniqueAllowed(selectedTechnique)) {
if (typeof updateTechniquesAvailability === 'function') updateTechniquesAvailability();
if (typeof showNotification === 'function') {
showNotification('La technique sélectionnée n’est pas autorisée pour ce produit.', 'warning', 'Technique non autorisée');
}
return;
}
if (currentProduct?.patch?.pricing) syncPatchPricingSize();
const quantities = Object.entries(window.sizeQuantities || {}).filter(([, q]) => (parseInt(q, 10) || 0) > 0);
if (!quantities.length) {
throw new Error('Sélectionnez au moins une taille');
}
const totalQty = quantities.reduce((sum, [, q]) => sum + (parseInt(q, 10) || 0), 0);
const needsEmbroideryReview = hasEmbroideryImageForReview();
let embroideryContact = null;
if (!ozHasActualCustomization()) {
  throw new Error('Ajoutez au moins un texte, une image ou un design avant le panier.');
}
if (window.currentProduct?.patch) {
  const patchImages = document.querySelectorAll('.design-area .design-item[data-type="image"] img');
  if (patchImages.length !== 1 || !patchImages[0].dataset.ozPatchConfig || document.querySelector('.design-area .design-item[data-type="text"]')) {
    throw new Error('Pour cet écusson, choisissez un seul dessin puis appliquez sa forme et son contour avant de continuer.');
  }
}
const oobItems = (typeof window.__ozGetOobItems === 'function') ? window.__ozGetOobItems() : [];
if (oobItems && oobItems.length) {
  if (typeof showNotification === 'function') {
    showNotification(
      "⚠️ Un élément dépasse la zone de personnalisation (cadre orange). Replacez-le entièrement dans la zone pour ajouter au panier.",
      "warning",
      "Ajustez votre design"
    );
  } else {
    alert("Un élément dépasse la zone de personnalisation (cadre orange).");
  }
  try {
    const v = oobItems[0].view;
    if (v && typeof changeView === 'function') changeView(v);
    if (oobItems[0].el && oobItems[0].el.scrollIntoView) {
      oobItems[0].el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  } catch (e) {}
  return;
}
if (needsEmbroideryReview) {
  if (typeof window.ozCollectEmbroideryContact !== 'function' || typeof window.ozSubmitEmbroideryReview !== 'function') {
    throw new Error('Le service de validation de broderie est indisponible. Réessayez dans un instant.');
  }
  setLoading(false);
  embroideryContact = await window.ozCollectEmbroideryContact();
  if (!embroideryContact) return;
  setLoading(true, '⏳ Préparation de votre création...');
}
setLoading(true, '⏳ Création de votre dossier commande...');
try {
const folder = await createCommandeFolder();
if (folder) window.currentCommandeFolder = folder;
} catch (err) {
console.warn('[addToCart] createCommandeFolder failed', err);
window.currentCommandeFolder = null;
throw new Error('Le serveur de personnalisation est indisponible. Réessayez avant d’ajouter au panier.');
}
setLoading(true, '⏳ Sauvegarde de votre design...');
const designResult = await Promise.resolve(saveAllDesigns());
if (!designResult || !designResult.design_id || !designResult.meta_url || !designResult.folder) {
throw new Error('Sauvegarde complète du design impossible. Réessayez avant d’ajouter au panier.');
}
const newDesignId = designResult.design_id;
const commandeFolder = designResult.folder || (window.currentCommandeFolder || '');
if (needsEmbroideryReview) {
  setLoading(true, '⏳ Envoi à validation...');
  const embroideryLines = [];
  for (const [size, qtyText] of quantities) {
    const variantId = getVariantIdForSize(size);
    if (!variantId) throw new Error('Variante introuvable pour la taille ' + size);
    embroideryLines.push({handle: window.currentProduct?.handle || '', variant_id: Number(variantId), quantity: parseInt(qtyText, 10)});
  }
  const embroideryExtras = await buildCustomizationCartLines(totalQty);
  embroideryExtras.forEach(line => {
    if (line.variantId && line.handle && line.quantity) embroideryLines.push({handle: line.handle, variant_id: Number(line.variantId), quantity: Number(line.quantity)});
  });
  if ((!embroideryExtras.length && !window.currentProduct?.patch) || embroideryExtras.some(line => !line.variantId || !line.handle)) throw new Error('Le prix de la broderie est indisponible. Réessayez avant de demander la validation.');
  const result = await window.ozSubmitEmbroideryReview({
    name: embroideryContact.name,
    email: embroideryContact.email,
    note: embroideryContact.note,
    design_id: newDesignId,
    folder: commandeFolder,
    meta_url: designResult.meta_url,
    sizes: Object.fromEntries(quantities.map(([size, qty]) => [size, parseInt(qty, 10) || 0])),
    quantity: totalQty,
    payment_lines: embroideryLines
  });
  window.ozShowEmbroiderySuccess(result.reference);
  return;
}
try {
let previousSaved = {};
try { previousSaved = JSON.parse(localStorage.getItem('oazar_design_' + newDesignId) || '{}') || {}; } catch (_) {}
const editable = Object.assign({}, previousSaved, designResult || {}, {
design_id: newDesignId,
product_handle: window.currentProduct?.handle || null,
technique: window.currentTechnique || 'impression',
note: window.designNote || '',
snapshots: {
front: (typeof snapshotView === 'function') ? snapshotView('front') : null,
back:  (typeof snapshotView === 'function') ? snapshotView('back') : null,
left:  (typeof snapshotView === 'function') ? snapshotView('left') : null,
right: (typeof snapshotView === 'function') ? snapshotView('right') : null
}
});
localStorage.setItem('oazar_design_' + newDesignId, JSON.stringify(editable));
} catch (_) {}
const views = designResult?.views || {};
const previewsAll = {};
const printsAll = {};
for (const [viewName, viewData] of Object.entries(views)) {
if (!viewData || !viewData.mockup) continue;
previewsAll[viewName] = viewData.mockup;
if (viewData.print) printsAll[viewName] = viewData.print;
}
// On garde aussi l'aperçu global dans le carrousel du panier quand il existe.
if (designResult?.overview) previewsAll.overview = designResult.overview;
const cartPreviewUrl =
designResult?.cart_thumbs?.front ||
designResult?.cart_thumbs?.back ||
designResult?.cart_thumbs?.left ||
designResult?.cart_thumbs?.right ||
previewsAll.front ||
previewsAll.back ||
previewsAll.left ||
previewsAll.right ||
designResult?.overview ||
'';
setLoading(true, '⏳ Ajout au panier...');
const items = [];
// ====== TECHNIQUE (cachée dans le panier grâce au _) ======
const tech = (window.currentTechnique || 'impression').toLowerCase();

// 1) Lignes "main" : un item Shopify par taille sélectionnée
for (const [size, qtyStr] of quantities) {
  const qty = parseInt(qtyStr, 10) || 0;
  if (qty <= 0) continue;

  const sourceSvg = window.__ozSourceSvgProduct;
  const baseGarmentVariantId = (typeof getVariantIdForSize === 'function')
    ? getVariantIdForSize(size)
    : (window.variantBySize && window.variantBySize[size]);

  // Tarif standard : la ligne principale du panier reste toujours le vêtement
  // et jamais le produit Shopify qui sert de source au SVG.
  const variantId = baseGarmentVariantId;

  if (!variantId) {
    throw new Error('Variante introuvable pour la taille ' + size);
  }

  const mainProps = {
    _design_id: newDesignId,
    _Design_lie: newDesignId,
    _BundleID: newDesignId,
    _BundleRole: 'main',

    _Preview_front: previewsAll?.front || '',
    _Preview_back: previewsAll?.back || '',
    _Preview_left: previewsAll?.left || '',
    _Preview_right: previewsAll?.right || '',
    _Print_front: printsAll?.front || '',
    _Print_back: printsAll?.back || '',
    _Print_left: printsAll?.left || '',
    _Print_right: printsAll?.right || '',
    _previews_all: JSON.stringify(previewsAll || {}),
    _ViewThumb_front: designResult?.cart_thumbs?.front || '',
    _ViewThumb_back: designResult?.cart_thumbs?.back || '',
    _ViewThumb_left: designResult?.cart_thumbs?.left || '',
    _ViewThumb_right: designResult?.cart_thumbs?.right || '',

    // ❌ on enlève l'overview pour ne jamais l'afficher
    // _Preview_overview: designResult?.overview || '',

    _CartPreview: cartPreviewUrl,
    'cartx__preview-img': cartPreviewUrl,

    _Technique: tech,
    _Technique_parent: tech,

    ...(sourceSvg ? {
      _SourceSvgProduct: sourceSvg.handle || '',
      _SourceSvgVariant: String(sourceSvg.variantId || ''),
      _SourceSvgPriceCents: String(sourceSvg.priceCents || ''),
      _SourceSvgTitle: sourceSvg.title || '',
      _CustomizerBaseHandle: window.currentProduct?.handle || '',
      _CustomizerBaseVariant: String(baseGarmentVariantId || '')
    } : {}),

    Taille: size,
    _CommandeFolder: commandeFolder || '',
    _CommandeMetaUrl: designResult?.meta_url || '',

    ...(window.designNote ? { Note: window.designNote } : {}),
    ...(isEditMode ? { _EditedFromBundle: oldBundleId } : {})
  };

  // ⚠️ IMPORTANT : ne mets PAS de propriété visible "Technique" ici
  items.push({
    id: Number(variantId),
    quantity: qty,
    properties: mainProps
  });
}

// 2) Lignes "extra" : vrais produits Shopify (impression/broderie texte/image) => leur prix s'affiche
const extraLines = await buildCustomizationCartLines(totalQty);
extraLines.forEach((line) => {
  if (!line || !line.variantId) return;

  const q = Number(line.quantity || 0);
  if (!q) return;

  items.push({
    id: Number(line.variantId),
    quantity: q,
    properties: {
      _BundleID: newDesignId,
      _BundleRole: 'extra',
      _Design_lie: newDesignId,

      _Technique_parent: tech,
      _Type_personnalisation: line.label || '',
      _SizeTier: line.tier || '',
      _ExtraKind: line.kind || '',
      _TshirtSize: line.tshirtSize || '',
      _Multiplier: String(line.multiplier || ''),
      _DesignCount: String(line.designCount || 1),

      _CommandeFolder: commandeFolder || '',
      _CommandeMetaUrl: designResult?.meta_url || '',

      ...(isEditMode ? { _EditedFromBundle: oldBundleId } : {})
    }
  });
});

if (!items.length) {
  throw new Error('Aucun variant valide trouvé');
}

// En mode « Modifier dans l’atelier », l’ancienne ligne doit être retirée AVANT
// d’ajouter la nouvelle. Sinon Shopify voit temporairement 2 exemplaires de la
// même variante et peut répondre 422 « quantité maximale déjà dans le panier ».
let removedBundleBackup = [];
if (isEditMode && typeof removeBundleFromCart === 'function') {
setLoading(true, '⏳ Mise à jour de votre personnalisation...');
removedBundleBackup = await removeBundleFromCart(oldBundleId);
}

const addRes = await fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items })
});
if (!addRes.ok) {
const t = await addRes.text().catch(() => '');

// Sécurité : si le remplacement échoue, on tente de remettre exactement
// l’ancien bundle afin de ne pas faire disparaître le produit du panier.
if (removedBundleBackup.length && typeof restoreBundleToCart === 'function') {
await restoreBundleToCart(removedBundleBackup);
}

throw new Error('Erreur ajout panier: ' + addRes.status + (t ? (' ' + t) : ''));
}

try {
  const notificationRes = await fetch('https://customizer.oazar-shop.com/cart-intent.php', {
    method: 'POST',
    mode: 'cors',
    keepalive: true,
    headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
    body: JSON.stringify({
      design_id: newDesignId,
      folder: commandeFolder,
      meta_url: designResult.meta_url,
      product: window.currentProduct?.title || window.currentProduct?.handle || '',
      quantity: totalQty,
      sizes: quantities.map(([size]) => size)
    })
  });
  if (!notificationRes.ok) console.warn('[cart-intent] HTTP', notificationRes.status);
} catch (error) {
  console.warn('[cart-intent] notification impossible', error);
}
closeCartSuccessModal();
window.location.assign('/cart');
} catch (error) {
console.error(error);
if (typeof showNotification === 'function') {
showNotification(error.message || "Erreur lors de l'ajout au panier", 'error');
} else {
alert(error.message || "Erreur lors de l'ajout au panier");
}
} finally {
window.currentCommandeFolder = null;
setLoading(false);
if (typeof window.__ozUpdateCartButtons === 'function') window.__ozUpdateCartButtons();
}
}
window.addToCart = addToCart;
async function renderTextToCanvas(textElement, scale = 1) {
const text = textElement.textContent || '';
if (!text.trim()) return null;
const cs = window.getComputedStyle(textElement);
const fontSize = parseFloat(cs.fontSize) * scale * 2;
const fontFamily = cs.fontFamily;
const fontWeight = cs.fontWeight;
const color = cs.color;
const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
const metrics = ctx.measureText(text);
canvas.width = Math.ceil(metrics.width) + 40;
canvas.height = Math.ceil(fontSize * 1.5) + 20;
ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
ctx.fillStyle = color;
ctx.textBaseline = 'middle';
ctx.fillText(text, 20, canvas.height / 2);
return canvas;
}
function preserveImageRatio(imgNaturalWidth, imgNaturalHeight, targetWidth, targetHeight) {
const imgRatio = imgNaturalWidth / imgNaturalHeight;
const targetRatio = targetWidth / targetHeight;
let finalWidth = targetWidth;
let finalHeight = targetHeight;
if (imgRatio > targetRatio) {
finalHeight = targetWidth / imgRatio;
} else {
finalWidth = targetHeight * imgRatio;
}
return {
width: finalWidth,
height: finalHeight,
offsetX: (targetWidth - finalWidth) / 2,
offsetY: (targetHeight - finalHeight) / 2
};
}
window.saveAllDesigns = saveAllDesigns;
async function collectDesignData(viewName) {
const viewRoot = document.querySelector(`.product-view[data-view="${viewName}"]`);
const designArea = viewRoot?.querySelector(`.design-area[data-area="${viewName}"]`);
const imgId = 'productImage' + viewName.charAt(0).toUpperCase() + viewName.slice(1);
const productImg = viewRoot?.querySelector('#' + imgId);
if (!viewRoot || !designArea || !productImg) {
return null;
}
const items = designArea.querySelectorAll('.design-item');
if (!items.length) {
return null;
}
const productWidth = productImg.naturalWidth || 2100;
const productHeight = productImg.naturalHeight || 2520;
const areaRect = designArea.getBoundingClientRect();
const designItems = [];
for (let i = 0; i < items.length; i++) {
const item = items[i];
const itemType = item.dataset.type;
const itemRect = item.getBoundingClientRect();
const baseWidth = item.offsetWidth;
const baseHeight = item.offsetHeight;
const leftPercent  = ((itemRect.left - areaRect.left) / areaRect.width) * 100;
const topPercent   = ((itemRect.top  - areaRect.top)  / areaRect.height) * 100;
const widthPercent  = (baseWidth  / areaRect.width)  * 100;
const heightPercent = (baseHeight / areaRect.height) * 100;
const rotation = parseFloat(item.dataset.angle || 0);
if (itemType === 'image') {
const imgEl = item.querySelector('img');
if (!imgEl?.src) continue;
let finalUrl = imgEl.src;
let naturalWidth = imgEl.naturalWidth;
let naturalHeight = imgEl.naturalHeight;
if (imgEl.src.startsWith('blob:')) {
try {
let file = null;
if (window.pendingUploads && window.pendingUploads.has(imgEl)) {
file = window.pendingUploads.get(imgEl);
} else {
const filename = imgEl.dataset.originalName ||
imgEl.dataset.fileName ||
'design_' + Date.now() + '.png';
file = await blobUrlToFile(imgEl.src, filename);
}
const uploadResult = await uploadFileToO2Switch(file, file.name, getActiveCommandeBucket('client_uploads'), (imgEl.dataset.uploadSubType || 'images'));
finalUrl = uploadResult.url;
naturalWidth = uploadResult.width || naturalWidth;
naturalHeight = uploadResult.height || naturalHeight;
if (window.pendingUploads && window.pendingUploads.has(imgEl)) {
window.pendingUploads.delete(imgEl);
}
} catch (uploadErr) {
continue;
}
}
const imgRatio = naturalWidth / naturalHeight;
const displayWidthPx = (widthPercent / 100) * productWidth;
const displayHeightPx = (heightPercent / 100) * productHeight;
let finalWidthPx, finalHeightPx;
const displayRatio = displayWidthPx / displayHeightPx;
if (Math.abs(imgRatio - displayRatio) > 0.01) {
if (imgRatio > displayRatio) {
finalWidthPx = displayWidthPx;
finalHeightPx = displayWidthPx / imgRatio;
} else {
finalHeightPx = displayHeightPx;
finalWidthPx = displayHeightPx * imgRatio;
}
} else {
finalWidthPx = displayWidthPx;
finalHeightPx = displayHeightPx;
}
designItems.push({
type: 'image',
src: finalUrl,
left: leftPercent,
top: topPercent,
width: widthPercent,
height: heightPercent,
rotation: rotation,
naturalWidth: naturalWidth,
naturalHeight: naturalHeight,
aspectRatio: imgRatio,
finalWidthPx: Math.round(finalWidthPx),
finalHeightPx: Math.round(finalHeightPx)
});
} else if (itemType === 'text') {
const textDiv = item.querySelector('.di-content > div');
if (!textDiv) continue;
const text = (textDiv.textContent || '').trim();
if (!text) continue;
const cs = window.getComputedStyle(textDiv);
let hexColor = '#000000';
const rgbMatch = cs.color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
if (rgbMatch) {
hexColor = '#' + [1,2,3].map(idx =>
parseInt(rgbMatch[idx]).toString(16).padStart(2, '0')
).join('');
}
const fontSizePx = parseFloat(cs.fontSize);
const fontSizeOnProduct = (fontSizePx / areaRect.height) * productHeight;
designItems.push({
type: 'text',
text: text,
left: leftPercent,
top: topPercent,
font_family: cs.fontFamily.replace(/['"]/g, '').split(',')[0],
font_size: parseFloat(cs.fontSize),
font_weight: cs.fontWeight,
color: hexColor,
rotation: rotation,
finalFontSizePx: Math.round(fontSizeOnProduct)
});
}
}
return {
view: viewName,
product: {
imageUrl: productImg.src,
width: productWidth,
height: productHeight
},
items: designItems
};
}
window.collectDesignData = collectDesignData;
window.uploadFileToO2Switch = uploadFileToO2Switch;
window.blobUrlToFile = blobUrlToFile;
async function saveMockupPreview() {
if (!window.canvas)
try {
const dataURL = window.canvas.toDataURL({ format: 'png', quality: 1 });
const r = await fetch(SAVE_URL, {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({
image: dataURL,
json: JSON.stringify(window.canvas.toJSON()),
kind: 'mockup'
})
});
const j = await r.json();
if (j?.success && j.image_url) {
return j.image_url;
}
} catch (e) {
}
return '';
}
async function customizerAddToCartWrapper(e) {
if (e && e.preventDefault) e.preventDefault();
return addToCart();
}
window.uploadDesignAndAddToCart   = customizerAddToCartWrapper;
window.customizerSaveAndAddToCart = customizerAddToCartWrapper;
function canvasToBlob(canvas, type, quality) {
return new Promise((resolve, reject) => {
canvas.toBlob(
(blob) => {
if (!blob) {
reject(new Error('Canvas to blob failed'));
} else {
resolve(blob);
}
},
type || 'image/png',
quality || 0.92
);
});
}
function loadImageForCanvas(src) {
return new Promise((resolve, reject) => {
const img = new Image();
img.crossOrigin = 'anonymous';
img.onload = () => resolve(img);
img.onerror = () => reject(new Error('Image load failed'));
img.src = src;
});
}
async function uploadFileToO2Switch(file, filename, bucket = null, subtype = '') {
if (!file) throw new Error('Aucun fichier à uploader');
const fd = new FormData();
const finalName = filename || file.name || 'upload';
const resolvedBucket = (bucket && String(bucket).trim()) ? String(bucket).trim() : getActiveCommandeBucket('client_uploads');
let resolvedSubtype = subtype || '';
if (!resolvedSubtype) {
  const lower = String(finalName || '').toLowerCase();
  if (lower.endsWith('.json') || lower.endsWith('.txt')) resolvedSubtype = 'meta';
  else if (lower.includes('mockup') || lower.includes('preview') || lower.includes('overview') || lower.includes('final') || lower.includes('zone_')) resolvedSubtype = 'renders';
  else resolvedSubtype = 'images';
}
fd.append('file', file, finalName);
fd.append('bucket', resolvedBucket);
if (resolvedSubtype) fd.append('subtype', resolvedSubtype);
fd.append('original_name', file.name || finalName);
fd.append('mime_type', file.type || '');
const res = await fetch('https://customizer.oazar-shop.com/upload.php', {
method: 'POST',
body: fd
});
if (!res.ok) {
const t = await res.text().catch(()=>'');
throw new Error('Upload failed: ' + res.status + (t ? (' - ' + t.slice(0,120)) : ''));
}
const data = await res.json();
if (!data.success) {
throw new Error(data.error || 'Upload error');
}
return {
url: normalizeCustomizerAssetUrl(data.url),
filename: data.filename,
originalName: data.original_name,
width: data.width,
height: data.height,
bucket: data.bucket || resolvedBucket,
subtype: data.subtype || resolvedSubtype || '',
clientImagePath: data.client_image_path,
clientImageFile: data.client_image_file
};
}

function filenameFromUrl(url) {
try {
const u = new URL(url, window.location.href);
const base = decodeURIComponent((u.pathname || '').split('/').pop() || '');
return (base || '').replace(/[^A-Za-z0-9._-]/g, '_');
} catch (e) {
return '';
}
}
function normalizeToAbsoluteUrl(src) {
if (!src) return '';
if (src.startsWith('//')) return window.location.protocol + src;
if (src.startsWith('/')) return window.location.origin + src;
return src;
}
function isAlreadyOnCustomizerUploads(url) {
return typeof url === 'string' && url.includes('customizer.oazar-shop.com/uploads/');
}
async function uploadRemoteUrlToServer(remoteUrl, suggestedName, bucket = 'designs', subtype = '') {
const fd = new FormData();
fd.append('remote_url', remoteUrl);
fd.append('bucket', bucket);
if (subtype) fd.append('subtype', subtype);
if (suggestedName) fd.append('original_name', suggestedName);
const res = await fetch('https://customizer.oazar-shop.com/upload.php', {
method: 'POST',
body: fd
});
const data = await res.json();
if (!res.ok || !data.success) {
throw new Error(data?.error || `remote upload failed (${res.status})`);
}
if (data && data.url) data.url = normalizeCustomizerAssetUrl(data.url);
return data;
}
function normalizeToHttpsUrl(url) {
const s = (url || '').trim();
if (!s) return '';
if (s.startsWith('//')) return 'https:' + s;
return s;
}
function isHttpUrl(url) {
return /^https?:\/\//i.test(url || '');
}
async function createCommandeFolder() {
const res = await fetch('https://customizer.oazar-shop.com/new_commande.php', {
method: 'POST',
mode: 'cors',
cache: 'no-store'
});
const raw = await res.text();
let data = null;
try {
data = JSON.parse(raw);
} catch (e) {
const preview = String(raw || '').slice(0, 200).replace(/\s+/g, ' ').trim();
throw new Error(`new_commande.php n'a pas renvoyé du JSON (HTTP ${res.status}). Réponse: ${preview}`);
}
if (!res.ok || !data.success) {
throw new Error(data.error || `Cannot create commande folder (HTTP ${res.status})`);
}
return data.folder;
}
async function ensureDesignsInClientImages(bucketOverride = null) {
const bucketBase = bucketOverride || getActiveCommandeBucket('designs_remote');
const imgs = Array.from(document.querySelectorAll(
'.design-area .design-item[data-type="image"] img'
));
const uploadsBySrc = new Map();
const tasks = [];
for (const imgEl of imgs) {
const rawSrc = imgEl.dataset.originalSrc || imgEl.src || '';
let src = normalizeToAbsoluteUrl(rawSrc);
src = normalizeToHttpsUrl(src);
if (!src) continue;
if (window.pendingUploads?.has(imgEl)) continue;
if (src.startsWith('blob:') || src.startsWith('data:')) continue;
if (isAlreadyOnCustomizerUploads(src)) continue;
if (imgEl.closest('.product-image') || imgEl.closest('.base-product-image')) continue;
const subtype = imgEl.dataset.uploadSubType || 'designs';
if (!uploadsBySrc.has(src)) {
const wantedName = imgEl.dataset.originalName || filenameFromUrl(src) || `design_${Date.now()}.png`;
uploadsBySrc.set(src, uploadRemoteUrlToServer(src, wantedName, bucketBase, subtype));
}
tasks.push(
uploadsBySrc.get(src).then((data) => {
if (data?.client_image_path) imgEl.dataset.clientImagePath = data.client_image_path;
if (data?.original_name) imgEl.dataset.originalName = data.original_name;
if (data?.bucket) imgEl.dataset.serverBucket = data.bucket;
if (data?.subtype) imgEl.dataset.serverSubType = data.subtype;
if (data?.filename) imgEl.dataset.serverFilename = data.filename;
if (data?.url) {
imgEl.src = data.url;
imgEl.dataset.originalSrc = data.url;
}
}).catch(()=>{})
);
}
await Promise.all(tasks);
return true;
}
function oazar_filenameFromUrl(url) {
try {
const u = new URL(url, window.location.href);
const base = decodeURIComponent((u.pathname || '').split('/').pop() || '');
return (base || '').replace(/[^A-Za-z0-9._-]/g, '_');
} catch (e) {
return '';
}
}
function oazar_isAlreadyOnCustomizer(src) {
return typeof src === 'string' && src.includes('/uploads/');
}
async function oazar_copyRemoteToServer(remoteUrl, suggestedName) {
const fd = new FormData();
fd.append('remote_url', remoteUrl);
fd.append('bucket', 'remote_designs');
if (suggestedName) fd.append('original_name', suggestedName);
const res = await fetch('https://customizer.oazar-shop.com/upload.php', {
method: 'POST',
body: fd
});
const data = await res.json();
if (!res.ok || !data.success) {
throw new Error(data?.error || `remote upload failed (${res.status})`);
}
return data;
}
async function ensureDesignsCopiedToClientImages() {
const imgs = Array.from(document.querySelectorAll(
'.design-area .design-item[data-type="image"] img'
));
const seen = new Set();
const results = [];
for (const imgEl of imgs) {
const src = imgEl.dataset.originalSrc || imgEl.src || '';
if (!src) continue;
if (src.startsWith('blob:') || src.startsWith('data:')) continue;
if (oazar_isAlreadyOnCustomizer(src)) continue;
if (seen.has(src)) continue;
seen.add(src);
const name =
imgEl.dataset.originalName ||
oazar_filenameFromUrl(src) ||
`design_${Date.now()}.png`;
try {
const up = await oazar_copyRemoteToServer(src, name);
imgEl.dataset.clientImageSrc = up.client_image_path || '';
results.push({
original_url: src,
client_image_path: up.client_image_path || null,
client_image_file: up.client_image_file || null
});
} catch (e) {
}
}
return results;
}
async function uploadClientImagesSeparately(bucketOverride = null) {
if (!window.pendingUploads || !window.pendingUploads.size) {
return [];
}
const bucketBase = bucketOverride || getActiveCommandeBucket('client_images');
const results = [];
const entries = Array.from(window.pendingUploads.entries());
for (const [imgEl, file] of entries) {
try {
const subtype = imgEl.dataset.uploadSubType || 'images';
if (imgEl._ozEmbroiderySourceFile && !imgEl.dataset.ozEmbroiderySourceUrl) {
  const sourceFile = imgEl._ozEmbroiderySourceFile;
  const originalUpload = await uploadFileToO2Switch(sourceFile, sourceFile.name || 'image-originale.png', bucketBase, 'images-originales');
  if (!originalUpload?.url) throw new Error('L’image originale n’a pas pu être conservée.');
  imgEl.dataset.ozEmbroiderySourceUrl = originalUpload.url;
  imgEl.dataset.ozEmbroiderySourceName = sourceFile.name || 'image-originale.png';
  if (imgEl.dataset.ozPatchSource) imgEl.dataset.ozPatchSource = originalUpload.url;
}
const res = await uploadFileToO2Switch(file, file.name, bucketBase, subtype);
if (res && res.url) {
const oldSrc = imgEl.src || '';
imgEl.src = res.url;
imgEl.dataset.originalSrc = res.url;
if (res.originalName) imgEl.dataset.originalName = res.originalName;
if (res.clientImagePath) imgEl.dataset.clientImagePath = res.clientImagePath;
imgEl.dataset.serverBucket = res.bucket || bucketBase;
imgEl.dataset.serverSubType = res.subtype || subtype;
if (res.filename) imgEl.dataset.serverFilename = res.filename;
delete imgEl.dataset.pendingFile;
delete imgEl.dataset.fileName;
if (oldSrc && oldSrc.startsWith('blob:')) {
try {
const stillUsed = Array.from(document.querySelectorAll('img'))
.some(other => other !== imgEl && other.src === oldSrc);
if (!stillUsed) {
URL.revokeObjectURL(oldSrc);
}
} catch (e) {}
}
window.pendingUploads.delete(imgEl);
results.push({
elementId: imgEl.dataset.id || null,
url: res.url,
originalName: file.name,
clientImagePath: res.clientImagePath || null,
subtype
});
}
} catch (e) {
console.warn('[uploadClientImagesSeparately] upload failed', e);
if (imgEl.dataset.embroideredPreview === '1') throw e;
}
}
return results;
}
function rgbToHex(rgb) {
const match = rgb.match(/\d+/g);
if (!match || match.length < 3) return '#000000';
return '#' + match.slice(0, 3).map(x =>
parseInt(x).toString(16).padStart(2, '0')
).join('');
}
window.rgbToHex = rgbToHex;
async function captureMockupCanvas(viewName) {
const viewRoot = document.querySelector(`.product-view[data-view="${viewName}"]`);
if (!viewRoot) {
throw new Error('Vue non trouvée');
}
const controls = viewRoot.querySelectorAll('.di-controls, .di-trash');
controls.forEach(el => el.style.display = 'none');
const savedDisplay = viewRoot.style.display;
viewRoot.style.display = 'block';
await new Promise(r => setTimeout(r, 150));
try {
const canvas = await html2canvas(viewRoot, {
backgroundColor: null,
scale: 2,
useCORS: true,
allowTaint: true,
logging: false
});
viewRoot.style.display = savedDisplay;
controls.forEach(el => el.style.display = '');
return canvas;
} catch (err) {
viewRoot.style.display = savedDisplay;
controls.forEach(el => el.style.display = '');
throw err;
}
}
window.canvasToBlob = canvasToBlob;
window.loadImageForCanvas = loadImageForCanvas;
window.uploadFileToO2Switch = uploadFileToO2Switch;
window.saveAllDesigns = saveAllDesigns;
window.captureMockupCanvas = captureMockupCanvas;
window.capturePrintCanvas = capturePrintCanvas;
document.addEventListener('DOMContentLoaded', function() {
var productForm = document.querySelector('form[action*="/cart/add"]');
var addToCartBtn = document.querySelector('button[name="add"], #AddToCart, .product-form__submit');
if (productForm) {
var inputPreview = document.createElement('input');
inputPreview.type = 'hidden';
inputPreview.name = 'properties[_CustomPreview]';
inputPreview.id = 'custom-preview-input';
productForm.appendChild(inputPreview);
function captureThumbImage() {
var thumbFront = document.querySelector('.view-thumb[data-view-thumb="front"]');
if (thumbFront) {
var style = window.getComputedStyle(thumbFront);
var bgImage = style.backgroundImage;
if (bgImage && bgImage !== 'none') {
var cleanImage = bgImage.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '');
inputPreview.value = cleanImage;
}
}
}
if (addToCartBtn) {
addToCartBtn.addEventListener('mousedown', captureThumbImage);
addToCartBtn.addEventListener('click', captureThumbImage);
}
productForm.addEventListener('submit', captureThumbImage);
}
});

document.addEventListener('DOMContentLoaded', function() {
document.body.addEventListener('click', function(e) {
if (e.target.closest('[data-design-name]')) {
let nom = e.target.closest('[data-design-name]').getAttribute('data-design-name');
const el = document.getElementById('save_design_name');
if (el) el.value = nom;
}
});
document.body.addEventListener('click', function(e) {
if (e.target.closest('[data-technique]')) {
let tech = e.target.closest('[data-technique]').getAttribute('data-technique');
const el = document.getElementById('save_technique');
if (el) el.value = tech;
}
});
let textInput = document.querySelector('input[type="text"]');
if(textInput) {
textInput.addEventListener('input', function() {
const el = document.getElementById('save_custom_text');
if (el) el.value = this.value;
});
}
});

/* Le loader plein écran ne doit PAS se lancer automatiquement au chargement.
   Il est réservé aux vraies actions panier via showCustomizerCartLoader(). */

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    var canvasVar = window.canvas || window.fabricCanvas;
    if (canvasVar) {
      canvasVar.on('object:added', function(e) {
        var obj = e.target;
        if (obj && obj.selectable === false) return;
        if (!obj) return;
        if (obj.type === 'image' || obj.type === 'text' || obj.type === 'i-text') {
          var canvasW = canvasVar.width;
          if (obj.getScaledWidth && obj.getScaledWidth() > canvasW * 0.6) {
            var newScale = (canvasW * 0.6) / obj.width;
            obj.scale(newScale);
            canvasVar.centerObject(obj);
            obj.setCoords();
            canvasVar.requestRenderAll();
          }
        }
      });
    }
  }, 2000);
});


// ============================================================
// LANDSCAPE DETECTION (JS)
// ============================================================
(function() {
  function checkLandscape() {
    var warning = document.getElementById('landscape-warning');
    if (!warning) return;
    var isLandscape = window.innerWidth > window.innerHeight;
    var isMobile = window.innerWidth <= 1024;
    if (isLandscape && isMobile) {
      warning.style.display = 'flex';
    } else {
      warning.style.display = 'none';
    }
  }
  window.addEventListener('resize', checkLandscape);
  window.addEventListener('orientationchange', function() {
    setTimeout(checkLandscape, 200);
  });
  // Check initial
  setTimeout(checkLandscape, 500);
})();


// ============================================================
// ÉTAT DES BOUTONS : quantité et limites de la zone imprimable
// ============================================================
(function() {
  function updateAllCartButtons() {
    var qty = Object.values(window.sizeQuantities || {}).reduce(function(sum, q) {
      return sum + (parseInt(q, 10) || 0);
    }, 0);
    var buttons = [
      document.getElementById('addToCartMainBtn'),
      document.getElementById('addToCartFinal'),
      document.getElementById('goToCartFromSizes')
    ].filter(Boolean);
    buttons.forEach(function(btn) {
      if (btn.dataset && btn.dataset.ozOobBlocked === '1') return;
      btn.disabled = qty <= 0;
      btn.style.opacity = '';
    });
    // Le choix des tailles est toujours accessible, même sans marquage.
    var sizesBtn = document.getElementById('selectSizesBtn');
    if (sizesBtn) {
      sizesBtn.disabled = false;
      sizesBtn.style.opacity = '';
      sizesBtn.title = '';
    }
    if (typeof window.__ozApplyCartEligibilityUI === 'function') {
      window.__ozApplyCartEligibilityUI();
    }
  }
  
  // Observer les changements dans les design-areas
  var observer = new MutationObserver(function() {
    updateAllCartButtons();
  });
  
  setTimeout(function() {
    var areas = document.querySelectorAll('.design-area');
    areas.forEach(function(area) {
      observer.observe(area, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    updateAllCartButtons();
  }, 1000);
  
  // Exposer pour appel externe
  window.__ozUpdateCartButtons = updateAllCartButtons;
})();

/* ==========================================================
   AUTO-UPDATE PRIX LIVE — observe les design-areas + technique
   ========================================================== */
(function() {
  var _priceUpdateTimer = null;
  var _isUpdatingPrice = false;

  function debouncedPriceUpdate() {
    if (_isUpdatingPrice) return;
    clearTimeout(_priceUpdateTimer);
    _priceUpdateTimer = setTimeout(function() {
      _isUpdatingPrice = true;
      try {
        if (typeof updatePriceLiveBlock === 'function') updatePriceLiveBlock();
      } catch(e) {}
      _isUpdatingPrice = false;
    }, 300);
  }

  var priceObserver = new MutationObserver(function(mutations) {
    var dominated = mutations.every(function(m) {
      var t = m.target;
      if (!t) return true;
      if (t.classList && t.classList.contains('di-size-badge')) return true;
      if (t.parentElement && t.parentElement.classList && t.parentElement.classList.contains('di-size-badge')) return true;
      return false;
    });
    if (dominated) return;
    debouncedPriceUpdate();
  });

  setTimeout(function() {
    document.querySelectorAll('.design-area').forEach(function(area) {
      priceObserver.observe(area, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    });

    document.querySelectorAll('.technique-card, .mobile-technique-card').forEach(function(card) {
      card.addEventListener('click', function() {
        setTimeout(debouncedPriceUpdate, 150);
      });
    });

    debouncedPriceUpdate();
  }, 1500);
})();

function refreshSizingAndPrice() {
  try { updateAllSizeBadges(); } catch (e) {}
  try {
    if (typeof window.updatePriceLiveBlock === 'function') window.updatePriceLiveBlock();
  } catch (e) {}
}

function bindTextSizeControl() {
  const controls = document.querySelectorAll(
    '#text-size-control, .text-size-control, [data-text-size-control], [name="text-size-control"]'
  );

  controls.forEach((el) => {
    ['input', 'change', 'mouseup', 'touchend'].forEach((evt) => {
      el.addEventListener(evt, () => {
        // on laisse le temps au DOM/canvas d'appliquer la nouvelle taille
        requestAnimationFrame(() => refreshSizingAndPrice());
      });
    });
  });
}

// lance au chargement
document.addEventListener('DOMContentLoaded', () => {
  bindTextSizeControl();
  refreshSizingAndPrice();
});

['pointerup', 'mouseup', 'touchend'].forEach((evt) => {
  document.addEventListener(evt, () => requestAnimationFrame(refreshSizingAndPrice));
});

/* ===== Oazar Smart Templates — integrated runtime ===== */
(function () {
  'use strict';

  var TEMPLATE_DATA_SCRIPT_ID = 'smart-templates-data';
  var SLOT_OPTIONS_DATA_SCRIPT_ID = 'smart-template-slot-options-data';
  var MODAL_ID = 'ozSmartTemplateModal';
  var templateCache = new Map();
  var optionMarkupCache = new Map();

  var runtime = {
    templates: [],
    slotOptions: [],
    modal: null,
    list: null,
    search: null,
    editor: null,
    preview: null,
    controls: null,
    title: null,
    subtitle: null,
    applyBtn: null,
    cancelBtn: null,
    changeBtn: null,
    activeTemplate: null,
    activeMarkup: '',
    activeMeta: null,
    activeState: null,
    editingItem: null,
    incomingStarter: false,
    openEditorAfterInsert: false,
    incomingLiveItem: null,
    incomingInsertPending: false,
    incomingLibraryExpanded: false,
    forcedView: '',
    previewDebounce: null,
    liveFinalizeTimer: null,
    aiImageRuns: Object.create(null),
    aiImageSources: Object.create(null),
    aiImageSession: 0,
    aiHistory: [],
    aiHistoryLoaded: false,
    imageRatioJobs: Object.create(null),
    editorState: {
      openGroups: {},
      scrollTop: 0
    },
    initialized: false,
    mobileCompact: false
  };

  function isSmartTplPhoneViewport() {
    try {
      return window.matchMedia('(max-width: 768px)').matches;
    } catch (e) {
      return window.innerWidth <= 768;
    }
  }

  function syncMobileCompactState() {
    if (!runtime.modal) return;
    var hasSelection = !!(runtime.activeTemplate && runtime.activeTemplate.id);
    var shouldCompact = !!(runtime.mobileCompact && hasSelection && isSmartTplPhoneViewport());
    runtime.modal.classList.toggle('oz-smarttpl-mobile-compact', shouldCompact);
    runtime.modal.classList.toggle('oz-smarttpl-has-selection', hasSelection);
    if (runtime.changeBtn) {
      var showChange = shouldCompact || runtime.incomingStarter;
      runtime.changeBtn.hidden = !showChange;
      runtime.changeBtn.setAttribute('aria-hidden', showChange ? 'false' : 'true');
    }
  }

  function syncIncomingStarterPresentation() {
    if (!runtime.modal) return;
    var svgEditor = !!(runtime.activeTemplate && runtime.activeTemplate.sourceKind === 'svg');
    var productEditor = svgEditor || !!(runtime.incomingStarter && !runtime.incomingLibraryExpanded);
    runtime.modal.classList.toggle('oz-smarttpl-product-editor', productEditor);
    runtime.modal.classList.toggle('oz-smarttpl-library-open', !svgEditor && !!(runtime.incomingStarter && runtime.incomingLibraryExpanded));
    if (runtime.changeBtn) {
      var showChange = !svgEditor && !!runtime.incomingStarter;
      runtime.changeBtn.hidden = !showChange;
      runtime.changeBtn.setAttribute('aria-hidden', showChange ? 'false' : 'true');
      if (showChange) runtime.changeBtn.textContent = runtime.incomingLibraryExpanded ? 'Retour aux réglages' : 'Changer de design';
    }
    if (runtime.cancelBtn) runtime.cancelBtn.textContent = productEditor ? 'Fermer' : 'Annuler';
  }

  function setMobileCompactState(nextValue) {
    runtime.mobileCompact = !!nextValue;
    syncMobileCompactState();
  }

  function notify(message, type, title, duration) {
    if (typeof window.showNotification === 'function') {
      window.showNotification(message, type || 'info', title, duration);
      return;
    }
    try { window.alert(message); } catch (e) {}
  }

  function safeJsonParse(text, fallback) {
    try { return JSON.parse(text); } catch (e) { return fallback; }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'template';
  }

  function uniqueByKey(arr, key) {
    var seen = new Set();
    return (arr || []).filter(function (item) {
      var val = item && item[key];
      if (!val || seen.has(val)) return false;
      seen.add(val);
      return true;
    });
  }

  function parseList(value) {
    if (Array.isArray(value)) {
      return value.map(function (entry) { return String(entry || '').trim(); }).filter(Boolean);
    }
    return String(value || '')
      .split(/[\n,]/)
      .map(function (entry) { return entry.trim(); })
      .filter(Boolean);
  }

  function parseColorList(value) {
    return parseList(value).map(function (entry) {
      return entry.replace(/\s+/g, '');
    }).filter(Boolean);
  }

  function normalizeTemplateKey(value, fallback) {
    var raw = String(value || '').trim();
    return raw ? slugify(raw) : slugify(fallback || '');
  }

  function currentViewName() {
    return String(window.currentView || 'front').trim().toLowerCase();
  }

  function getCurrentTechnique() {
    return String(window.currentTechnique || 'impression').trim().toLowerCase();
  }

  function templateMatchesTechnique(template) {
    var technique = String((template && template.technique) || 'both').trim().toLowerCase();
    if (technique === 'both') return true;
    return technique === getCurrentTechnique();
  }

  function fileToDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () { resolve(String(reader.result || '')); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function decodeSvgDataUri(uri) {
    var value = String(uri || '');
    if (!value.startsWith('data:image/svg+xml')) return '';
    var commaIndex = value.indexOf(',');
    if (commaIndex === -1) return '';
    var meta = value.slice(0, commaIndex);
    var data = value.slice(commaIndex + 1);
    try {
      if (/;base64/i.test(meta)) return window.atob(data);
      return decodeURIComponent(data);
    } catch (e) {
      return '';
    }
  }

  var imagesEmbarquees = new Map();

  /*
   * Un SVG servi en data-URI dans une balise <img> est isole : le navigateur
   * refuse d'y charger la moindre ressource externe. Toute photo referencee
   * par une URL http s'affiche donc en image cassee sur le vetement, alors
   * qu'elle s'affiche tres bien dans le panneau, ou c'est un <img> normal.
   * On rapatrie donc chaque photo en base64 avant serialisation.
   */
  function urlVersDataUri(url) {
    if (imagesEmbarquees.has(url)) return imagesEmbarquees.get(url);

    var job = fetch(url, { mode: 'cors', credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.blob();
      })
      .then(reduirePuisEncoder)
      .catch(function (e) {
        /* Un echec ne doit pas etre memorise : sinon une erreur passagere,
           ou un en-tete CORS corrige entre-temps sur le serveur, resterait
           bloquante jusqu'au rechargement complet de la page. On oublie
           l'entree pour que la tentative suivante reparte de zero. */
        imagesEmbarquees.delete(url);
        console.warn('[oazar] image non rapatriee : ' + url, e);
        return url;
      });

    imagesEmbarquees.set(url, job);
    return job;
  }

  /*
   * Une photo de telephone fait 3 a 5 Mo. Encodee en base64 elle grossit
   * encore d'un tiers, et le data-URI du SVG doit etre reparse par le
   * navigateur a chaque frappe au clavier : c'est la source des a-coups.
   * On plafonne donc le cote long a 900 px, largement suffisant pour un
   * visuel qui s'affiche a 300 px dans le SVG.
   */
  var COTE_MAX = 900;

  function reduirePuisEncoder(blob) {
    return new Promise(function (resolve) {
      var lecteur = new FileReader();
      lecteur.onerror = function () { resolve(''); };
      lecteur.onload = function () {
        var original = String(lecteur.result || '');

        /* Le SVG et le GIF anime ne survivent pas a un passage par canvas. */
        if (/^data:image\/(svg|gif)/i.test(original)) return resolve(original);

        var img = new Image();
        img.onerror = function () { resolve(original); };
        img.onload = function () {
          var cote = Math.max(img.naturalWidth, img.naturalHeight);
          if (!cote || cote <= COTE_MAX) return resolve(original);

          var ratio = COTE_MAX / cote;
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(img.naturalWidth * ratio);
          canvas.height = Math.round(img.naturalHeight * ratio);

          try {
            canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
            /* PNG impose : le detourage IA rend un fond transparent. */
            resolve(canvas.toDataURL('image/png'));
          } catch (e) {
            resolve(original);
          }
        };
        img.src = original;
      };
      lecteur.readAsDataURL(blob);
    });
  }

  function embarquerImages(markup) {
    /* Test bon marche avant d'engager un parse XML du document entier :
       a chaque frappe au clavier, ce raccourci evite tout le travail. */
    if (!/(?:xlink:)?href\s*=\s*["']https?:/i.test(String(markup || ''))) {
      return Promise.resolve(markup);
    }

    var doc;

    try {
      doc = parseSvg(markup);
    } catch (e) {
      return Promise.resolve(markup);
    }

    var svg = doc.documentElement;
    var XLINK = 'http://www.w3.org/1999/xlink';

    var cibles = Array.prototype.slice.call(svg.querySelectorAll('image')).map(function (el) {
      return {
        el: el,
        url: String(el.getAttribute('href') || el.getAttributeNS(XLINK, 'href') || '').trim()
      };
    }).filter(function (c) {
      return /^https?:\/\//i.test(c.url);
    });

    if (!cibles.length) return Promise.resolve(markup);

    return Promise.all(cibles.map(function (c) {
      return urlVersDataUri(c.url).then(function (dataUri) {
        c.el.setAttribute('href', dataUri);
        c.el.setAttributeNS(XLINK, 'xlink:href', dataUri);
      });
    })).then(function () {
      return new XMLSerializer().serializeToString(doc);
    }).catch(function () {
      return markup;
    });
  }

  /*
   * La modale est montee sur <body>, donc hors de #mon-customizer que le
   * voile de chargement masque. Une regle CSS peut la couvrir, mais elle
   * vit dans la section Liquid : tant que ce fichier n'est pas redeploye,
   * la modale reste visible. Un style inline pose ici ne depend d'aucun
   * fichier externe et l'emporte sur toute feuille.
   */
  function masquerPendantChargement(el) {
    var racine = document.documentElement;
    if (!el || (!racine.classList.contains('customizer-booting') && !racine.classList.contains('oz-drawers-locked'))) return;

    el.style.visibility = 'hidden';

    var rendre = function () {
      el.style.visibility = '';
    };

    if (typeof MutationObserver === 'function') {
      var obs = new MutationObserver(function () {
        if (racine.classList.contains('customizer-booting') || racine.classList.contains('oz-drawers-locked')) return;
        rendre();
        obs.disconnect();
      });
      obs.observe(racine, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function svgMarkupToDataUri(markup) {
    var encoded = encodeURIComponent(String(markup || ''))
      .replace(/%0A/g, '')
      .replace(/%20/g, ' ');
    return 'data:image/svg+xml;charset=utf-8,' + encoded;
  }

  function parseSvg(markup) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(String(markup || ''), 'image/svg+xml');
    var parserError = doc.querySelector('parsererror');
    if (parserError) {
      /* Le navigateur decrit precisement la faute — ligne, colonne,
         entite non reconnue. La masquer derriere « SVG invalide »
         obligeait a chercher a l'aveugle. */
      var detail = String(parserError.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 220);

      console.error('[modele] SVG rejete par le parseur :', detail);
      console.error('[modele] debut du balisage recu :', String(markup || '').slice(0, 300));

      throw new Error('SVG invalide' + (detail ? ' — ' + detail : '.'));
    }

    var svg = doc.documentElement;
    if (!svg || svg.nodeName.toLowerCase() !== 'svg') {
      throw new Error('Le modèle doit être un fichier SVG.');
    }

    if (!svg.getAttribute('xmlns')) svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    if (!svg.getAttribute('xmlns:xlink')) svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');

    /*
      IMPORTANT : DOMParser(..., 'image/svg+xml') lit le SVG comme du XML.
      En XML, "viewbox" et "viewBox" sont deux attributs différents.
      On corrige donc l'ancien "viewbox" sur le SVG racine ET sur tous les
      SVG imbriqués, avant tout calcul de taille ou de rendu.
    */
    [svg].concat(Array.prototype.slice.call(svg.querySelectorAll('svg'))).forEach(function (node) {
      var legacyViewBox = node.getAttribute('viewbox');

      if (!node.getAttribute('viewBox') && legacyViewBox) {
        node.setAttribute('viewBox', legacyViewBox);
      }

      if (node.hasAttribute('viewbox')) {
        node.removeAttribute('viewbox');
      }

      if (!node.getAttribute('preserveAspectRatio')) {
        node.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      }
    });

    if (!svg.getAttribute('viewBox')) {
      var width = parseFloat(svg.getAttribute('width') || '1200') || 1200;
      var height = parseFloat(svg.getAttribute('height') || '1200') || 1200;
      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
    }

    return doc;
  }

  function parseSvgFragment(markup) {
    var clean = String(markup || '').trim();
    if (!clean) return null;
    var wrapped = /^<svg[\s>]/i.test(clean)
      ? clean
      : '<svg xmlns="http://www.w3.org/2000/svg">' + clean + '</svg>';
    return parseSvg(wrapped);
  }

  function guessAssetKind(url, forcedMode) {
    var mode = String(forcedMode || '').trim().toLowerCase();
    if (mode === 'image') return 'image';
    if (mode === 'svg') return 'svg';
    var clean = String(url || '').split('?')[0].split('#')[0].trim().toLowerCase();
    if (!clean) return 'svg';
    if (/\.svg$/i.test(clean) || clean.indexOf('image/svg+xml') !== -1) return 'svg';
    return 'image';
  }

  function buildImageWrapperSvg(url) {
    var href = String(url || '').trim();
    return [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" data-oz-generated-from="image">',
      '<image href="', escapeHtml(href), '" x="0" y="0" width="1000" height="1000" preserveAspectRatio="xMidYMid meet" />',
      '</svg>'
    ].join('');
  }


  function deepCloneJson(value, fallback) {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (e) {
      return fallback;
    }
  }

  function parseObjectLike(value, fallback) {
    var safeFallback = (fallback && typeof fallback === 'object' && !Array.isArray(fallback))
      ? deepCloneJson(fallback, {})
      : {};
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return deepCloneJson(value, safeFallback);
    }
    var text = String(value == null ? '' : value).trim();
    if (!text) return safeFallback;
    try {
      var parsed = JSON.parse(text);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return parsed;
      }
    } catch (e) {}
    return safeFallback;
  }

  function mergePlainObjects(base, extra) {
    var out = deepCloneJson(base || {}, {});
    if (!extra || typeof extra !== 'object' || Array.isArray(extra)) return out;
    Object.keys(extra).forEach(function (key) {
      var extraValue = extra[key];
      var baseValue = out[key];
      if (extraValue && typeof extraValue === 'object' && !Array.isArray(extraValue)) {
        out[key] = mergePlainObjects(baseValue && typeof baseValue === 'object' ? baseValue : {}, extraValue);
        return;
      }
      out[key] = deepCloneJson(extraValue, extraValue);
    });
    return out;
  }

  function normalizeTemplateDefinition(item, context) {
    if (!item || typeof item !== 'object') return null;
    var ctx = context || {};
    var fallbackKey = item.template_key || item.key || item.id || item.title || ctx.fallbackKey || 'modele';
    var defaultState = parseObjectLike(
      item.default_state_json != null ? item.default_state_json : item.default_state,
      {}
    );

    var template = {
      id: String(item.id || '').trim(),
      key: normalizeTemplateKey(item.template_key || item.key, fallbackKey),
      title: String(item.title || 'Modèle').trim(),
      description: String(item.description || '').trim(),
      technique: String(item.technique || 'both').trim().toLowerCase(),
      preview: item.preview || '',
      mode: String(item.template_mode || item.mode || 'auto').trim().toLowerCase(),
      tags: parseList(item.tags),
      defaultView: String(item.default_view || item.defaultView || 'front').trim().toLowerCase(),
      productScope: String(item.product_scope || item.productScope || 'all').trim().toLowerCase(),
      allowedProducts: parseList(item.allowed_products || item.allowedProducts),
      assetImage: String(item.asset_image || item.assetImage || '').trim(),
      assetUrl: String(item.asset_url || item.assetUrl || '').trim(),
      svgUrl: String(item.svg || item.svg_url || '').trim(),
      svgMarkup: String(item.svg_markup || item.svgMarkup || '').trim(),
      presetColors: parseColorList(item.preset_colors || item.presetColors),
      defaultState: (defaultState && typeof defaultState === 'object') ? defaultState : {},
      designCategoryId: String(
        item.design_category_id ||
        item.designCategoryId ||
        item.category_id ||
        item.categoryId ||
        ctx.categoryId ||
        ''
      ).trim(),
      designCategoryTitle: String(
        item.design_category_title ||
        item.designCategoryTitle ||
        item.category_title ||
        item.categoryTitle ||
        item.design_category ||
        item.category ||
        ctx.categoryTitle ||
        ''
      ).trim(),
      designCategoryTags: parseList(
        item.design_category_tags ||
        item.designCategoryTags ||
        ctx.categoryTags ||
        []
      ),
      librarySort: parseInt(item.library_sort || item.sort || ctx.sort || '0', 10) || 0,
      hiddenFromDesigns: !!(item.hidden_from_designs || item.hiddenFromDesigns),
      hasExplicitShowInDesigns: ('show_in_designs' in item || 'showInDesigns' in item || 'place_in_designs' in item || 'placeInDesigns' in item),
      showInDesigns: ('show_in_designs' in item || 'showInDesigns' in item || 'place_in_designs' in item || 'placeInDesigns' in item)
        ? (('show_in_designs' in item) ? !!item.show_in_designs
          : ('showInDesigns' in item) ? !!item.showInDesigns
          : ('place_in_designs' in item) ? !!item.place_in_designs
          : !!item.placeInDesigns)
        : false,
      libraryPreview: String(
        item.library_preview ||
        item.libraryPreview ||
        item.card_preview ||
        item.cardPreview ||
        item.preview ||
        ''
      ).trim(),
      designItemId: String(item.design_item_id || item.designItemId || ctx.designItemId || '').trim()
    };

    if (template.designCategoryTitle && !template.designCategoryId) {
      template.designCategoryId = slugify(template.designCategoryTitle);
    }
    if (template.designCategoryId && !template.designCategoryTitle) {
      template.designCategoryTitle = String(template.designCategoryId).replace(/[-_]+/g, ' ').trim();
    }
    if (!template.hasExplicitShowInDesigns && !template.showInDesigns) {
      template.showInDesigns = !!(template.designCategoryId || template.designCategoryTitle || template.designItemId);
    }

    template.mediaUrl = template.assetImage || template.assetUrl || template.svgUrl || '';
    template.sourceKind = template.svgMarkup ? 'svg' : guessAssetKind(template.mediaUrl, template.mode);

    if (!template.id) return null;
    if (!(template.svgMarkup || template.svgUrl || template.assetImage || template.assetUrl)) return null;
    return template;
  }

  function mergeTemplateDefinitions(baseTemplate, extraTemplate) {
    if (!baseTemplate) return extraTemplate;
    if (!extraTemplate) return baseTemplate;
    var merged = Object.assign({}, baseTemplate, extraTemplate);
    merged.tags = uniqueByKey(
      (baseTemplate.tags || []).concat(extraTemplate.tags || []).map(function (tag) {
        return { value: String(tag || '').trim() };
      }).filter(function (entry) { return entry.value; }),
      'value'
    ).map(function (entry) { return entry.value; });
    merged.allowedProducts = uniqueByKey(
      (baseTemplate.allowedProducts || []).concat(extraTemplate.allowedProducts || []).map(function (handle) {
        return { value: String(handle || '').trim() };
      }).filter(function (entry) { return entry.value; }),
      'value'
    ).map(function (entry) { return entry.value; });
    merged.designCategoryTags = uniqueByKey(
      (baseTemplate.designCategoryTags || []).concat(extraTemplate.designCategoryTags || []).map(function (tag) {
        return { value: String(tag || '').trim() };
      }).filter(function (entry) { return entry.value; }),
      'value'
    ).map(function (entry) { return entry.value; });
    merged.defaultState = mergePlainObjects(baseTemplate.defaultState || {}, extraTemplate.defaultState || {});
    return merged;
  }

  function buildTemplateContextFromCategory(category, rawItem, index) {
    return {
      categoryId: String((category && category.id) || (rawItem && rawItem.category_id) || '').trim(),
      categoryTitle: String((category && category.title) || (rawItem && rawItem.category_title) || '').trim(),
      categoryTags: parseList((category && category.tags) || (rawItem && rawItem.category_tags) || []),
      sort: parseInt((rawItem && rawItem.sort) || index || '0', 10) || 0,
      designItemId: String((rawItem && rawItem.id) || '').trim()
    };
  }

  function normalizeSmartLibraryItem(item, category, index) {
    if (!item || typeof item !== 'object') return null;
    var context = buildTemplateContextFromCategory(category, item, index);
    var normalized = Object.assign({}, item);
    normalized.id = String(normalized.id || [context.categoryId || 'design', index || 0].join('__')).trim();
    normalized.type = String(normalized.type || normalized.kind || '').trim().toLowerCase();
    normalized.tags = parseList(normalized.tags);
    normalized.title = String(normalized.title || normalized.name || normalized.label || '').trim();
    normalized.description = String(normalized.description || '').trim();
    normalized.preview = String(
      normalized.preview ||
      normalized.thumbnail ||
      normalized.card_preview ||
      normalized.src ||
      ''
    ).trim();
    normalized.templateId = String(normalized.templateId || normalized.template_id || '').trim();
    normalized.templateKey = String(normalized.templateKey || normalized.template_key || '').trim();
    normalized.isSmartTemplate = !!(
      normalized.isSmartTemplate ||
      normalized.smartTemplate ||
      normalized.smart_template ||
      normalized.template ||
      normalized.templateId ||
      normalized.template_id ||
      normalized.templateKey ||
      normalized.template_key ||
      normalized.type === 'smart-template' ||
      normalized.type === 'smart_template'
    );

    var inlineTemplateSource = null;
    if (normalized.template && typeof normalized.template === 'object' && !Array.isArray(normalized.template)) {
      inlineTemplateSource = mergePlainObjects(normalized.template, {
        title: normalized.title || normalized.template.title || normalized.template.label || '',
        description: normalized.description || normalized.template.description || '',
        preview: normalized.preview || normalized.template.preview || '',
        design_item_id: normalized.id
      });
    } else if (
      normalized.isSmartTemplate &&
      (normalized.svg_markup || normalized.svgMarkup || normalized.svg_url || normalized.svg || normalized.asset_image || normalized.asset_url)
    ) {
      inlineTemplateSource = mergePlainObjects(normalized, { design_item_id: normalized.id });
    }

    if (inlineTemplateSource) {
      normalized.inlineTemplate = normalizeTemplateDefinition(inlineTemplateSource, context);
      if (normalized.inlineTemplate) {
        normalized.templateId = normalized.templateId || normalized.inlineTemplate.id;
        normalized.templateKey = normalized.templateKey || normalized.inlineTemplate.key;
        normalized.title = normalized.title || normalized.inlineTemplate.title;
        normalized.description = normalized.description || normalized.inlineTemplate.description;
        normalized.preview = normalized.preview || normalized.inlineTemplate.libraryPreview || normalized.inlineTemplate.preview || '';
        normalized.tags = uniqueByKey(
          normalized.tags.concat(normalized.inlineTemplate.tags || []).map(function (tag) {
            return { value: String(tag || '').trim() };
          }).filter(function (entry) { return entry.value; }),
          'value'
        ).map(function (entry) { return entry.value; });
      }
    }

    return normalized;
  }

  function readTemplatesFromDesignLibrary() {
    var cats = (typeof designLibrary !== 'undefined' && designLibrary && Array.isArray(designLibrary.categories))
      ? designLibrary.categories
      : [];
    var templates = [];
    cats.forEach(function (category, catIndex) {
      var items = Array.isArray(category && category.items) ? category.items : [];
      items.forEach(function (rawItem, itemIndex) {
        var normalizedItem = normalizeSmartLibraryItem(rawItem, category || {}, catIndex * 1000 + itemIndex);
        if (normalizedItem && normalizedItem.inlineTemplate) {
          templates.push(normalizedItem.inlineTemplate);
        }
      });
    });
    return templates;
  }

  var incomingProductTemplate = null;
  function readTemplatesFromDom() {
    var node = document.getElementById(TEMPLATE_DATA_SCRIPT_ID);
    var parsed = node ? safeJsonParse(node.textContent || '{}', {}) : {};
    var list = Array.isArray(parsed.templates) ? parsed.templates : [];

    var domTemplates = list.map(function (item) {
      return normalizeTemplateDefinition(item, {});
    }).filter(Boolean);

    var combined = domTemplates.concat(readTemplatesFromDesignLibrary());
    try {
      var incoming = safeJsonParse(sessionStorage.getItem('oazar_customizer_context') || '{}', {});
      var inline = incoming && incoming.inlineTemplate;
      var expectedHandle = String(new URLSearchParams(location.search).get('design_product') || '').trim();
      var currentAge = Date.now() - Number(incoming.timestamp || 0);
      if (inline && incoming.designProductHandle === expectedHandle && currentAge >= 0 && currentAge < 30 * 60 * 1000) {
        incomingProductTemplate = normalizeTemplateDefinition(inline, {});
      }
    } catch (error) {}
    if (incomingProductTemplate) combined.push(incomingProductTemplate);
    var map = new Map();

    combined.forEach(function (template) {
      var existing = map.get(template.id);
      map.set(template.id, existing ? mergeTemplateDefinitions(existing, template) : template);
    });

    return Array.from(map.values());
  }


function readSlotOptionsFromDom() {
  var node = document.getElementById(SLOT_OPTIONS_DATA_SCRIPT_ID);
  if (!node) return [];

  var parsed = safeJsonParse(node.textContent || '{}', {});
  var list = Array.isArray(parsed.options) ? parsed.options : [];

  return list.map(function (raw, index) {
    var templateKey = normalizeTemplateKey(raw.template_key || raw.templateKey, raw.template_id || raw.templateId || 'template');
    var slotKey = normalizeTemplateKey(raw.slot_key || raw.slotKey, 'slot');
    var optionValue = normalizeTemplateKey(raw.option_value || raw.optionValue || raw.value || raw.label || ('option-' + index), 'option-' + index);

    var item = {
      id: String(raw.id || [templateKey, slotKey, optionValue].join('__')).trim(),
      templateKey: templateKey,
      templateId: String(raw.template_id || raw.templateId || '').trim(),
      slotKey: slotKey,
      slotLabel: String(raw.slot_label || raw.slotLabel || slotKey).trim(),
      value: optionValue,
      label: String(raw.option_label || raw.optionLabel || raw.label || optionValue).trim(),
      preview: String(raw.preview || '').trim(),
      mode: String(raw.option_mode || raw.mode || 'auto').trim().toLowerCase(),
      assetImage: String(raw.asset_image || raw.assetImage || '').trim(),
      assetUrl: String(raw.asset_url || raw.assetUrl || '').trim(),
      svgUrl: String(raw.svg || raw.svg_url || '').trim(),
      svgMarkup: String(raw.svg_markup || raw.svgMarkup || '').trim(),
      isDefault: !!raw.is_default,
      tags: parseList(raw.tags),
      sort: parseInt(raw.sort || index, 10) || index
    };

    item.mediaUrl = item.assetImage || item.assetUrl || item.svgUrl || '';
    item.sourceKind = item.svgMarkup ? 'svg' : guessAssetKind(item.mediaUrl, item.mode);

    return item;
  }).filter(function (item) {
    return item.templateKey && item.slotKey && item.value && (item.svgMarkup || item.svgUrl || item.assetImage || item.assetUrl);
  }).sort(function (a, b) {
    return a.sort - b.sort;
  });
}

  function getTemplateById(templateId) {
    var id = String(templateId || '').trim();
    return runtime.templates.find(function (template) { return template.id === id; }) || null;
  }

  function getTemplateByKey(templateKey) {
    var key = normalizeTemplateKey(templateKey, templateKey || 'template');
    return runtime.templates.find(function (template) { return template.key === key; }) || null;
  }

  /*
   * Les modèles SVG/images intelligents proviennent uniquement des blocs Shopify
   * « 🧠 Modèle intelligent ». Aucun modèle (EVG compris) n’est injecté en dur.
   */
  function refreshCatalog() {
    runtime.templates = readTemplatesFromDom();
    runtime.slotOptions = readSlotOptionsFromDom();
    return runtime.templates;
  }

  function getTemplateCardPreview(template) {
    if (!template) return '';
    if (template.libraryPreview) return template.libraryPreview;
    if (template.preview) return template.preview;
    if (template.sourceKind === 'image' && template.mediaUrl) return template.mediaUrl;
    if (template.svgMarkup) {
      try {
        var previewMarkup = String(template.svgMarkup).replace(/<!--[\s\S]*?-->/g, '');
        previewMarkup = previewMarkup
          .replace(/<\?xml[^>]*\?>/i, '')
          .replace(/<metadata\b[^>]*>[\s\S]*?<\/metadata>/gi, '')
          .replace(/\bviewbox=/gi, 'viewBox=')
          .replace(/\bpreserveaspectratio=/gi, 'preserveAspectRatio=');
        return svgMarkupToDataUri(previewMarkup);
      } catch (e) {}
    }
    return template.svgUrl || template.mediaUrl || '';
  }

  function buildSmartLibraryItemFromTemplate(template) {
    return {
      id: template.designItemId || [template.id, 'library'].join('__'),
      type: 'smart-template',
      isSmartTemplate: true,
      smartTemplate: true,
      templateId: template.id,
      templateKey: template.key,
      title: template.title,
      description: template.description,
      preview: getTemplateCardPreview(template),
      svgMarkup: template.svgMarkup || '',
      tags: (template.tags || []).slice(),
      technique: template.technique || 'both',
      sort: template.librarySort || 0
    };
  }

  function getDesignCategoriesForDrawer(techOverride, sourceLibrary) {
    refreshCatalog();
    var tech = String(techOverride || getCurrentTechnique() || 'impression').trim().toLowerCase();
    var source = sourceLibrary && Array.isArray(sourceLibrary.categories)
      ? sourceLibrary
      : ((typeof designLibrary !== 'undefined' && designLibrary && Array.isArray(designLibrary.categories)) ? designLibrary : { categories: [] });

    var categories = [];
    var categoryMap = new Map();

    function ensureCategory(catLike, fallbackId, fallbackTitle, fallbackTags) {
      var id = String((catLike && catLike.id) || fallbackId || '').trim() || 'designs-personnalisables';
      if (categoryMap.has(id)) return categoryMap.get(id);
      var category = {
        id: id,
        title: String((catLike && catLike.title) || fallbackTitle || 'Designs personnalisables').trim(),
        tags: parseList((catLike && catLike.tags) || fallbackTags || []),
        technique: String((catLike && catLike.technique) || 'both').trim().toLowerCase(),
        items: []
      };
      categories.push(category);
      categoryMap.set(id, category);
      return category;
    }

    (source.categories || []).forEach(function (rawCategory, catIndex) {
      if (!isCategoryVisibleForTechnique(rawCategory, tech)) return;
      var category = ensureCategory(rawCategory, rawCategory && rawCategory.id, rawCategory && rawCategory.title, rawCategory && rawCategory.tags);
      var items = Array.isArray(rawCategory && rawCategory.items) ? rawCategory.items : [];
      items.forEach(function (rawItem, itemIndex) {
        if (!rawItem || typeof rawItem !== 'object') return;

        var normalizedSmartItem = normalizeSmartLibraryItem(rawItem, rawCategory || {}, catIndex * 1000 + itemIndex);
        if (normalizedSmartItem && normalizedSmartItem.isSmartTemplate) {
          var template = null;
          if (normalizedSmartItem.templateId) template = getTemplateById(normalizedSmartItem.templateId);
          if (!template && normalizedSmartItem.templateKey) template = getTemplateByKey(normalizedSmartItem.templateKey);
          if (!template && normalizedSmartItem.inlineTemplate) template = normalizedSmartItem.inlineTemplate;
          if (!template) return;
          if (!templateMatchesTechnique(template) || !templateMatchesCurrentProduct(template)) return;
          normalizedSmartItem.templateId = template.id;
          normalizedSmartItem.templateKey = template.key;
          normalizedSmartItem.title = normalizedSmartItem.title || template.title;
          normalizedSmartItem.description = normalizedSmartItem.description || template.description;
          normalizedSmartItem.preview = normalizedSmartItem.preview || getTemplateCardPreview(template);
          normalizedSmartItem.svgMarkup = template.svgMarkup || normalizedSmartItem.svgMarkup || '';
          normalizedSmartItem.tags = uniqueByKey(
            (normalizedSmartItem.tags || []).concat(template.tags || []).map(function (tag) {
              return { value: String(tag || '').trim() };
            }).filter(function (entry) { return entry.value; }),
            'value'
          ).map(function (entry) { return entry.value; });
          category.items.push(normalizedSmartItem);
          return;
        }

        var itemTechnique = String(rawItem.technique || rawCategory.technique || 'both').trim().toLowerCase();
        if (itemTechnique !== 'both' && itemTechnique !== tech) return;
        category.items.push(Object.assign({}, rawItem));
      });
    });

    runtime.templates.forEach(function (template) {
      if (template.hiddenFromDesigns) return;
      if (!template.showInDesigns && !template.designCategoryId && !template.designCategoryTitle) return;
      if (!templateMatchesTechnique(template)) return;
      if (!templateMatchesCurrentProduct(template)) return;
      var category = ensureCategory(
        { id: template.designCategoryId, title: template.designCategoryTitle, tags: template.designCategoryTags, technique: template.technique || 'both' },
        template.designCategoryId,
        template.designCategoryTitle,
        template.designCategoryTags
      );
      var exists = category.items.some(function (item) {
        return String(item.templateId || item.template_id || '').trim() === template.id;
      });
      if (!exists) {
        category.items.push(buildSmartLibraryItemFromTemplate(template));
      }
    });

    categories.forEach(function (category) {
      category.items = category.items.sort(function (a, b) {
        var aSort = parseInt(a.sort || '0', 10) || 0;
        var bSort = parseInt(b.sort || '0', 10) || 0;
        if (aSort !== bSort) return aSort - bSort;
        return String(a.title || a.name || '').localeCompare(String(b.title || b.name || ''), 'fr', { sensitivity: 'base' });
      });
    });

    return categories.filter(function (category) {
      return Array.isArray(category.items) && category.items.length > 0;
    });
  }

  function openTemplateById(templateId, options) {
    refreshCatalog();
    var template = getTemplateById(templateId);
    if (!template) {
      notify('Le modèle n’est plus disponible.', 'warning');
      return false;
    }
    /* On marque la cible avant l'ouverture : openModal ne doit pas charger
       brièvement le premier modèle de la bibliothèque à sa place. */
    runtime.activeTemplate = template;
    runtime.activeMarkup = '';
    runtime.activeMeta = null;
    runtime.activeState = null;
    runtime.editingItem = (options && options.editingItem) || null;
    runtime.incomingStarter = !!(options && options.incomingStarter);
    runtime.openEditorAfterInsert = !!(options && options.openEditorAfterInsert);
    runtime.incomingLiveItem = null;
    runtime.incomingInsertPending = false;
    runtime.incomingLibraryExpanded = false;
    var waitForSvg = template.sourceKind === 'svg';
    ensureModal();
    if (waitForSvg) runtime.modal.classList.add('oz-smarttpl-waiting');
    if (runtime.incomingStarter) {
      runtime.modal.dataset.ozDeferredOpen = 'true';
      runtime.modal.style.setProperty('display', 'none', 'important');
      runtime.modal.hidden = true;
      runtime.modal.setAttribute('aria-hidden', 'true');
      setMobileCompactState(false);
      syncIncomingStarterPresentation();
      renderLibrary();
    } else {
      openModal();
    }
    if (waitForSvg) {
      runtime.modal.hidden = true;
      runtime.modal.setAttribute('aria-hidden', 'true');
    }
    var loading = selectTemplate(template.id, options || {});
    if (waitForSvg && !runtime.incomingStarter) {
      loading.then(function () {
        if (!runtime.activeTemplate || runtime.activeTemplate.id !== template.id || !runtime.activeMarkup || !runtime.activeMeta) return;
        runtime.modal.classList.remove('oz-smarttpl-waiting');
        runtime.modal.hidden = false;
        runtime.modal.setAttribute('aria-hidden', 'false');
      });
    }
    return true;
  }

  function openTemplateFromLibraryItem(item) {
    refreshCatalog();
    if (!item || typeof item !== 'object') {
      notify('Ce design est introuvable.', 'warning');
      return false;
    }
    var template = null;
    var templateId = String(item.templateId || item.template_id || '').trim();
    var templateKey = String(item.templateKey || item.template_key || '').trim();
    if (templateId) template = getTemplateById(templateId);
    if (!template && templateKey) template = getTemplateByKey(templateKey);
    if (!template && item.inlineTemplate && item.inlineTemplate.id) {
      template = getTemplateById(item.inlineTemplate.id) || item.inlineTemplate;
    }
    if (!template && item.id) {
      template = getTemplateById(String(item.id || '').trim()) || null;
    }
if (!template) {
      notify('Le modèle lié à ce design n’a pas été trouvé.', 'warning');
      return false;
    }
    return openTemplateById(template.id, {
      userInitiated: true,
      incomingStarter: true,
      openEditorAfterInsert: true
    });
  }


  function templateMatchesCurrentProduct(template) {
    if (!template) return false;
    var scope = String(template.productScope || 'all').trim().toLowerCase();
    if (scope !== 'selected') return true;
    var currentHandle = String((window.currentProduct && window.currentProduct.handle) || '').trim().toLowerCase();
    var allowed = Array.isArray(template.allowedProducts) ? template.allowedProducts.map(function (item) {
      return String(item || '').trim().toLowerCase();
    }).filter(Boolean) : [];
    if (!allowed.length) return true;
    if (!currentHandle) return false;
    return allowed.indexOf(currentHandle) !== -1;
  }

  function getCurrentProductTemplateCount() {
    return runtime.templates.filter(function (template) {
      return templateMatchesTechnique(template) && templateMatchesCurrentProduct(template);
    }).length;
  }

  function getVisibleTemplates() {
    var query = runtime.search ? String(runtime.search.value || '').trim().toLowerCase() : '';
    return runtime.templates.filter(function (template) {
      if (!templateMatchesTechnique(template)) return false;
      if (!templateMatchesCurrentProduct(template)) return false;
      if (!query) return true;
      var haystack = [
        template.title,
        template.description,
        (template.tags || []).join(' '),
        (template.allowedProducts || []).join(' ')
      ].join(' ').toLowerCase();
      return haystack.indexOf(query) !== -1;
    });
  }

  function getExternalOptionsForTemplate(template) {
    if (!template) return [];
    return runtime.slotOptions.filter(function (option) {
      return option.templateKey === template.key || (option.templateId && option.templateId === template.id);
    });
  }

  function getElementTextValue(el) {
    var tspans = Array.prototype.slice.call(el.querySelectorAll(':scope > tspan'));
    if (tspans.length > 1) {
      return tspans.map(function (tspan) { return tspan.textContent || ''; }).join('\n');
    }
    return el.textContent || '';
  }

  var SMARTTPL_TEXT_COLOR_PREFIX = '__text_color__';

  function escapeRegExp(value) {
    return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function extractInlineStyleValue(styleText, propName) {
    var style = String(styleText || '');
    if (!style || !propName) return '';
    var match = style.match(new RegExp('(?:^|;)\\s*' + escapeRegExp(propName) + '\\s*:\\s*([^;]+)', 'i'));
    return match ? String(match[1] || '').trim() : '';
  }

  function upsertInlineStyleValue(el, propName, value) {
    if (!el || !el.getAttribute || !propName) return;
    var current = String(el.getAttribute('style') || '');
    var cleaned = current
      .replace(new RegExp('(?:^|;)\\s*' + escapeRegExp(propName) + '\\s*:\\s*[^;]*;?', 'ig'), ';')
      .replace(/;;+/g, ';')
      .replace(/^;|;$/g, '')
      .trim();
    var next = (value == null || value === '')
      ? cleaned
      : (cleaned ? cleaned + ';' : '') + propName + ':' + String(value).trim();
    if (next) el.setAttribute('style', next);
    else el.removeAttribute('style');
  }

  function ozResolveSvgPaintColor(el, value) {
    var normalized = ozNormalizeHexColor(value);
    if (normalized) return normalized;
    if (String(value || '').trim().toLowerCase() !== 'currentcolor') return '';
    var ancestor = el;
    while (ancestor && ancestor.getAttribute) {
      var inherited = extractInlineStyleValue(ancestor.getAttribute('style'), 'color') || ancestor.getAttribute('color');
      normalized = ozNormalizeHexColor(inherited);
      if (normalized) return normalized;
      ancestor = ancestor.parentElement;
    }
    return '#111111';
  }

  function readSvgColorValue(el) {
    if (!el || !el.getAttribute) return '#111111';
    function ownPaint(node) {
      var style = node.getAttribute('style') || '';
      var fill = extractInlineStyleValue(style, 'fill') || String(node.getAttribute('fill') || '').trim();
      var stroke = extractInlineStyleValue(style, 'stroke') || String(node.getAttribute('stroke') || '').trim();
      var color = extractInlineStyleValue(style, 'color') || String(node.getAttribute('color') || '').trim();
      var mode = String(node.getAttribute('data-oz-color-target') || node.getAttribute('data-oz-apply') || '').trim().toLowerCase();
      var values = mode === 'stroke' ? [stroke, fill, color] : mode === 'color' ? [color, fill, stroke] : [fill, stroke, color];
      for (var i = 0; i < values.length; i++) {
        if (values[i] && values[i].toLowerCase() !== 'none') {
          var resolved = ozResolveSvgPaintColor(node, values[i]);
          if (resolved) return resolved;
        }
      }
      return '';
    }
    var direct = ownPaint(el);
    if (direct) return direct;
    // A palette key is often attached to a <g>; its visible paths carry the
    // actual colour. Reading only the group used to turn it black on reopen.
    var descendants = el.querySelectorAll('path,rect,circle,ellipse,line,polyline,polygon,text,tspan');
    for (var j = 0; j < descendants.length; j++) {
      var nestedGroup = descendants[j].closest('[data-oz-color],[data-oz-color-fill],[data-oz-color-stroke]');
      if (nestedGroup && nestedGroup !== el) continue;
      var descendantColor = ownPaint(descendants[j]);
      if (descendantColor) return descendantColor;
    }
    return '#111111';
  }

  function readSvgFontFamilyValue(el) {
    if (!el || !el.getAttribute) return '';
    var inline = extractInlineStyleValue(el.getAttribute('style'), 'font-family');
    var attr = String(el.getAttribute('font-family') || '').trim();
    var value = inline || attr || '';
    return value.replace(/^['"]+|['"]+$/g, '').trim();
  }

  function readImageAspect(source) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        var width = Number(img.naturalWidth || img.width || 0);
        var height = Number(img.naturalHeight || img.height || 0);
        if (!width || !height) return reject(new Error('Dimensions d’image introuvables.'));
        resolve(Math.max(0.05, Math.min(20, width / height)));
      };
      img.onerror = function () { reject(new Error('Impossible de mesurer l’image.')); };
      img.src = String(source || '');
    });
  }

  function ensureSmartImageAspect(slotKey, source) {
    if (!runtime.activeState || !source) return Promise.resolve(0);
    runtime.activeState.imageAspects = runtime.activeState.imageAspects || {};
    if (Number(runtime.activeState.imageAspects[slotKey]) > 0) {
      return Promise.resolve(Number(runtime.activeState.imageAspects[slotKey]));
    }
    if (runtime.imageRatioJobs[slotKey]) return runtime.imageRatioJobs[slotKey];
    var session = runtime.aiImageSession;
    var job = readImageAspect(source).then(function (ratio) {
      if (runtime.activeState && session === runtime.aiImageSession) {
        runtime.activeState.imageAspects[slotKey] = ratio;
        renderEditor();
        rerenderPreview();
      }
      return ratio;
    }).catch(function () { return 0; }).finally(function () {
      delete runtime.imageRatioJobs[slotKey];
    });
    runtime.imageRatioJobs[slotKey] = job;
    return job;
  }

  function normalizeOzDateValue(value) {
    var text = String(value == null ? '' : value).trim();
    var iso = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (iso) return iso[1] + '-' + iso[2] + '-' + iso[3];
    var fr = text.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (fr) return fr[3] + '-' + fr[2] + '-' + fr[1];
    return '';
  }

  function formatOzDateValue(value) {
    var iso = normalizeOzDateValue(value);
    if (!iso) return '';
    var parts = iso.split('-');
    return parts[2] + '/' + parts[1] + '/' + parts[0];
  }

  function zodiacSignForOzDate(value) {
    var iso = normalizeOzDateValue(value);
    if (!iso) return '';
    var parts = iso.split('-');
    var md = parts[1] + '-' + parts[2];
    var ranges = [
      ['capricorne', '12-22', '01-19'],
      ['verseau', '01-20', '02-18'],
      ['poissons', '02-19', '03-20'],
      ['belier', '03-21', '04-19'],
      ['taureau', '04-20', '05-20'],
      ['gemeaux', '05-21', '06-20'],
      ['cancer', '06-21', '07-22'],
      ['lion', '07-23', '08-22'],
      ['vierge', '08-23', '09-22'],
      ['balance', '09-23', '10-22'],
      ['scorpion', '10-23', '11-21'],
      ['sagittaire', '11-22', '12-21']
    ];
    for (var i = 0; i < ranges.length; i += 1) {
      var range = ranges[i];
      var inside = range[1] <= range[2]
        ? md >= range[1] && md <= range[2]
        : md >= range[1] || md <= range[2];
      if (inside) return range[0];
    }
    return '';
  }

  function buildTextColorStateKey(fieldKey) {
    return SMARTTPL_TEXT_COLOR_PREFIX + String(fieldKey || '').trim();
  }

  function parseTextColorStateKey(key) {
    var value = String(key || '').trim();
    return value.indexOf(SMARTTPL_TEXT_COLOR_PREFIX) === 0
      ? value.slice(SMARTTPL_TEXT_COLOR_PREFIX.length)
      : '';
  }

  function requestTemplateFontLoad(fontName) {
    var font = String(fontName || '').trim();
    if (!font) return Promise.resolve();
    try {
      if (typeof oazarLoadGoogleFonts === 'function') oazarLoadGoogleFonts([font]);
    } catch (e) {}
    try {
      if (typeof oazarEnsureFontLoaded === 'function') {
        return Promise.resolve(oazarEnsureFontLoaded(font, 48, '700')).catch(function () { return null; });
      }
    } catch (e) {}
    try {
      if (document.fonts && document.fonts.load) {
        return Promise.resolve(document.fonts.load('400 32px "' + font.replace(/"/g, '') + '"')).catch(function () { return null; });
      }
    } catch (e) {}
    return Promise.resolve();
  }

  function isElementVisible(el) {
    var display = (el.getAttribute('display') || '').trim().toLowerCase();
    var visibility = (el.getAttribute('visibility') || '').trim().toLowerCase();
    var style = (el.getAttribute('style') || '').toLowerCase();
    return display !== 'none' && visibility !== 'hidden' && style.indexOf('display:none') === -1;
  }

  /*
   * Choix SVG inline : compatibilité avec les deux structures utilisées par Oazar.
   *
   * Ancienne structure :
   *   <g data-oz-slot="mon_slot" data-oz-option="option_a">
   *
   * Structure actuelle (EVG, etc.) :
   *   <g data-oz-slot="mon_slot">
   *     <g data-oazar-choice-slot="mon_slot" data-oz-option="option_a">...</g>
   *   </g>
   */
  function getInlineChoiceInfo(el) {
    if (!el || !el.getAttribute) return { key: '', label: '' };

    var key = String(
      el.getAttribute('data-oz-slot') ||
      el.getAttribute('data-oazar-choice-slot') ||
      ''
    ).trim();

    var label = String(el.getAttribute('data-oz-slot-label') || '').trim();
    var parent = el.parentElement;

    while (parent && (!key || !label)) {
      if (!key) {
        key = String(
          parent.getAttribute('data-oz-slot') ||
          parent.getAttribute('data-oazar-choice-slot') ||
          ''
        ).trim();
      }

      if (!label) {
        label = String(parent.getAttribute('data-oz-slot-label') || '').trim();
      }

      if (parent === el.ownerDocument.documentElement) break;
      parent = parent.parentElement;
    }

    return { key: key, label: label || key };
  }

  /*
   * Valeur d'une option de choix.
   * Priorite a data-oz-option ; a defaut on retombe sur l'id du groupe,
   * ce qui permet de lire les SVG EVG/EVJF historiques ou seuls les ids
   * (#modele_team_marie, #modele_futur_marie) identifient les modeles.
   */
  function getInlineOptionValue(el) {
    if (!el || !el.getAttribute) return '';

    return String(
      el.getAttribute('data-oz-option') ||
      el.getAttribute('data-oazar-icon-choice') ||
      el.getAttribute('id') ||
      ''
    ).trim();
  }

  /* Groupes candidats : un conteneur qui enveloppe d'autres options n'en est pas une. */
  function getInlineChoiceCandidates(svg) {
    if (!svg) return [];

    return Array.prototype.slice.call(
      svg.querySelectorAll('[data-oz-option],[data-oazar-choice-slot]')
    ).filter(function (el) {
      return !el.querySelector('[data-oz-option],[data-oazar-choice-slot]');
    });
  }

  function getInlineChoiceNodes(svg, slotKey) {
    var wanted = String(slotKey || '').trim();
    if (!svg || !wanted) return [];

    return getInlineChoiceCandidates(svg).filter(function (el) {
      return getInlineChoiceInfo(el).key === wanted && getInlineOptionValue(el);
    });
  }

  var inlineChoicePreviewCache = new Map();
  var smartFontChoiceCache = new Map();
  var smartFontDataCache = new Map();
  var smartFontDataPromiseCache = new Map();


var smartGoogleFontSourceCache = new Map();
var smartGoogleFontSourcePromiseCache = new Map();

function ensureGoogleSmartFontSource(fontFamily) {
  var family = primaryFontFamilyName(fontFamily);
  if (!family) return Promise.resolve('');

  var systemFonts = [
    'Arial','Verdana','Tahoma','Trebuchet MS',
    'Georgia','Times New Roman','Courier New','Impact'
  ];
  if (systemFonts.indexOf(family) !== -1) return Promise.resolve('');

  if (OAZAR_EMBEDDABLE_SMART_FONTS && OAZAR_EMBEDDABLE_SMART_FONTS[family]) {
    var localUrl = OAZAR_EMBEDDABLE_SMART_FONTS[family].url || '';
    if (!localUrl) return Promise.resolve('');
    return preloadSmartFontData(localUrl).then(function () { return localUrl; });
  }

  return Promise.resolve('');
}

var OAZAR_EMBEDDABLE_SMART_FONTS = {
  'Coming Soon Oazar': {
    url: 'https://cdn.shopify.com/s/files/1/0755/7083/9897/files/coming-soon.woff2',
    weight: '400',
    format: 'woff2'
  },
  'Oazar Corben': {
    url: 'https://cdn.shopify.com/s/files/1/0755/7083/9897/files/oazar-corben-bold.woff',
    weight: '700',
    format: 'woff'
  },
  'Oazar Coiny': {
    url: 'https://cdn.shopify.com/s/files/1/0755/7083/9897/files/oazar-coiny.woff',
    weight: '400',
    format: 'woff'
  },
  'Oazar Lilita': {
    url: 'https://cdn.shopify.com/s/files/1/0755/7083/9897/files/oazar-lilita-one.woff',
    weight: '400',
    format: 'woff'
  },
  'Oazar Ultra': {
    url: 'https://cdn.shopify.com/s/files/1/0755/7083/9897/files/oazar-ultra.woff',
    weight: '400',
    format: 'woff'
  }
};

function stripFontQuotes(value) {
  return String(value || '').replace(/^["']+|["']+$/g, '').trim();
}

function primaryFontFamilyName(value) {
  var first = String(value || '').split(',')[0] || '';
  return stripFontQuotes(first);
}

function getActiveTemplateIdentity(template) {
  if (!template || typeof template !== 'object') return '';
  return [
    template.id,
    template.key,
    template.handle,
    template.title,
    template.name,
    template.label,
    template.description,
    template.subtitle
  ].join(' ').toLowerCase();
}

function getSmartTemplateSuggestedFonts(template, field) {
  var identity = getActiveTemplateIdentity(template);
  var key = String((field && field.key) || '').toLowerCase();
  var detected = primaryFontFamilyName((field && field.defaultFont) || '');

  var systemFonts = [
    'Arial','Verdana','Tahoma','Trebuchet MS',
    'Georgia','Times New Roman','Courier New','Impact'
  ];
  var oazarFonts = [
    'Oazar Corben','Oazar Coiny','Oazar Lilita',
    'Oazar Ultra','Coming Soon Oazar'
  ];

  var list = [];

  if (oazarFonts.indexOf(detected) !== -1 || systemFonts.indexOf(detected) !== -1) {
    list.push(detected);
  }

  if (key === 'texte_destination' || identity.indexOf('i love') !== -1) {
    list = list.concat([
      'Oazar Corben','Oazar Coiny','Oazar Lilita','Oazar Ultra',
      'Impact','Georgia','Arial'
    ]);
  } else if (key === 'texte_famille' || identity.indexOf('famille') !== -1) {
    list = list.concat([
      'Coming Soon Oazar','Trebuchet MS','Georgia','Arial','Verdana'
    ]);
  } else {
    list = list.concat([
      'Arial','Verdana','Trebuchet MS','Georgia',
      'Times New Roman','Courier New','Impact'
    ]);
  }

  return uniqueByKey(list.map(function (fontName) {
    var value = String(fontName || '').trim();
    return value ? { key: value.toLowerCase(), value: value } : null;
  }).filter(Boolean), 'key').map(function (entry) { return entry.value; });
}

function getSmartTemplateFontOptions(template, field, fontOptionsMap) {
  var allowed = [
    'Arial','Verdana','Tahoma','Trebuchet MS',
    'Georgia','Times New Roman','Courier New','Impact',
    'Oazar Corben','Oazar Coiny','Oazar Lilita',
    'Oazar Ultra','Coming Soon Oazar'
  ];

  var explicit = Array.isArray((fontOptionsMap || {})[field.key])
    ? (fontOptionsMap[field.key] || []).slice()
    : [];
  var suggested = getSmartTemplateSuggestedFonts(template, field);

  var merged = explicit.concat(suggested).filter(function (fontName) {
    return allowed.indexOf(String(fontName || '').trim()) !== -1;
  });

  if (!merged.length) merged = ['Arial','Verdana','Georgia','Impact'];

  return uniqueByKey(merged.map(function (fontName) {
    var value = String(fontName || '').trim();
    return value ? { key: value.toLowerCase(), value: value } : null;
  }).filter(Boolean), 'key').map(function (entry) { return entry.value; });
}

function ensureSvgEmbeddedFont(svg, fontFamily, fontWeight) {
  if (!svg || !svg.querySelector) return;
  var family = primaryFontFamilyName(fontFamily);
  if (!family) return;

  var source = OAZAR_EMBEDDABLE_SMART_FONTS[family] || null;
  var sourceUrl = source && source.url
    ? source.url
    : (smartGoogleFontSourceCache.get(family) || '');

  if (!sourceUrl) {
    ensureGoogleSmartFontSource(family);
    return;
  }

  preloadSmartFontData(sourceUrl);
  var embeddedData = smartFontDataCache.get(sourceUrl) || '';
  if (!embeddedData) return;

  var token = family.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  var style = svg.querySelector('style[data-oz-embedded-font="' + token + '"]');
  if (!style) {
    style = svg.ownerDocument.createElementNS('http://www.w3.org/2000/svg', 'style');
    style.setAttribute('data-oz-embedded-font', token);
    svg.insertBefore(style, svg.firstChild);
  }

  style.textContent =
    '@font-face{' +
    'font-family:"' + family.replace(/"/g, '') + '";' +
    'src:url("' + embeddedData + '") format("' + ((source && source.format) || (sourceUrl.indexOf('.woff2') !== -1 ? 'woff2' : 'woff')) + '");' +
    'font-weight:' + String(fontWeight || (source && source.weight) || '400') + ';' +
    'font-style:normal;' +
    'font-display:block;' +
    '}';
}


  function fontBufferToDataUri(buffer, mimeType) {
    var bytes = new Uint8Array(buffer);
    var chunks = [];
    var chunkSize = 0x8000;
    for (var i = 0; i < bytes.length; i += chunkSize) {
      chunks.push(String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize)));
    }
    return 'data:' + (mimeType || 'font/woff') + ';base64,' + btoa(chunks.join(''));
  }

  function preloadSmartFontData(url) {
    var source = String(url || '').trim();
    if (!source) return Promise.resolve('');

    if (smartFontDataCache.has(source)) {
      return Promise.resolve(smartFontDataCache.get(source) || '');
    }
    if (smartFontDataPromiseCache.has(source)) {
      return smartFontDataPromiseCache.get(source);
    }

    var request = fetch(source, { mode: 'cors', credentials: 'omit', cache: 'force-cache' })
      .then(function (response) {
        if (!response.ok) throw new Error('Police indisponible : ' + response.status);
        var mime = String(response.headers.get('content-type') || 'font/woff').split(';')[0];
        return response.arrayBuffer().then(function (buffer) {
          return fontBufferToDataUri(buffer, mime);
        });
      })
      .then(function (dataUri) {
        smartFontDataCache.set(source, dataUri);
        smartFontDataPromiseCache.delete(source);
        return dataUri;
      })
      .catch(function () {
        smartFontDataPromiseCache.delete(source);
        return '';
      });

    smartFontDataPromiseCache.set(source, request);
    return request;
  }

  function ensureSmartFontChoiceLoaded(option) {
    var family = String((option && option.fontFamily) || '').trim();
    var url = String((option && option.fontUrl) || '').trim();
    var weight = String((option && option.fontWeight) || '400').trim();
    if (!family || !url) return;

    /* Une police chargée par la page n'est pas réutilisable à l'intérieur
       d'un SVG affiché via <img>. On récupère donc aussi ses octets afin de
       l'embarquer en Base64 dans le SVG final. */
    preloadSmartFontData(url);

    if (typeof FontFace === 'undefined' || !document.fonts) return;

    var cacheKey = [family, url, weight].join('::');
    if (smartFontChoiceCache.has(cacheKey)) return;
    smartFontChoiceCache.set(cacheKey, true);

    try {
      var face = new FontFace(family, 'url("' + url.replace(/"/g, '%22') + '")', { weight: weight });
      face.load().then(function (loadedFace) {
        document.fonts.add(loadedFace);
        if (runtime.activeTemplate) renderEditor();
      }).catch(function () {});
    } catch (e) {}
  }

  /*
   * Vignette d'une option inline : on reprend le SVG du modele et on n'y laisse
   * visible que l'option demandee. Remplace les pastilles « T » / « L » par le
   * vrai design, comme sur la fiche produit.
   */
  /*
   * Emprise d'une option, calculee sur les attributs plutot que par un rendu.
   * getBBox exigerait d'attacher le document au DOM ; ici image, rect et use
   * portent deja x, y, width et height, ce qui suffit.
   */
  function empriseOption(el) {
    if (!el || !el.querySelectorAll) return null;

    var noeuds = Array.prototype.slice.call(el.querySelectorAll('image, rect, use'));
    if (el.getAttribute && el.getAttribute('width')) noeuds.push(el);
    if (!noeuds.length) return null;

    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;

    /* Un transform sur un ancetre deplacerait le contenu sans que les
       attributs x et y le refletent : le cadrage tomberait a cote. On
       renonce alors au calcul plutot que de produire un faux. */
    var transforme = false;

    noeuds.forEach(function (n) {
      var p = n;
      while (p && p !== el) {
        if (p.getAttribute && p.getAttribute('transform')) transforme = true;
        p = p.parentNode;
      }

      var x = parseFloat(n.getAttribute('x'));
      var y = parseFloat(n.getAttribute('y'));
      var w = parseFloat(n.getAttribute('width'));
      var h = parseFloat(n.getAttribute('height'));
      if ([x, y, w, h].some(isNaN)) return;
      x0 = Math.min(x0, x); y0 = Math.min(y0, y);
      x1 = Math.max(x1, x + w); y1 = Math.max(y1, y + h);
    });

    if (transforme) return null;
    if (!isFinite(x0) || x1 <= x0 || y1 <= y0) return null;
    return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
  }

  function buildInlineChoicePreview(markup, template, slotKey, optionValue) {
    if (!markup) return '';

    var cacheKey = [
      (template && template.id) || '',
      slotKey,
      optionValue
    ].join('::');

    if (inlineChoicePreviewCache.has(cacheKey)) {
      return inlineChoicePreviewCache.get(cacheKey);
    }

    var uri = '';

    try {
      var doc = parseSvg(markup);
      var svg = doc.documentElement;
      var nodes = getInlineChoiceNodes(svg, slotKey);

      if (nodes.length) {
        var actif = null;

        nodes.forEach(function (el) {
          var choisi = getInlineOptionValue(el) === String(optionValue);
          setDisplay(el, choisi);
          if (choisi) actif = el;
        });

        /* Optimisation forte pour les petites variantes / emojis :
           si l'option contient une image Shopify, la vignette utilise
           directement cette image. Aucun SVG complet à sérialiser,
           aucun PNG de famille à télécharger une seconde fois. */
        if (actif) {
          var directImage = actif.querySelector && actif.querySelector('image');
          var directHref = directImage
            ? String(
                directImage.getAttribute('href') ||
                directImage.getAttributeNS('http://www.w3.org/1999/xlink', 'href') ||
                ''
              ).trim()
            : '';

          if (directHref && (
            String(slotKey) === 'choix_icone_famille' ||
            actif.hasAttribute('data-oazar-icon-choice')
          )) {
            inlineChoicePreviewCache.set(cacheKey, directHref);
            return directHref;
          }
        }

        var boite = svg.getAttribute('viewBox');
        var emprise = empriseOption(actif);

        if (emprise && boite) {
          var toile = boite.split(/[\s,]+/).map(Number);

          if (toile.length === 4 && toile[2] > 0 && toile[3] > 0) {
            var part = (emprise.w * emprise.h) / (toile[2] * toile[3]);

            if (part < 0.25) {
              var marge = Math.max(emprise.w, emprise.h) * 0.18;
              svg.setAttribute('viewBox', [
                emprise.x - marge,
                emprise.y - marge,
                emprise.w + marge * 2,
                emprise.h + marge * 2
              ].join(' '));
              svg.setAttribute('width', String(Math.round(emprise.w + marge * 2)));
              svg.setAttribute('height', String(Math.round(emprise.h + marge * 2)));
            }
          }
        }

        var brut = new XMLSerializer().serializeToString(doc);
        uri = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(brut);

        /* Pour les autres choix contenant une photo externe, on garde
           l'ancien mécanisme d'intégration asynchrone. */
        embarquerImages(brut).then(function (avecPhotos) {
          if (avecPhotos === brut) return;
          inlineChoicePreviewCache.set(
            cacheKey,
            'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(avecPhotos)
          );
          if (runtime.activeTemplate) renderEditor();
        });
      }
    } catch (e) {}

    inlineChoicePreviewCache.set(cacheKey, uri);
    return uri;
  }


  function ozHumanizeSmartKey(value) {
    var raw = String(value || '')
      .replace(/^modele_/, '')
      .replace(/^icone_famille_\d+$/, 'symbole')
      .replace(/^texte_/, '')
      .replace(/^date_/, 'date_')
      .replace(/[_\-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!raw) return 'Élément';
    return raw.charAt(0).toUpperCase() + raw.slice(1);
  }

  function ozNormalizeHexColor(value) {
    var raw = String(value || '').trim().toLowerCase().replace(/\s*!important\s*$/i, '').trim();
    if (/^#[0-9a-f]{3}$/.test(raw)) {
      return '#' + raw[1] + raw[1] + raw[2] + raw[2] + raw[3] + raw[3];
    }
    if (/^#[0-9a-f]{6}$/.test(raw)) return raw;
    var rgb = raw.match(/^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*(?:0(?:\.\d+)?|1(?:\.0+)?))?\s*\)$/);
    if (rgb) return '#' + rgb.slice(1,4).map(function(part) {
      return Math.min(255, Number(part)).toString(16).padStart(2,'0');
    }).join('');
    return '';
  }

  /*
   * Rend éditables les anciens SVG Oazar sans devoir retourner modifier
   * chaque fichier à la main.
   *
   * Le moteur ajoute uniquement des attributs data-oz-* au SVG en mémoire :
   * le fichier Asset original n'est jamais modifié.
   */
  function ozUpgradeLegacySmartSvgMarkup(markup) {
    if (!markup) return markup;

    try {
      var doc = parseSvg(markup);
      var svg = doc.documentElement;

      function setIfMissing(el, name, value) {
        if (!el || !value) return;
        if (!String(el.getAttribute(name) || '').trim()) el.setAttribute(name, String(value));
      }

function textContent(el) {
  return String((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
}

var svgIdentity = [
  String(svg.getAttribute('data-oz-template-key') || '').trim(),
  textContent(svg.querySelector('title')),
  textContent(svg.querySelector('desc')),
  String(markup || '')
].join(' ').toLowerCase();

function applyAttrs(el, attrs) {
  if (!el || !attrs) return;
  Object.keys(attrs).forEach(function (name) {
    var value = attrs[name];
    if (value == null || value === '') return;
    el.setAttribute(name, String(value));
  });
}

function inferLegacyAiConfig(slot) {
  var key = String(slot || '').trim().toLowerCase();
  var looksLikeChildDrawing = (
    key === 'dessin_enfant' ||
    svgIdentity.indexOf('dessin d’enfant') !== -1 ||
    svgIdentity.indexOf("dessin d'enfant") !== -1 ||
    svgIdentity.indexOf('dessin enfant') !== -1 ||
    svgIdentity.indexOf('gribouilli') !== -1
  );

  if (looksLikeChildDrawing) {
    return {
      'data-oz-ai-endpoint': 'https://customizer.oazar-shop.com/v2/ai-child-drawing-recraft/generate.php',
      'data-oz-ai-mode': 'child_drawing_cutout',
      'data-oz-ai-preset': 'child_drawing_cutout_exact',
      'data-oz-ai-label': 'Supprimer le fond',
      'data-oz-ai-loading': 'Suppression du fond uniquement, sans modification du dessin…',
      'data-oz-ai-error': 'Le détourage a échoué. Réessayez avec le dessin entier visible et un peu d’espace autour.',
      'data-oz-ai-timeout': '240000',
      'data-oz-ai-automatic': 'true',
      'data-oz-ai-required': 'true',
      'data-oz-ai-max-bytes': '10485760',
      'data-oz-ai-upload-help': 'Dessin entier, photo nette et prise bien à plat — JPG, PNG ou WEBP — maximum 10 Mo',
      'data-oz-ai-note': 'Le dessin original n’est pas redessiné : seul le fond est retiré. Une fois prêt, il peut être déplacé, agrandi, rétréci et tourné sur le produit.',
      'data-oz-ai-ready': 'Dessin prêt pour la suppression du fond.',
      'data-oz-ai-success': 'Le dessin est prêt. Vous pouvez maintenant le déplacer et modifier sa taille.',
      'data-oz-ai-busy': 'Détourage en cours…',
      'data-oz-ai-required-text': 'Importez le dessin puis attendez la fin du détourage automatique avant de continuer.'
    };
  }

  var looksLikeFamilyIllustration = (
    key === 'photo_famille' ||
    svgIdentity.indexOf('illustration familiale') !== -1 ||
    svgIdentity.indexOf('illustration de famille') !== -1 ||
    svgIdentity.indexOf('photo_famille') !== -1 ||
    svgIdentity.indexOf('source lock') !== -1
  );

  if (looksLikeFamilyIllustration) {
    return {
      'data-oz-ai-endpoint': 'https://customizer.oazar-shop.com/ai-family-illustration/queue.php',
      'data-oz-ai-mode': 'family_source_lock',
      'data-oz-ai-preset': 'family_semi_faceless_v1',
      'data-oz-ai-label': 'Créer l’illustration',
      'data-oz-ai-loading': 'Illustration familiale en cours… cela peut prendre un peu de temps.',
      'data-oz-ai-error': 'La création de l’illustration a échoué. Réessayez avec une photo nette, entière et bien cadrée.',
      'data-oz-ai-timeout': '900000',
      'data-oz-ai-automatic': 'false',
      'data-oz-ai-required': 'true',
      'data-oz-ai-max-bytes': '10485760',
      'data-oz-ai-upload-help': 'Photo nette de la famille — JPG, PNG ou WEBP — maximum 10 Mo',
      'data-oz-ai-note': 'La photo importée est transformée automatiquement en illustration fidèle, puis reste modifiable sur le produit.',
      'data-oz-ai-ready': 'Photo prête pour la génération de l’illustration.',
      'data-oz-ai-success': 'Illustration prête. Vous pouvez maintenant ajuster la taille et le placement.',
      'data-oz-ai-busy': 'Création de l’illustration en cours…',
      'data-oz-ai-required-text': 'Importez la photo puis attendez la fin de la génération avant de continuer.'
    };
  }

  return null;
}

/* ------------------------------------------------------
   TEXTES
   ------------------------------------------------------ */
      Array.prototype.slice.call(svg.querySelectorAll('text')).forEach(function (el, index) {
        if (el.hasAttribute('data-oz-field') || el.hasAttribute('data-oz-date-field')) return;

        var id = String(el.getAttribute('id') || '').trim();
        var legacySlot = String(
          el.getAttribute('data-slot') ||
          el.getAttribute('data-oazar-slot') ||
          ''
        ).trim();
        var value = textContent(el);

        /* Date de naissance des Constellations :
           elle pilote aussi automatiquement le signe astrologique. */
        if (id === 'date_naissance_affichee' || legacySlot === 'date_naissance') {
          el.setAttribute('data-oz-date-field', 'date_naissance');
          el.setAttribute('data-oz-label', 'Date de naissance');

          var fr = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
          if (fr) el.setAttribute('data-oz-date-value', fr[3] + '-' + fr[2] + '-' + fr[1]);
          return;
        }

        var key = '';
        var label = '';

        if (/^texte_evenement_/i.test(id)) {
          key = 'texte_evenement';
          label = "Texte de l’événement";
          el.setAttribute('data-oz-uppercase', 'true');
          el.setAttribute('data-oz-maxlength', '36');
        } else if (/^date_evenement_/i.test(id)) {
          /* Les anciens EVG/EVJF utilisent JJ-MM-AAAA :
             on le laisse volontairement comme texte libre. */
          key = 'date_evenement';
          label = "Date de l’événement";
          el.setAttribute('data-oz-maxlength', '20');
          el.setAttribute('data-oz-font', 'false');
        } else if (id === 'prenom_naissance') {
          key = 'prenom_naissance';
          label = 'Prénom';
          el.setAttribute('data-oz-maxlength', '30');
        } else if (id === 'texte_famille' || legacySlot === 'texte_famille') {
          key = 'texte_famille';
          label = 'Prénoms';
          el.setAttribute('data-oz-maxlength', '80');
          setIfMissing(el, 'font-family', '"Coming Soon Oazar", "Coming Soon", "Segoe Print", "Bradley Hand", cursive');
        } else if (id === 'texte_destination' || legacySlot === 'texte_destination') {
          key = 'texte_destination';
          label = 'Destination';
          el.setAttribute('data-oz-uppercase', 'true');
          el.setAttribute('data-oz-maxlength', '24');
          setIfMissing(el, 'font-family', '"Oazar Corben", "Cooper Black", Georgia, serif');
        } else if (legacySlot) {
          key = legacySlot;
          label = ozHumanizeSmartKey(legacySlot);
        } else if (
          id &&
          value &&
          value.length > 1 &&
          id !== 'lettre_i' &&
          !/^source_/i.test(id) &&
          !/^label_/i.test(id)
        ) {
          /* Fallback générique : tout vrai texte identifié devient
             personnalisable, sauf les éléments volontairement fixes
             comme le "I" du modèle I LOVE. */
          key = id;
          label = ozHumanizeSmartKey(id);
        }

        if (!key) return;

        el.setAttribute('data-oz-field', key);
        setIfMissing(el, 'data-oz-label', label || ozHumanizeSmartKey(key));
        setIfMissing(el, 'data-oz-placeholder', value);
      });

      /* ------------------------------------------------------
         IMAGES
         ------------------------------------------------------ */
      Array.prototype.slice.call(svg.querySelectorAll('image')).forEach(function (el) {
        /* Cette ancienne image d'exemple n'est plus disponible. Elle ne doit
           jamais revenir dans l'etat d'un nouveau portrait de famille. */
        var existingSlot = String(el.getAttribute('data-oz-image-slot') || el.getAttribute('data-slot') || '').trim();
        var existingHref = String(el.getAttribute('href') || el.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || '');
        if (existingSlot === 'photo_famille' && /famille-20260818-124709-a0050168bc32922c\.png/i.test(existingHref)) {
          // Keep the original portrait only as a visual example. It must never
          // become the customer's uploaded photo or generated illustration.
          el.setAttribute('data-oz-reference-href', existingHref);
          el.removeAttribute('href');
          el.removeAttributeNS('http://www.w3.org/1999/xlink', 'href');
          /* La visibilite du champ dans le panneau est calculee a partir du
             SVG source. Le cacher ici ferait disparaitre "Importer". Le
             rendu applique display:none uniquement sur sa copie d'apercu. */
          el.removeAttribute('display');
        }
        if (el.hasAttribute('data-oz-image-slot')) return;

        var slot = String(
          el.getAttribute('data-slot') ||
          el.getAttribute('data-oazar-slot') ||
          ''
        ).trim();

        if (!slot) return;

        el.setAttribute('data-oz-image-slot', slot);

        var label = slot === 'photo_famille'
          ? 'Photo / illustration de famille'
          : ozHumanizeSmartKey(slot);

        setIfMissing(el, 'data-oz-image-label', label);

        var currentAiEndpoint = String(el.getAttribute('data-oz-ai-endpoint') || '').trim();
        if (slot === 'photo_famille' || !currentAiEndpoint) {
          var aiCfg = inferLegacyAiConfig(slot);
          if (aiCfg) applyAttrs(el, aiCfg);
        }
      });

      /* ------------------------------------------------------
         CHOIX DE VARIANTES / ICÔNES
         ------------------------------------------------------ */
      Array.prototype.slice.call(
        svg.querySelectorAll('[data-oazar-choice-slot],[data-oz-option]')
      ).forEach(function (el) {
        var slot = String(
          el.getAttribute('data-oazar-choice-slot') ||
          el.getAttribute('data-oz-slot') ||
          ''
        ).trim();

        if (slot && !el.getAttribute('data-oz-slot')) {
          el.setAttribute('data-oz-slot', slot);
        }

        if (slot && !el.getAttribute('data-oz-slot-label')) {
          if (slot === 'choix_modele_evjf') el.setAttribute('data-oz-slot-label', 'Choisissez le modèle');
          else if (slot === 'choix_icone_famille') el.setAttribute('data-oz-slot-label', 'Symbole décoratif');
          else el.setAttribute('data-oz-slot-label', ozHumanizeSmartKey(slot));
        }

        if (!el.getAttribute('data-oz-option')) {
          var legacyValue = String(
            el.getAttribute('data-oazar-icon-choice') ||
            el.getAttribute('id') ||
            ''
          ).trim();
          if (legacyValue) el.setAttribute('data-oz-option', legacyValue);
        }

        if (!el.getAttribute('data-oz-option-label')) {
          var optionValue = String(el.getAttribute('data-oz-option') || '').trim();
          var iconValue = String(el.getAttribute('data-oazar-icon-choice') || '').trim();
          var label = '';

          if (optionValue === 'modele_team_mariee') label = 'Team de la Mariée';
          else if (optionValue === 'modele_future_mariee') label = 'La future Mariée';
          else if (optionValue === 'modele_team_marie') label = 'Team du Marié';
          else if (optionValue === 'modele_futur_marie') label = 'Le futur Marié';
          else if (iconValue) label = ozHumanizeSmartKey(iconValue);
          else label = ozHumanizeSmartKey(optionValue);

          if (label) el.setAttribute('data-oz-option-label', label);
        }
      });

      /* ------------------------------------------------------
         COULEURS OAZAR HISTORIQUES
         ------------------------------------------------------ */
      var legacyColorGroups = [
        {
          selector: '.oazar-couleur-principale',
          key: 'couleur_principale',
          label: 'Couleur principale'
        },
        {
          selector: '.oazar-couleur-accent,.oazar-trait-accent',
          key: 'couleur_accent',
          label: 'Couleur secondaire'
        },
        {
          selector: '.oazar-couleur-date',
          key: 'couleur_date',
          label: 'Couleur de la date'
        }
      ];

      legacyColorGroups.forEach(function (group) {
        var nodes = Array.prototype.slice.call(svg.querySelectorAll(group.selector));
        if (!nodes.length) return;

        nodes.forEach(function (el) {
          // Les clés explicites du SVG priment sur les anciennes classes Oazar.
          if (!el.hasAttribute('data-oz-color')) {
            el.setAttribute('data-oz-color', group.key);
            el.setAttribute('data-oz-color-label', group.label);
          }
        });
      });

      /* Les tracés non balisés reçoivent leurs propres champs de couleur.
         Un même tracé peut avoir un remplissage et un contour différents. */
      {
        var colorMap = {};
        var paintNodes = Array.prototype.slice.call(
          svg.querySelectorAll('g,symbol,path,rect,circle,ellipse,line,polyline,polygon,text')
        );

        paintNodes.forEach(function (el) {
          // The AI image placeholder is never part of the visible design.
          // Its vector paint must not become a misleading color control.
          if (el.closest('[data-oz-image-placeholder]')) return;
          if (el.closest('[data-oz-color],[data-oz-color-fill],[data-oz-color-stroke]')) return;
          ['fill', 'stroke'].forEach(function (attr) {
            var color = ozResolveSvgPaintColor(el, extractInlineStyleValue(el.getAttribute('style') || '', attr) || el.getAttribute(attr));
            if (!color) return;
            if (color === '#ffffff') return;
            if (!colorMap[color]) colorMap[color] = [];
            colorMap[color].push({ element: el, paint: attr });
          });
        });

        var colors = Object.keys(colorMap);
        if (colors.length > 0 && colors.length <= 8) {
          var sharedDesignNodes = svg.querySelectorAll('[data-oz-color="couleur_design"]');
          var sharedDesignKey = colors.length === 1 && sharedDesignNodes.length > 1;
          colors.forEach(function (color, index) {
            var key = sharedDesignKey ? 'couleur_design' : 'couleur_auto_' + (index + 1);
            var label = sharedDesignKey ? 'Couleur du design' : colors.length === 1
              ? 'Couleur du dessin'
              : 'Couleur du dessin ' + (index + 1);

            colorMap[color].forEach(function (entry) {
              entry.element.setAttribute('data-oz-color-' + entry.paint, key);
              entry.element.setAttribute('data-oz-color-' + entry.paint + '-label', label);
            });
          });
        }
      }

      return new XMLSerializer().serializeToString(doc);
    } catch (e) {
      console.warn('[modèle intelligent] normalisation SVG impossible', e);
      return markup;
    }
  }


  function preloadInlineChoiceImages(markup) {
    if (!markup) return;
    try {
      var doc = parseSvg(markup);
      var svg = doc.documentElement;
      var seen = {};

      Array.prototype.slice.call(
        svg.querySelectorAll('[data-oazar-choice-slot] image,[data-oz-option] image')
      ).forEach(function (imgEl) {
        var href = String(
          imgEl.getAttribute('href') ||
          imgEl.getAttributeNS('http://www.w3.org/1999/xlink', 'href') ||
          ''
        ).trim();

        if (!href || seen[href]) return;
        seen[href] = true;

        var img = new Image();
        img.decoding = 'async';
        img.src = href;
      });
    } catch (e) {}
  }

  function extractMetaFromDoc(doc) {
    var svg = doc.documentElement;
    var texts = uniqueByKey(Array.prototype.slice.call(svg.querySelectorAll('[data-oz-field]')).map(function (el) {
      return {
        key: String(el.getAttribute('data-oz-field') || '').trim(),
        label: String(el.getAttribute('data-oz-label') || el.getAttribute('data-oz-field') || 'Texte').trim(),
        placeholder: String(el.getAttribute('data-oz-placeholder') || '').trim(),
        maxlength: parseInt(el.getAttribute('data-oz-maxlength') || '0', 10) || 0,
        multiline: el.getAttribute('data-oz-multiline') === 'true' || (getElementTextValue(el).indexOf('\n') !== -1),
        uppercase: el.getAttribute('data-oz-uppercase') === 'true',
        fitWidth: String(el.getAttribute('data-oz-fit-width') || '').trim(),
        defaultValue: getElementTextValue(el),
        defaultColor: readSvgColorValue(el),
        defaultFont: readSvgFontFamilyValue(el),
        allowFont: String(el.getAttribute('data-oz-font') || 'true').trim().toLowerCase() !== 'false',
        colorPalette: parseColorList(el.getAttribute('data-oz-palette') || ''),
        /* Ce texte est deja pilote par la section Couleurs : pas de doublon. */
        hasOwnColor: !!el.closest('[data-oz-color],[data-oz-color-fill],[data-oz-color-stroke]')
      };
    }).filter(function (field) {
      return field.key;
    }), 'key');

    var dates = uniqueByKey(Array.prototype.slice.call(svg.querySelectorAll('[data-oz-date-field]')).map(function (el) {
      var displayed = getElementTextValue(el);
      var stored = String(el.getAttribute('data-oz-date-value') || '').trim();
      return {
        key: String(el.getAttribute('data-oz-date-field') || '').trim(),
        label: String(el.getAttribute('data-oz-label') || 'Date de naissance').trim(),
        defaultValue: normalizeOzDateValue(displayed) || normalizeOzDateValue(stored) || '',
        required: String(el.getAttribute('data-oz-required') || '').trim().toLowerCase() === 'true'
      };
    }).filter(function (field) {
      return field.key;
    }), 'key');

    var explicitColors = Array.prototype.slice.call(svg.querySelectorAll('[data-oz-color]')).map(function (el) {
      var defaultColor = readSvgColorValue(el);
      return {
        key: String(el.getAttribute('data-oz-color') || '').trim(),
        label: String(el.getAttribute('data-oz-color-label') || el.getAttribute('data-oz-color') || 'Couleur').trim(),
        mode: String(el.getAttribute('data-oz-apply') || '').trim().toLowerCase(),
        defaultValue: defaultColor,
        palette: parseColorList(el.getAttribute('data-oz-palette') || '')
      };
    });
    ['fill', 'stroke'].forEach(function (paint) {
      Array.prototype.slice.call(svg.querySelectorAll('[data-oz-color-' + paint + ']')).forEach(function (el) {
        explicitColors.push({
          key: String(el.getAttribute('data-oz-color-' + paint) || '').trim(),
          label: String(el.getAttribute('data-oz-color-' + paint + '-label') || el.getAttribute('data-oz-color-label') || 'Couleur du dessin').trim(),
          mode: paint,
          defaultValue: ozResolveSvgPaintColor(el, extractInlineStyleValue(el.getAttribute('style') || '', paint) || el.getAttribute(paint)) || '#111111',
          palette: parseColorList(el.getAttribute('data-oz-palette') || '')
        });
      });
    });
    var colors = uniqueByKey(explicitColors.filter(function (field) {
      return field.key;
    }), 'key');

    var choiceMap = {};
    getInlineChoiceCandidates(svg).forEach(function (el) {
      var info = getInlineChoiceInfo(el);
      var slot = info.key;
      var option = getInlineOptionValue(el);
      if (!slot || !option) return;

      if (!choiceMap[slot]) {
        choiceMap[slot] = {
          key: slot,
          label: info.label || slot,
          defaultValue: option,
          options: []
        };
      }

      if (isElementVisible(el)) choiceMap[slot].defaultValue = option;

      choiceMap[slot].options.push({
        value: option,
        label: String(el.getAttribute('data-oz-option-label') || option).trim(),
        preview: String(el.getAttribute('data-oz-option-preview') || '').trim(),
        fontFamily: String(el.getAttribute('data-oz-font-family') || '').trim(),
        fontFallback: String(el.getAttribute('data-oz-font-fallback') || '').trim(),
        fontUrl: String(el.getAttribute('data-oz-font-url') || '').trim(),
        fontWeight: String(el.getAttribute('data-oz-font-weight') || '').trim(),
        fontPreview: String(el.getAttribute('data-oz-font-preview') || '').trim(),
        source: 'inline'
      });
    });

    var toggles = uniqueByKey(Array.prototype.slice.call(svg.querySelectorAll('[data-oz-toggle]')).map(function (el) {
      return {
        key: String(el.getAttribute('data-oz-toggle') || '').trim(),
        label: String(el.getAttribute('data-oz-toggle-label') || el.getAttribute('data-oz-toggle') || 'Option').trim(),
        defaultValue: isElementVisible(el)
      };
    }).filter(function (field) { return field.key; }), 'key');

    var imageSlots = uniqueByKey(Array.prototype.slice.call(svg.querySelectorAll('[data-oz-image-slot]')).map(function (el) {
      var href = String(el.getAttribute('href') || el.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || '').trim();
      /* Config IA propre a l'emplacement. Elle vit dans le SVG, seul support
         que l'atelier et la fiche produit ont en commun : le JSON de slots
         n'est lu que par la fiche. */
      var aiEndpoint = String(el.getAttribute('data-oz-ai-endpoint') || '').trim();

      return {
        key: String(el.getAttribute('data-oz-image-slot') || '').trim(),
        label: String(el.getAttribute('data-oz-image-label') || el.getAttribute('data-oz-image-slot') || 'Image').trim(),
        defaultValue: href,
        required: el.getAttribute('data-oz-required') === 'true',
        compact: el.getAttribute('data-oz-compact') === 'true',
        ai: aiEndpoint ? {
          endpoint: aiEndpoint,
          mode: String(el.getAttribute('data-oz-ai-mode') || '').trim(),
          preset: String(el.getAttribute('data-oz-ai-preset') || '').trim(),
          label: String(el.getAttribute('data-oz-ai-label') || 'Transformer avec l’IA').trim(),
          loading: String(el.getAttribute('data-oz-ai-loading') || 'Transformation en cours…').trim(),
          error: String(el.getAttribute('data-oz-ai-error') || 'La transformation a échoué. Réessayez avec une photo nette.').trim(),
          timeoutMs: parseInt(el.getAttribute('data-oz-ai-timeout') || '240000', 10) || 240000,
          automatic: el.getAttribute('data-oz-ai-automatic') === 'true',
          required: el.getAttribute('data-oz-ai-required') === 'true',
          uploadHelp: String(el.getAttribute('data-oz-ai-upload-help') || '').trim(),
          note: String(el.getAttribute('data-oz-ai-note') || '').trim(),
          ready: String(el.getAttribute('data-oz-ai-ready') || 'Image prête pour le traitement.').trim(),
          success: String(el.getAttribute('data-oz-ai-success') || 'Image traitée.').trim(),
          busy: String(el.getAttribute('data-oz-ai-busy') || 'Traitement en cours…').trim(),
          requiredText: String(el.getAttribute('data-oz-ai-required-text') || 'Importez l’image puis attendez la fin du traitement avant de continuer.').trim(),
          maxBytes: parseInt(el.getAttribute('data-oz-ai-max-bytes') || '10485760', 10) || 10485760
        } : null
      };
    }).filter(function (field) { return field.key; }), 'key');

    var imageGrid = svg.getAttribute('data-oz-image-grid') === 'true' ? {
      enabled: true,
      label: String(svg.getAttribute('data-oz-image-grid-label') || 'Photos').trim(),
      help: String(svg.getAttribute('data-oz-image-grid-help') || '').trim(),
      columns: Math.max(1, Math.min(4, parseInt(svg.getAttribute('data-oz-image-grid-columns') || '3', 10) || 3))
    } : null;

    var anchors = uniqueByKey(Array.prototype.slice.call(svg.querySelectorAll('[data-oz-slot-anchor],[data-oz-slot-host]')).map(function (el) {
      var slot = String(el.getAttribute('data-oz-slot-anchor') || el.getAttribute('data-oz-slot-host') || '').trim();
      return {
        key: slot,
        label: String(el.getAttribute('data-oz-slot-label') || slot).trim()
      };
    }).filter(function (field) { return field.key; }), 'key');

    /* ELEMENTS DEPLACABLES A LA SOURIS / AU DOIGT
       L'apercu est une <img>, pas un SVG vivant : on ne peut pas lui
       demander sa CTM. La conversion point ecran -> point SVG n'est donc
       exacte que si l'element deplace est un enfant direct du <svg>
       racine, sans transformation de groupe intermediaire. */
    var boiteVueSvg = String(svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
    if (boiteVueSvg.length !== 4 || boiteVueSvg.some(isNaN)) boiteVueSvg = [0, 0, 1000, 1000];

    var drags = uniqueByKey(Array.prototype.slice.call(svg.querySelectorAll('[data-oz-drag]')).map(function (el) {
      var transform = String(el.getAttribute('transform') || '');
      var translation = /translate\(\s*(-?[\d.]+)[\s,]+(-?[\d.]+)/.exec(transform);
      var rotation = /rotate\(\s*(-?[\d.]+)/.exec(transform);

      function nombre(attribut, secours) {
        var brut = String(el.getAttribute(attribut) || '').trim();
        var valeur = parseFloat(brut);
        return brut !== '' && !isNaN(valeur) ? valeur : secours;
      }

      return {
        key: String(el.getAttribute('data-oz-drag') || '').trim(),
        label: String(el.getAttribute('data-oz-drag-label') || 'Element mobile').trim(),
        help: String(el.getAttribute('data-oz-drag-help') || '').trim(),
        x: nombre('data-oz-drag-x', translation ? parseFloat(translation[1]) : boiteVueSvg[0] + boiteVueSvg[2] / 2),
        y: nombre('data-oz-drag-y', translation ? parseFloat(translation[2]) : boiteVueSvg[1] + boiteVueSvg[3] / 2),
        rotate: nombre('data-oz-drag-rotate', rotation ? parseFloat(rotation[1]) : 0),
        minX: nombre('data-oz-drag-min-x', boiteVueSvg[0]),
        maxX: nombre('data-oz-drag-max-x', boiteVueSvg[0] + boiteVueSvg[2]),
        minY: nombre('data-oz-drag-min-y', boiteVueSvg[1]),
        maxY: nombre('data-oz-drag-max-y', boiteVueSvg[1] + boiteVueSvg[3]),
        /* Rayon de saisie : au-dela, un clic sur l'apercu ne prend pas
           l'element. Sinon le moindre clic le teleporterait. */
        radius: nombre('data-oz-drag-radius', Math.max(boiteVueSvg[2], boiteVueSvg[3]) * 0.12),
        rotatable: String(el.getAttribute('data-oz-drag-rotatable') || 'true').trim().toLowerCase() !== 'false'
      };
    }).filter(function (field) { return field.key; }), 'key');

    /* COMPOSITION LIBRE (FLASHS)
       La bibliotheque vit dans <defs> : chaque entree est une image de
       Shopify > Contenu > Fichiers. Le plan de travail, lui, part vide et
       recoit les copies posees par le client. */
    var optionsFlash = Array.prototype.slice.call(svg.querySelectorAll('[data-oz-flash-option]')).map(function (el) {
      var conteneur = el.closest ? el.closest('[data-oz-flash-library]') : null;
      return {
        value: String(el.getAttribute('data-oz-flash-option') || '').trim(),
        library: String(
          el.getAttribute('data-oz-flash-library') ||
          (conteneur ? conteneur.getAttribute('data-oz-flash-library') : '') || ''
        ).trim(),
        label: String(el.getAttribute('data-oz-flash-label') || el.getAttribute('data-oz-flash-option') || 'Flash').trim(),
        href: String(el.getAttribute('href') || el.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || '').trim(),
        width: parseFloat(el.getAttribute('data-oz-flash-width') || '') || 0,
        height: parseFloat(el.getAttribute('data-oz-flash-height') || '') || 0
      };
    }).filter(function (option) { return option.value && option.href; });

    var flashSpaces = uniqueByKey(Array.prototype.slice.call(svg.querySelectorAll('[data-oz-flash-workspace]')).map(function (el) {
      function nombre(attribut, secours) {
        var brut = String(el.getAttribute(attribut) || '').trim();
        var valeur = parseFloat(brut);
        return brut !== '' && !isNaN(valeur) ? valeur : secours;
      }
      var key = String(el.getAttribute('data-oz-flash-workspace') || '').trim();

      return {
        key: key,
        label: String(el.getAttribute('data-oz-flash-label') || 'Mes flashs').trim(),
        help: String(el.getAttribute('data-oz-flash-help') || '').trim(),
        libraryLabel: String(el.getAttribute('data-oz-flash-library-label') || 'Choisissez vos flashs').trim(),
        max: Math.max(1, nombre('data-oz-flash-max', 20)),
        size: nombre('data-oz-flash-size', 220),
        minScale: nombre('data-oz-flash-min-scale', 0.3),
        maxScale: nombre('data-oz-flash-max-scale', 2.5),
        minX: nombre('data-oz-flash-min-x', boiteVueSvg[0]),
        maxX: nombre('data-oz-flash-max-x', boiteVueSvg[0] + boiteVueSvg[2]),
        minY: nombre('data-oz-flash-min-y', boiteVueSvg[1]),
        maxY: nombre('data-oz-flash-max-y', boiteVueSvg[1] + boiteVueSvg[3]),
        options: optionsFlash.filter(function (option) {
          return !option.library || option.library === key;
        })
      };
    }).filter(function (espace) { return espace.key; }), 'key');

    return {
      texts: texts,
      flashSpaces: flashSpaces,
      dates: dates,
      colors: colors,
      drags: drags,
      choices: Object.keys(choiceMap).map(function (key) {
        choiceMap[key].options = uniqueByKey(choiceMap[key].options, 'value');
        return choiceMap[key];
      }),
      toggles: toggles,
      imageSlots: imageSlots,
      imageGrid: imageGrid,
      anchors: anchors
    };
  }

  function mergeMeta(target, extra) {
    var merged = {
      texts: uniqueByKey((target.texts || []).concat(extra.texts || []), 'key'),
      dates: uniqueByKey((target.dates || []).concat(extra.dates || []), 'key'),
      colors: [],
      choices: [],
      toggles: uniqueByKey((target.toggles || []).concat(extra.toggles || []), 'key'),
      drags: uniqueByKey((target.drags || []).concat(extra.drags || []), 'key'),
      flashSpaces: uniqueByKey((target.flashSpaces || []).concat(extra.flashSpaces || []), 'key'),
      imageSlots: uniqueByKey((target.imageSlots || []).concat(extra.imageSlots || []), 'key'),
      imageGrid: extra.imageGrid || target.imageGrid || null,
      anchors: uniqueByKey((target.anchors || []).concat(extra.anchors || []), 'key')
    };

    var colorMap = {};
    (target.colors || []).concat(extra.colors || []).forEach(function (field) {
      if (!field || !field.key) return;
      if (!colorMap[field.key]) {
        colorMap[field.key] = Object.assign({}, field);
      } else {
        colorMap[field.key].palette = uniqueByKey([].concat(
          (colorMap[field.key].palette || []).map(function (c) { return { key: c, value: c }; }),
          (field.palette || []).map(function (c) { return { key: c, value: c }; })
        ), 'key').map(function (entry) { return entry.value; });
      }
    });
    merged.colors = Object.keys(colorMap).map(function (key) { return colorMap[key]; });

    var choiceMap = {};
    (target.choices || []).concat(extra.choices || []).forEach(function (group) {
      if (!group || !group.key) return;
      if (!choiceMap[group.key]) {
        choiceMap[group.key] = {
          key: group.key,
          label: group.label || group.key,
          defaultValue: group.defaultValue || '',
          options: []
        };
      }
      if (!choiceMap[group.key].label && group.label) choiceMap[group.key].label = group.label;
      if (group.defaultValue) choiceMap[group.key].defaultValue = group.defaultValue;
      choiceMap[group.key].options = choiceMap[group.key].options.concat(group.options || []);
    });
    merged.choices = Object.keys(choiceMap).map(function (key) {
      choiceMap[key].options = uniqueByKey(choiceMap[key].options, 'value');
      if (!choiceMap[key].defaultValue && choiceMap[key].options[0]) {
        choiceMap[key].defaultValue = choiceMap[key].options[0].value;
      }
      return choiceMap[key];
    });

    return merged;
  }

  async function getOptionMarkup(option) {
    if (!option) return '';
    var cacheKey = option.id || [option.templateKey, option.slotKey, option.value].join('::');
    if (option.svgMarkup) return option.svgMarkup;
    if (optionMarkupCache.has(cacheKey)) return optionMarkupCache.get(cacheKey);
    if (option.sourceKind === 'image' && option.mediaUrl) {
      var imageMarkup = buildImageWrapperSvg(option.mediaUrl);
      optionMarkupCache.set(cacheKey, imageMarkup);
      return imageMarkup;
    }
    var response = await fetch(option.svgUrl || option.mediaUrl, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Impossible de charger une option de modèle.');
    var markup = await response.text();
    markup = ozUpgradeLegacySmartSvgMarkup(markup);
    optionMarkupCache.set(cacheKey, markup);
    return markup;
  }

  async function preloadExternalOptions(template) {
    var options = getExternalOptionsForTemplate(template);
    await Promise.all(options.map(function (option) {
      return getOptionMarkup(option).catch(function () { return ''; });
    }));
  }

  async function buildMeta(template, markup) {
    var doc = parseSvg(markup);
    var meta = extractMetaFromDoc(doc);
    var slotGroupMap = {};
    (meta.choices || []).forEach(function (group) {
      slotGroupMap[group.key] = {
        key: group.key,
        label: group.label || group.key,
        defaultValue: group.defaultValue || '',
        options: (group.options || []).slice()
      };
    });

    (meta.anchors || []).forEach(function (anchor) {
      if (!slotGroupMap[anchor.key]) {
        slotGroupMap[anchor.key] = {
          key: anchor.key,
          label: anchor.label || anchor.key,
          defaultValue: '',
          options: []
        };
      } else if (!slotGroupMap[anchor.key].label && anchor.label) {
        slotGroupMap[anchor.key].label = anchor.label;
      }
    });

    var extOptions = getExternalOptionsForTemplate(template);
    await preloadExternalOptions(template);

    for (var i = 0; i < extOptions.length; i += 1) {
      var option = extOptions[i];
      if (!slotGroupMap[option.slotKey]) {
        slotGroupMap[option.slotKey] = {
          key: option.slotKey,
          label: option.slotLabel || option.slotKey,
          defaultValue: '',
          options: []
        };
      }
      if (!slotGroupMap[option.slotKey].label && option.slotLabel) {
        slotGroupMap[option.slotKey].label = option.slotLabel;
      }
      slotGroupMap[option.slotKey].options.push({
        value: option.value,
        label: option.label || option.value,
        preview: option.preview || '',
        source: 'external'
      });
      if (option.isDefault) {
        slotGroupMap[option.slotKey].defaultValue = option.value;
      }
      try {
        var optionMarkup = await getOptionMarkup(option);
        if (optionMarkup) {
          meta = mergeMeta(meta, extractMetaFromDoc(parseSvgFragment(optionMarkup)));
        }
      } catch (e) {}
    }

    meta.choices = Object.keys(slotGroupMap).map(function (key) {
      var group = slotGroupMap[key];
      group.options = uniqueByKey(group.options, 'value');
      if (!group.defaultValue && group.options[0]) group.defaultValue = group.options[0].value;
      return group;
    });

    return meta;
  }

  function borner(valeur, minimum, maximum, secours) {
    var nombre = Number(valeur);
    if (!isFinite(nombre)) nombre = Number(secours);
    if (!isFinite(nombre)) nombre = 0;
    if (isFinite(minimum) && nombre < minimum) nombre = minimum;
    if (isFinite(maximum) && nombre > maximum) nombre = maximum;
    return Math.round(nombre * 100) / 100;
  }

  function buildDefaultState(meta) {
    var state = { texts: {}, dates: {}, colors: {}, choices: {}, toggles: {}, images: {}, imageAspects: {}, fonts: {}, variants: {}, transforms: {}, flashes: {} };
    (meta.texts || []).forEach(function (field) {
      state.texts[field.key] = field.defaultValue || '';
      if (!field.hasOwnColor) {
        state.colors[buildTextColorStateKey(field.key)] = field.defaultColor || '#111111';
      }
      if (field.defaultFont) state.fonts[field.key] = field.defaultFont;
    });
    (meta.dates || []).forEach(function (field) { state.dates[field.key] = field.defaultValue || ''; });
    (meta.colors || []).forEach(function (field) { state.colors[field.key] = field.defaultValue || '#111111'; });
    (meta.choices || []).forEach(function (field) { state.choices[field.key] = field.defaultValue || (field.options[0] ? field.options[0].value : ''); });
    (meta.toggles || []).forEach(function (field) { state.toggles[field.key] = !!field.defaultValue; });
    (meta.drags || []).forEach(function (field) {
      state.transforms[field.key] = { x: field.x, y: field.y, rotate: field.rotate };
    });
    (meta.flashSpaces || []).forEach(function (espace) { state.flashes[espace.key] = []; });
    (meta.imageSlots || []).forEach(function (field) {
      state.images[field.key] = field.defaultValue || '';
      state.imageAspects[field.key] = 0;
    });
    try {
      var ds = (runtime && runtime.activeTemplate && runtime.activeTemplate.defaultState) || {};
      Object.keys(ds.fonts || {}).forEach(function (key) { state.fonts[key] = ds.fonts[key]; });
      if (ds.orientation) state.variants.orientation = String(ds.orientation || 'vertical');
    } catch (e) {}
    return state;
  }

  function sanitizeState(meta, incoming) {
    var safe = buildDefaultState(meta);
    if (!incoming || typeof incoming !== 'object') return safe;

    /*
     * Compatibilité fiche produit -> atelier :
     * les choix SVG doivent vivre dans state.choices.
     * Les anciennes versions du pont les envoyaient par erreur dans
     * state.variants, ce qui faisait retomber le modèle sur son choix
     * par défaut (ex. Team du Marié). On accepte donc les deux formats.
     */
    var normalizedIncoming = Object.assign({}, incoming);
    var legacyVariants = (incoming.variants && typeof incoming.variants === 'object')
      ? incoming.variants
      : {};
    var explicitChoices = (incoming.choices && typeof incoming.choices === 'object')
      ? incoming.choices
      : {};

    normalizedIncoming.choices = Object.assign({}, legacyVariants, explicitChoices);

    normalizedIncoming.dates = Object.assign({}, normalizedIncoming.dates || {});
    Object.keys(safe.dates || {}).forEach(function (key) {
      if (!(key in normalizedIncoming.dates) && incoming.texts && key in incoming.texts) {
        normalizedIncoming.dates[key] = incoming.texts[key];
      }
      if (!(key in normalizedIncoming.dates) && key in incoming) {
        normalizedIncoming.dates[key] = incoming[key];
      }
    });

    ['texts', 'dates', 'colors', 'choices', 'toggles', 'images', 'imageAspects', 'fonts', 'variants', 'transforms', 'flashes'].forEach(function (groupKey) {
      if (!normalizedIncoming[groupKey] || typeof normalizedIncoming[groupKey] !== 'object') return;
      Object.keys(safe[groupKey]).forEach(function (key) {
        if (key in normalizedIncoming[groupKey]) {
          safe[groupKey][key] = normalizedIncoming[groupKey][key];
        }
      });
    });

    /* Une composition peut arriver du panier avec des flashs devenus
       introuvables, hors cadre ou en surnombre : on la remet d'aplomb. */
    (meta.flashSpaces || []).forEach(function (espace) {
      var recus = safe.flashes[espace.key];
      var connus = {};
      (espace.options || []).forEach(function (option) { connus[option.value] = true; });

      safe.flashes[espace.key] = (Array.isArray(recus) ? recus : [])
        .filter(function (flash) { return flash && connus[String(flash.option)]; })
        .slice(0, espace.max)
        .map(function (flash) {
          return {
            option: String(flash.option),
            x: borner(flash.x, espace.minX, espace.maxX, (espace.minX + espace.maxX) / 2),
            y: borner(flash.y, espace.minY, espace.maxY, (espace.minY + espace.maxY) / 2),
            rotate: borner(flash.rotate, -180, 180, 0),
            scale: borner(flash.scale, espace.minScale, espace.maxScale, 1)
          };
        });
    });

    /* Une position venue de la fiche produit ou d'un panier ancien peut
       etre incomplete ou hors cadre : on la ramene dans les bornes du SVG. */
    (meta.drags || []).forEach(function (field) {
      var recu = safe.transforms[field.key];
      safe.transforms[field.key] = {
        x: borner(recu && recu.x, field.minX, field.maxX, field.x),
        y: borner(recu && recu.y, field.minY, field.maxY, field.y),
        rotate: borner(recu && recu.rotate, -180, 180, field.rotate)
      };
    });

    return safe;
  }

  function applyTemplateDefaultState(meta, baseState, template) {
    if (!template || !template.defaultState || typeof template.defaultState !== 'object') return baseState;
    return sanitizeState(meta, (function () {
      var merged = JSON.parse(JSON.stringify(baseState || buildDefaultState(meta)));
      ['texts', 'dates', 'colors', 'choices', 'toggles', 'images', 'imageAspects', 'fonts', 'variants', 'transforms', 'flashes'].forEach(function (group) {
        if (template.defaultState[group] && typeof template.defaultState[group] === 'object') {
          merged[group] = merged[group] || {};
          Object.keys(template.defaultState[group]).forEach(function (key) {
            merged[group][key] = template.defaultState[group][key];
          });
        }
      });
      return merged;
    })());
  }

  function setSvgElementText(el, value) {
    var safeValue = String(value == null ? '' : value);
    var maxlength = parseInt(el.getAttribute('data-oz-maxlength') || '0', 10) || 0;
    if (maxlength > 0) safeValue = safeValue.slice(0, maxlength);
    if (el.getAttribute('data-oz-uppercase') === 'true') safeValue = safeValue.toUpperCase();

    var isMultiline = el.getAttribute('data-oz-multiline') === 'true' || safeValue.indexOf('\n') !== -1;
    var lines = isMultiline ? safeValue.split(/\r?\n/) : [safeValue];
    var x = el.getAttribute('x');
    var y = el.getAttribute('y');
    var lineGap = el.getAttribute('data-oz-line-gap') || el.getAttribute('data-oz-lineHeight') || '1.15em';

    while (el.firstChild) el.removeChild(el.firstChild);

    if (lines.length <= 1) {
      el.textContent = safeValue;
    } else {
      lines.forEach(function (line, index) {
        var tspan = el.ownerDocument.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        if (x != null && x !== '') tspan.setAttribute('x', x);
        if (index === 0) {
          if (y != null && y !== '') tspan.setAttribute('y', y);
        } else {
          tspan.setAttribute('dy', lineGap);
        }
        tspan.textContent = line || ' ';
        el.appendChild(tspan);
      });
    }

    /*
     * data-oz-fit-width est une LARGEUR MAXIMALE, pas une largeur forcée.
     * Ne jamais convertir cette valeur en textLength : cela étire les textes
     * courts (ex. « EVG DE LUCAS ») sur toute la largeur disponible.
     */
    el.removeAttribute('textLength');
    el.removeAttribute('lengthAdjust');
  }

  function setDisplay(el, visible) {
    var style = (el.getAttribute('style') || '').replace(/display\s*:\s*none\s*;?/ig, '').trim();
    if (visible) {
      el.removeAttribute('display');
      if (style) el.setAttribute('style', style);
      else el.removeAttribute('style');
      return;
    }
    el.setAttribute('display', 'none');
    el.setAttribute('style', style ? style + ';display:none;' : 'display:none;');
  }

  function applyColorToElement(el, color, mode) {
    var applyMode = mode || String(el.getAttribute('data-oz-color-target') || el.getAttribute('data-oz-apply') || '').trim().toLowerCase();
    var currentStyle = String(el.getAttribute('style') || '');
    var hasFill = ((extractInlineStyleValue(currentStyle, 'fill') || String(el.getAttribute('fill') || '').trim()) || '').toLowerCase();
    var hasStroke = ((extractInlineStyleValue(currentStyle, 'stroke') || String(el.getAttribute('stroke') || '').trim()) || '').toLowerCase();

    if (applyMode === 'color') {
      el.setAttribute('color', color);
      upsertInlineStyleValue(el, 'color', color); if (el.style) el.style.setProperty('color', color, 'important');
      return;
    }

    if (applyMode === 'fill') {
      el.setAttribute('fill', color);
      upsertInlineStyleValue(el, 'fill', color); if (el.style) el.style.setProperty('fill', color, 'important');
      return;
    }

    if (applyMode === 'stroke') {
      el.setAttribute('stroke', color);
      upsertInlineStyleValue(el, 'stroke', color); if (el.style) el.style.setProperty('stroke', color, 'important');
      return;
    }
    if (applyMode === 'both') {
      el.setAttribute('fill', color);
      el.setAttribute('stroke', color);
      upsertInlineStyleValue(el, 'fill', color); if (el.style) el.style.setProperty('fill', color, 'important');
      upsertInlineStyleValue(el, 'stroke', color); if (el.style) el.style.setProperty('stroke', color, 'important');
      return;
    }
    if (hasFill && hasFill !== 'none') {
      el.setAttribute('fill', color);
      upsertInlineStyleValue(el, 'fill', color); if (el.style) el.style.setProperty('fill', color, 'important');
      return;
    }
    if (hasStroke && hasStroke !== 'none') {
      el.setAttribute('stroke', color);
      upsertInlineStyleValue(el, 'stroke', color); if (el.style) el.style.setProperty('stroke', color, 'important');
      return;
    }
    el.setAttribute('fill', color);
    upsertInlineStyleValue(el, 'fill', color); if (el.style) el.style.setProperty('fill', color, 'important');
  }

  function applyFontToTextElement(el, fontFamily) {
    var font = String(fontFamily || '').trim();
    if (!font) return;
    el.setAttribute('font-family', font);
    upsertInlineStyleValue(el, 'font-family', font);

    try {
      var weight = String(
        el.getAttribute('font-weight') ||
        extractInlineStyleValue(el.getAttribute('style'), 'font-weight') ||
        ''
      ).trim();
      ensureSvgEmbeddedFont(el.ownerDocument && el.ownerDocument.documentElement, font, weight);
    } catch (e) {}
  }

  function applySmartFontChoices(svg, state) {
    Object.keys(state.choices || {}).forEach(function (slotKey) {
      var selectedValue = String(state.choices[slotKey] || '');
      var selected = getInlineChoiceNodes(svg, slotKey).find(function (el) {
        return getInlineOptionValue(el) === selectedValue;
      });
      if (!selected) return;

      var family = String(selected.getAttribute('data-oz-font-family') || '').trim();
      var fallback = String(selected.getAttribute('data-oz-font-fallback') || '').trim();
      var weight = String(selected.getAttribute('data-oz-font-weight') || '').trim();
      var targets = String(selected.getAttribute('data-oz-font-targets') || '').trim();
      var fontUrl = String(selected.getAttribute('data-oz-font-url') || '').trim();
      if (!family || !targets) return;

      var appliedFamily = family;
      var embeddedData = smartFontDataCache.get(fontUrl) || '';
      if (embeddedData) {
        appliedFamily = family + ' Oazar Inline';
        var embeddedStyle = svg.querySelector('style[data-oz-embedded-font="true"]');
        if (!embeddedStyle) {
          embeddedStyle = svg.ownerDocument.createElementNS('http://www.w3.org/2000/svg', 'style');
          embeddedStyle.setAttribute('data-oz-embedded-font', 'true');
          svg.insertBefore(embeddedStyle, svg.firstChild);
        }
        embeddedStyle.textContent = '@font-face{font-family:"' + appliedFamily.replace(/"/g, '') + '";src:url("' + embeddedData + '") format("woff");font-weight:' + (weight || '400') + ';font-style:normal;}';
      } else if (fontUrl) {
        preloadSmartFontData(fontUrl);
      }

      var fullFamily = '"' + appliedFamily.replace(/"/g, '') + '"' + (fallback ? ', ' + fallback : '');
      Array.prototype.slice.call(svg.querySelectorAll(targets)).forEach(function (el) {
        applyFontToTextElement(el, fullFamily);
        if (weight) {
          el.setAttribute('font-weight', weight);
          upsertInlineStyleValue(el, 'font-weight', weight);
        }
      });

      var styles = {};
      try {
        styles = JSON.parse(String(selected.getAttribute('data-oz-font-styles') || '{}'));
      } catch (e) {}

      /* Format sans accolades doubles pour les champs Shopify svg_markup :
         Shopify prendrait la fin d'un JSON embarqué pour une balise Liquid. */
      var compactStyles = {
        '#lettre_i': {
          'font-size': selected.getAttribute('data-oz-font-size-i'),
          'letter-spacing': selected.getAttribute('data-oz-letter-spacing-i')
        },
        '#texte_destination': {
          'font-size': selected.getAttribute('data-oz-font-size-destination'),
          'letter-spacing': selected.getAttribute('data-oz-letter-spacing-destination')
        }
      };
      Object.keys(compactStyles).forEach(function (selector) {
        var incoming = compactStyles[selector];
        if (!incoming['font-size'] && !incoming['letter-spacing']) return;
        styles[selector] = Object.assign({}, styles[selector] || {}, incoming);
      });

      Object.keys(styles || {}).forEach(function (selector) {
        var values = styles[selector] || {};
        Array.prototype.slice.call(svg.querySelectorAll(selector)).forEach(function (el) {
          Object.keys(values).forEach(function (property) {
            var value = String(values[property] == null ? '' : values[property]);
            if (!value) return;
            el.setAttribute(property, value);
            upsertInlineStyleValue(el, property, value);
          });
        });
      });
    });
  }

  function getAnchorNodes(svg, slotKey) {
    var selector = '[data-oz-slot-anchor="' + slotKey.replace(/"/g, '\\"') + '"], [data-oz-slot-host="' + slotKey.replace(/"/g, '\\"') + '"]';
    return Array.prototype.slice.call(svg.querySelectorAll(selector));
  }

  function removeExternalInstances(anchor) {
    if (!anchor) return;
    Array.prototype.slice.call(anchor.querySelectorAll('[data-oz-external-instance="true"]')).forEach(function (node) {
      if (node && node.parentNode) node.parentNode.removeChild(node);
    });
    anchor.removeAttribute('data-oz-selected-option');
  }

  function isExternalChoice(template, slotKey, value) {
    return getExternalOptionsForTemplate(template).some(function (option) {
      return option.slotKey === slotKey && option.value === value;
    });
  }

  function injectExternalChoice(doc, svg, template, slotKey, selectedValue) {
    var anchors = getAnchorNodes(svg, slotKey);
    if (!anchors.length) return false;

    anchors.forEach(removeExternalInstances);

    if (!selectedValue) return false;

    var option = getExternalOptionsForTemplate(template).find(function (entry) {
      return entry.slotKey === slotKey && entry.value === selectedValue;
    });
    if (!option) return false;

    var rawMarkup = option.svgMarkup || optionMarkupCache.get(option.id) || '';
    if (!rawMarkup) return false;

    var fragmentDoc;
    try {
      fragmentDoc = parseSvgFragment(rawMarkup);
    } catch (e) {
      return false;
    }

    anchors.forEach(function (anchor) {
      Array.prototype.slice.call(fragmentDoc.documentElement.childNodes).forEach(function (node) {
        if (!node || node.nodeType !== 1) return;
        var imported = doc.importNode ? doc.importNode(node, true) : node.cloneNode(true);
        if (imported.setAttribute) imported.setAttribute('data-oz-external-instance', 'true');
        anchor.appendChild(imported);
      });
      anchor.setAttribute('data-oz-selected-option', selectedValue);
    });
    return true;
  }

  function mergeStateFromSvg(doc, meta, template, fallbackState) {
    var base = fallbackState ? sanitizeState(meta, fallbackState) : buildDefaultState(meta);
    var svg = doc.documentElement;

    (meta.texts || []).forEach(function (field) {
      var first = svg.querySelector('[data-oz-field="' + field.key.replace(/"/g, '\\"') + '"]');
      if (!first) return;
      base.texts[field.key] = getElementTextValue(first);
      base.colors[buildTextColorStateKey(field.key)] = readSvgColorValue(first) || base.colors[buildTextColorStateKey(field.key)] || '#111111';
      var detectedFont = readSvgFontFamilyValue(first);
      if (detectedFont) base.fonts[field.key] = detectedFont;
    });

    (meta.dates || []).forEach(function (field) {
      var first = svg.querySelector('[data-oz-date-field="' + field.key.replace(/"/g, '\\"') + '"]');
      if (!first) return;
      var displayed = normalizeOzDateValue(getElementTextValue(first));
      var stored = normalizeOzDateValue(first.getAttribute('data-oz-date-value') || '');
      base.dates[field.key] = displayed || stored || base.dates[field.key] || '';
    });

    (meta.colors || []).forEach(function (field) {
      var safeKey = field.key.replace(/"/g, '\\"');
      var first = svg.querySelector('[data-oz-color="' + safeKey + '"],[data-oz-color-fill="' + safeKey + '"],[data-oz-color-stroke="' + safeKey + '"]');
      if (first) {
        var paint = first.getAttribute('data-oz-color-fill') === field.key ? 'fill' :
          first.getAttribute('data-oz-color-stroke') === field.key ? 'stroke' : '';
        base.colors[field.key] = (paint
          ? ozResolveSvgPaintColor(first, extractInlineStyleValue(first.getAttribute('style') || '', paint) || first.getAttribute(paint))
          : readSvgColorValue(first)) || base.colors[field.key] || '#111111';
      }
    });

    (meta.choices || []).forEach(function (field) {
      var inlineNodes = getInlineChoiceNodes(svg, field.key);
      var chosenInline = inlineNodes.find(function (el) {
        return isElementVisible(el);
      });

      if (chosenInline) {
        base.choices[field.key] = String(
          chosenInline.getAttribute('data-oz-option') || base.choices[field.key]
        );
        return;
      }

      var anchor = svg.querySelector(
        '[data-oz-slot-anchor="' + field.key.replace(/"/g, '\\"') + '"], ' +
        '[data-oz-slot-host="' + field.key.replace(/"/g, '\\"') + '"]'
      );

      if (anchor && anchor.getAttribute('data-oz-selected-option')) {
        base.choices[field.key] = String(
          anchor.getAttribute('data-oz-selected-option') || base.choices[field.key]
        );
      }
    });
    (meta.toggles || []).forEach(function (field) {
      var first = svg.querySelector('[data-oz-toggle="' + field.key.replace(/"/g, '\\"') + '"]');
      if (first) base.toggles[field.key] = isElementVisible(first);
    });

    (meta.imageSlots || []).forEach(function (field) {
      var first = svg.querySelector('[data-oz-image-slot="' + field.key.replace(/"/g, '\\"') + '"]');
      if (first) {
        base.images[field.key] = String(first.getAttribute('href') || first.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || base.images[field.key] || '');
        base.imageAspects[field.key] = parseFloat(first.getAttribute('data-oz-current-ratio') || '0') || base.imageAspects[field.key] || 0;
      }
    });

    return base;
  }

  function applySmartTemplateMoveRules(svg, state) {
    Array.prototype.slice.call(
      svg.querySelectorAll('[data-oz-move-when-hidden]')
    ).forEach(function (el) {
      var toggleKey = String(el.getAttribute('data-oz-move-when-hidden') || '').trim();
      if (!toggleKey) return;

      var offset = String(el.getAttribute('data-oz-move-offset') || '0 0')
        .trim()
        .split(/[ ,]+/)
        .map(Number);
      var offsetX = Number.isFinite(offset[0]) ? offset[0] : 0;
      var offsetY = Number.isFinite(offset[1]) ? offset[1] : 0;

      var baseTransform = el.getAttribute('data-oz-base-transform');
      if (baseTransform === null) {
        baseTransform = String(el.getAttribute('transform') || '').trim();
        el.setAttribute('data-oz-base-transform', baseTransform);
      }

      var referenceVisible = !state.toggles || state.toggles[toggleKey] !== false;
      var nextTransform = String(baseTransform || '').trim();
      if (!referenceVisible && (offsetX || offsetY)) {
        nextTransform = (nextTransform + ' translate(' + offsetX + ' ' + offsetY + ')').trim();
      }

      if (nextTransform) el.setAttribute('transform', nextTransform);
      else el.removeAttribute('transform');
    });
  }

  function applyStateToMarkup(markup, template, state) {
    var doc = parseSvg(markup);
    var svg = doc.documentElement;

    svg.setAttribute('data-oz-template-id', template.id);
    svg.setAttribute('data-oz-template-key', template.key);
    svg.setAttribute('data-oz-template-title', template.title);
    svg.setAttribute('data-oz-template-technique', template.technique || 'both');

    Object.keys(state.choices || {}).forEach(function (slotKey) {
      if (isExternalChoice(template, slotKey, state.choices[slotKey])) {
        injectExternalChoice(doc, svg, template, slotKey, String(state.choices[slotKey] || ''));
      } else {
        getAnchorNodes(svg, slotKey).forEach(removeExternalInstances);
      }
    });

    /* Recadrage par variante.

       Le SVG garde un repere fixe pour que les coordonnees restent lisibles,
       mais chaque variante n'occupe qu'une partie de ce repere. Sans
       recadrage, le cadre de manipulation sur le vetement epouse la toile
       entiere et non le dessin : l'element parait minuscule au milieu d'une
       grande zone vide, et le redimensionnement devient impraticable.

       Chaque option peut donc porter son propre viewBox serre. */
    Object.keys(state.choices || {}).forEach(function (slotKey) {
      var choisi = String(state.choices[slotKey] || '');

      getInlineChoiceNodes(svg, slotKey).forEach(function (el) {
        if (getInlineOptionValue(el) !== choisi) return;

        var boite = String(el.getAttribute('data-oz-viewbox') || '').trim();
        if (!boite) return;

        var nombres = boite.split(/[\s,]+/).map(Number);
        if (nombres.length !== 4 || nombres.some(isNaN)) return;

        svg.setAttribute('viewBox', boite);
        svg.setAttribute('width', String(nombres[2]));
        svg.setAttribute('height', String(nombres[3]));
      });
    });

    Object.keys(state.texts || {}).forEach(function (key) {
      Array.prototype.slice.call(svg.querySelectorAll('[data-oz-field="' + key.replace(/"/g, '\\"') + '"]')).forEach(function (el) {
        setSvgElementText(el, state.texts[key]);
      });
    });

    Object.keys(state.fonts || {}).forEach(function (key) {
      Array.prototype.slice.call(svg.querySelectorAll('[data-oz-field="' + key.replace(/"/g, '\\"') + '"]')).forEach(function (el) {
        applyFontToTextElement(el, state.fonts[key]);
      });
    });

    Object.keys(state.dates || {}).forEach(function (key) {
      var isoDate = normalizeOzDateValue(state.dates[key]);
      Array.prototype.slice.call(svg.querySelectorAll('[data-oz-date-field="' + key.replace(/"/g, '\\"') + '"]')).forEach(function (el) {
        el.setAttribute('data-oz-date-value', isoDate);
        setSvgElementText(el, formatOzDateValue(isoDate));
      });

      var sign = zodiacSignForOzDate(isoDate);
      if (!sign) return;
      var activeZodiac = null;
      Array.prototype.slice.call(svg.querySelectorAll('[data-zodiac-constellation="true"]')).forEach(function (el) {
        var active = String(el.getAttribute('data-sign') || '').trim() === sign;
        setDisplay(el, active);
        if (active) {
          activeZodiac = el;
          var transform = String(el.getAttribute('data-oz-zodiac-transform') || '').trim();
          if (transform) el.setAttribute('transform', transform);
        }
      });
      if (activeZodiac) {
        var zodiacViewBox = String(activeZodiac.getAttribute('data-oz-zodiac-viewbox') || '').trim();
        var zodiacBox = zodiacViewBox.split(/[\s,]+/).map(Number);
        if (zodiacBox.length === 4 && zodiacBox.every(Number.isFinite) && zodiacBox[2] > 0 && zodiacBox[3] > 0) {
          svg.setAttribute('viewBox', zodiacBox.join(' '));
          svg.setAttribute('width', String(zodiacBox[2]));
          svg.setAttribute('height', String(zodiacBox[3]));
        }
      }
      svg.setAttribute('data-oz-zodiac-sign', sign);
    });

    Object.keys(state.colors || {}).forEach(function (key) {
      var textFieldKey = parseTextColorStateKey(key);
      if (textFieldKey) {
        Array.prototype.slice.call(svg.querySelectorAll('[data-oz-field="' + textFieldKey.replace(/"/g, '\\"') + '"]')).forEach(function (el) {
          // A text colour inherited from old state must not overwrite its explicit SVG palette field.
          if (el.closest('[data-oz-color],[data-oz-color-fill],[data-oz-color-stroke]')) return;
          applyColorToElement(el, state.colors[key]);
        });
        return;
      }
      Array.prototype.slice.call(svg.querySelectorAll('[data-oz-color="' + key.replace(/"/g, '\\"') + '"]')).forEach(function (el) {
        applyColorToElement(el, state.colors[key]);
        // Dans un groupe, les couleurs explicites des tracés priment sur
        // l'héritage SVG : les mettre à jour sans toucher aux autres champs.
        Array.prototype.slice.call(el.querySelectorAll('path,rect,circle,ellipse,line,polyline,polygon,text,tspan')).forEach(function (paintNode) {
          var nearestColorGroup = paintNode.closest('[data-oz-color]');
          if (nearestColorGroup && nearestColorGroup.getAttribute('data-oz-color') !== key) return;
          applyColorToElement(paintNode, state.colors[key]);
        });
      });
      ['fill', 'stroke'].forEach(function (paint) {
        Array.prototype.slice.call(svg.querySelectorAll('[data-oz-color-' + paint + '="' + key.replace(/"/g, '\\"') + '"]')).forEach(function (el) {
          applyColorToElement(el, state.colors[key], paint);
        });
      });
    });

    Object.keys(state.choices || {}).forEach(function (slotKey) {
      var selectedValue = String(state.choices[slotKey] || '');

      getInlineChoiceNodes(svg, slotKey).forEach(function (el) {
        /* Compatibilité avec les SVG historiques EVG / EVJF :
           s'il n'y a pas data-oz-option, l'id du groupe est la valeur. */
        var optionValue = getInlineOptionValue(el);
        setDisplay(el, String(optionValue) === selectedValue);
      });
    });
    applySmartFontChoices(svg, state);
    Object.keys(state.toggles || {}).forEach(function (toggleKey) {
      var visible = !!state.toggles[toggleKey];
      Array.prototype.slice.call(svg.querySelectorAll('[data-oz-toggle="' + toggleKey.replace(/"/g, '\\"') + '"]')).forEach(function (el) {
        setDisplay(el, visible);
      });
    });
    applySmartTemplateMoveRules(svg, state);

    var orientation = String(((state.variants || {}).orientation) || (((template.defaultState || {}).orientation) || 'vertical'));
    if (orientation) {
      Array.prototype.slice.call(svg.querySelectorAll('[data-oz-photo-orientation-target="true"]')).forEach(function (el) {
        if (orientation === 'horizontal') {
          el.setAttribute('x', el.getAttribute('data-oz-horizontal-x') || '110');
          el.setAttribute('y', el.getAttribute('data-oz-horizontal-y') || '170');
          el.setAttribute('width', el.getAttribute('data-oz-horizontal-width') || '480');
          el.setAttribute('height', el.getAttribute('data-oz-horizontal-height') || '320');
        } else {
          el.setAttribute('x', el.getAttribute('data-oz-vertical-x') || '170');
          el.setAttribute('y', el.getAttribute('data-oz-vertical-y') || '110');
          el.setAttribute('width', el.getAttribute('data-oz-vertical-width') || '360');
          el.setAttribute('height', el.getAttribute('data-oz-vertical-height') || '480');
        }
      });
    }

    Array.prototype.slice.call(svg.querySelectorAll('[data-oz-flash-workspace]')).forEach(function (espace) {
      var key = String(espace.getAttribute('data-oz-flash-workspace') || '').trim();
      var poses = ((state.flashes || {})[key]) || [];
      var tailleParDefaut = parseFloat(espace.getAttribute('data-oz-flash-size') || '') || 220;

      /* Le plan de travail est reconstruit a chaque rendu : c'est l'etat
         qui fait foi, jamais le DOM precedent. */
      while (espace.firstChild) espace.removeChild(espace.firstChild);

      poses.forEach(function (flash) {
        var source = svg.querySelector('[data-oz-flash-option="' + String(flash.option).replace(/"/g, '\\"') + '"]');
        if (!source) return;

        var href = String(source.getAttribute('href') || source.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || '');
        if (!href) return;

        var largeur = parseFloat(source.getAttribute('data-oz-flash-width') || '') || tailleParDefaut;
        var hauteur = parseFloat(source.getAttribute('data-oz-flash-height') || '') || tailleParDefaut;
        var echelle = Number(flash.scale) || 1;
        var angle = Number(flash.rotate) || 0;

        var image = doc.createElementNS('http://www.w3.org/2000/svg', 'image');
        image.setAttribute('href', href);
        image.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', href);
        image.setAttribute('crossorigin', 'anonymous');
        /* Ancre au centre : c'est ce qui fait tourner et grandir le flash
           autour de lui-meme, et non autour de son coin haut-gauche. */
        image.setAttribute('x', String(-largeur / 2));
        image.setAttribute('y', String(-hauteur / 2));
        image.setAttribute('width', String(largeur));
        image.setAttribute('height', String(hauteur));
        image.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        image.setAttribute(
          'transform',
          'translate(' + (Math.round(Number(flash.x) * 100) / 100) + ' ' + (Math.round(Number(flash.y) * 100) / 100) + ')' +
          (angle ? ' rotate(' + (Math.round(angle * 100) / 100) + ')' : '') +
          (echelle !== 1 ? ' scale(' + (Math.round(echelle * 1000) / 1000) + ')' : '')
        );
        espace.appendChild(image);
      });
    });

    Object.keys(state.transforms || {}).forEach(function (dragKey) {
      var position = state.transforms[dragKey] || {};
      var x = Number(position.x);
      var y = Number(position.y);
      var angle = Number(position.rotate) || 0;
      if (!isFinite(x) || !isFinite(y)) return;

      var echappeDrag = dragKey.replace(/"/g, '\\"');
      Array.prototype.slice.call(svg.querySelectorAll('[data-oz-drag="' + echappeDrag + '"]')).forEach(function (el) {
        el.setAttribute(
          'transform',
          'translate(' + (Math.round(x * 100) / 100) + ' ' + (Math.round(y * 100) / 100) + ')' +
          (angle ? ' rotate(' + (Math.round(angle * 100) / 100) + ')' : '')
        );
      });
    });

    Object.keys(state.images || {}).forEach(function (slotKey) {
      var href = String(state.images[slotKey] || '');
      var echappe = slotKey.replace(/"/g, '\\"');

      /* Reserve visuelle : un groupe marque data-oz-image-placeholder est
         affiche tant que l'emplacement est vide, puis efface des qu'une
         photo arrive. Sans ca, un emplacement libre est un trou blanc et
         le client ne devine pas qu'il peut y deposer quelque chose. */
      Array.prototype.slice.call(
        svg.querySelectorAll('[data-oz-image-placeholder="' + echappe + '"]')
      ).forEach(function (el) {
        setDisplay(el, !href);
      });

      Array.prototype.slice.call(svg.querySelectorAll('[data-oz-image-slot="' + echappe + '"]')).forEach(function (el) {
        if (href) {
          el.setAttribute('href', href);
          el.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', href);
          setDisplay(el, true);

          /* Pour un dessin horizontal ou vertical, le cadre de sélection doit
             suivre le rapport réel de l’image. Un viewBox carré laissait une
             grande zone vide au-dessus et en dessous du dessin. */
          var ratio = Number(((state.imageAspects || {})[slotKey]) || el.getAttribute('data-oz-current-ratio') || 0);
          if (el.getAttribute('data-oz-fit-frame') === 'true' && ratio > 0) {
            var longSide = 860;
            var margin = 20;
            var center = 500;
            var imageWidth = ratio >= 1 ? longSide : longSide * ratio;
            var imageHeight = ratio >= 1 ? longSide / ratio : longSide;
            var boxWidth = imageWidth + margin * 2;
            var boxHeight = imageHeight + margin * 2;
            var imageX = center - imageWidth / 2;
            var imageY = center - imageHeight / 2;
            var boxX = center - boxWidth / 2;
            var boxY = center - boxHeight / 2;
            function cleanNumber(value) { return String(Math.round(value * 100) / 100); }
            el.setAttribute('x', cleanNumber(imageX));
            el.setAttribute('y', cleanNumber(imageY));
            el.setAttribute('width', cleanNumber(imageWidth));
            el.setAttribute('height', cleanNumber(imageHeight));
            el.setAttribute('data-oz-current-ratio', cleanNumber(ratio));
            svg.setAttribute('viewBox', [boxX, boxY, boxWidth, boxHeight].map(cleanNumber).join(' '));
            svg.setAttribute('width', cleanNumber(boxWidth));
            svg.setAttribute('height', cleanNumber(boxHeight));
          }
        } else if (el.getAttribute('data-oz-hide-when-empty') === 'true' || slotKey === 'photo_famille') {
          var referenceHref = slotKey === 'photo_famille' ? String(el.getAttribute('data-oz-reference-href') || '') : '';
          if (referenceHref) {
            el.setAttribute('href', referenceHref);
            el.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', referenceHref);
          }
          setDisplay(el, !!referenceHref);
        }
      });
    });

    return new XMLSerializer().serializeToString(doc);
  }

  function hydrateTemplateMetadataFromImg(img, wrapper) {
    if (!img || !wrapper || wrapper.dataset.templateId) return;
    var markup = decodeSvgDataUri(img.getAttribute('src') || '');
    if (!markup) return;
    try {
      var doc = parseSvg(markup);
      var svg = doc.documentElement;
      var templateId = String(svg.getAttribute('data-oz-template-id') || '').trim();
      if (!templateId) return;
      var template = getTemplateById(templateId);
      wrapper.dataset.templateId = templateId;
      wrapper.dataset.templateKey = String(svg.getAttribute('data-oz-template-key') || (template ? template.key : '') || '').trim();
      wrapper.dataset.templateTitle = String(svg.getAttribute('data-oz-template-title') || (template ? template.title : templateId)).trim();
      wrapper.dataset.templateKind = (template && template.sourceKind === 'image') ? 'smart-image' : 'smart-svg';
    } catch (e) {}
  }

  function hydrateAllTemplateItems(scope) {
    var root = scope || document;
    Array.prototype.slice.call(root.querySelectorAll('.design-item[data-type="image"], .design-item')).forEach(function (wrapper) {
      var img = wrapper.querySelector('img');
      if (!img) return;
      hydrateTemplateMetadataFromImg(img, wrapper);
    });
  }

  function getSelectedTemplateItem() {
    var selected = document.querySelector('.design-item.selected[data-template-id]');
    if (selected) return selected;
    var anySelected = document.querySelector('.design-item.selected');
    if (anySelected) {
      hydrateTemplateMetadataFromImg(anySelected.querySelector('img'), anySelected);
      if (anySelected.dataset.templateId) return anySelected;
    }
    return null;
  }

  async function getTemplateMarkup(template, editingItem) {
    if (editingItem) {
      /* Réutiliser le SVG du canvas uniquement quand on rouvre exactement le
         même modèle. Lors d'un « Changer de design », il faut charger le SVG
         du nouveau modèle puis remplacer le visuel existant. */
      var editingTemplateId = String(editingItem.dataset.templateId || '').trim();
      var editingTemplateKey = String(editingItem.dataset.templateKey || '').trim();
      var isSameTemplate = (editingTemplateId && editingTemplateId === template.id) ||
        (editingTemplateKey && editingTemplateKey === template.key);
      if (isSameTemplate) {
        var editingImg = editingItem.querySelector('img');
        var currentMarkup = decodeSvgDataUri(editingImg ? editingImg.getAttribute('src') || '' : '');
        if (currentMarkup) return currentMarkup;
      }
    }
    if (template.svgMarkup) return template.svgMarkup;
    if (templateCache.has(template.id)) return templateCache.get(template.id);
    if (template.sourceKind === 'image' && template.mediaUrl) {
      var imageMarkup = buildImageWrapperSvg(template.mediaUrl);
      templateCache.set(template.id, imageMarkup);
      return imageMarkup;
    }
    var response = await fetch(template.svgUrl || template.mediaUrl, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Impossible de charger le modèle.');
    var markup = await response.text();
    templateCache.set(template.id, markup);
    return markup;
  }

  function renderLibrary() {
    if (!runtime.list) return;
    var visibleTemplates = getVisibleTemplates();
    runtime.list.innerHTML = '';
    if (!visibleTemplates.length) {
      runtime.list.innerHTML = '<div class="oz-smarttpl-empty-state">Aucun modèle ne correspond à votre recherche ou à la technique sélectionnée.</div>';
      syncMobileCompactState();
      return;
    }

    visibleTemplates.forEach(function (template) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'oz-smarttpl-card' + ((runtime.activeTemplate && runtime.activeTemplate.id === template.id) ? ' is-active' : '');
      button.setAttribute('data-template-id', template.id);
      button.innerHTML = [
        '<span class="oz-smarttpl-card-thumb">',
        template.preview
          ? '<img src="' + escapeHtml(template.preview) + '" alt="' + escapeHtml(template.title) + '">'
          : '<span class="oz-smarttpl-card-fallback">' + escapeHtml((template.sourceKind === 'image' ? 'IMG' : 'SVG')) + '</span>',
        '</span>',
        '<span class="oz-smarttpl-card-texts">',
        '<strong>' + escapeHtml(template.title) + '</strong>',
        template.description ? '<small>' + escapeHtml(template.description) + '</small>' : '<small>' + escapeHtml((template.tags || []).join(' • ')) + '</small>',
        '</span>'
      ].join('');
      if (template.sourceKind !== 'image') {
        hydrateDesignLibraryTile(button, {
          type: 'smart-template',
          templateId: template.id,
          templateKey: template.key,
          svgMarkup: template.svgMarkup || ''
        });
      }
      button.addEventListener('click', function () {
        selectTemplate(template.id, {
          userInitiated: true,
          editingItem: runtime.editingItem || null
        });
      });
      runtime.list.appendChild(button);
    });
    syncMobileCompactState();
  }

  function renderEmptyEditor(message) {
    if (!runtime.preview || !runtime.controls || !runtime.title || !runtime.subtitle) return;
    runtime.title.textContent = 'Choisissez un modèle';
    runtime.subtitle.textContent = message || 'Sélectionnez un SVG personnalisable dans la bibliothèque.';
    runtime.preview.removeAttribute('src');
    runtime.preview.alt = '';
    runtime.preview.hidden = true;
    runtime.controls.innerHTML = '<div class="oz-smarttpl-empty-state">Ajoutez des attributs <code>data-oz-*</code> ou des blocs d’options de slot dans votre schéma Shopify.</div>';
    setMobileCompactState(false);
    if (runtime.applyBtn) runtime.applyBtn.textContent = 'Ajouter au produit';
  }

  /*
   * Quand un modele propose des variantes, chacune n'expose qu'une partie
   * des champs : choisir « 2 animaux » ne doit pas faire apparaitre les
   * emplacements photo des animaux 3 et 4, qui ne seront jamais imprimes.
   * On applique les choix courants sur une copie du SVG et on releve les
   * champs qui restent visibles.
   */
  function clesVisibles(meta, state) {
    if (!runtime.activeMarkup || !(meta.choices || []).length) return null;

    try {
      var doc = parseSvg(runtime.activeMarkup);
      var svg = doc.documentElement;

      (meta.choices || []).forEach(function (groupe) {
        var choisi = String(state.choices[groupe.key] || '');
        getInlineChoiceNodes(svg, groupe.key).forEach(function (el) {
          setDisplay(el, getInlineOptionValue(el) === choisi);
        });
      });

      function masque(el, ignorerSoi) {
        var noeud = ignorerSoi ? el.parentNode : el;
        while (noeud && noeud !== svg) {
          if (noeud.getAttribute && String(noeud.getAttribute('display') || '') === 'none') return true;
          noeud = noeud.parentNode;
        }
        return false;
      }

      function releve(selecteur, attribut, ignorerSoi) {
        var vus = {};
        Array.prototype.slice.call(svg.querySelectorAll(selecteur)).forEach(function (el) {
          if (!masque(el, ignorerSoi)) vus[String(el.getAttribute(attribut) || '')] = true;
        });
        return vus;
      }

      return {
        images: releve('[data-oz-image-slot]', 'data-oz-image-slot', true),
        texts: releve('[data-oz-field]', 'data-oz-field')
      };
    } catch (e) {
      return null;
    }
  }

  function getSmartImageSlot(slotKey) {
    return ((runtime.activeMeta && runtime.activeMeta.imageSlots) || []).find(function (slot) {
      return String(slot.key || '') === String(slotKey || '');
    }) || null;
  }

  function smartAiDataUriToBlob(uri) {
    var match = String(uri || '').match(/^data:([^;,]*)(;base64)?,([\s\S]*)$/i);
    if (!match) throw new Error('L’aperçu du dessin est invalide.');
    var type = match[1] || 'application/octet-stream';
    var contenu;
    try {
      contenu = match[2]
        ? window.atob(match[3].replace(/\s/g, ''))
        : decodeURIComponent(match[3]);
    } catch (e) {
      throw new Error('L’aperçu du dessin ne peut pas être décodé.');
    }
    var octets = new Uint8Array(contenu.length);
    for (var i = 0; i < contenu.length; i++) octets[i] = contenu.charCodeAt(i) & 255;
    return new Blob([octets], { type: type });
  }

  function smartAiBlobName(blob) {
    var type = String((blob && blob.type) || '').toLowerCase();
    if (/jpe?g/.test(type)) return 'dessin.jpg';
    if (/webp/.test(type)) return 'dessin.webp';
    return 'dessin.png';
  }

  function smartAiHistoryDb() {
    return new Promise(function (resolve, reject) {
      if (!window.indexedDB) return reject(new Error('Historique indisponible'));
      var request = indexedDB.open('oazar-ai-illustrations', 1);
      request.onupgradeneeded = function () {
        if (!request.result.objectStoreNames.contains('images')) request.result.createObjectStore('images', { keyPath: 'id' });
      };
      request.onsuccess = function () { resolve(request.result); };
      request.onerror = function () { reject(request.error); };
    });
  }

  function loadSmartAiHistory() {
    if (runtime.aiHistoryLoaded) return Promise.resolve(runtime.aiHistory);
    return smartAiHistoryDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var transaction = db.transaction('images', 'readwrite');
        var store = transaction.objectStore('images');
        var items = [];
        var cutoff = Date.now() - (90 * 86400000);
        var request = store.getAll();
        request.onsuccess = function () {
          (request.result || []).forEach(function (item) {
            if (!item.createdAt || item.createdAt < cutoff || !item.blob) store.delete(item.id);
            else items.push(item);
          });
        };
        transaction.oncomplete = function () { resolve(items); };
        transaction.onerror = function () { reject(transaction.error); };
      }).finally(function () { db.close(); });
    }).then(function (items) {
      runtime.aiHistory.forEach(function (item) { if (item.preview) URL.revokeObjectURL(item.preview); });
      runtime.aiHistory = items.sort(function (a, b) { return b.createdAt - a.createdAt; }).map(function (item) {
        item.preview = URL.createObjectURL(item.blob);
        return item;
      });
      runtime.aiHistoryLoaded = true;
      if (runtime.activeState && runtime.controls) renderEditor();
      return runtime.aiHistory;
    }).catch(function () { return runtime.aiHistory; });
  }

  function saveSmartAiHistory(slotKey, image) {
    var blobJob = /^data:/i.test(String(image || ''))
      ? Promise.resolve(smartAiDataUriToBlob(image))
      : smartAiSourceBlob(image);
    return blobJob.then(function (blob) {
      if (!blob || !blob.size) return;
      var now = Date.now();
      var entry = { id: now + '-' + Math.random().toString(36).slice(2), slotKey: slotKey, source: slotKey === 'photo_famille' ? 'family_illustration' : 'smart_template', createdAt: now, blob: blob };
      // Show the new illustration immediately, even when browser storage is unavailable.
      entry.preview = URL.createObjectURL(blob);
      runtime.aiHistory.unshift(entry);
      runtime.aiHistoryLoaded = true;
      if (runtime.activeState && runtime.controls) renderEditor();
      return smartAiHistoryDb().then(function (db) {
        return new Promise(function (resolve, reject) {
          var transaction = db.transaction('images', 'readwrite');
          var store = transaction.objectStore('images');
          var all = store.getAll();
          all.onsuccess = function () {
            var cutoff = now - (90 * 86400000);
            var slotCounts = {};
            (all.result || []).sort(function (a, b) { return b.createdAt - a.createdAt; }).forEach(function (item) {
              var key = String(item.slotKey || '');
              slotCounts[key] = (slotCounts[key] || 0) + 1;
              if (!item.createdAt || item.createdAt < cutoff || slotCounts[key] >= 24) store.delete(item.id);
            });
            store.put({ id: entry.id, slotKey: entry.slotKey, source: entry.source, createdAt: entry.createdAt, blob: entry.blob });
          };
          transaction.oncomplete = resolve;
          transaction.onerror = function () { reject(transaction.error); };
        }).finally(function () { db.close(); });
      });
    }).catch(function (error) {
      console.warn('[oazar] Historique des illustrations indisponible', error);
      return runtime.aiHistory;
    });
  }

  function smartAiHistoryHtml(slot) {
    if (!slot.ai) return '';
    var items = runtime.aiHistory.filter(function (item) {
      return item.slotKey === slot.key && (slot.key !== 'photo_famille' || !item.source || item.source === 'family_illustration');
    }).slice(0, 12);
    return '<div class="oz-smarttpl-ai-history"><strong>Mes illustrations ' + (slot.key === 'photo_famille' ? 'de famille ' : '') + 'sur cet appareil</strong><small style="display:block;margin-top:6px">Conservées 90 jours sur cet appareil.</small>' + (items.length ? '<div class="oz-smarttpl-ai-history__grid">' : '<small style="display:block;margin-top:6px">Vos prochaines illustrations créées ici apparaîtront dans cette galerie.</small>') +
      items.map(function (item) {
        return '<button type="button" data-ai-history-id="' + escapeHtml(item.id) + '" data-ai-history-slot="' + escapeHtml(slot.key) + '" aria-label="Réutiliser cette illustration"><img src="' + escapeHtml(item.preview) + '" alt="Illustration créée précédemment" loading="lazy"></button>';
      }).join('') + (items.length ? '</div>' : '') + '</div>';
  }

  function smartAiAbsoluteUrl(url, base) {
    try { return new URL(url, base).href; } catch (e) { return url; }
  }

  function updateSmartAiProgress(slotKey) {
    if (!runtime.controls) return;
    var run = runtime.aiImageRuns[slotKey];
    var card = runtime.controls.querySelector('.oz-smarttpl-image-slot[data-smart-ai-slot="' + slotKey.replace(/"/g, '\\"') + '"]');
    if (!card || !run) return;
    var status = card.querySelector('[data-smart-ai-status]');
    var button = card.querySelector('[data-run-image-ai]');
    var slot = getSmartImageSlot(slotKey);
    var ai = slot && slot.ai;
    if (!ai) return;
    if (status && run.status === 'running') {
      status.textContent = ai.loading + (run.seconds ? ' ' + run.seconds + ' s' : '');
    }
    if (button && run.status === 'running') {
      button.disabled = true;
      button.textContent = ai.busy + (run.seconds ? ' ' + run.seconds + ' s' : '');
    }
  }

  function smartAiSourceBlob(source) {
    if (typeof Blob !== 'undefined' && source instanceof Blob) return Promise.resolve(source);
    if (/^data:/i.test(String(source || ''))) {
      try { return Promise.resolve(smartAiDataUriToBlob(source)); }
      catch (e) { return Promise.reject(e); }
    }
    return fetch(String(source || ''), { mode: 'cors', credentials: 'omit', cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('Le dessin importé ne peut pas être relu (HTTP ' + res.status + ').');
        return res.blob();
      });
  }

  function postFamilyImageInChunks(blob, ai, signal) {
    if (blob.size > 10 * 1024 * 1024) {
      return Promise.reject(new Error('La photo dépasse la limite de 10 Mo.'));
    }
    var endpoint = String(ai.endpoint || '');
    function request(action, query, body) {
      var url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'action=' + action + (query || '');
      return fetch(url, {
        method: 'POST',
        body: body,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
        mode: 'cors', credentials: 'omit', cache: 'no-store', signal: signal
      }).then(function (response) {
        return response.text().then(function (bodyText) {
          var data;
          try { data = JSON.parse(bodyText); }
          catch (e) { throw new Error('Le serveur a refusé l’envoi de la photo (HTTP ' + response.status + ').'); }
          if (!response.ok || !data || data.success !== true) {
            throw new Error((data && data.error) || ('Erreur serveur ' + response.status + '.'));
          }
          return data;
        });
      });
    }
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = function () { reject(new Error('La photo ne peut pas être lue.')); };
      reader.onload = function () { resolve(String(reader.result || '').split(',')[1] || ''); };
      reader.readAsDataURL(blob);
    }).then(function (encoded) {
      if (!encoded) throw new Error('La photo est vide.');
      return request('init', '&preset=' + encodeURIComponent(ai.preset || 'family_semi_faceless_v1'), 'init')
        .then(function (started) {
          var job = encodeURIComponent(started.job_id || '');
          if (!job) throw new Error('La génération n’a pas démarré.');
          var chunkSize = 60000;
          function sendPart(index) {
            var start = index * chunkSize;
            if (start >= encoded.length) {
              return request('finish', '&job=' + job, 'finish');
            }
            return request('chunk', '&job=' + job + '&part=' + index, encoded.slice(start, start + chunkSize))
              .then(function () { return sendPart(index + 1); });
          }
          return sendPart(0);
        });
    });
  }

  function runSmartImageAi(slotKey) {
    var slot = getSmartImageSlot(slotKey);
    if (!slot || !slot.ai || !runtime.activeState) return Promise.resolve(false);
    var source = runtime.aiImageSources[slotKey] || runtime.activeState.images[slotKey];
    if (!source) {
      notify('Importez d’abord le dessin de l’enfant.', 'warning');
      return Promise.resolve(false);
    }

    var precedent = runtime.aiImageRuns[slotKey];
    if (precedent && precedent.status === 'running') return precedent.promise || Promise.resolve(false);

    var ai = slot.ai;
    var session = runtime.aiImageSession;
    var controller = ('AbortController' in window) ? new AbortController() : null;
    var run = {
      status: 'running',
      seconds: 0,
      error: '',
      controller: controller,
      promise: null
    };
    runtime.aiImageRuns[slotKey] = run;
    renderEditor();
    rerenderPreview();

    var interval = window.setInterval(function () {
      run.seconds += 1;
      updateSmartAiProgress(slotKey);
    }, 1000);
    var expired = false;
    var timeout = window.setTimeout(function () {
      expired = true;
      if (controller) {
        try { controller.abort(); } catch (e) {}
      }
    }, ai.timeoutMs);

    run.promise = smartAiSourceBlob(source)
      .then(function (blob) {
        if (slotKey === 'photo_famille') {
          return postFamilyImageInChunks(blob, ai, controller ? controller.signal : undefined)
            .then(function (data) {
              return { ok: true, status: 202, text: function () { return Promise.resolve(JSON.stringify(data)); } };
            });
        }
        var form = new FormData();
        form.append('image', blob, smartAiBlobName(blob));
        form.append('mode', ai.mode || 'child_drawing_cutout');
        form.append('preset', ai.preset || 'child_drawing_cutout_exact');
        form.append('slot_id', String(slotKey || 'dessin_enfant'));
        form.append('fields_json', '{}');
        return fetch(String(ai.endpoint || ''), {
          method: 'POST',
          body: form,
          headers: { Accept: 'application/json' },
          mode: 'cors',
          credentials: 'omit',
          cache: 'no-store',
          signal: controller ? controller.signal : undefined
        });
      })
      .then(function (res) {
        return res.text().then(function (txt) {
          var json = null;
          try { json = JSON.parse(String(txt || '').replace(/^\uFEFF/, '').trim()); }
          catch (e) { throw new Error('Réponse serveur illisible (HTTP ' + res.status + ').'); }
          if (!res.ok || !json || json.success !== true) {
            throw new Error((json && json.error) || ('Erreur serveur ' + res.status + '.'));
          }
          var url = String(json.image_url || json.url || ((json.data || {}).image_url) || '').trim();
          if (url) return smartAiAbsoluteUrl(url, ai.endpoint);
          var statusUrl = String(json.status_url || '').trim();
          if (!statusUrl || !json.job_id) throw new Error('La g\u00e9n\u00e9ration de l\u2019illustration n\u2019a pas d\u00e9marr\u00e9.');
          statusUrl = smartAiAbsoluteUrl(statusUrl, ai.endpoint);
          function waitForFamilyResult() {
            return new Promise(function (resolve) { window.setTimeout(resolve, 2500); }).then(function () {
              if (controller && controller.signal.aborted) throw new Error('G\u00e9n\u00e9ration interrompue.');
              return fetch(statusUrl, { mode: 'cors', credentials: 'omit', cache: 'no-store', signal: controller ? controller.signal : undefined });
            }).then(function (statusResponse) {
              return statusResponse.json().then(function (status) {
                if (!statusResponse.ok || status.state === 'error') throw new Error(status.error || 'La cr\u00e9ation de l\u2019illustration a \u00e9chou\u00e9.');
                if (status.state === 'done') {
                  var imageUrl = String(status.image_url || '').trim();
                  if (!imageUrl) throw new Error('L\u2019illustration termin\u00e9e est introuvable.');
                  return statusUrl + (statusUrl.indexOf('?') === -1 ? '?' : '&') + 'image=1';
                }
                return waitForFamilyResult();
              });
            });
          }
          return waitForFamilyResult();
        });
      })
      .then(function (resultUrl) {
        if (slotKey !== 'photo_famille') return resultUrl;
        return urlVersDataUri(resultUrl).then(function (embedded) {
          if (!/^data:image\//i.test(embedded)) throw new Error('L\u2019illustration g\u00e9n\u00e9r\u00e9e ne peut pas \u00eatre affich\u00e9e. R\u00e9essayez.');
          return new Promise(function (resolve, reject) {
            var check = new Image();
            check.onload = function () {
              if (check.naturalWidth && check.naturalHeight) resolve(embedded);
              else reject(new Error('L\u2019illustration g\u00e9n\u00e9r\u00e9e est vide. R\u00e9essayez.'));
            };
            check.onerror = function () { reject(new Error('L\u2019illustration g\u00e9n\u00e9r\u00e9e est illisible. R\u00e9essayez.')); };
            check.src = embedded;
          });
        });
      })
      .then(function (resultUrl) {
        if (session !== runtime.aiImageSession || !runtime.activeState || runtime.aiImageRuns[slotKey] !== run) return false;
        runtime.activeState.images[slotKey] = resultUrl;
        run.status = 'success';
        run.error = '';
        saveSmartAiHistory(slotKey, resultUrl);
        renderEditor();
        rerenderPreview();
        notify(ai.success, 'success');
        return true;
      })
      .catch(function (err) {
        if (session !== runtime.aiImageSession || runtime.aiImageRuns[slotKey] !== run) return false;
        function showFailure() {
          var message = (err && err.message && !/^(Failed to fetch|NetworkError|Load failed)/i.test(err.message))
            ? err.message
            : (slotKey === 'photo_famille'
              ? 'Le service de portrait est temporairement indisponible. R\u00e9essayez sans remplacer votre photo.'
              : 'Le d\u00e9tourage est indisponible pour le moment. R\u00e9essayez.');
          run.status = 'error';
          run.error = message;
          renderEditor();
          rerenderPreview();
          notify(message, 'error');
          return false;
        }
        return showFailure();
      })
      .finally(function () {
        window.clearInterval(interval);
        window.clearTimeout(timeout);
      });

    return run.promise;
  }

  function smartAiBlockingReason() {
    var meta = runtime.activeMeta || {};
    var state = runtime.activeState || { images: {} };
    var slots = meta.imageSlots || [];
    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      var current = String((state.images || {})[slot.key] || '').trim();
      if (slot.required && !current) return slot.ai ? slot.ai.requiredText : ('Importez « ' + slot.label + ' ».');
      if (slot.ai && slot.ai.required) {
        var run = runtime.aiImageRuns[slot.key];
        if (!current || !run || run.status !== 'success') return slot.ai.requiredText;
      }
    }
    return '';
  }


  var smartLiveRenderFrame = 0;
  function queueSmartLiveRender() {
    if (smartLiveRenderFrame) cancelAnimationFrame(smartLiveRenderFrame);
    smartLiveRenderFrame = requestAnimationFrame(function () {
      smartLiveRenderFrame = 0;
      rerenderPreviewNow();
    });
  }

  function renderEditor() {
    if (!runtime.activeTemplate || !runtime.activeMeta || !runtime.activeState) {
      renderEmptyEditor('Sélectionnez un modèle pour voir les champs de personnalisation.');
      return;
    }

    var previousScrollTop = 0;
    if (runtime.controls) {
      previousScrollTop = runtime.controls.scrollTop || 0;
    }
    runtime.editorState = runtime.editorState || { scrollTop: 0 };
    runtime.editorState.scrollTop = previousScrollTop;

    var meta = runtime.activeMeta;
    var state = runtime.activeState;
    var sections = [];
    initSmartTemplatePreviewDrag();
    var visibles = clesVisibles(meta, state);
    var templatePalette = runtime.activeTemplate.presetColors || [];

    function openSection(title, inner) {
      return [
        '<section class="oz-smarttpl-group">',
        '<h4 class="oz-smarttpl-group-title">' + escapeHtml(title) + '</h4>',
        '<div class="oz-smarttpl-group-body">', inner, '</div>',
        '</section>'
      ].join('');
    }

    function syncColorUi(fieldKey, value) {
      if (!runtime.controls) return;
      var normalized = String(value || '').trim();
      runtime.controls.querySelectorAll('[data-field-group="colors"][data-field-key="' + fieldKey + '"]').forEach(function (node) {
        if (node.value !== normalized) node.value = normalized;
        var wrap = node.closest ? node.closest('.oz-smarttpl-color-input-wrap') : null;
        var label = wrap ? wrap.querySelector('small') : null;
        if (wrap) {
          wrap.style.setProperty('--oz-current-color', normalized);
          wrap.style.setProperty('--oz-current-ink', oazarStudioColorInk(normalized));
        }
        if (label) label.textContent = oazarStudioColorName(normalized);
      });
      runtime.controls.querySelectorAll('[data-color-swatch-key="' + fieldKey + '"]').forEach(function (node) {
        var active = String(node.getAttribute('data-color-swatch-value') || '').toLowerCase() === normalized.toLowerCase();
        node.classList.toggle('is-active', active);
        node.setAttribute('aria-pressed', String(active));
      });
    }

    if ((meta.dates || []).length) {
      sections.push(openSection('Date de naissance', meta.dates.map(function (field) {
        var value = normalizeOzDateValue(state.dates[field.key] || field.defaultValue || '');
        return [
          '<label class="oz-smarttpl-field">',
          '<span>' + escapeHtml(field.label) + '</span>',
          '<input data-field-group="dates" data-field-key="' + escapeHtml(field.key) + '" type="date" value="' + escapeHtml(value) + '"', field.required ? ' required' : '', '>',
          '</label>'
        ].join('');
      }).join(''), true));
    }

    if ((meta.texts || []).length) {
      var fontOptionsMap = (((runtime.activeTemplate || {}).defaultState || {}).font_options) || {};
      sections.push(openSection('Textes', meta.texts.filter(function (field) {
        return !visibles || visibles.texts[field.key];
      }).map(function (field) {
        var value = state.texts[field.key] || '';
        var chunks = [];
        if (field.multiline) {
          chunks.push([
            '<label class="oz-smarttpl-field">',
            '<span>' + escapeHtml(field.label) + '</span>',
            '<textarea data-field-group="texts" data-field-key="' + escapeHtml(field.key) + '" rows="3" placeholder="' + escapeHtml(field.placeholder || '') + '">' + escapeHtml(value) + '</textarea>',
            '</label>'
          ].join(''));
        } else {
          chunks.push([
            '<label class="oz-smarttpl-field">',
            '<span>' + escapeHtml(field.label) + '</span>',
            '<input data-field-group="texts" data-field-key="' + escapeHtml(field.key) + '" type="text" value="' + escapeHtml(value) + '" placeholder="' + escapeHtml(field.placeholder || '') + '">',
            '</label>'
          ].join(''));
        }
        var fontOptions = getSmartTemplateFontOptions(runtime.activeTemplate || {}, field, fontOptionsMap || {});
        if (field.allowFont !== false && fontOptions.length) {
          var currentFont = (state.fonts && state.fonts[field.key]) || field.defaultFont || fontOptions[0] || 'Arial';

          chunks.push([
            '<div class="oz-smarttpl-field oz-smarttpl-font-field">',
            '<span>Police du ' + escapeHtml(field.label.toLowerCase()) + '</span>',
            '<div class="oz-smarttpl-font-slider">',
            '<button type="button" class="oz-smarttpl-font-arrow" data-oz-font-slide="-1" aria-label="Polices précédentes">‹</button>',
            '<div class="oz-smarttpl-font-grid">',
            fontOptions.map(function (fontName) {
              var selected = String(fontName) === String(currentFont);
              var safeFamily = String(fontName || '').replace(/"/g, '');
              /* Les polices Google sont déjà chargées par la section Liquid.
                 Les polices Oazar sont préparées pour le SVG et la page. */
              ensureGoogleSmartFontSource(fontName);

              return [
                '<button type="button" class="oz-smarttpl-font-choice', selected ? ' is-active' : '', '"',
                ' data-font-choice-key="' + escapeHtml(field.key) + '"',
                ' data-font-choice-value="' + escapeHtml(fontName) + '">',
                '<span class="oz-smarttpl-font-sample" style="font-family:&quot;' + escapeHtml(safeFamily) + '&quot;,Arial,sans-serif;">Aa</span>',
                '<small>' + escapeHtml(fontName) + '</small>',
                '</button>'
              ].join('');
            }).join(''),
            '</div>',
            '<button type="button" class="oz-smarttpl-font-arrow" data-oz-font-slide="1" aria-label="Polices suivantes">›</button>',
            '</div>',
            '</div>'
          ].join(''));
        }
        if (field.hasOwnColor) return chunks.join('');

        var textColorKey = buildTextColorStateKey(field.key);
        var textColorValue = (state.colors && state.colors[textColorKey]) || field.defaultColor || '#111111';
        var textPalette = uniqueByKey([].concat(
          (field.colorPalette || []).map(function (c) { return { key: c, value: c }; }),
          OAZAR_STUDIO_PALETTE.map(function (entry) { return { key: entry[1], value: entry[1] }; }),
          [{ key: textColorValue, value: textColorValue }]
        ), 'key').map(function (entry) { return entry.value; });
        chunks.push([
          '<div class="oz-smarttpl-field oz-smarttpl-color-field">',
          '<span>Couleur du ' + escapeHtml(field.label.toLowerCase()) + '</span>',
          '<div class="oz-smarttpl-color-stack">',
          '<span class="oz-smarttpl-color-input-wrap" style="--oz-current-color:' + escapeHtml(textColorValue) + ';--oz-current-ink:' + oazarStudioColorInk(textColorValue) + '">',
          '<input data-field-group="colors" data-field-key="' + escapeHtml(textColorKey) + '" type="color" value="' + escapeHtml(textColorValue) + '">',
          '<small>' + escapeHtml(oazarStudioColorName(textColorValue)) + '</small>',
          oazarStudioIcon('edit'),
          '</span>',
          textPalette.length ? (
            '<div class="oz-smarttpl-swatch-row">' + textPalette.map(function (color) {
              var active = String(color).toLowerCase() === String(textColorValue).toLowerCase();
              return '<button type="button" class="oz-smarttpl-swatch oz-color-option' + (active ? ' is-active' : '') + '" style="--oz-swatch:' + escapeHtml(color) + ';" data-color-swatch-key="' + escapeHtml(textColorKey) + '" data-color-swatch-value="' + escapeHtml(color) + '" aria-label="' + escapeHtml(oazarStudioColorName(color)) + '" aria-pressed="' + active + '"><span class="oz-color-option-chip"></span><span class="oz-color-option-label">' + escapeHtml(oazarStudioColorName(color)) + '</span>' + oazarStudioIcon('check') + '</button>';
            }).join('') + '</div>'
          ) : '',
          '</div>',
          '</div>'
        ].join(''));
        return chunks.join('');
      }).join(''), true));
    }

    if ((meta.colors || []).length) {
      sections.push(openSection('Couleurs', meta.colors.map(function (field) {
        var value = state.colors[field.key] || '#111111';
        var palette = uniqueByKey([].concat(
          (field.palette || []).map(function (c) { return { key: c, value: c }; }),
          templatePalette.map(function (c) { return { key: c, value: c }; }),
          [{ key: value, value: value }]
        ), 'key').map(function (entry) { return entry.value; });

        return [
          '<div class="oz-smarttpl-field oz-smarttpl-color-field">',
          '<span>' + escapeHtml(field.label) + '</span>',
          '<div class="oz-smarttpl-color-stack">',
          '<span class="oz-smarttpl-color-input-wrap" style="--oz-current-color:' + escapeHtml(value) + ';--oz-current-ink:' + oazarStudioColorInk(value) + '">',
          '<input data-field-group="colors" data-field-key="' + escapeHtml(field.key) + '" type="color" value="' + escapeHtml(value) + '">',
          '<small>' + escapeHtml(oazarStudioColorName(value)) + '</small>',
          oazarStudioIcon('edit'),
          '</span>',
          palette.length ? (
            '<div class="oz-smarttpl-swatch-row">' + palette.map(function (color) {
              var active = String(color).toLowerCase() === String(value).toLowerCase();
              return '<button type="button" class="oz-smarttpl-swatch oz-color-option' + (active ? ' is-active' : '') + '" style="--oz-swatch:' + escapeHtml(color) + ';" data-color-swatch-key="' + escapeHtml(field.key) + '" data-color-swatch-value="' + escapeHtml(color) + '" aria-label="' + escapeHtml(oazarStudioColorName(color)) + '" aria-pressed="' + active + '"><span class="oz-color-option-chip"></span><span class="oz-color-option-label">' + escapeHtml(oazarStudioColorName(color)) + '</span>' + oazarStudioIcon('check') + '</button>';
            }).join('') + '</div>'
          ) : '',
          '</div>',
          '</div>'
        ].join('');
      }).join('')));
    }

    if ((meta.choices || []).length) {
      /* Le choix du modele passe en tete et s'ouvre par defaut : c'est la
         decision la plus structurante, et celle qui arrive de la fiche produit. */
      sections.unshift(openSection('Variantes', meta.choices.map(function (group) {
        return [
          '<div class="oz-smarttpl-field">',
          '<span>' + escapeHtml(group.label) + '</span>',
          '<div class="oz-smarttpl-choice-grid">',
          (group.options || []).map(function (option) {
            var isActive = String(state.choices[group.key] || '') === String(option.value || '');
            var preview = option.preview;
            var fontPreview = '';

            if (option.fontFamily) {
              ensureSmartFontChoiceLoaded(option);
              fontPreview = [
                '<span class="oz-smarttpl-choice-font-preview" style="',
                escapeHtml('display:flex;align-items:center;justify-content:center;min-height:72px;overflow:hidden;font-family:"' + option.fontFamily + '",' + (option.fontFallback || 'serif') + ';font-weight:' + (option.fontWeight || '400') + ';font-size:24px;line-height:1;'),
                '">',
                escapeHtml(option.fontPreview || 'PARIS'),
                '</span>'
              ].join('');
            }

            if (!fontPreview && !preview && option.source !== 'external') {
              preview = buildInlineChoicePreview(
                runtime.activeMarkup,
                runtime.activeTemplate,
                group.key,
                option.value
              );
            }

            return [
              '<button type="button" class="oz-smarttpl-choice', isActive ? ' is-active' : '', '" data-choice-slot="', escapeHtml(group.key), '" data-choice-value="', escapeHtml(option.value), '">',
              fontPreview || (preview
                ? '<img class="oz-smarttpl-choice-thumb" src="' + escapeHtml(preview) + '" alt="' + escapeHtml(option.label) + '" loading="lazy">'
                : '<span class="oz-smarttpl-choice-fallback">' + escapeHtml((option.label || '').slice(0, 1).toUpperCase()) + '</span>'),
              '<span>' + escapeHtml(option.label) + '</span>',
              '</button>'
            ].join('');
          }).join(''),
          '</div>',
          '</div>'
        ].join('');
      }).join(''), true));
    }

    /* Variantes puis Emplacement occupent la tete de liste quand ils
       existent : les photos se glissent juste apres. */
    function indexApresVariantes() {
      var n = 0;
      if ((meta.choices || []).length) n += 1;
      if (getAvailableViews().length > 1) n += 1;
      return Math.min(n, sections.length);
    }

    var emplacementSection = '';
    var vuesDisponibles = getAvailableViews();
    if (vuesDisponibles.length > 1) {
      var vueCourante = currentViewName();
      emplacementSection = openSection('Emplacement', [
        '<div class="oz-smarttpl-field">',
        '<span>Où placer le design</span>',
        '<div class="oz-smarttpl-choice-grid oz-smarttpl-placement-grid" style="display:grid;grid-template-columns:repeat(' +
        Math.min(4, vuesDisponibles.length) + ',minmax(0,1fr));gap:10px;">',
        vuesDisponibles.map(function (vue) {
          var active = vue.value === vueCourante;

          return [
            '<button type="button" class="oz-smarttpl-choice oz-smarttpl-placement-choice', active ? ' is-active' : '',
            '" data-template-view="', escapeHtml(vue.value), '">',
            '<span class="view-thumb oz-smarttpl-view-thumb" data-view-thumb="', escapeHtml(vue.value),
            '" style="', vue.thumb ? 'background-image:' + vue.thumb : '',
            '"></span>',
            '<span>', escapeHtml(vue.label), '</span>',
            '</button>'
          ].join('');
        }).join(''),
        '</div>',
        '</div>'
      ].join(''), false);
    }

    var photoFormats = ((((runtime.activeTemplate || {}).defaultState || {}).photo_formats) || []);
    if (photoFormats.length > 1) {
      sections.push(openSection('Format photo', [
        '<div class="oz-smarttpl-field">',
        '<span>Orientation</span>',
        '<div class="oz-smarttpl-choice-grid oz-smarttpl-choice-grid--compact">',
        photoFormats.map(function (fmt) {
          var value = String(fmt || '');
          var active = String(((state.variants || {}).orientation) || 'vertical') === value;
          var label = value === 'horizontal' ? 'Horizontale' : 'Verticale';
          return '<button type="button" class="oz-smarttpl-choice' + (active ? ' is-active' : '') + '" data-field-group="variants" data-field-key="orientation" data-choice-value="' + escapeHtml(value) + '"><span>' + escapeHtml(label) + '</span></button>';
        }).join(''),
        '</div>',
        '</div>'
      ].join(''), false));
    }

    if ((meta.imageSlots || []).length) {
      /* Les photos sont l'etape la plus structurante de ce genre de modele :
         elles passent devant les textes et les couleurs. */
      var imageGrid = meta.imageGrid || {};
      var visibleImageSlots = meta.imageSlots.filter(function (slot) {
        return !visibles || visibles.images[slot.key];
      });
      var imageItemsHtml = visibleImageSlots.map(function (slot) {
        var current = state.images[slot.key] || '';
        state.imageAspects = state.imageAspects || {};
        if (current && !Number(state.imageAspects[slot.key])) {
          ensureSmartImageAspect(slot.key, current);
        }
        var aiRun = runtime.aiImageRuns[slot.key];
        if (current && slot.ai && !aiRun) {
          /* Une personnalisation déjà enregistrée contient déjà le résultat
             détouré. Elle ne doit pas être retraitée à chaque réouverture. */
          aiRun = runtime.aiImageRuns[slot.key] = { status: 'success', seconds: 0, error: '' };
        }
        var attrsAi = slot.ai
          ? ' data-smart-ai-slot="' + escapeHtml(slot.key) + '"' +
            ' data-ai-endpoint="' + escapeHtml(slot.ai.endpoint) + '"' +
            ' data-ai-mode="' + escapeHtml(slot.ai.mode) + '"' +
            ' data-ai-preset="' + escapeHtml(slot.ai.preset) + '"' +
            ' data-ai-label="' + escapeHtml(slot.ai.label) + '"' +
            ' data-ai-loading="' + escapeHtml(slot.ai.loading) + '"' +
            ' data-ai-error="' + escapeHtml(slot.ai.error) + '"' +
            ' data-ai-timeout="' + slot.ai.timeoutMs + '"'
          : '';

        var compactImageSlot = !!(imageGrid.enabled || slot.compact);
        return [
          '<div class="oz-smarttpl-field oz-smarttpl-image-slot' + (compactImageSlot ? ' is-compact' : '') + '"' + attrsAi + '>',
          '<span class="oz-smarttpl-image-title">' + escapeHtml(slot.label) + '</span>',
          slot.ai && slot.ai.uploadHelp ? '<small class="oz-smarttpl-image-help">' + escapeHtml(slot.ai.uploadHelp) + '</small>' : '',
          current
            ? '<div class="oz-smarttpl-inline-preview"><img src="' + escapeHtml(current) + '" alt="' + escapeHtml(slot.label) + '"></div>'
            : '<div class="oz-smarttpl-inline-preview oz-smarttpl-inline-preview--empty" aria-hidden="true">+</div>',
          '<div class="oz-smarttpl-image-actions">',
          '<label class="oz-smarttpl-upload-btn">',
          '<input type="file" accept="' + (slot.ai ? 'image/jpeg,image/png,image/webp' : 'image/*,image/svg+xml') + '" hidden data-image-slot="' + escapeHtml(slot.key) + '">',
          current ? 'Changer' : 'Importer',
          '</label>',
          '<button type="button" class="oz-smarttpl-secondary-btn" data-clear-image-slot="' + escapeHtml(slot.key) + '"', current ? '' : ' disabled', '>Retirer</button>',
          '</div>',
          slot.ai ? '<small data-smart-ai-status' + (aiRun && aiRun.status === 'error' ? ' class="is-error"' : '') + '>' + escapeHtml(
            !current ? slot.ai.requiredText :
            !aiRun ? slot.ai.ready :
            aiRun.status === 'running' ? (slot.ai.loading + (aiRun.seconds ? ' ' + aiRun.seconds + ' s' : '')) :
            aiRun.status === 'success' ? (aiRun.localFallback ? 'Aperçu stylisé créé sur votre appareil.' : slot.ai.success) :
            aiRun.status === 'error' ? (aiRun.error || slot.ai.error) : slot.ai.ready
          ) + '</small>' : '',
          slot.ai && slot.ai.note && (!aiRun || aiRun.localFallback || aiRun.status !== 'success') ? '<small class="oz-smarttpl-ai-note">' + escapeHtml(aiRun && aiRun.localFallback ? 'Le serveur est indisponible : un effet illustré a été appliqué à votre photo sur cet appareil.' : slot.ai.note) + '</small>' : '',
          smartAiHistoryHtml(slot),
          '</div>'
        ].join('');
      }).join('');
      var imageGridBody = imageGrid.enabled
        ? [
            imageGrid.help ? '<p style="margin:0 0 10px;color:#667085;line-height:1.45;">' + escapeHtml(imageGrid.help) + '</p>' : '',
            '<div class="oz-smarttpl-image-grid" style="display:grid!important;grid-template-columns:repeat(' + Number(imageGrid.columns || 3) + ',minmax(0,1fr))!important;gap:10px!important;align-items:stretch!important;">',
            imageItemsHtml,
            '</div>'
          ].join('')
        : imageItemsHtml;
      sections.unshift(openSection(imageGrid.label || 'Photos', imageGridBody, true));
    }

    if ((meta.flashSpaces || []).length) {
      runtime.flashSelection = runtime.flashSelection || {};

      sections.push(openSection(meta.flashSpaces[0].label, meta.flashSpaces.map(function (espace) {
        var poses = (state.flashes || {})[espace.key] || [];
        var selection = runtime.flashSelection[espace.key];
        if (typeof selection !== 'number' || selection < 0 || selection >= poses.length) {
          selection = poses.length - 1;
        }
        var choisi = poses[selection];
        var complet = poses.length >= espace.max;
        var optionChoisie = choisi
          ? (espace.options.find(function (option) { return option.value === choisi.option; }) || {})
          : {};

        function vignette(href, alt, cote) {
          return '<img src="' + escapeHtml(href || '') + '" alt="' + escapeHtml(alt || '') + '"' +
            ' style="display:block!important;width:100%!important;height:' + cote + 'px!important;object-fit:contain!important;">';
        }

        return [
          '<div class="oz-smarttpl-field" style="display:flex!important;flex-direction:column!important;gap:12px!important;">',

          espace.help ? '<small style="line-height:1.45;color:#667085;">' + escapeHtml(espace.help) + '</small>' : '',

          '<span style="font-weight:700;line-height:1.3;">' + escapeHtml(espace.libraryLabel) +
            ' <span style="font-weight:400;color:#667085;">(' + poses.length + '/' + espace.max + ')</span></span>',

          espace.options.length
            ? '<div style="display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:8px!important;">' +
              espace.options.map(function (option) {
                return [
                  '<button type="button" data-flash-add="' + escapeHtml(espace.key) + '|' + escapeHtml(option.value) + '"',
                  complet ? ' disabled' : '',
                  ' title="' + escapeHtml(option.label) + '"',
                  ' style="padding:5px!important;border:1px solid #e5e7eb!important;border-radius:10px!important;background:#fff!important;cursor:' + (complet ? 'not-allowed' : 'pointer') + '!important;opacity:' + (complet ? '0.45' : '1') + '!important;">',
                  vignette(option.href, option.label, 44),
                  '</button>'
                ].join('');
              }).join('') +
              '</div>'
            : '<small style="line-height:1.45;color:#b42318;">Aucun flash dans la bibliotheque. Ajoute une entree data-oz-flash-option par fichier Shopify dans le SVG.</small>',

          poses.length
            ? [
                '<span style="font-weight:700;line-height:1.3;">Flashs poses</span>',
                '<div style="display:flex!important;flex-wrap:wrap!important;gap:8px!important;">',
                poses.map(function (flash, index) {
                  var option = espace.options.find(function (entry) { return entry.value === flash.option; }) || {};
                  var actif = index === selection;
                  return [
                    '<button type="button" data-flash-select="' + escapeHtml(espace.key) + '|' + index + '"',
                    ' style="width:56px!important;padding:5px!important;border:2px solid ' + (actif ? '#4b5d3a' : '#e5e7eb') + '!important;border-radius:10px!important;background:#fff!important;cursor:pointer!important;">',
                    vignette(option.href, option.label, 40),
                    '</button>'
                  ].join('');
                }).join(''),
                '</div>'
              ].join('')
            : '<small style="line-height:1.45;color:#667085;">Choisis un flash ci-dessus : il apparaitra au centre de l\u2019apercu.</small>',

          choisi
            ? [
                '<div style="display:flex!important;flex-direction:column!important;gap:10px!important;padding-top:10px!important;border-top:1px solid #ece7dc!important;">',
                '<span style="font-weight:700;line-height:1.3;">' + escapeHtml(optionChoisie.label || 'Flash selectionne') + '</span>',

                '<label style="display:flex;flex-direction:column;gap:6px;width:100%;">',
                '<span style="display:flex;justify-content:space-between;gap:8px;"><span>Inclinaison</span>',
                '<span data-flash-rotate-readout style="color:#667085;">' + Math.round(Number(choisi.rotate) || 0) + '\u00b0</span></span>',
                '<input type="range" min="-180" max="180" step="1" value="' + (Math.round(Number(choisi.rotate) || 0)) + '"',
                ' data-flash-rotate="' + escapeHtml(espace.key) + '|' + selection + '" style="width:100%;">',
                '</label>',

                '<label style="display:flex;flex-direction:column;gap:6px;width:100%;">',
                '<span style="display:flex;justify-content:space-between;gap:8px;"><span>Taille</span>',
                '<span data-flash-scale-readout style="color:#667085;">' + Math.round((Number(choisi.scale) || 1) * 100) + '%</span></span>',
                '<input type="range" min="' + Math.round(espace.minScale * 100) + '" max="' + Math.round(espace.maxScale * 100) + '" step="5"',
                ' value="' + Math.round((Number(choisi.scale) || 1) * 100) + '"',
                ' data-flash-scale="' + escapeHtml(espace.key) + '|' + selection + '" style="width:100%;">',
                '</label>',

                '<button type="button" class="oz-smarttpl-secondary-btn" data-flash-remove="' + escapeHtml(espace.key) + '|' + selection + '">Supprimer ce flash</button>',
                '</div>'
              ].join('')
            : '',

          '</div>'
        ].join('');
      }).join(''), true));
    }

    if ((meta.drags || []).length) {
      var titreDrags = meta.drags.length === 1 ? meta.drags[0].label : 'Elements a placer';
      sections.push(openSection(titreDrags, meta.drags.map(function (field) {
        var position = (state.transforms || {})[field.key] || { x: field.x, y: field.y, rotate: field.rotate };
        var angle = Math.round(Number(position.rotate) || 0);
        return [
          '<div class="oz-smarttpl-field" style="display:flex!important;flex-direction:column!important;gap:10px!important;">',
          '<span style="font-weight:700;line-height:1.3;">' + escapeHtml(field.label) + '</span>',
          field.help ? '<small style="line-height:1.45;color:#667085;">' + escapeHtml(field.help) + '</small>' : '',
          field.rotatable ? [
            '<label style="display:flex;flex-direction:column;gap:6px;width:100%;">',
            '<span style="display:flex;justify-content:space-between;gap:8px;">',
            '<span>Inclinaison</span>',
            '<span data-drag-rotate-readout="' + escapeHtml(field.key) + '" style="color:#667085;">' + angle + '\u00b0</span>',
            '</span>',
            '<input type="range" min="-180" max="180" step="1" value="' + angle + '" data-drag-rotate="' + escapeHtml(field.key) + '" style="width:100%;">',
            '</label>'
          ].join('') : '',
          '<button type="button" class="oz-smarttpl-secondary-btn" data-drag-reset="' + escapeHtml(field.key) + '">Position d\u2019origine</button>',
          '</div>'
        ].join('');
      }).join(''), true));
    }

    if ((meta.toggles || []).length) {
      sections.push(openSection('Options', meta.toggles.map(function (toggle) {
        return [
          '<label class="oz-smarttpl-switch">',
          '<input type="checkbox" role="switch" data-field-group="toggles" data-field-key="' + escapeHtml(toggle.key) + '"', state.toggles[toggle.key] ? ' checked' : '', '>',
          '<span class="oz-smarttpl-switch-label">' + escapeHtml(toggle.label) + '</span>',
          '<span class="oz-smarttpl-switch-track" aria-hidden="true"><span class="oz-smarttpl-switch-thumb"></span></span>',
          '</label>'
        ].join('');
      }).join('')));
    }

    if (emplacementSection) {
      sections.push(emplacementSection);
    }

    runtime.title.textContent = runtime.activeTemplate.title;
    var hasImageAi = (meta.imageSlots || []).some(function (slot) { return !!slot.ai; });
    runtime.subtitle.textContent = hasImageAi && (meta.imageSlots || []).some(function (slot) { return slot.key === 'photo_famille'; })
      ? 'Importez votre photo, puis cr\u00e9ez un portrait illustr\u00e9 sur fond transparent.'
      : hasImageAi
      ? 'Importez le dessin : le fond sera supprimé automatiquement avant de continuer.'
      : (runtime.incomingStarter
        ? 'Modifiez les textes, couleurs, images et variantes : le résultat apparaît directement sur le produit.'
        : (runtime.activeTemplate.description || (runtime.activeTemplate.sourceKind === 'image' ? 'Ce modèle est ajouté automatiquement à partir de ton image.' : 'Tous les éléments du SVG restent liés et se déplacent ensemble sur le produit.')));
    runtime.controls.innerHTML = sections.length
      ? sections.join('')
      : '<div class="oz-smarttpl-empty-state">Ce modèle n\'a pas encore de zones éditables. Tu peux tout de même l\'ajouter tel quel. Pour aller plus loin, utilise un SVG intelligent avec data-oz-*.</div>';
    var selectedFontPending = (meta.choices || []).some(function (group) {
      var chosen = String(state.choices[group.key] || '');
      var option = (group.options || []).find(function (entry) {
        return String(entry.value || '') === chosen;
      });
      return !!(option && option.fontUrl && !smartFontDataCache.has(option.fontUrl));
    });
    var aiBlockingReason = smartAiBlockingReason();
    var aiRunning = (meta.imageSlots || []).some(function (slot) {
      var run = runtime.aiImageRuns[slot.key];
      return !!(slot.ai && run && run.status === 'running');
    });
    runtime.applyBtn.disabled = selectedFontPending || !!aiBlockingReason;
    runtime.applyBtn.title = aiBlockingReason || '';
    if (selectedFontPending) runtime.applyBtn.textContent = 'Chargement de la police…';
    else if (aiBlockingReason) runtime.applyBtn.textContent = aiRunning ? 'Détourage en cours…' : 'Importez le dessin';
    else runtime.applyBtn.textContent = (runtime.incomingStarter || runtime.editingItem)
      ? 'Terminer'
      : 'Ajouter au produit';
    syncIncomingStarterPresentation();
    if (runtime.editorState && runtime.editorState.scrollTop > 0) {
      runtime.controls.scrollTop = runtime.editorState.scrollTop;
      window.requestAnimationFrame(function () {
        if (runtime.controls) runtime.controls.scrollTop = runtime.editorState.scrollTop;
      });
    }


    runtime.controls.querySelectorAll('[data-oz-font-slide]').forEach(function(button) {
      button.addEventListener('click', function() {
        var slider = button.parentElement && button.parentElement.querySelector('.oz-smarttpl-font-grid');
        if (slider) slider.scrollBy({ left: Number(button.getAttribute('data-oz-font-slide')) * slider.clientWidth * .8, behavior: 'smooth' });
      });
    });

    runtime.controls.querySelectorAll('[data-font-choice-key][data-font-choice-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-font-choice-key');
        var fontName = btn.getAttribute('data-font-choice-value');
        runtime.activeState.fonts = runtime.activeState.fonts || {};
        runtime.activeState.fonts[key] = fontName;

        runtime.controls.querySelectorAll('[data-font-choice-key="' + key.replace(/"/g, '\\"') + '"]').forEach(function (node) {
          node.classList.toggle('is-active', node === btn);
        });

        Promise.all([
          requestTemplateFontLoad(fontName),
          ensureGoogleSmartFontSource(fontName)
        ]).catch(function () {
          return [];
        }).then(function () {
          /* Force le SVG ET le visuel produit à changer immédiatement. */
          rerenderPreviewNow();
        });
      });
    });

    runtime.controls.querySelectorAll('[data-field-group][data-field-key]').forEach(function (input) {
      var group = input.getAttribute('data-field-group');
      var key = input.getAttribute('data-field-key');
      var handler = function () {
        runtime.activeState[group][key] = (input.type === 'checkbox') ? !!input.checked : input.value;

        if (group === 'fonts') {
          var selectedFont = runtime.activeState[group][key];

          Promise.all([
            requestTemplateFontLoad(selectedFont),
            ensureGoogleSmartFontSource(selectedFont)
          ]).catch(function () {
            return [];
          }).then(function () {
            rerenderPreviewNow();
          });

          return;
        }

        if (group === 'colors') {
          syncColorUi(key, runtime.activeState[group][key]);
          queueSmartLiveRender();
          return;
        }
        rerenderPreview();
      };
      input.addEventListener('input', handler);
      input.addEventListener('change', handler);
    });

    runtime.controls.querySelectorAll('[data-field-group="variants"][data-field-key][data-choice-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-field-group');
        var key = btn.getAttribute('data-field-key');
        runtime.activeState[group] = runtime.activeState[group] || {};
        runtime.activeState[group][key] = btn.getAttribute('data-choice-value');
        renderEditor();
        rerenderPreview();
      });
    });

    if (runtime.controls.querySelector('[data-template-view]') &&
        typeof window.scheduleThumbnailUpdate === 'function') {
      window.scheduleThumbnailUpdate();
    }

    runtime.controls.querySelectorAll('[data-template-view]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        moveTemplateToView(btn.getAttribute('data-template-view'));
      });
    });

    runtime.controls.querySelectorAll('[data-choice-slot][data-choice-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        runtime.activeState.choices[btn.getAttribute('data-choice-slot')] = btn.getAttribute('data-choice-value');
        renderEditor();
        rerenderPreview();
      });
    });

    runtime.controls.querySelectorAll('[data-color-swatch-key][data-color-swatch-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var swatchKey = btn.getAttribute('data-color-swatch-key');
        var swatchValue = btn.getAttribute('data-color-swatch-value');
        runtime.activeState.colors[swatchKey] = swatchValue;
        syncColorUi(swatchKey, swatchValue);
        queueSmartLiveRender();
      });
    });

    runtime.controls.querySelectorAll('[data-image-slot]').forEach(function (input) {
      input.addEventListener('change', async function () {
        var file = input.files && input.files[0];
        if (!file) return;
        var completedAiResult = input.dataset.ozAiResult === '1';
        var localAiResult = input.dataset.ozAiResultLocal === '1';
        delete input.dataset.ozAiResult;
        delete input.dataset.ozAiResultLocal;
        var slotKey = input.getAttribute('data-image-slot');
        var slot = getSmartImageSlot(slotKey);
        if (slot && slot.ai && file.size > slot.ai.maxBytes) {
          notify('Le fichier dépasse 10 Mo. Choisissez une image plus légère.', 'error');
          input.value = '';
          return;
        }
        try {
          var oldRun = runtime.aiImageRuns[slotKey];
          if (oldRun && oldRun.controller) {
            try { oldRun.controller.abort(); } catch (e) {}
          }
          runtime.aiImageSources[slotKey] = file;
          /* Le navigateur doit pouvoir relire la photo a l'interieur d'un SVG
             autonome. La normalisation en PNG evite les formats HEIC/WEBP
             acceptes en miniature mais refuses par certains moteurs SVG. */
          var imageData = slot && slot.ai ? await reduirePuisEncoder(file) : await fileToDataUrl(file);
          if (!/^data:image\//i.test(imageData)) throw new Error('Image invalide');
          runtime.activeState.images[slotKey] = imageData;
          runtime.activeState.imageAspects = runtime.activeState.imageAspects || {};
          try {
            runtime.activeState.imageAspects[slotKey] = await readImageAspect(imageData);
          } catch (dimensionError) {
            runtime.activeState.imageAspects[slotKey] = 0;
          }
          runtime.aiImageRuns[slotKey] = slot && slot.ai
            ? { status: completedAiResult ? 'success' : 'ready', seconds: 0, error: '', localFallback: localAiResult }
            : null;
          if (completedAiResult && slotKey === 'photo_famille') {
            await saveSmartAiHistory(slotKey, imageData);
          }
          renderEditor();
          rerenderPreview();
          if (slot && slot.ai && slot.ai.automatic && !completedAiResult) runSmartImageAi(slotKey);
        } catch (e) {
          notify('Impossible de lire cette image.', 'error');
        }
      });
    });

    runtime.controls.querySelectorAll('[data-run-image-ai]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        runSmartImageAi(btn.getAttribute('data-run-image-ai'));
      });
    });

    runtime.controls.querySelectorAll('[data-ai-history-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = runtime.aiHistory.find(function (entry) { return entry.id === btn.getAttribute('data-ai-history-id'); });
        var slotKey = btn.getAttribute('data-ai-history-slot');
        if (!item || !runtime.activeState) return;
        var session = runtime.aiImageSession;
        var reader = new FileReader();
        reader.onload = function () {
          if (!runtime.activeState || session !== runtime.aiImageSession) return;
          runtime.activeState.images[slotKey] = String(reader.result || '');
          delete runtime.aiImageSources[slotKey];
          runtime.aiImageRuns[slotKey] = { status: 'success', seconds: 0, error: '' };
          runtime.activeState.imageAspects = runtime.activeState.imageAspects || {};
          runtime.activeState.imageAspects[slotKey] = 0;
          renderEditor();
          rerenderPreview();
        };
        reader.readAsDataURL(item.blob);
      });
    });

    function espaceFlash(cle) {
      return ((runtime.activeMeta || {}).flashSpaces || []).find(function (entry) { return entry.key === cle; });
    }

    function flashCible(attribut, noeud) {
      var parts = String(noeud.getAttribute(attribut) || '').split('|');
      var espace = espaceFlash(parts[0]);
      if (!espace) return null;
      runtime.activeState.flashes = runtime.activeState.flashes || {};
      var poses = runtime.activeState.flashes[espace.key] = runtime.activeState.flashes[espace.key] || [];
      return { espace: espace, poses: poses, index: parseInt(parts[1], 10), option: parts[1] };
    }

    runtime.controls.querySelectorAll('[data-flash-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cible = flashCible('data-flash-add', btn);
        if (!cible) return;

        var espace = cible.espace;
        if (cible.poses.length >= espace.max) {
          notify('Vous avez atteint la limite de ' + espace.max + ' flashs.', 'error');
          return;
        }

        /* Les nouveaux flashs sont decales en quinconce : empiles au meme
           point, le client croirait n'en avoir ajoute qu'un seul. */
        var rang = cible.poses.length;
        var centreX = (espace.minX + espace.maxX) / 2;
        var centreY = (espace.minY + espace.maxY) / 2;
        var pas = espace.size * 0.45;

        cible.poses.push({
          option: cible.option,
          x: borner(centreX + ((rang % 3) - 1) * pas, espace.minX, espace.maxX, centreX),
          y: borner(centreY + ((Math.floor(rang / 3) % 3) - 1) * pas, espace.minY, espace.maxY, centreY),
          rotate: 0,
          scale: 1
        });

        runtime.flashSelection = runtime.flashSelection || {};
        runtime.flashSelection[espace.key] = cible.poses.length - 1;
        renderEditor();
        rerenderPreview();
      });
    });

    runtime.controls.querySelectorAll('[data-flash-select]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cible = flashCible('data-flash-select', btn);
        if (!cible) return;
        runtime.flashSelection = runtime.flashSelection || {};
        runtime.flashSelection[cible.espace.key] = cible.index;
        renderEditor();
      });
    });

    runtime.controls.querySelectorAll('[data-flash-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cible = flashCible('data-flash-remove', btn);
        if (!cible || !cible.poses[cible.index]) return;
        cible.poses.splice(cible.index, 1);
        runtime.flashSelection[cible.espace.key] = cible.poses.length - 1;
        renderEditor();
        rerenderPreview();
      });
    });

    ['rotate', 'scale'].forEach(function (reglage) {
      runtime.controls.querySelectorAll('[data-flash-' + reglage + ']').forEach(function (input) {
        var handler = function () {
          var cible = flashCible('data-flash-' + reglage, input);
          if (!cible) return;
          var flash = cible.poses[cible.index];
          if (!flash) return;

          var lecture = runtime.controls.querySelector('[data-flash-' + reglage + '-readout]');
          if (reglage === 'rotate') {
            flash.rotate = Number(input.value) || 0;
            if (lecture) lecture.textContent = Math.round(flash.rotate) + '\u00b0';
          } else {
            flash.scale = borner((Number(input.value) || 100) / 100, cible.espace.minScale, cible.espace.maxScale, 1);
            if (lecture) lecture.textContent = Math.round(flash.scale * 100) + '%';
          }
          rerenderPreview();
        };
        input.addEventListener('input', handler);
        input.addEventListener('change', handler);
      });
    });

    runtime.controls.querySelectorAll('[data-drag-rotate]').forEach(function (input) {
      var handler = function () {
        var key = input.getAttribute('data-drag-rotate');
        runtime.activeState.transforms = runtime.activeState.transforms || {};
        var position = runtime.activeState.transforms[key];
        if (!position) return;
        position.rotate = Number(input.value) || 0;
        var lecture = runtime.controls.querySelector('[data-drag-rotate-readout="' + key + '"]');
        if (lecture) lecture.textContent = Math.round(position.rotate) + '\u00b0';
        rerenderPreview();
      };
      input.addEventListener('input', handler);
      input.addEventListener('change', handler);
    });

    runtime.controls.querySelectorAll('[data-drag-reset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-drag-reset');
        var field = (runtime.activeMeta.drags || []).find(function (entry) { return entry.key === key; });
        if (!field) return;
        runtime.activeState.transforms = runtime.activeState.transforms || {};
        runtime.activeState.transforms[key] = { x: field.x, y: field.y, rotate: field.rotate };
        renderEditor();
        rerenderPreview();
      });
    });

    runtime.controls.querySelectorAll('[data-clear-image-slot]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slotKey = btn.getAttribute('data-clear-image-slot');
        var run = runtime.aiImageRuns[slotKey];
        if (run && run.controller) {
          try { run.controller.abort(); } catch (e) {}
        }
        delete runtime.aiImageRuns[slotKey];
        delete runtime.aiImageSources[slotKey];
        runtime.activeState.images[slotKey] = '';
        runtime.activeState.imageAspects = runtime.activeState.imageAspects || {};
        runtime.activeState.imageAspects[slotKey] = 0;
        renderEditor();
        rerenderPreview();
      });
    });

    rerenderPreview();
  }

  /* ============================================================
     GLISSER-DEPOSER SUR L'APERCU
     Les elements marques data-oz-drag se prennent a la souris ou au doigt
     directement sur l'apercu, comme sur le vetement. L'apercu etant une
     <img> et non un SVG vivant, on refait a la main la mise en boite que
     ferait preserveAspectRatio="xMidYMid meet" pour convertir un point
     ecran en coordonnees du SVG.
     ============================================================ */
  /* Tout ce qui se deplace a la souris, quelle que soit son origine :
     element fixe declare dans le SVG (data-oz-drag) ou flash pose par le
     client. Le code de glissement ne connait que cette forme commune. */
  function champsDeplacables() {
    var liste = [];
    var etat = runtime.activeState || {};
    var meta = runtime.activeMeta || {};

    (meta.drags || []).forEach(function (field) {
      var position = (etat.transforms || {})[field.key];
      if (!position) return;
      liste.push({
        label: field.label,
        x: Number(position.x),
        y: Number(position.y),
        radius: field.radius,
        minX: field.minX, maxX: field.maxX, minY: field.minY, maxY: field.maxY,
        secoursX: field.x, secoursY: field.y,
        poser: function (x, y) { position.x = x; position.y = y; },
        selectionner: null
      });
    });

    (meta.flashSpaces || []).forEach(function (espace) {
      var poses = ((etat.flashes || {})[espace.key]) || [];
      poses.forEach(function (flash, index) {
        liste.push({
          label: espace.label,
          x: Number(flash.x),
          y: Number(flash.y),
          /* Le rayon de saisie suit la taille reelle du flash a l'ecran. */
          radius: Math.max(45, (espace.size * (Number(flash.scale) || 1)) / 2),
          minX: espace.minX, maxX: espace.maxX, minY: espace.minY, maxY: espace.maxY,
          secoursX: (espace.minX + espace.maxX) / 2,
          secoursY: (espace.minY + espace.maxY) / 2,
          poser: function (x, y) { flash.x = x; flash.y = y; },
          selectionner: function () {
            runtime.flashSelection = runtime.flashSelection || {};
            if (runtime.flashSelection[espace.key] === index) return false;
            runtime.flashSelection[espace.key] = index;
            return true;
          }
        });
      });
    });

    return liste;
  }

  function surfaceDeGlissementUtile() {
    return champsDeplacables().length > 0 || ((runtime.activeMeta || {}).flashSpaces || []).length > 0;
  }

  function champSousLePoint(point) {
    var liste = champsDeplacables();
    /* A l'envers : le dernier pose est celui du dessus, donc celui qu'on
       attrape quand deux flashs se chevauchent. */
    for (var i = liste.length - 1; i >= 0; i--) {
      var mobile = liste[i];
      var distance = Math.sqrt(Math.pow(point.x - mobile.x, 2) + Math.pow(point.y - mobile.y, 2));
      if (distance <= mobile.radius) return mobile;
    }
    return null;
  }

  function boiteVueApercu() {
    var boite = runtime.previewViewBox;
    if (boite && boite.length === 4 && !boite.some(isNaN)) return boite;

    /* Filet : le premier glissement peut arriver avant qu'un rendu ait
       renseigne runtime.previewViewBox. On relit alors le markup source. */
    var trouve = /viewBox\s*=\s*"([^"]+)"/i.exec(String(runtime.activeMarkup || ''));
    if (!trouve) return null;
    var nombres = trouve[1].trim().split(/[\s,]+/).map(Number);
    return (nombres.length === 4 && !nombres.some(isNaN)) ? nombres : null;
  }

  function pointApercuVersSvg(evt) {
    var boite = boiteVueApercu();
    var apercu = runtime.preview;
    if (!boite || !apercu) return null;

    var cadre = apercu.getBoundingClientRect();
    if (!cadre.width || !cadre.height) return null;

    var rapportBoite = boite[2] / boite[3];
    var rapportCadre = cadre.width / cadre.height;
    var largeurRendue = rapportCadre > rapportBoite ? cadre.height * rapportBoite : cadre.width;
    var hauteurRendue = rapportCadre > rapportBoite ? cadre.height : cadre.width / rapportBoite;
    var bordGauche = cadre.left + (cadre.width - largeurRendue) / 2;
    var bordHaut = cadre.top + (cadre.height - hauteurRendue) / 2;

    return {
      x: boite[0] + ((evt.clientX - bordGauche) / largeurRendue) * boite[2],
      y: boite[1] + ((evt.clientY - bordHaut) / hauteurRendue) * boite[3]
    };
  }

  function champSousLePoint(point) {
    var meilleur = null;
    var meilleureDistance = Infinity;

    champsDeplacables().forEach(function (field) {
      var position = (runtime.activeState.transforms || {})[field.key];
      if (!position) return;
      var distance = Math.sqrt(
        Math.pow(point.x - Number(position.x), 2) +
        Math.pow(point.y - Number(position.y), 2)
      );
      if (distance > field.radius || distance >= meilleureDistance) return;
      meilleur = field;
      meilleureDistance = distance;
    });

    return meilleur;
  }

  /* Sonde de diagnostic : ozDiagnosticChapeau() dans la console renvoie
     l'etat reel du glisser (slots detectes, viewBox, position courante). */
  window.ozDiagnosticChapeau = function () {
    var apercu = runtime.preview;
    var cadre = apercu ? apercu.getBoundingClientRect() : null;
    return {
      slotsDeplacables: champsDeplacables(),
      positions: (runtime.activeState || {}).transforms || null,
      viewBoxApercu: boiteVueApercu(),
      apercuTrouve: !!apercu,
      apercuTaille: cadre ? [Math.round(cadre.width), Math.round(cadre.height)] : null,
      ecouteursPoses: apercu ? apercu.dataset.ozDragBound === '1' : false,
      zoneVisible: (function () {
        var z = apercu && apercu.closest ? apercu.closest('[data-oz-drag-zone=\"true\"]') : null;
        var r = z ? z.getBoundingClientRect() : null;
        return r ? [Math.round(r.width), Math.round(r.height)] : null;
      })(),
      svgContientDrag: /data-oz-drag=/.test(String(runtime.activeMarkup || '')),
      derniereTentative: runtime.dernierGlissement || null
    };
  };

  function initSmartTemplatePreviewDrag() {
    var apercu = runtime.preview;
    if (!apercu) return;

    var zone = (apercu.closest && apercu.closest('.oz-smarttpl-preview-wrap')) || apercu.parentElement || apercu;
    var actif = surfaceDeGlissementUtile();

    /* En mode editeur produit, le theme masque l'apercu du tiroir : le
       dessin vit sur le vetement. Il n'y a alors aucune surface a saisir.
       Des qu'un element est deplacable, on rouvre cet apercu et on lui
       impose object-fit:contain, seule mise en boite pour laquelle la
       conversion point ecran -> point SVG ci-dessus est exacte. */
    if (actif) {
      zone.style.setProperty('display', 'block', 'important');
      zone.style.setProperty('visibility', 'visible', 'important');
      zone.style.setProperty('min-height', '0', 'important');
      apercu.hidden = false;
      apercu.style.setProperty('display', 'block', 'important');
      apercu.style.setProperty('width', '100%', 'important');
      apercu.style.setProperty('max-height', '46vh', 'important');
      apercu.style.setProperty('object-fit', 'contain', 'important');
      apercu.style.setProperty('margin', '0 auto', 'important');

      if (!zone.querySelector('[data-oz-drag-hint]')) {
        var consigne = document.createElement('small');
        consigne.setAttribute('data-oz-drag-hint', '');
        consigne.style.cssText = 'display:block;text-align:center;color:#667085;line-height:1.45;padding:6px 0 2px;';
        zone.appendChild(consigne);
      }
      var mobiles = champsDeplacables();
      zone.querySelector('[data-oz-drag-hint]').textContent =
        mobiles.length === 1
          ? 'Fais glisser ' + String(mobiles[0].label || '').toLowerCase() + ' sur cet apercu.'
          : (mobiles.length
            ? 'Fais glisser les elements sur cet apercu.'
            : 'Ajoute un flash ci-dessous, puis fais-le glisser ici.');
    }

    apercu.style.pointerEvents = 'auto';
    apercu.style.cursor = actif ? 'grab' : '';
    /* Sans touch-action:none, le navigateur mobile interprete le glissement
       comme un defilement et le doigt ne deplace jamais l'element. */
    apercu.style.touchAction = actif ? 'none' : '';
    zone.style.touchAction = actif ? 'none' : '';
    zone.setAttribute('data-oz-drag-zone', 'true');

    if (runtime.dragBound) return;
    runtime.dragBound = true;

    var prise = null;
    var dernierRendu = 0;

    /* Ecoute au niveau du document, en capture : c'est le seul point que ni
       le tiroir mobile, ni la prevention du double-tap, ni un calque du
       theme ne peuvent intercepter avant nous. */
    function dansLaZone(evt) {
      var cible = evt.target;
      return !!(cible && cible.closest && cible.closest('[data-oz-drag-zone="true"]'));
    }

    function rendreEnGlissant() {
      var maintenant = Date.now();
      if (maintenant - dernierRendu < 110) {
        rerenderPreview();
        return;
      }
      dernierRendu = maintenant;
      window.clearTimeout(runtime.previewDebounce);
      rerenderPreviewNow();
    }

    document.addEventListener('pointerdown', function (evt) {
      if (!runtime.activeState || evt.button > 0) return;

      var champs = champsDeplacables();
      if (!champs.length || !dansLaZone(evt)) return;

      var point = pointApercuVersSvg(evt);
      if (!point) return;

      /* Prise nette : on attrape l'element la ou il est, sans le faire
         sauter. Sinon, et s'il n'y a qu'un seul element mobile, on le
         prend quand meme : il rejoindra le curseur des le premier
         mouvement reel. Un simple clic, lui, ne deplace rien. */
      var mobile = champSousLePoint(point);
      var priseNette = !!mobile;
      if (!mobile && champs.length === 1) mobile = champs[0];
      if (!mobile) return;

      prise = {
        mobile: mobile,
        ecartX: priseNette ? mobile.x - point.x : 0,
        ecartY: priseNette ? mobile.y - point.y : 0,
        departX: evt.clientX,
        departY: evt.clientY,
        demarre: false,
        selectionChangee: !!(mobile.selectionner && mobile.selectionner())
      };

      runtime.dernierGlissement = {
        pointSvg: [Math.round(point.x), Math.round(point.y)],
        champ: mobile.label,
        priseNette: priseNette
      };

      try { apercu.setPointerCapture(evt.pointerId); } catch (e) {}
    }, true);

    document.addEventListener('pointermove', function (evt) {
      if (!prise) return;

      if (!prise.demarre) {
        var course = Math.abs(evt.clientX - prise.departX) + Math.abs(evt.clientY - prise.departY);
        if (course < 4) return;
        prise.demarre = true;
        apercu.style.cursor = 'grabbing';
      }

      var point = pointApercuVersSvg(evt);
      if (!point) return;

      var mobile = prise.mobile;
      mobile.poser(
        borner(point.x + prise.ecartX, mobile.minX, mobile.maxX, mobile.secoursX),
        borner(point.y + prise.ecartY, mobile.minY, mobile.maxY, mobile.secoursY)
      );

      evt.preventDefault();
      rendreEnGlissant();
    }, true);

    function relacher(evt) {
      if (!prise) return;
      var bougeait = prise.demarre;
      var selectionChangee = prise.selectionChangee;
      prise = null;
      apercu.style.cursor = 'grab';
      try { apercu.releasePointerCapture(evt.pointerId); } catch (e) {}
      /* On ne redessine le panneau qu'au relachement : le refaire pendant
         le glissement couperait le geste en cours. */
      if (selectionChangee) renderEditor();
      else if (bougeait) rerenderPreview();
    }

    document.addEventListener('pointerup', relacher, true);
    document.addEventListener('pointercancel', relacher, true);
    apercu.addEventListener('dragstart', function (evt) { evt.preventDefault(); });
  }

  /* Chaque rendu reserialise le SVG entier, photos comprises. Enchainer un
     rendu par caractere saccade la saisie : on regroupe les rafales. */
  function rerenderPreview() {
    window.clearTimeout(runtime.previewDebounce);
    runtime.previewDebounce = window.setTimeout(rerenderPreviewNow, 90);
  }


  function ozReadSvgViewBox(svg) {
    var raw = String((svg && svg.getAttribute('viewBox')) || '').trim();
    var parts = raw.split(/[\s,]+/).map(Number);
    if (parts.length === 4 && parts.every(function (n) { return Number.isFinite(n); }) && parts[2] > 0 && parts[3] > 0) {
      return { x: parts[0], y: parts[1], width: parts[2], height: parts[3] };
    }
    var width = parseFloat((svg && svg.getAttribute('width')) || '0');
    var height = parseFloat((svg && svg.getAttribute('height')) || '0');
    return {
      x: 0,
      y: 0,
      width: Number.isFinite(width) && width > 0 ? width : 1000,
      height: Number.isFinite(height) && height > 0 ? height : 1000
    };
  }

  function ozMatrixPoint(matrix, x, y) {
    if (!matrix) return { x: x, y: y };
    return {
      x: (matrix.a * x) + (matrix.c * y) + matrix.e,
      y: (matrix.b * x) + (matrix.d * y) + matrix.f
    };
  }

  function ozIsIgnoredMeasureNode(el) {
    if (!el || !el.closest) return true;
    if (el.closest('defs,clipPath,mask,pattern,marker,symbol')) return true;

    var p = el;
    while (p && p.nodeType === 1) {
      var id = String(p.getAttribute('id') || '').toLowerCase();
      var cls = String(p.getAttribute('class') || '').toLowerCase();
      var tr = String(p.getAttribute('transform') || '').replace(/\s+/g, '');

      if (
        id === 'textes_sources' ||
        id === 'text_sources' ||
        p.getAttribute('data-oz-measure-ignore') === 'true' ||
        cls.indexOf('oz-measure-ignore') !== -1 ||
        /translate\(-?10000(?:[,\s]|$)/i.test(tr)
      ) {
        return true;
      }
      p = p.parentElement;
    }
    return false;
  }

  function ozElementHasVisiblePaint(el) {
    var tag = String(el.tagName || '').toLowerCase();
    if (tag === 'image' || tag === 'text' || tag === 'use') return true;

    var cs;
    try { cs = window.getComputedStyle(el); } catch (e) { cs = null; }
    if (!cs) return true;

    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var opacity = parseFloat(cs.opacity || '1');
    if (Number.isFinite(opacity) && opacity <= 0.001) return false;

    var fill = String(cs.fill || '').toLowerCase();
    var fillOpacity = parseFloat(cs.fillOpacity || '1');
    var hasFill = (
      fill &&
      fill !== 'none' &&
      fill !== 'transparent' &&
      fill !== 'rgba(0, 0, 0, 0)' &&
      (!Number.isFinite(fillOpacity) || fillOpacity > 0.001)
    );

    var stroke = String(cs.stroke || '').toLowerCase();
    var strokeOpacity = parseFloat(cs.strokeOpacity || '1');
    var strokeWidth = parseFloat(cs.strokeWidth || '0');
    var hasStroke = (
      stroke &&
      stroke !== 'none' &&
      stroke !== 'transparent' &&
      (!Number.isFinite(strokeOpacity) || strokeOpacity > 0.001) &&
      (!Number.isFinite(strokeWidth) || strokeWidth > 0)
    );

    return hasFill || hasStroke;
  }

  function ozMeasureSmartSvgVisibleBounds(markup) {
    var doc = parseSvg(markup);
    var sourceSvg = doc.documentElement;
    var fallbackBox = ozReadSvgViewBox(sourceSvg);

    /*
     * Mesure du visuel réellement rendu.
     *
     * Cas important : Constellations stocke les textes sources dans un groupe
     * déplacé à -10000 puis les réutilise avec <use>. Il ne faut PAS supprimer
     * ces textes, sinon les <use> deviennent vides et le recadrage coupe le
     * prénom / la date.
     *
     * On déplace donc uniquement les éléments sources dans <defs> :
     * - ils restent disponibles pour les <use>
     * - ils ne participent plus eux-mêmes à la bounding box.
     */
    var host = document.createElement('div');
    host.setAttribute('aria-hidden', 'true');
    host.style.cssText = [
      'position:fixed',
      'left:-50000px',
      'top:-50000px',
      'width:' + Math.max(1, fallbackBox.width) + 'px',
      'height:' + Math.max(1, fallbackBox.height) + 'px',
      'overflow:visible',
      'opacity:0',
      'pointer-events:none',
      'z-index:-1'
    ].join(';');

    var svg = document.importNode(sourceSvg, true);
    svg.setAttribute('width', String(fallbackBox.width));
    svg.setAttribute('height', String(fallbackBox.height));
    svg.style.display = 'block';
    svg.style.overflow = 'visible';

    var defs = svg.querySelector('defs');
    if (!defs) {
      defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
      svg.insertBefore(defs, svg.firstChild);
    }

    Array.prototype.slice.call(
      svg.querySelectorAll('#textes_sources,#text_sources,[data-oz-source-only="true"]')
    ).forEach(function (sourceGroup) {
      while (sourceGroup.firstChild) {
        defs.appendChild(sourceGroup.firstChild);
      }
      if (sourceGroup.parentNode) sourceGroup.parentNode.removeChild(sourceGroup);
    });

    /* Les éléments explicitement exclus de la mesure ne sont pas nécessaires
       au rendu final de la miniature de mesure. */
    Array.prototype.slice.call(
      svg.querySelectorAll('[data-oz-measure-ignore="true"],.oz-measure-ignore')
    ).forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });

    host.appendChild(svg);
    document.body.appendChild(host);

    var box = null;
    var strokePadding = 0;
    try {
      box = svg.getBBox();
      var rootMatrix = svg.getScreenCTM();
      svg.querySelectorAll('path,rect,circle,ellipse,line,polyline,polygon,text,use').forEach(function (node) {
        if (ozIsIgnoredMeasureNode(node) || !ozElementHasVisiblePaint(node)) return;
        var style = window.getComputedStyle(node);
        if (style.stroke === 'none') return;
        var stroke = parseFloat(style.strokeWidth) || 0;
        var matrix = node.getScreenCTM();
        if (rootMatrix && matrix) {
          matrix = rootMatrix.inverse().multiply(matrix);
          stroke *= Math.max(Math.hypot(matrix.a, matrix.b), Math.hypot(matrix.c, matrix.d));
        }
        strokePadding = Math.max(strokePadding, stroke / 2);
      });
    } catch (eRootBox) {
      box = null;
    }

    if (host.parentNode) host.parentNode.removeChild(host);

    if (
      !box ||
      !Number.isFinite(Number(box.x)) ||
      !Number.isFinite(Number(box.y)) ||
      !Number.isFinite(Number(box.width)) ||
      !Number.isFinite(Number(box.height)) ||
      Number(box.width) <= 0 ||
      Number(box.height) <= 0
    ) {
      return {
        x: fallbackBox.x,
        y: fallbackBox.y,
        width: fallbackBox.width,
        height: fallbackBox.height
      };
    }

    var x = Number(box.x);
    var y = Number(box.y);
    var width = Number(box.width);
    var height = Number(box.height);

    /* Marge quasi nulle : le cadre doit réellement épouser le visuel. */
    var padding = Math.max(strokePadding + 1, Math.min(4, Math.max(width, height) * 0.005));

    return {
      x: x - padding,
      y: y - padding,
      width: width + (padding * 2),
      height: height + (padding * 2)
    };
  }

  function ozPrepareSmartSvgGeometry(markup) {
    if (!markup) return { markup: markup, bounds: null };

    try {
      var bounds = ozMeasureSmartSvgVisibleBounds(markup);
      if (!bounds || bounds.width <= 0 || bounds.height <= 0) {
        return { markup: markup, bounds: null };
      }

      var doc = parseSvg(markup);
      var svg = doc.documentElement;

      function clean(n) {
        return String(Math.round(Number(n) * 100) / 100);
      }

      svg.setAttribute('viewBox', [bounds.x, bounds.y, bounds.width, bounds.height].map(clean).join(' '));
      svg.setAttribute('width', clean(bounds.width));
      svg.setAttribute('height', clean(bounds.height));
      svg.setAttribute('data-oz-tight-frame', 'true');

      return {
        markup: new XMLSerializer().serializeToString(doc),
        bounds: bounds
      };
    } catch (e) {
      return { markup: markup, bounds: null };
    }
  }

  async function ozPrepareSmartSvgForCanvas(markup) {
    var embedded = await embarquerImages(markup);
    var prepared = ozPrepareSmartSvgGeometry(embedded);
    if (!window.OazarDesignBounds) return prepared;
    return window.OazarDesignBounds.prepareSvg(prepared.markup).then(function (tight) {
      return tight.bounds ? tight : prepared;
    });
  }

  function ozFitSmartSvgWrapper(wrapper, prepared, options) {
    if (!wrapper || !prepared || !prepared.bounds) return;

    var opts = options || {};
    var tries = 0;

    function apply() {
      if (!document.documentElement.contains(wrapper)) return;
      tries += 1;

      if (wrapper.dataset.inited !== '1' && tries < 14) {
        window.setTimeout(apply, 35);
        return;
      }

      var area = wrapper.closest('.design-area');
      if (!area) return;

      var areaW = area.clientWidth || area.offsetWidth || 0;
      var areaH = area.clientHeight || area.offsetHeight || 0;
      if (areaW < 20 || areaH < 20) {
        if (tries < 20) window.setTimeout(apply, 45);
        return;
      }

      var oldW = parseFloat(wrapper.style.width) || wrapper.offsetWidth || 0;
      var oldH = parseFloat(wrapper.style.height) || wrapper.offsetHeight || 0;
      var oldLeft = parseFloat(wrapper.style.left);
      var oldTop = parseFloat(wrapper.style.top);

      var centerX = Number.isFinite(oldLeft) ? oldLeft + oldW / 2 : areaW / 2;
      var centerY = Number.isFinite(oldTop) ? oldTop + oldH / 2 : areaH / 2;

      var ratio = prepared.bounds.width / Math.max(prepared.bounds.height, 1);
      var width, height;

      if (opts.preserveSize && oldW > 0 && oldH > 0) {
        var currentMax = Math.max(oldW / areaW, oldH / areaH);
        currentMax = Math.max(0.04, Math.min(1, currentMax));
        width = areaW * currentMax;
        height = width / Math.max(ratio, 0.0001);
        if ((height / areaH) > currentMax) {
          height = areaH * currentMax;
          width = height * ratio;
        }
      } else {
        var targetMax = (typeof opts.targetMax === 'number') ? opts.targetMax : 0.75; // L
        width = areaW * targetMax;
        height = width / Math.max(ratio, 0.0001);
        if ((height / areaH) > targetMax) {
          height = areaH * targetMax;
          width = height * ratio;
        }
      }

      width = Math.max(18, width);
      height = Math.max(18, height);

      if (!opts.preserveCenter) {
        centerX = areaW / 2;
        centerY = areaH / 2;
      }

      var left = centerX - width / 2;
      var top = centerY - height / 2;
      left = Math.max(0, Math.min(areaW - width, left));
      top = Math.max(0, Math.min(areaH - height, top));

      wrapper.style.width = width.toFixed(2) + 'px';
      wrapper.style.height = height.toFixed(2) + 'px';
      wrapper.style.left = left.toFixed(2) + 'px';
      wrapper.style.top = top.toFixed(2) + 'px';
      wrapper.dataset.w = width.toFixed(1);
      wrapper.dataset.h = height.toFixed(1);
      wrapper.dataset.scale = String(Math.max(width / areaW, height / areaH).toFixed(3));
      wrapper.dataset.ozSmartTightFrame = 'true';

      if (typeof window.updateOverflowState === 'function') window.updateOverflowState(wrapper);
      if (typeof window.updateDesignLayers === 'function') window.updateDesignLayers();
      if (typeof window.updateItemSizeBadge === 'function') window.updateItemSizeBadge(wrapper);
      if (typeof window.updateAllSizeBadges === 'function') window.updateAllSizeBadges();
      if (typeof window.updatePriceLiveBlock === 'function') window.updatePriceLiveBlock();
      if (typeof window.refreshProductView === 'function') window.refreshProductView();
      if (typeof window.drawZoneLimits === 'function') window.drawZoneLimits();
      if (typeof window.scheduleThumbnailUpdate === 'function') window.scheduleThumbnailUpdate();
      if (typeof window.saveDesignToLocalStorage === 'function') window.saveDesignToLocalStorage();
    }

    var img = wrapper.querySelector('img');
    if (img) img.addEventListener('load', apply, { once: true });
    window.setTimeout(apply, 0);
  }

  function rerenderPreviewNow() {
    if (!runtime.activeTemplate || !runtime.activeMarkup || !runtime.activeState || !runtime.preview) return;
    runtime.previewRenderToken = (runtime.previewRenderToken || 0) + 1;
    var token = runtime.previewRenderToken;
    var fontJobs = Object.keys(runtime.activeState.fonts || {}).map(function (key) {
      return requestTemplateFontLoad(runtime.activeState.fonts[key]);
    });
    return Promise.all(fontJobs).catch(function () { return []; }).then(function () {
      if (token !== runtime.previewRenderToken) return;
      return embarquerImages(
        applyStateToMarkup(runtime.activeMarkup, runtime.activeTemplate, runtime.activeState)
      );
    }).then(async function (markup) {
      if (token !== runtime.previewRenderToken) return;
      var preparedCanvas = await ozPrepareSmartSvgForCanvas(markup);
      if (token !== runtime.previewRenderToken) return;
      var canvasMarkup = preparedCanvas.markup || markup;

      /* Le panneau d'édition doit afficher exactement le même SVG serré que
         celui posé sur le produit. */
      var boiteRendue = /viewBox\s*=\s*"([^"]+)"/i.exec(canvasMarkup);
      var nombresBoite = boiteRendue ? boiteRendue[1].trim().split(/[\s,]+/).map(Number) : [];
      runtime.previewViewBox = (nombresBoite.length === 4 && !nombresBoite.some(isNaN)) ? nombresBoite : null;

      var dataUri = svgMarkupToDataUri(canvasMarkup);
      runtime.preview.src = dataUri;
      runtime.preview.alt = runtime.activeTemplate.title;
      runtime.preview.hidden = false;
      if (runtime.editingItem && document.documentElement.contains(runtime.editingItem)) {
        var liveWrapper = runtime.editingItem;
        var liveImg = liveWrapper.querySelector('img');
        if (liveImg) {
          liveImg.src = dataUri;
          liveImg.dataset.originalSrc = dataUri;
          liveImg.dataset.originalName = slugify(runtime.activeTemplate.title) + '.svg';
          markWrapperAsTemplate(liveWrapper, runtime.activeTemplate);
          if (preparedCanvas.bounds) {
            ozFitSmartSvgWrapper(liveWrapper, preparedCanvas, {
              preserveSize: true,
              preserveCenter: true
            });
          }
          window.clearTimeout(runtime.liveFinalizeTimer);
          runtime.liveFinalizeTimer = window.setTimeout(function () {
            if (document.documentElement.contains(liveWrapper)) finalizeExistingItem(liveWrapper);
          }, 180);
        }
      }
    });
  }

  function showReadyIncomingEditor() {
    if (!runtime.modal || !runtime.incomingStarter || !runtime.activeMarkup || !runtime.activeMeta || !runtime.editingItem) {
      return false;
    }

    /* Ne jamais ouvrir par-dessus le loader de démarrage. */
    if (
      document.documentElement.classList.contains('customizer-booting') ||
      document.querySelector('#customizer-boot-loader')
    ) {
      return false;
    }

    if (!runtime.modal.isConnected) document.body.appendChild(runtime.modal);

    runtime.modal.classList.remove('oz-smarttpl-waiting');
    delete runtime.modal.dataset.ozDeferredOpen;
    runtime.modal.style.removeProperty('display');
    runtime.modal.hidden = false;
    runtime.modal.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('oz-smarttpl-open');

    syncIncomingStarterPresentation();
    renderLibrary();

    /* Garantit que le panneau apparaît au-dessus du customizer. */
    try {
      runtime.modal.scrollTop = 0;
    } catch (e) {}

    return true;
  }

  async function insertIncomingTemplateOnCanvas() {
    if (!runtime.incomingStarter || runtime.editingItem || runtime.incomingInsertPending) return false;
    if (window.__ozCustomizerProductReady !== true || !window.currentProduct) return false;
    if (!runtime.activeTemplate || !runtime.activeMarkup || !runtime.activeState) return false;
    if (typeof window.addDesignToCurrentView !== 'function') return false;

    runtime.incomingInsertPending = true;
    var targetView = runtime.forcedView || runtime.activeTemplate.defaultView || currentViewName();
    if (targetView && targetView !== currentViewName()) changeCustomizerView(targetView);
    var finalMarkup = applyStateToMarkup(runtime.activeMarkup, runtime.activeTemplate, runtime.activeState);
    var insertingTemplate = runtime.activeTemplate;
    var preparedCanvas = await ozPrepareSmartSvgForCanvas(finalMarkup);
    if (!runtime.incomingStarter || runtime.activeTemplate !== insertingTemplate || runtime.editingItem) { runtime.incomingInsertPending = false; return false; }
    var canvasMarkup = preparedCanvas.markup || finalMarkup;
    var dataUri = svgMarkupToDataUri(canvasMarkup);
    var wrapper = window.addDesignToCurrentView(
      dataUri,
      'image',
      slugify(runtime.activeTemplate.title) + '.svg'
    ) || getLastDesignItemForCurrentView();

    runtime.incomingInsertPending = false;
    if (!wrapper) {
      notify('Le modèle n’a pas pu être placé sur le produit.', 'error');
      return false;
    }
    runtime.editingItem = wrapper;
    runtime.incomingLiveItem = wrapper;
    wrapper.dataset.ozIncludedInBase = 'true';
    markWrapperAsTemplate(wrapper, runtime.activeTemplate);
    if (preparedCanvas.bounds) {
      ozFitSmartSvgWrapper(wrapper, preparedCanvas, {
        preserveSize: false,
        preserveCenter: false,
        targetMax: 0.75
      });
    }
    finalizeExistingItem(wrapper);
    if (runtime.applyBtn) runtime.applyBtn.textContent = 'Terminer';
    syncIncomingStarterPresentation();

    /* Clic depuis Designs :
       le SVG est d'abord posé sur le vêtement, puis le tiroir de réglages
       s'ouvre automatiquement dès que le rendu est réellement prêt. */
    if (runtime.openEditorAfterInsert) {
      var tries = 0;
      var reveal = function () {
        if (showReadyIncomingEditor()) return;
        tries += 1;
        if (tries < 80) window.setTimeout(reveal, 25);
      };
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(reveal);
      });
    }

    return true;
  }

  async function selectTemplate(templateId, options) {
    loadSmartAiHistory();
    var opts = options || {};
    var template = getTemplateById(templateId);
    if (!template) return;

    try {
      var previousTemplateId = runtime.activeTemplate ? runtime.activeTemplate.id : '';
      var previousState = runtime.activeState;
      var carrySharedFields = !!(
        runtime.incomingStarter &&
        previousState &&
        previousTemplateId &&
        previousTemplateId !== template.id
      );
      runtime.activeTemplate = template;
      runtime.aiImageSession += 1;
      Object.keys(runtime.aiImageRuns || {}).forEach(function (key) {
        var run = runtime.aiImageRuns[key];
        if (run && run.controller) {
          try { run.controller.abort(); } catch (e) {}
        }
      });
      runtime.aiImageRuns = Object.create(null);
      runtime.aiImageSources = Object.create(null);
      runtime.imageRatioJobs = Object.create(null);
      runtime.editingItem = opts.editingItem || null;
      if (opts.incomingStarter) runtime.incomingStarter = true;
      if (runtime.incomingStarter && opts.userInitiated && runtime.incomingLibraryExpanded) {
        runtime.incomingLibraryExpanded = false;
      }
      syncIncomingStarterPresentation();
      if (runtime.incomingStarter) setMobileCompactState(false);
      else if (opts.userInitiated || opts.editingItem) setMobileCompactState(true);
      else if (!opts.preserveCompact) setMobileCompactState(false);
      renderLibrary();
      runtime.title.textContent = 'Chargement…';
      runtime.subtitle.textContent = (template.sourceKind === 'image') ? 'Préparation du modèle image' : 'Préparation du modèle SVG';
      runtime.controls.innerHTML = '<div class="oz-smarttpl-empty-state">Chargement du modèle…</div>';
      runtime.preview.removeAttribute('src');
      runtime.preview.hidden = true;

      var initialMarkup = await getTemplateMarkup(template, runtime.editingItem);
      initialMarkup = ozUpgradeLegacySmartSvgMarkup(initialMarkup);
      if (initialMarkup.indexOf('data-oz-reference-href=') !== -1) {
        var referenceDoc = parseSvg(initialMarkup);
        var referenceImage = referenceDoc.querySelector('image[data-oz-reference-href]');
        if (referenceImage) {
          var referenceUrl = referenceImage.getAttribute('data-oz-reference-href') || '';
          var referenceData = await urlVersDataUri(referenceUrl);
          if (/^data:image\//i.test(referenceData)) {
            referenceImage.setAttribute('data-oz-reference-href', referenceData);
            initialMarkup = new XMLSerializer().serializeToString(referenceDoc);
          }
        }
      }
      runtime.activeMarkup = initialMarkup;
      preloadInlineChoiceImages(initialMarkup);

    /* Les photos par defaut du SVG pointent vers des URL distantes.
       On les rapatrie une fois pour toutes a l'ouverture, plutot qu'a
       chaque rendu : ensuite le raccourci d'embarquerImages suffit. */
    embarquerImages(initialMarkup).then(function (avecPhotos) {
      if (runtime.activeMarkup !== initialMarkup) return;
      if (avecPhotos === initialMarkup) return;
      runtime.activeMarkup = avecPhotos;
      inlineChoicePreviewCache.clear();
      renderEditor();
      rerenderPreview();
    });
      var meta = await buildMeta(template, initialMarkup);
      runtime.activeMeta = meta;

      var doc = parseSvg(initialMarkup);
      var seed = applyTemplateDefaultState(meta, buildDefaultState(meta), template);
      runtime.activeState = mergeStateFromSvg(doc, meta, template, seed);
      /* En changeant de design, conserver automatiquement les champs ayant la
         même clé (nom, date, couleurs…) et ignorer ceux que le nouveau SVG
         n'expose pas. */
      if (carrySharedFields) {
        runtime.activeState = sanitizeState(
          meta,
          mergePlainObjects(runtime.activeState, previousState)
        );
      }
      if (opts.initialState && typeof opts.initialState === 'object') {
        runtime.activeState = sanitizeState(
          meta,
          mergePlainObjects(runtime.activeState, opts.initialState)
        );
      }
      renderEditor();
      await insertIncomingTemplateOnCanvas();
    } catch (e) {
      console.error('[modele] chargement impossible', e);
      var raison = (e && e.message) ? e.message : 'cause inconnue';
      notify(raison, 'error');
      /* Le message generique n'apprenait rien : impossible de
         distinguer un SVG invalide d'un champ reste vide. */
      renderEmptyEditor('Le modèle n’a pas pu être chargé : ' + raison);
    }
  }

  function getLastDesignItemForCurrentView() {
    var area = document.querySelector('.design-area[data-area="' + currentViewName() + '"]');
    if (!area) return null;
    return area.querySelector('.design-item:last-child');
  }

  function markWrapperAsTemplate(wrapper, template) {
    if (!wrapper) return;
    wrapper.dataset.templateId = template.id;
    wrapper.dataset.templateKey = template.key;
    wrapper.dataset.templateTitle = template.title;
    wrapper.dataset.templateKind = (template.sourceKind === 'image') ? 'smart-image' : 'smart-svg';
    var img = wrapper.querySelector('img');
    if (img) {
      img.dataset.originalName = slugify(template.title) + ((template.sourceKind === 'image' && template.mediaUrl && /\.(png|jpe?g|webp)(?:[?#].*)?$/i.test(template.mediaUrl)) ? '.png' : '.svg');
      img.dataset.originalSrc = img.getAttribute('src') || '';
    }
  }

  function finalizeExistingItem(wrapper) {
    hydrateTemplateMetadataFromImg(wrapper.querySelector('img'), wrapper);
    if (typeof window.updateItemSizeBadge === 'function') window.updateItemSizeBadge(wrapper);
    if (typeof window.updateAllSizeBadges === 'function') window.updateAllSizeBadges();
    if (typeof window.updatePriceLiveBlock === 'function') window.updatePriceLiveBlock();
    if (typeof window.refreshProductView === 'function') window.refreshProductView();
    if (typeof window.drawZoneLimits === 'function') window.drawZoneLimits();
    if (typeof window.scheduleThumbnailUpdate === 'function') window.scheduleThumbnailUpdate();
    if (typeof window.pushHistory === 'function') window.pushHistory(currentViewName());
  }

  var VIEW_LABELS = {
    front: 'Avant',
    back: 'Dos',
    left: 'Gauche',
    right: 'Droite'
  };

  /* Seules les vues que le vetement expose reellement pour la couleur
     courante sont proposees : refreshViewAvailability masque les autres.
     On reprend au passage le libelle et la vignette deja calcules par le
     navigateur de vues, pour que les deux listes se ressemblent. */
  function getAvailableViews() {
    return ['front', 'back', 'left', 'right'].map(function (view) {
      var btn = document.querySelector('.view-button[data-view="' + view + '"]');
      if (!btn) return null;
      if (btn.style && btn.style.display === 'none') return null;

      var labelEl = btn.querySelector('.view-label');
      var thumbEl = btn.querySelector('.view-thumb');

      return {
        value: view,
        label: (labelEl && labelEl.textContent.trim()) || VIEW_LABELS[view] || view,
        thumb: (thumbEl && thumbEl.style && thumbEl.style.backgroundImage) || ''
      };
    }).filter(Boolean);
  }

  function removeTemplateItemFromCanvas(wrapper) {
    if (!wrapper) return;

    var viewRoot = wrapper.closest ? wrapper.closest('.product-view') : null;
    var viewName = (viewRoot && viewRoot.dataset && viewRoot.dataset.view) || currentViewName();
    var layers = (window.designLayers && window.designLayers[viewName]) || null;

    if (layers) {
      var index = layers.indexOf(wrapper);
      if (index > -1) layers.splice(index, 1);
    }

    wrapper.remove();

    if (typeof window.deselectAll === 'function') window.deselectAll();
    if (typeof window.pushHistory === 'function') window.pushHistory(viewName);
    if (typeof window.scheduleThumbnailUpdate === 'function') window.scheduleThumbnailUpdate();
  }

  /*
   * Deplace le modele sur une autre face. On ne bouge pas le noeud DOM :
   * on le retire et on le recree sur la vue cible, pour que les poignees,
   * la zone d'impression et le calcul de prix soient recables proprement.
   */
  async function moveTemplateToView(viewName) {
    var next = String(viewName || '').trim().toLowerCase();
    if (!next || next === currentViewName()) return;

    var wrapper = runtime.editingItem || runtime.incomingLiveItem;
    var etaitEntrant = !!runtime.incomingStarter;

    if (wrapper) removeTemplateItemFromCanvas(wrapper);

    runtime.editingItem = null;
    runtime.incomingLiveItem = null;
    runtime.incomingInsertPending = false;
    runtime.forcedView = next;

    changeCustomizerView(next);

    if (etaitEntrant) {
      insertIncomingTemplateOnCanvas();
    } else if (wrapper && typeof window.addDesignToCurrentView === 'function') {
      var finalMarkup = applyStateToMarkup(runtime.activeMarkup, runtime.activeTemplate, runtime.activeState);
      var movingTemplate = runtime.activeTemplate;
      var preparedCanvas = await ozPrepareSmartSvgForCanvas(finalMarkup);
      if (runtime.activeTemplate !== movingTemplate || runtime.forcedView !== next) return;
      var neuf = window.addDesignToCurrentView(
        svgMarkupToDataUri(preparedCanvas.markup || finalMarkup),
        'image',
        slugify(runtime.activeTemplate.title) + '.svg'
      ) || getLastDesignItemForCurrentView();

      if (neuf) {
        runtime.editingItem = neuf;
        markWrapperAsTemplate(neuf, runtime.activeTemplate);
        if (preparedCanvas.bounds) {
          ozFitSmartSvgWrapper(neuf, preparedCanvas, {
            preserveSize: false,
            preserveCenter: false,
            targetMax: 0.75
          });
        }
        finalizeExistingItem(neuf);
      }
    }

    renderEditor();
  }

  function changeCustomizerView(viewName) {
    var next = String(viewName || '').trim().toLowerCase();
    if (!next) return;
    if (typeof window.changeView === 'function') {
      window.changeView(next);
      return;
    }
    var btn = document.querySelector('.view-button[data-view="' + next + '"]');
    if (btn) btn.click();
  }

  function upsertRenderedTemplate() {
    if (!runtime.activeTemplate || !runtime.activeMarkup || !runtime.activeState) return;
    var aiReason = smartAiBlockingReason();
    if (aiReason) {
      notify(aiReason, 'warning');
      return;
    }
    window.clearTimeout(runtime.previewDebounce);
    /* Les photos ont deja ete rapatriees par rerenderPreview et sont en cache :
       cette relecture est quasi instantanee. */
    embarquerImages(
      applyStateToMarkup(runtime.activeMarkup, runtime.activeTemplate, runtime.activeState)
    ).then(finaliserRendu);
  }

  async function finaliserRendu(finalMarkup) {
    var finalTemplate = runtime.activeTemplate;
    var finalItem = runtime.editingItem;
    var preparedCanvas = await ozPrepareSmartSvgForCanvas(finalMarkup);
    if (runtime.activeTemplate !== finalTemplate || runtime.editingItem !== finalItem) return;
    var dataUri = svgMarkupToDataUri(preparedCanvas.markup || finalMarkup);

    if (runtime.editingItem) {
      var currentWrapper = runtime.editingItem;
      var img = currentWrapper.querySelector('img');
      if (!img) {
        notify('Impossible de mettre à jour ce modèle.', 'error');
        return;
      }
      img.src = dataUri;
      img.dataset.originalSrc = dataUri;
      img.dataset.originalName = slugify(runtime.activeTemplate.title) + ((runtime.activeTemplate.sourceKind === 'image' && runtime.activeTemplate.mediaUrl && /\.(png|jpe?g|webp)(?:[?#].*)?$/i.test(runtime.activeTemplate.mediaUrl)) ? '.png' : '.svg');
      markWrapperAsTemplate(currentWrapper, runtime.activeTemplate);
      if (preparedCanvas.bounds) {
        ozFitSmartSvgWrapper(currentWrapper, preparedCanvas, {
          preserveSize: true,
          preserveCenter: true
        });
      }
      finalizeExistingItem(currentWrapper);
      notify('Modèle mis à jour.', 'success');
      closeModal();
      return;
    }

    var targetView = runtime.forcedView || runtime.activeTemplate.defaultView || currentViewName();
    if (targetView && targetView !== currentViewName()) {
      changeCustomizerView(targetView);
    }
    if (!window.currentProduct || window.__ozCustomizerProductReady !== true) {
      notify('Le produit doit être chargé avant d’ajouter le modèle.', 'warning');
      closeModal();
      if (typeof window.openProductPicker === 'function') window.openProductPicker({ required: true });
      return;
    }
    if (typeof window.addDesignToCurrentView !== 'function') {
      notify('Le moteur du customizer n’est pas prêt.', 'error');
      return;
    }
    var wrapper = window.addDesignToCurrentView(
      dataUri,
      'image',
      slugify(runtime.activeTemplate.title) + ((runtime.activeTemplate.sourceKind === 'image' && runtime.activeTemplate.mediaUrl && /\.(png|jpe?g|webp)(?:[?#].*)?$/i.test(runtime.activeTemplate.mediaUrl)) ? '.png' : '.svg')
    ) || getLastDesignItemForCurrentView();
    if (!wrapper) {
      notify('Le modèle n’a pas pu être ajouté dans la zone d’impression.', 'error');
      return;
    }
    markWrapperAsTemplate(wrapper, runtime.activeTemplate);
    if (preparedCanvas.bounds) {
      ozFitSmartSvgWrapper(wrapper, preparedCanvas, {
        preserveSize: false,
        preserveCenter: false,
        targetMax: 0.75
      });
    }
    finalizeExistingItem(wrapper);
    notify('Modèle ajouté au produit.', 'success');
    closeModal();
  }

  function openForExistingItem(wrapper) {
    if (!wrapper) return false;
    var img = wrapper.querySelector('img');
    hydrateTemplateMetadataFromImg(img, wrapper);
    var templateId = wrapper.dataset.templateId;
    var template = getTemplateById(templateId);
    if (!template) {
      notify('Le modèle d’origine n’est plus disponible dans la bibliothèque.', 'warning');
      return false;
    }
    return openTemplateById(template.id, { editingItem: wrapper, userInitiated: true });
  }

  function openModal() {
    refreshCatalog();
    ensureModal();
    if (!runtime.modal.isConnected) document.body.appendChild(runtime.modal);
    setMobileCompactState(false);
    runtime.modal.hidden = false;
    runtime.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('oz-smarttpl-open');
    syncIncomingStarterPresentation();
    renderLibrary();
    if (!runtime.activeTemplate) {
      var visible = getVisibleTemplates();
      if (visible[0]) selectTemplate(visible[0].id);
      else renderEmptyEditor('Ajoute des modèles intelligents dans les designs pour activer cette bibliothèque.');
    }
  }

  function closeModal() {
    if (!runtime.modal) return;
    runtime.modal.hidden = true;
    runtime.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('oz-smarttpl-open');
    runtime.editingItem = null;
    runtime.incomingStarter = false;
    runtime.openEditorAfterInsert = false;
    runtime.incomingLiveItem = null;
    runtime.incomingInsertPending = false;
    runtime.incomingLibraryExpanded = false;
    runtime.forcedView = '';
    window.clearTimeout(runtime.liveFinalizeTimer);
    runtime.modal.classList.remove('oz-smarttpl-product-editor', 'oz-smarttpl-library-open');
    runtime.modal.classList.remove('oz-smarttpl-waiting');
    delete runtime.modal.dataset.ozDeferredOpen;
    runtime.modal.style.removeProperty('display');
    setMobileCompactState(false);
  }

  function ensureModal() {
    if (runtime.modal) return;

var modal = document.createElement('div');
modal.id = MODAL_ID;
modal.className = 'oz-smarttpl-modal';
modal.hidden = true;
modal.setAttribute('aria-hidden', 'true');
modal.setAttribute('data-mobile-presentation', 'dialog');
modal.innerHTML = [
      '<div class="oz-smarttpl-backdrop" data-close-modal></div>',
      '<div class="oz-smarttpl-shell" role="dialog" aria-modal="true" aria-label="Bibliothèque de modèles">',
      '  <div class="oz-smarttpl-drag-zone" data-drawer-drag-zone aria-hidden="true"><span class="oz-smarttpl-drag-handle"></span></div>',
      '  <aside class="oz-smarttpl-sidebar">',
      '    <div class="oz-smarttpl-sidebar-head">',
      '      <div>',
      '        <h3>Modèles intelligents</h3>',
      '        <p>Texte, couleurs, options SVG et images intégrées.</p>',
      '      </div>',
       '      <button type="button" class="oz-smarttpl-icon-btn" data-close-modal aria-label="Fermer"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>',
      '    </div>',
      '    <label class="oz-smarttpl-search">',
      '      <input type="search" placeholder="Rechercher un modèle" id="ozSmartTplSearch">',
      '    </label>',
      '    <div class="oz-smarttpl-library" id="ozSmartTplLibrary"></div>',
      '  </aside>',
      '  <section class="oz-smarttpl-editor">',
      '    <div class="oz-smarttpl-editor-head">',
      '      <div>',
      '        <h3 id="ozSmartTplTitle">Choisissez un modèle</h3>',
      '        <p id="ozSmartTplSubtitle">Sélectionnez un SVG personnalisable pour commencer.</p>',
      '      </div>',
      '      <div class="oz-smarttpl-editor-actions">',
      '        <button type="button" class="oz-smarttpl-change-btn" id="ozSmartTplChange" hidden>Changer de design</button>',
       '        <button type="button" class="oz-smarttpl-icon-btn oz-smarttpl-editor-close" data-close-modal aria-label="Fermer"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>',
      '      </div>',
      '    </div>',
      '    <div class="oz-smarttpl-editor-grid">',
      '      <div class="oz-smarttpl-preview-wrap">',
      '        <img id="ozSmartTplPreview" class="oz-smarttpl-preview" alt="">',
      '      </div>',
      '      <div class="oz-smarttpl-controls" id="ozSmartTplControls"></div>',
      '    </div>',
      '    <div class="oz-smarttpl-footer">',
      '      <button type="button" class="oz-smarttpl-secondary-btn" id="ozSmartTplCancel">Annuler</button>',
      '      <button type="button" class="oz-smarttpl-primary-btn" id="ozSmartTplApply">Ajouter au produit</button>',
      '    </div>',
      '  </section>',
      '</div>'
    ].join('');

    masquerPendantChargement(modal);
    runtime.modal = modal;
    runtime.list = modal.querySelector('#ozSmartTplLibrary');
    runtime.search = modal.querySelector('#ozSmartTplSearch');
    runtime.preview = modal.querySelector('#ozSmartTplPreview');
    runtime.controls = modal.querySelector('#ozSmartTplControls');
    runtime.title = modal.querySelector('#ozSmartTplTitle');
    runtime.subtitle = modal.querySelector('#ozSmartTplSubtitle');
    runtime.applyBtn = modal.querySelector('#ozSmartTplApply');
    runtime.cancelBtn = modal.querySelector('#ozSmartTplCancel');
    runtime.changeBtn = modal.querySelector('#ozSmartTplChange');

    runtime.search.addEventListener('input', renderLibrary);
    runtime.applyBtn.addEventListener('click', upsertRenderedTemplate);
    runtime.cancelBtn.addEventListener('click', closeModal);
    if (runtime.changeBtn) {
      runtime.changeBtn.addEventListener('click', function () {
        if (runtime.incomingStarter) {
          runtime.incomingLibraryExpanded = !runtime.incomingLibraryExpanded;
          syncIncomingStarterPresentation();
          if (!runtime.incomingLibraryExpanded) return;
          renderLibrary();
        }
        setMobileCompactState(false);
        if (runtime.search) {
          try {
            runtime.search.focus({ preventScroll: true });
          } catch (e) {
            runtime.search.focus();
          }
        }
      });
    }
    modal.querySelectorAll('[data-close-modal]').forEach(function (node) {
      node.addEventListener('click', closeModal);
    });

    syncMobileCompactState();

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && runtime.modal && !runtime.modal.hidden) {
        closeModal();
      }
    });
  }

  function createTemplateButton(markup, id, label, className) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = id;
    btn.className = className;
    btn.innerHTML = markup + '<span>' + escapeHtml(label) + '</span>';
    btn.addEventListener('click', function () {
      runtime.activeTemplate = null;
      runtime.activeMarkup = '';
      runtime.activeMeta = null;
      runtime.activeState = null;
      runtime.editingItem = null;
      runtime.incomingStarter = false;
      runtime.incomingLiveItem = null;
      runtime.incomingLibraryExpanded = false;
      openModal();
    });
    return btn;
  }

  function injectEntryPoints() {
    Array.prototype.slice.call(document.querySelectorAll('#openTemplatesDrawer, #mobileTemplateBtn')).forEach(function (node) {
      if (node && node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function installDoubleClickEdit() {
    document.addEventListener('dblclick', function (event) {
      var wrapper = event.target && event.target.closest ? event.target.closest('.design-item') : null;
      if (!wrapper) return;
      hydrateTemplateMetadataFromImg(wrapper.querySelector('img'), wrapper);
      if (!wrapper.dataset.templateId) return;
      openForExistingItem(wrapper);
    });
  }

  function observeDesignAreas() {
    var targets = Array.prototype.slice.call(document.querySelectorAll('.design-area'));
    if (!targets.length) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.slice.call(mutation.addedNodes || []).forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          hydrateAllTemplateItems(node);
        });
      });
    });

    targets.forEach(function (target) {
      observer.observe(target, { childList: true, subtree: true });
    });
  }

  function init() {
    if (runtime.initialized) return;
    refreshCatalog();
    ensureModal();
    injectEntryPoints();
    installDoubleClickEdit();
    observeDesignAreas();
    hydrateAllTemplateItems(document);
    runtime.initialized = true;
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', function () {
    setTimeout(function () {
      if (!runtime.initialized) init();
      hydrateAllTemplateItems(document);
    }, 800);
  });

  window.OazarSmartTemplates = {
    flushPreview: function () {
      window.clearTimeout(runtime.liveFinalizeTimer);
      return rerenderPreviewNow();
    },
    openForItem: function (item) {
      if (!item || !item.classList || !item.classList.contains('design-item')) return false;
      hydrateTemplateMetadataFromImg(item.querySelector('img'), item);
      var template = getTemplateById(item.dataset.templateId);
      if (!template || template.sourceKind !== 'svg') return false;
      return openForExistingItem(item);
    },
    showReadyEditor: function () {
      return showReadyIncomingEditor();
    },
    getControlsRoot: function () {
      return runtime.controls || null;
    },
    open: function () {
      if (!runtime.initialized) init();
      openModal();
    },
    openTemplateById: function (templateId, options) {
      if (!runtime.initialized) init();
      return openTemplateById(templateId, options || {});
    },
    /* Impose la face sur laquelle le modele sera pose. A appeler avant
       openTemplateById, sinon le modele part sur la vue courante. */
    /* Pose une image dans un emplacement a partir de son URL, sans passer
       par un File. Le module IA s'en sert quand le telechargement du
       resultat est refuse par le CORS : la fiche produit fonctionne de cette
       facon depuis toujours, en affectant l'URL directement au href. */
    setImageSlot: function (slotKey, url) {
      if (!runtime.activeState || !runtime.activeState.images) return false;
      var key = String(slotKey || '').trim();
      if (!key) return false;

      var valeur = String(url || '');
      runtime.activeState.images[key] = valeur;
      renderEditor();
      rerenderPreview();

      /* Conversion en base64 des maintenant : sans elle, chaque rendu
         ulterieur relancerait un telechargement du meme fichier. */
      if (/^https?:/i.test(valeur)) {
        urlVersDataUri(valeur).then(function (dataUri) {
          if (runtime.activeState && runtime.activeState.images[key] === valeur && dataUri !== valeur) {
            runtime.activeState.images[key] = dataUri;
            rerenderPreview();
          }
        });
      }

      return true;
    },
    setPlacementView: function (viewName) {
      var next = String(viewName || '').trim().toLowerCase();
      if (['front', 'back', 'left', 'right'].indexOf(next) === -1) return false;
      runtime.forcedView = next;
      return true;
    },
    openTemplateFromLibraryItem: function (item) {
      if (!runtime.initialized) init();
      return openTemplateFromLibraryItem(item);
    },
    editSelected: function () {
      if (!runtime.initialized) init();
      var selected = getSelectedTemplateItem();
      if (selected) openForExistingItem(selected);
    },
    hydrate: hydrateAllTemplateItems,
    refreshCatalog: function () {
      if (!runtime.initialized) init();
      refreshCatalog();
      return runtime.templates.slice();
    },
    getPreviewForLibraryItem: function (item) {
      if (!runtime.initialized) init();
      if (!item || typeof item !== 'object') return '';
      var templateId = String(item.templateId || item.template_id || '').trim();
      var templateKey = String(item.templateKey || item.template_key || '').trim();
      var template = templateId ? getTemplateById(templateId) : null;
      if (!template && templateKey) template = getTemplateByKey(templateKey);
      if (!template && item.inlineTemplate && item.inlineTemplate.id) {
        template = getTemplateById(item.inlineTemplate.id) || item.inlineTemplate;
      }
      return getTemplateCardPreview(template);
    },
    getSvgPreviewMarkupForLibraryItem: async function (item) {
      if (!runtime.initialized) init();
      if (!item || typeof item !== 'object') return '';
      var template = item.templateId ? getTemplateById(item.templateId) : null;
      if (!template && item.templateKey) template = getTemplateByKey(item.templateKey);
      if (!template && item.id) template = getTemplateById(item.id);
      if (!template && item.inlineTemplate) template = item.inlineTemplate;
      if (!template || template.sourceKind === 'image') return '';
      var markup = await getTemplateMarkup(template, null);
      return embarquerImages(markup);
    },
    getDesignCategories: function (techOverride, sourceLibrary) {
      if (!runtime.initialized) init();
      return getDesignCategoriesForDrawer(techOverride, sourceLibrary);
    },
    getCatalog: function () {
      if (!runtime.initialized) init();
      refreshCatalog();
      return {
        templates: runtime.templates.slice(),
        slotOptions: runtime.slotOptions.slice()
      };
    }
  };})();


(function () {
  var MODAL_ID = 'ozSmartTemplateModal';
  var BOUND_ATTR = 'data-oz-mobile-drawer-bound';

  function isPhoneViewport() {
    try {
      return window.matchMedia('(max-width: 768px)').matches;
    } catch (e) {
      return window.innerWidth <= 768;
    }
  }

  function resetSheetPresentation(modal) {
    if (!modal) return;
    modal.removeAttribute('data-dragging');
    var shell = modal.querySelector('.oz-smarttpl-shell');
    var backdrop = modal.querySelector('.oz-smarttpl-backdrop');
    if (shell) {
      shell.style.transition = '';
      shell.style.transform = '';
    }
    if (backdrop) {
      backdrop.style.transition = '';
      backdrop.style.opacity = '';
    }
  }

  function closeSheet(modal) {
    if (!modal) return;
    var closeBtn = modal.querySelector('[data-close-modal], #ozSmartTplCancel');
    if (closeBtn) {
      closeBtn.click();
      return;
    }
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('oz-smarttpl-open');
  }

  function bindMobileDrawer(modal) {
    if (!modal || modal.getAttribute(BOUND_ATTR) === 'true') return;
    if (String(modal.getAttribute('data-mobile-presentation') || '').toLowerCase() === 'dialog') {
      modal.setAttribute(BOUND_ATTR, 'true');
      return;
    }

    var shell = modal.querySelector('.oz-smarttpl-shell');
    var backdrop = modal.querySelector('.oz-smarttpl-backdrop');
    if (!shell || !backdrop) return;

    modal.setAttribute(BOUND_ATTR, 'true');

    var drag = {
      active: false,
      startY: 0,
      currentY: 0
    };

    function setOffset(offset) {
      var y = Math.max(0, Number(offset) || 0);
      shell.style.transform = 'translateY(' + y + 'px)';
      var max = Math.max(shell.offsetHeight * 0.45, 220);
      backdrop.style.opacity = String(Math.max(0, Math.min(1, 1 - (y / max))));
    }

    function canStartDrag(target, clientY) {
      if (!isPhoneViewport()) return false;
      if (modal.hidden || modal.getAttribute('aria-hidden') === 'true') return false;
      if (!(target instanceof Element)) return false;

      if (target.closest('[data-drawer-drag-zone]')) return true;

      /* IMPORTANT :
         on empêche le drawer de "voler" le geste tactile
         quand on glisse dans les couleurs / groupes ouverts */
      if (target.closest('.oz-smarttpl-group-body, .oz-smarttpl-swatch-row')) return false;

      if (target.closest('input, textarea, select, button, label, a, [contenteditable="true"]')) return false;

      var controls = target.closest('.oz-smarttpl-controls');
      if (controls) return false;

      var library = target.closest('.oz-smarttpl-library');
      if (library) return (library.scrollTop || 0) <= 0 && (library.scrollLeft || 0) <= 0;

      if (target.closest('.oz-smarttpl-preview-wrap')) return true;
      if (target.closest('.oz-smarttpl-sidebar-head, .oz-smarttpl-editor-head')) return true;

      var rect = shell.getBoundingClientRect();
      return (clientY - rect.top) <= 120;
    }

    shell.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      var touch = event.touches[0];
      if (!canStartDrag(event.target, touch.clientY)) return;

      drag.active = true;
      drag.startY = touch.clientY;
      drag.currentY = touch.clientY;

      modal.setAttribute('data-dragging', 'true');
      shell.style.transition = 'none';
      backdrop.style.transition = 'none';
    }, { passive: true });

    shell.addEventListener('touchmove', function (event) {
      if (!drag.active || !event.touches || event.touches.length !== 1) return;

      var touch = event.touches[0];
      drag.currentY = touch.clientY;

      var delta = Math.max(0, touch.clientY - drag.startY);
      setOffset(delta);

      if (delta > 0) event.preventDefault();
    }, { passive: false });

    function finishDrag() {
      if (!drag.active) return;

      var delta = Math.max(0, drag.currentY - drag.startY);
      drag.active = false;

      modal.removeAttribute('data-dragging');
      shell.style.transition = 'transform 0.22s cubic-bezier(0.4, 0, 0.2, 1)';
      backdrop.style.transition = 'opacity 0.22s ease';

      var threshold = Math.min(180, Math.max(90, shell.offsetHeight * 0.18));

      if (delta > threshold) {
        setOffset(shell.offsetHeight + 40);
        window.setTimeout(function () {
          closeSheet(modal);
          resetSheetPresentation(modal);
        }, 180);
        return;
      }

      setOffset(0);
      window.setTimeout(function () {
        resetSheetPresentation(modal);
      }, 220);
    }

    shell.addEventListener('touchend', finishDrag, { passive: true });
    shell.addEventListener('touchcancel', finishDrag, { passive: true });

    var observer = new MutationObserver(function () {
      resetSheetPresentation(modal);
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['hidden', 'aria-hidden']
    });
  }

  function initSmartTemplateMobileDrawer() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) bindMobileDrawer(modal);

    var root = document.body || document.documentElement;
    if (!root) return;

    var observer = new MutationObserver(function () {
      var nextModal = document.getElementById(MODAL_ID);
      if (nextModal) bindMobileDrawer(nextModal);
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmartTemplateMobileDrawer);
  } else {
    initSmartTemplateMobileDrawer();
  }
})();


/* =============================================================================
   OAZAR — Pont fiche produit → atelier, rendu SVG fidèle
   -----------------------------------------------------------------------------
   Ce bloc :
   1. ouvre automatiquement le bon modèle dans l'atelier ;
   2. reprend les textes, couleurs, polices, toggles et variantes de la fiche ;
   3. conserve les déplacements data-oz-move-when-hidden ;
   4. NE déforme plus le SVG avec preserveAspectRatio="none".

   Important : le rendu doit rester basé sur le vrai viewBox du SVG.
   ============================================================================= */
(function () {
  'use strict';

  var DEBUG = false;
  var demarre = false;
  var termine = false;
  var MARQUE = 'data-oz-postraite';

  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[modele]'].concat([].slice.call(arguments)));
    }
  }

  function decoder(src) {
    var v = String(src || '');
    if (v.indexOf('data:image/svg+xml') !== 0) return '';

    var i = v.indexOf(',');
    if (i === -1) return '';

    var meta = v.slice(0, i);
    var data = v.slice(i + 1);

    try {
      return /;base64/i.test(meta) ? atob(data) : decodeURIComponent(data);
    } catch (e) {
      return '';
    }
  }

  function encoder(markup) {
    return 'data:image/svg+xml;charset=utf-8,' +
      encodeURIComponent(String(markup || ''))
        .replace(/%0A/g, '')
        .replace(/%20/g, ' ');
  }

  function estMasque(el) {
    if (!el) return false;

    var display = String(el.getAttribute('display') || '').toLowerCase();
    var visibility = String(el.getAttribute('visibility') || '').toLowerCase();
    var style = String(el.getAttribute('style') || '').toLowerCase();

    return display === 'none' ||
      visibility === 'hidden' ||
      style.indexOf('display:none') !== -1 ||
      style.indexOf('display: none') !== -1;
  }

  function normaliserViewBox(svg) {
    if (!svg) return false;

    var change = false;
    var nodes = [svg].concat(Array.prototype.slice.call(svg.querySelectorAll('svg')));

    nodes.forEach(function (node) {
      var legacyViewBox = node.getAttribute('viewbox');

      if (!node.getAttribute('viewBox') && legacyViewBox) {
        node.setAttribute('viewBox', legacyViewBox);
        change = true;
      }

      if (node.hasAttribute('viewbox')) {
        node.removeAttribute('viewbox');
        change = true;
      }

      if (!node.getAttribute('preserveAspectRatio')) {
        node.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        change = true;
      }
    });

    return change;
  }

  function traiter(markup) {
    var doc;

    try {
      doc = new DOMParser().parseFromString(markup, 'image/svg+xml');
    } catch (e) {
      return null;
    }

    if (doc.querySelector('parsererror') || !doc.documentElement) return null;

    var svg = doc.documentElement;
    if (svg.nodeName.toLowerCase() !== 'svg') return null;
    if (svg.getAttribute(MARQUE) === '1') return null;

    var change = normaliserViewBox(svg);

    /* Déplace les dates quand le texte EVG est masqué. */
    Array.prototype.slice.call(
      svg.querySelectorAll('[data-oz-move-when-hidden]')
    ).forEach(function (el) {
      var cle = String(el.getAttribute('data-oz-move-when-hidden') || '').trim();
      if (!cle) return;

      var offset = String(el.getAttribute('data-oz-move-offset') || '0 0').trim();
      var reference = svg.querySelector(
        '[data-oz-toggle="' + cle.replace(/"/g, '\\"') + '"]'
      );
      var doitBouger = estMasque(reference);

      /* On retire uniquement le translate géré par cette règle avant de le recalculer. */
      var actuel = String(el.getAttribute('transform') || '')
        .replace(/translate\([^)]*\)/g, '')
        .trim();

      var voulu = doitBouger
        ? ('translate(' + offset + ') ' + actuel).trim()
        : actuel;

      if (String(el.getAttribute('transform') || '') !== voulu) {
        if (voulu) el.setAttribute('transform', voulu);
        else el.removeAttribute('transform');
        change = true;
      }
    });

    if (!change) return null;

    svg.setAttribute(MARQUE, '1');
    return new XMLSerializer().serializeToString(doc);
  }

  function traiterImage(img) {
    if (!img || !img.src) return;

    var markup = decoder(img.src);
    if (!markup) return;

    var sortie = traiter(markup);
    if (!sortie) return;

    img.src = encoder(sortie);

    if (img.dataset && img.dataset.originalSrc) {
      img.dataset.originalSrc = img.src;
    }
  }

  function surveillerRendus() {
    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.target.tagName === 'IMG') {
          traiterImage(m.target);
          return;
        }

        Array.prototype.slice.call(m.addedNodes || []).forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (node.tagName === 'IMG') traiterImage(node);

          if (node.querySelectorAll) {
            Array.prototype.slice.call(node.querySelectorAll('img')).forEach(traiterImage);
          }
        });
      });
    });

    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src']
    });

    Array.prototype.slice.call(
      document.querySelectorAll('.oz-smarttpl-preview, .design-area img')
    ).forEach(traiterImage);

    log('post-traitement SVG actif');
  }

  function lireParametres() {
    var p;

    try {
      p = new URLSearchParams(window.location.search || '');
    } catch (e) {
      return null;
    }

    var cle = String(
      p.get('tpl') ||
      p.get('template_key') ||
      p.get('template') ||
      p.get('template_name') ||
      p.get('starter_template') ||
      p.get('starter_template_name') ||
      p.get('design_template') ||
      ''
    ).trim();

    var etat = null;
    var brut = p.get('tplstate');

    if (brut) {
      try {
        var b64 = brut.replace(/-/g, '+').replace(/_/g, '/');
        while (b64.length % 4) b64 += '=';
        etat = JSON.parse(decodeURIComponent(escape(atob(b64))));
      } catch (e) {
        log('tplstate illisible', e);
      }
    }

    function parseObjet(value) {
      if (!value) return null;
      if (typeof value === 'object') return value;
      if (typeof value !== 'string') return null;
      try { return JSON.parse(value); } catch (e) {}
      try { return JSON.parse(decodeURIComponent(value)); } catch (e2) {}
      return null;
    }

    function valeurParCles(obj, keys, depth) {
      if (!obj || typeof obj !== 'object' || depth > 5) return null;
      for (var i = 0; i < keys.length; i++) {
        if (obj[keys[i]] != null && obj[keys[i]] !== '') return obj[keys[i]];
      }
      var nested = ['template', 'smartTemplate', 'smart_template', 'starterTemplate', 'starter_template', 'designTemplate', 'design_template', 'customization', 'personnalisation', 'options', 'payload', 'data'];
      for (var j = 0; j < nested.length; j++) {
        var child = parseObjet(obj[nested[j]]) || obj[nested[j]];
        var found = valeurParCles(child, keys, depth + 1);
        if (found != null && found !== '') return found;
      }
      return null;
    }

    function reprendreContexte(obj) {
      obj = parseObjet(obj) || obj;
      if (!obj || typeof obj !== 'object') return;

      if (!cle) {
        var foundKey = valeurParCles(obj, [
          'tpl', 'template_key', 'templateKey', 'template_name', 'templateName',
          'starter_template', 'starterTemplate', 'starter_template_name', 'starterTemplateName',
          'design_template', 'designTemplate', 'smart_template_key', 'smartTemplateKey',
          'model_key', 'modelKey', 'modele_key', 'modeleKey', 'name', 'title', 'key'
        ], 0);
        if (typeof foundKey === 'string') cle = foundKey.trim();
      }

      if (!etat) {
        var foundState = valeurParCles(obj, [
          'tplstate', 'template_state', 'templateState', 'smart_state', 'smartState',
          'customization_state', 'customizationState', 'initial_state', 'initialState',
          'slot_state', 'slotState', 'state'
        ], 0);
        foundState = parseObjet(foundState) || foundState;
        if (foundState && typeof foundState === 'object') etat = foundState;
      }
    }

    /* La fiche produit récente transmet surtout un transfer_token. L'ancienne
       version chargeait bien le vêtement depuis ce jeton mais oubliait d'en
       extraire le modèle intelligent, laissant donc le t-shirt vide. */
    var transferToken = String(p.get('transfer_token') || '').trim();
    if (transferToken) {
      try {
        reprendreContexte(sessionStorage.getItem('oazarCustomizerTransfer:' + transferToken));
      } catch (e) {}
    }

    if (cle || transferToken) {
      try {
        var contexteBrut = sessionStorage.getItem('oazar_customizer_context');
        var contexteSauve = parseObjet(contexteBrut);
        var contexteAge = contexteSauve && contexteSauve.timestamp
          ? Date.now() - Number(contexteSauve.timestamp)
          : 0;
        var contexteCle = contexteSauve && String(
          contexteSauve.template_key || contexteSauve.templateKey || contexteSauve.tpl || ''
        ).trim();
        var contexteCompatible = !cle || !contexteCle || contexteCle === cle;
        if (contexteSauve && contexteAge < (30 * 60 * 1000) && contexteCompatible) {
          reprendreContexte(contexteSauve);
        } else if (contexteBrut) {
          sessionStorage.removeItem('oazar_customizer_context');
        }
      } catch (e) {}
    }

    if (!cle) return null;

    return {
      cle: cle,
      vue: String(p.get('view') || p.get('face') || '').trim().toLowerCase(),
      etat: etat || {}
    };
  }

  function nettoyerUrl() {
    try {
      var url = new URL(window.location.href);

      ['tpl', 'template_key', 'tplstate', 'ratio', 'view', 'face'].forEach(function (key) {
        url.searchParams.delete(key);
      });

      window.history.replaceState({}, '', url.toString());
      sessionStorage.removeItem('oazar_customizer_context');
    } catch (e) {}
  }

  function attendre(condition, delaiMax) {
    return new Promise(function (resolve, reject) {
      var debut = Date.now();

      (function boucle() {
        var valeur = condition();
        if (valeur) return resolve(valeur);

        if (Date.now() - debut > (delaiMax || 20000)) {
          return reject(new Error('délai dépassé'));
        }

        setTimeout(boucle, 50);
      })();
    });
  }

  function normalise(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/œ/g, 'oe')
      .replace(/æ/g, 'ae')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/coeur/g, 'love')
      .replace(/[_\s]+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  /*
   * Correspondance tolerante, sur le modele de ce qui a ete fait pour les
   * variantes EVG. La cle envoyee par la fiche produit et celle saisie dans
   * le bloc de l'editeur de theme viennent de deux sources differentes :
   * metachamp d'un cote, saisie manuelle de l'autre. Exiger l'egalite stricte
   * revient a demander au marchand de les tenir synchronisees a la lettre.
   *
   * Ordre des tentatives, du plus sur au plus permissif :
   *   1. cle ou identifiant exacts
   *   2. titre du bloc, une fois normalise
   *   3. inclusion dans un sens ou dans l'autre (animaux-tsuk / animaux-tsuki)
   *   4. premiers segments communs (tetes-d-animaux-... / animaux-...)
   * Une correspondance approchee est signalee en console : elle depanne,
   * mais il vaut mieux aligner les cles pour de bon.
   */
  function trouverModele(api, cle) {
    var catalogue;

    try {
      catalogue = api.getCatalog();
    } catch (e) {
      return null;
    }

    var liste = (catalogue && catalogue.templates) || [];
    if (!Array.isArray(liste) || !liste.length) return null;

    var cible = normalise(cle);
    if (!cible) return null;

    function chercher(test) {
      for (var i = 0; i < liste.length; i++) {
        if (test(liste[i])) return liste[i];
      }
      return null;
    }

    var exact = chercher(function (t) {
      return normalise(t.key) === cible || normalise(t.id) === cible;
    });
    if (exact) return exact;

    var approche = chercher(function (t) {
      return normalise(t.title) === cible || normalise(t.template_key) === cible;
    });

    if (!approche) {
      approche = chercher(function (t) {
        return [t.key, t.id, t.title, t.template_key].some(function (valeur) {
          var v = normalise(valeur);
          return v && v.length > 3 && (v.indexOf(cible) !== -1 || cible.indexOf(v) !== -1);
        });
      });
    }

    if (!approche) {
      /* Dernier recours : au moins deux segments de tete en commun. */
      var segments = cible.split('-').filter(Boolean);
      if (segments.length >= 2) {
        approche = chercher(function (t) {
          return [t.key, t.id, t.title, t.template_key].some(function (valeur) {
            var mots = normalise(valeur).split('-').filter(Boolean);
            if (mots.length < 2) return false;
            var communs = mots.filter(function (mot) {
              return segments.indexOf(mot) !== -1;
            });
            return communs.length >= 2;
          });
        });
      }
    }

    if (approche) {
      log(
        'correspondance approchee pour « ' + cle + ' » -> bloc « ' +
        (approche.key || approche.id) + ' ». Aligne les deux cles pour fiabiliser.'
      );
    }

    return approche;
  }

  function declencher(el, type) {
    el.dispatchEvent(new Event(type, { bubbles: true }));
  }

  function remplir(etat, api) {
    var racine = (api && typeof api.getControlsRoot === 'function')
      ? api.getControlsRoot()
      : document.querySelector('.oz-smarttpl-controls');
    if (!racine) return 0;

    var poses = 0;

    ['texts', 'colors', 'fonts'].forEach(function (groupe) {
      Object.keys(etat[groupe] || {}).forEach(function (cle) {
        var champ = racine.querySelector(
          '[data-field-group="' + groupe + '"]' +
          '[data-field-key="' + CSS.escape(cle) + '"]'
        );

        if (!champ) {
          log('champ introuvable :', groupe, cle);
          return;
        }

        champ.value = String(
          etat[groupe][cle] == null ? '' : etat[groupe][cle]
        );

        declencher(champ, 'input');
        declencher(champ, 'change');
        poses++;
      });
    });

    Object.keys(etat.toggles || {}).forEach(function (cle) {
      var champ = racine.querySelector(
        '[data-field-group="toggles"]' +
        '[data-field-key="' + CSS.escape(cle) + '"]'
      );

      if (!champ) {
        log('case introuvable :', cle);
        return;
      }

      var voulu = !!etat.toggles[cle];

      if (champ.checked !== voulu) {
        champ.checked = voulu;
        declencher(champ, 'change');
      }

      poses++;
    });

    /*
     * Rejoue aussi les choix SVG reçus depuis la fiche produit.
     * On fusionne l'ancien format variants et le nouveau format choices.
     */
    var choixRecus = Object.assign({}, etat.variants || {}, etat.choices || {});

    Object.keys(choixRecus).forEach(function (cle) {
      var valeur = String(choixRecus[cle] || '');
      if (!valeur) return;

      /* Tous les boutons du meme slot, quel que soit le format d'attribut. */
      var boutons = Array.prototype.slice.call(
        racine.querySelectorAll('[data-choice-slot][data-choice-value]')
      ).concat(Array.prototype.slice.call(
        racine.querySelectorAll('[data-field-group="variants"][data-field-key][data-choice-value]')
      )).filter(function (btn) {
        var slot = btn.getAttribute('data-choice-slot') || btn.getAttribute('data-field-key');
        return normalise(slot) === normalise(cle);
      });

      if (!boutons.length) {
        log('slot de choix introuvable :', cle);
        return;
      }

      var cible = normalise(valeur);

      /* Egalite stricte, puis normalisee, puis inclusion : les valeurs de la
         fiche produit (futur_marie) et du SVG (modele_futur_marie) different
         souvent d'un prefixe. */
      var bouton =
        boutons.filter(function (b) {
          return b.getAttribute('data-choice-value') === valeur;
        })[0] ||
        boutons.filter(function (b) {
          return normalise(b.getAttribute('data-choice-value')) === cible;
        })[0] ||
        boutons.filter(function (b) {
          var v = normalise(b.getAttribute('data-choice-value'));
          return v && (v.indexOf(cible) !== -1 || cible.indexOf(v) !== -1);
        })[0];

      if (!bouton) {
        log(
          'choix introuvable :', cle, valeur,
          'valeurs disponibles :',
          boutons.map(function (b) { return b.getAttribute('data-choice-value'); })
        );
        return;
      }

      bouton.click();
      poses++;
    });

    return poses;
  }

  function signalerEtatModele(nom) {
    try {
      window.dispatchEvent(new CustomEvent(nom));
    } catch (e) {
      var eventFallback = document.createEvent('Event');
      eventFallback.initEvent(nom, false, false);
      window.dispatchEvent(eventFallback);
    }
  }

  async function demarrer() {
    if (demarre || termine) return;

    var params = lireParametres();
    if (!params) return;

    demarre = true;
    document.documentElement.classList.add('oz-drawers-locked');
    window.__ozAtelierBootState = 'loading-model';
    signalerEtatModele('oazar:modele-detecte');
    log('modèle demandé :', params.cle);

    /* Le produit doit être chargé avant le SVG. */
    try {
      await attendre(function () {
        return window.__ozCustomizerProductReady === true &&
          window.currentProduct &&
          document.querySelector('.design-area[data-area="front"]');
      }, 20000);
    } catch (e) {
      demarre = false;

      if (typeof window.showNotification === 'function') {
        window.showNotification('Le vêtement n’a pas pu être chargé.', 'error');
      }

      signalerEtatModele('oazar:modele-erreur');
      return;
    }

    var api;

    try {
      api = await attendre(function () {
        var currentApi = window.OazarSmartTemplates;

        return (
          currentApi &&
          typeof currentApi.openTemplateById === 'function' &&
          typeof currentApi.getCatalog === 'function'
        ) ? currentApi : null;
      });
    } catch (e) {
      demarre = false;
      signalerEtatModele('oazar:modele-erreur');
      return;
    }

    var modele;

    try {
      modele = await attendre(function () {
        return trouverModele(api, params.cle);
      }, 8000);
    } catch (e) {
      if (typeof window.showNotification === 'function') {
        window.showNotification('Ce modèle n’est plus disponible.', 'warning');
      }

      var disponibles = [];
      try {
        disponibles = ((api.getCatalog() || {}).templates || []).map(function (t) {
          return (t.key || t.id) + ' (' + (t.title || '') + ')';
        });
      } catch (e2) {}

      console.warn(
        '[modele] aucune correspondance pour la clé « ' + params.cle + ' ».\n' +
        'Clés présentes dans le catalogue : ' +
        (disponibles.length ? disponibles.join(', ') : 'aucune — le bloc « Modèle intelligent » est-il bien publié ?')
      );

      demarre = false;
      signalerEtatModele('oazar:modele-erreur');
      return;
    }

    if (params.vue && typeof api.setPlacementView === 'function') {
      api.setPlacementView(params.vue);
    }

    api.openTemplateById(modele.id, {
      userInitiated: true,
      incomingStarter: true,
      initialState: params.etat
    });

    try {
      await attendre(function () {
        var controls = (typeof api.getControlsRoot === 'function')
          ? api.getControlsRoot()
          : document.querySelector('.oz-smarttpl-controls');
        return (
          controls &&
          controls.querySelector('[data-field-group]')
        ) ? true : null;
      }, 10000);
    } catch (e) {
      demarre = false;
      signalerEtatModele('oazar:modele-erreur');
      return;
    }

    log(remplir(params.etat, api) + ' valeur(s) reprise(s)');

    /* L'éditeur ne devient visible que lorsque le vêtement et le SVG posé
       ont terminé leur premier chargement. */
    var visuelPret = false;
    try {
      visuelPret = await attendre(function () {
        var design = document.querySelector('.design-item[data-template-id] img');
        var garment = document.querySelector('.product-view.active .product-mockup > img');
        return design && design.complete && design.naturalWidth > 0 &&
          (!garment || (garment.complete && garment.naturalWidth > 0));
      }, 8000);
    } catch (imageError) {
      log('aperçu encore en chargement', imageError);
    }

    if (!visuelPret) {
      signalerEtatModele('oazar:modele-erreur');
      nettoyerUrl();
      termine = true;
      demarre = false;
      return;
    }

    /* Le voile de chargement se retire lorsque le produit et le SVG sont prets. */
    signalerEtatModele('oazar:modele-pret');

    /* Le signal de chargement lance la disparition du voile. Le tiroir ne
       peut s'ouvrir qu'une fois tous les voiles vraiment retires du DOM. */
    try {
      await attendre(function () {
        return !document.documentElement.classList.contains('customizer-booting') &&
          !document.querySelector('#customizer-boot-loader');
      }, 12000);
    } catch (e) {
      log('atelier encore en chargement', e);
    }
    if (visuelPret && !document.documentElement.classList.contains('customizer-booting') &&
        !document.querySelector('#customizer-boot-loader')) {
      document.documentElement.classList.remove('oz-drawers-locked', 'oz-svg-autostart-locked');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var tentativesAffichage = 0;
          var afficherEditeurPret = function () {
            if (api.showReadyEditor()) {
              window.__ozAtelierBootState = 'interactive';
              return;
            }
            tentativesAffichage += 1;
            if (tentativesAffichage < 100) window.setTimeout(afficherEditeurPret, 50);
          };
          afficherEditeurPret();
        });
      });
    }

    nettoyerUrl();
    termine = true;
    demarre = false;
  }

  function init() {
    surveillerRendus();
    demarrer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
